!(function (t) {
  var e = {};
  function n(r) {
    if (e[r]) return e[r].exports;
    var i = (e[r] = { i: r, l: !1, exports: {} });
    return t[r].call(i.exports, i, i.exports, n), (i.l = !0), i.exports;
  }
  (n.m = t),
    (n.c = e),
    (n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r });
    }),
    (n.r = function (t) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (n.t = function (t, e) {
      if ((1 & e && (t = n(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if ((n.r(r), Object.defineProperty(r, 'default', { enumerable: !0, value: t }), 2 & e && 'string' != typeof t))
        for (var i in t)
          n.d(
            r,
            i,
            function (e) {
              return t[e];
            }.bind(null, i)
          );
      return r;
    }),
    (n.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return n.d(e, 'a', e), e;
    }),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.p = ''),
    n((n.s = 62));
})([
  function (t, e, n) {
    'use strict';
    function r(t) {
      (this.listenerMap = [{}, {}]), t && this.root(t), (this.handle = r.prototype.handle.bind(this)), (this._removedListeners = []);
    }
    function i(t, e) {
      return t.toLowerCase() === e.tagName.toLowerCase();
    }
    function o(t, e) {
      return t === e.id;
    }
    Object.defineProperty(e, '__esModule', { value: !0 }),
      (e.default = void 0),
      (r.prototype.root = function (t) {
        var e,
          n = this.listenerMap;
        if (this.rootElement) {
          for (e in n[1]) n[1].hasOwnProperty(e) && this.rootElement.removeEventListener(e, this.handle, !0);
          for (e in n[0]) n[0].hasOwnProperty(e) && this.rootElement.removeEventListener(e, this.handle, !1);
        }
        if (!t || !t.addEventListener) return this.rootElement && delete this.rootElement, this;
        for (e in ((this.rootElement = t), n[1])) n[1].hasOwnProperty(e) && this.rootElement.addEventListener(e, this.handle, !0);
        for (e in n[0]) n[0].hasOwnProperty(e) && this.rootElement.addEventListener(e, this.handle, !1);
        return this;
      }),
      (r.prototype.captureForType = function (t) {
        return -1 !== ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(t);
      }),
      (r.prototype.on = function (t, e, n, r) {
        var a, s, c, u;
        if (!t) throw new TypeError('Invalid event type: ' + t);
        if (('function' == typeof e && ((r = n), (n = e), (e = null)), void 0 === r && (r = this.captureForType(t)), 'function' != typeof n))
          throw new TypeError('Handler must be a type of Function');
        return (
          (a = this.rootElement),
          (s = this.listenerMap[r ? 1 : 0])[t] || (a && a.addEventListener(t, this.handle, r), (s[t] = [])),
          e
            ? /^[a-z]+$/i.test(e)
              ? ((u = e), (c = i))
              : /^#[a-z0-9\-_]+$/i.test(e)
              ? ((u = e.slice(1)), (c = o))
              : ((u = e), (c = Element.prototype.matches))
            : ((u = null),
              (c = function (t, e) {
                return this.rootElement === window ? e === document || e === document.documentElement || e === window : this.rootElement === e;
              }.bind(this))),
          s[t].push({ selector: e, handler: n, matcher: c, matcherParam: u }),
          this
        );
      }),
      (r.prototype.off = function (t, e, n, r) {
        var i, o, a, s, c;
        if (('function' == typeof e && ((r = n), (n = e), (e = null)), void 0 === r)) return this.off(t, e, n, !0), this.off(t, e, n, !1), this;
        if (((a = this.listenerMap[r ? 1 : 0]), !t)) {
          for (c in a) a.hasOwnProperty(c) && this.off(c, e, n);
          return this;
        }
        if (!(s = a[t]) || !s.length) return this;
        for (i = s.length - 1; i >= 0; i--) (o = s[i]), (e && e !== o.selector) || (n && n !== o.handler) || (this._removedListeners.push(o), s.splice(i, 1));
        return s.length || (delete a[t], this.rootElement && this.rootElement.removeEventListener(t, this.handle, r)), this;
      }),
      (r.prototype.handle = function (t) {
        var e,
          n,
          r,
          i,
          o,
          a = t.type,
          s = [];
        if (!0 !== t.ftLabsDelegateIgnore) {
          switch (
            (3 === (o = t.target).nodeType && (o = o.parentNode),
            o.correspondingUseElement && (o = o.correspondingUseElement),
            (r = this.rootElement),
            t.eventPhase || (t.target !== t.currentTarget ? 3 : 2))
          ) {
            case 1:
              s = this.listenerMap[1][a];
              break;
            case 2:
              this.listenerMap[0] && this.listenerMap[0][a] && (s = s.concat(this.listenerMap[0][a])),
                this.listenerMap[1] && this.listenerMap[1][a] && (s = s.concat(this.listenerMap[1][a]));
              break;
            case 3:
              s = this.listenerMap[0][a];
          }
          var c,
            u = [];
          for (n = s.length; o && n; ) {
            for (e = 0; e < n && (i = s[e]); e++)
              o.tagName && ['button', 'input', 'select', 'textarea'].indexOf(o.tagName.toLowerCase()) > -1 && o.hasAttribute('disabled')
                ? (u = [])
                : i.matcher.call(o, i.matcherParam, o) && u.push([t, o, i]);
            if (o === r) break;
            if (((n = s.length), (o = o.parentElement || o.parentNode) instanceof HTMLDocument)) break;
          }
          for (e = 0; e < u.length; e++)
            if (!(this._removedListeners.indexOf(u[e][2]) > -1) && !1 === this.fire.apply(this, u[e])) {
              (u[e][0].ftLabsDelegateIgnore = !0), u[e][0].preventDefault(), (c = !1);
              break;
            }
          return c;
        }
      }),
      (r.prototype.fire = function (t, e, n) {
        return n.handler.call(e, t, e);
      }),
      (r.prototype.destroy = function () {
        this.off(), this.root();
      });
    var a = r;
    (e.default = a), (t.exports = e.default);
  },
  function (t, e, n) {
    !(function (e, n) {
      var r = (function (t, e, n) {
        'use strict';
        var r, i;
        if (
          ((function () {
            var e,
              n = {
                lazyClass: 'lazyload',
                loadedClass: 'lazyloaded',
                loadingClass: 'lazyloading',
                preloadClass: 'lazypreload',
                errorClass: 'lazyerror',
                autosizesClass: 'lazyautosizes',
                fastLoadedClass: 'ls-is-cached',
                iframeLoadMode: 0,
                srcAttr: 'data-src',
                srcsetAttr: 'data-srcset',
                sizesAttr: 'data-sizes',
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: 0.8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 0,
                throttleDelay: 125,
              };
            for (e in ((i = t.lazySizesConfig || t.lazysizesConfig || {}), n)) e in i || (i[e] = n[e]);
          })(),
          !e || !e.getElementsByClassName)
        )
          return { init: function () {}, cfg: i, noSupport: !0 };
        var o,
          a,
          s,
          c,
          u,
          l,
          d,
          f,
          h,
          p,
          g,
          v,
          m,
          y,
          b,
          w,
          _,
          E,
          k,
          A,
          T,
          x,
          S,
          C,
          O,
          L,
          q,
          D,
          P,
          I,
          M,
          N,
          j,
          R,
          B,
          z,
          H,
          F,
          V,
          U,
          W,
          G,
          $,
          J = e.documentElement,
          Y = t.HTMLPictureElement,
          Q = t.addEventListener.bind(t),
          X = t.setTimeout,
          Z = t.requestAnimationFrame || X,
          K = t.requestIdleCallback,
          tt = /^picture$/i,
          et = ['load', 'error', 'lazyincluded', '_lazyloaded'],
          nt = {},
          rt = Array.prototype.forEach,
          it = function (t, e) {
            return nt[e] || (nt[e] = new RegExp('(\\s|^)' + e + '(\\s|$)')), nt[e].test(t.getAttribute('class') || '') && nt[e];
          },
          ot = function (t, e) {
            it(t, e) || t.setAttribute('class', (t.getAttribute('class') || '').trim() + ' ' + e);
          },
          at = function (t, e) {
            var n;
            (n = it(t, e)) && t.setAttribute('class', (t.getAttribute('class') || '').replace(n, ' '));
          },
          st = function (t, e, n) {
            var r = n ? 'addEventListener' : 'removeEventListener';
            n && st(t, e),
              et.forEach(function (n) {
                t[r](n, e);
              });
          },
          ct = function (t, n, i, o, a) {
            var s = e.createEvent('Event');
            return i || (i = {}), (i.instance = r), s.initEvent(n, !o, !a), (s.detail = i), t.dispatchEvent(s), s;
          },
          ut = function (e, n) {
            var r;
            !Y && (r = t.picturefill || i.pf)
              ? (n && n.src && !e.getAttribute('srcset') && e.setAttribute('srcset', n.src), r({ reevaluate: !0, elements: [e] }))
              : n && n.src && (e.src = n.src);
          },
          lt = function (t, e) {
            return (getComputedStyle(t, null) || {})[e];
          },
          dt = function (t, e, n) {
            for (n = n || t.offsetWidth; n < i.minSize && e && !t._lazysizesWidth; ) (n = e.offsetWidth), (e = e.parentNode);
            return n;
          },
          ft =
            ((U = []),
            (W = V = []),
            (($ = function (t, n) {
              H && !n ? t.apply(this, arguments) : (W.push(t), F || ((F = !0), (e.hidden ? X : Z)(G)));
            })._lsFlush = G =
              function () {
                var t = W;
                for (W = V.length ? U : V, H = !0, F = !1; t.length; ) t.shift()();
                H = !1;
              }),
            $),
          ht = function (t, e) {
            return e
              ? function () {
                  ft(t);
                }
              : function () {
                  var e = this,
                    n = arguments;
                  ft(function () {
                    t.apply(e, n);
                  });
                };
          },
          pt = function (t) {
            var e,
              r,
              i = function () {
                (e = null), t();
              },
              o = function () {
                var t = n.now() - r;
                t < 99 ? X(o, 99 - t) : (K || i)(i);
              };
            return function () {
              (r = n.now()), e || (e = X(o, 99));
            };
          },
          gt =
            ((_ = /^img$/i),
            (E = /^iframe$/i),
            (k = 'onscroll' in t && !/(gle|ing)bot/.test(navigator.userAgent)),
            (A = 0),
            (T = 0),
            (x = -1),
            (S = function (t) {
              T--, (!t || T < 0 || !t.target) && (T = 0);
            }),
            (C = function (t) {
              return null == w && (w = 'hidden' == lt(e.body, 'visibility')), w || !('hidden' == lt(t.parentNode, 'visibility') && 'hidden' == lt(t, 'visibility'));
            }),
            (O = function (t, n) {
              var r,
                i = t,
                o = C(t);
              for (v -= n, b += n, m -= n, y += n; o && (i = i.offsetParent) && i != e.body && i != J; )
                (o = (lt(i, 'opacity') || 1) > 0) &&
                  'visible' != lt(i, 'overflow') &&
                  ((r = i.getBoundingClientRect()), (o = y > r.left && m < r.right && b > r.top - 1 && v < r.bottom + 1));
              return o;
            }),
            (q = (function (t) {
              var e,
                r = 0,
                o = i.throttleDelay,
                a = i.ricTimeout,
                s = function () {
                  (e = !1), (r = n.now()), t();
                },
                c =
                  K && a > 49
                    ? function () {
                        K(s, { timeout: a }), a !== i.ricTimeout && (a = i.ricTimeout);
                      }
                    : ht(function () {
                        X(s);
                      }, !0);
              return function (t) {
                var i;
                (t = !0 === t) && (a = 33), e || ((e = !0), (i = o - (n.now() - r)) < 0 && (i = 0), t || i < 9 ? c() : X(c, i));
              };
            })(
              (L = function () {
                var t,
                  n,
                  o,
                  a,
                  s,
                  c,
                  d,
                  h,
                  _,
                  E,
                  S,
                  L,
                  q = r.elements;
                if ((f = i.loadMode) && T < 8 && (t = q.length)) {
                  for (n = 0, x++; n < t; n++)
                    if (q[n] && !q[n]._lazyRace)
                      if (!k || (r.prematureUnveil && r.prematureUnveil(q[n]))) j(q[n]);
                      else if (
                        (((h = q[n].getAttribute('data-expand')) && (c = 1 * h)) || (c = A),
                        E ||
                          ((E = !i.expand || i.expand < 1 ? (J.clientHeight > 500 && J.clientWidth > 500 ? 500 : 370) : i.expand),
                          (r._defEx = E),
                          (S = E * i.expFactor),
                          (L = i.hFac),
                          (w = null),
                          A < S && T < 1 && x > 2 && f > 2 && !e.hidden ? ((A = S), (x = 0)) : (A = f > 1 && x > 1 && T < 6 ? E : 0)),
                        _ !== c && ((p = innerWidth + c * L), (g = innerHeight + c), (d = -1 * c), (_ = c)),
                        (o = q[n].getBoundingClientRect()),
                        (b = o.bottom) >= d &&
                          (v = o.top) <= g &&
                          (y = o.right) >= d * L &&
                          (m = o.left) <= p &&
                          (b || y || m || v) &&
                          (i.loadHidden || C(q[n])) &&
                          ((l && T < 3 && !h && (f < 3 || x < 4)) || O(q[n], c)))
                      ) {
                        if ((j(q[n]), (s = !0), T > 9)) break;
                      } else
                        !s &&
                          l &&
                          !a &&
                          T < 4 &&
                          x < 4 &&
                          f > 2 &&
                          (u[0] || i.preloadAfterLoad) &&
                          (u[0] || (!h && (b || y || m || v || 'auto' != q[n].getAttribute(i.sizesAttr)))) &&
                          (a = u[0] || q[n]);
                  a && !s && j(a);
                }
              })
            )),
            (P = ht(
              (D = function (t) {
                var e = t.target;
                e._lazyCache ? delete e._lazyCache : (S(t), ot(e, i.loadedClass), at(e, i.loadingClass), st(e, I), ct(e, 'lazyloaded'));
              })
            )),
            (I = function (t) {
              P({ target: t.target });
            }),
            (M = function (t) {
              var e,
                n = t.getAttribute(i.srcsetAttr);
              (e = i.customMedia[t.getAttribute('data-media') || t.getAttribute('media')]) && t.setAttribute('media', e), n && t.setAttribute('srcset', n);
            }),
            (N = ht(function (t, e, n, r, o) {
              var a, s, c, u, l, f;
              (l = ct(t, 'lazybeforeunveil', e)).defaultPrevented ||
                (r && (n ? ot(t, i.autosizesClass) : t.setAttribute('sizes', r)),
                (s = t.getAttribute(i.srcsetAttr)),
                (a = t.getAttribute(i.srcAttr)),
                o && (u = (c = t.parentNode) && tt.test(c.nodeName || '')),
                (f = e.firesLoad || ('src' in t && (s || a || u))),
                (l = { target: t }),
                ot(t, i.loadingClass),
                f && (clearTimeout(d), (d = X(S, 2500)), st(t, I, !0)),
                u && rt.call(c.getElementsByTagName('source'), M),
                s
                  ? t.setAttribute('srcset', s)
                  : a &&
                    !u &&
                    (E.test(t.nodeName)
                      ? (function (t, e) {
                          var n = t.getAttribute('data-load-mode') || i.iframeLoadMode;
                          0 == n ? t.contentWindow.location.replace(e) : 1 == n && (t.src = e);
                        })(t, a)
                      : (t.src = a)),
                o && (s || u) && ut(t, { src: a })),
                t._lazyRace && delete t._lazyRace,
                at(t, i.lazyClass),
                ft(function () {
                  var e = t.complete && t.naturalWidth > 1;
                  (f && !e) ||
                    (e && ot(t, i.fastLoadedClass),
                    D(l),
                    (t._lazyCache = !0),
                    X(function () {
                      '_lazyCache' in t && delete t._lazyCache;
                    }, 9)),
                    'lazy' == t.loading && T--;
                }, !0);
            })),
            (j = function (t) {
              if (!t._lazyRace) {
                var e,
                  n = _.test(t.nodeName),
                  r = n && (t.getAttribute(i.sizesAttr) || t.getAttribute('sizes')),
                  o = 'auto' == r;
                ((!o && l) || !n || (!t.getAttribute('src') && !t.srcset) || t.complete || it(t, i.errorClass) || !it(t, i.lazyClass)) &&
                  ((e = ct(t, 'lazyunveilread').detail), o && vt.updateElem(t, !0, t.offsetWidth), (t._lazyRace = !0), T++, N(t, e, o, r, n));
              }
            }),
            (R = pt(function () {
              (i.loadMode = 3), q();
            })),
            (z = function () {
              l || (n.now() - h < 999 ? X(z, 999) : ((l = !0), (i.loadMode = 3), q(), Q('scroll', B, !0)));
            }),
            {
              _: function () {
                (h = n.now()),
                  (r.elements = e.getElementsByClassName(i.lazyClass)),
                  (u = e.getElementsByClassName(i.lazyClass + ' ' + i.preloadClass)),
                  Q('scroll', q, !0),
                  Q('resize', q, !0),
                  Q('pageshow', function (t) {
                    if (t.persisted) {
                      var n = e.querySelectorAll('.' + i.loadingClass);
                      n.length &&
                        n.forEach &&
                        Z(function () {
                          n.forEach(function (t) {
                            t.complete && j(t);
                          });
                        });
                    }
                  }),
                  t.MutationObserver
                    ? new MutationObserver(q).observe(J, { childList: !0, subtree: !0, attributes: !0 })
                    : (J.addEventListener('DOMNodeInserted', q, !0), J.addEventListener('DOMAttrModified', q, !0), setInterval(q, 999)),
                  Q('hashchange', q, !0),
                  ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function (t) {
                    e.addEventListener(t, q, !0);
                  }),
                  /d$|^c/.test(e.readyState) ? z() : (Q('load', z), e.addEventListener('DOMContentLoaded', q), X(z, 2e4)),
                  r.elements.length ? (L(), ft._lsFlush()) : q();
              },
              checkElems: q,
              unveil: j,
              _aLSL: (B = function () {
                3 == i.loadMode && (i.loadMode = 2), R();
              }),
            }),
          vt =
            ((a = ht(function (t, e, n, r) {
              var i, o, a;
              if (((t._lazysizesWidth = r), (r += 'px'), t.setAttribute('sizes', r), tt.test(e.nodeName || '')))
                for (o = 0, a = (i = e.getElementsByTagName('source')).length; o < a; o++) i[o].setAttribute('sizes', r);
              n.detail.dataAttr || ut(t, n.detail);
            })),
            (s = function (t, e, n) {
              var r,
                i = t.parentNode;
              i &&
                ((n = dt(t, i, n)),
                (r = ct(t, 'lazybeforesizes', { width: n, dataAttr: !!e })).defaultPrevented || ((n = r.detail.width) && n !== t._lazysizesWidth && a(t, i, r, n)));
            }),
            {
              _: function () {
                (o = e.getElementsByClassName(i.autosizesClass)), Q('resize', c);
              },
              checkElems: (c = pt(function () {
                var t,
                  e = o.length;
                if (e) for (t = 0; t < e; t++) s(o[t]);
              })),
              updateElem: s,
            }),
          mt = function () {
            !mt.i && e.getElementsByClassName && ((mt.i = !0), vt._(), gt._());
          };
        return (
          X(function () {
            i.init && mt();
          }),
          (r = { cfg: i, autoSizer: vt, loader: gt, init: mt, uP: ut, aC: ot, rC: at, hC: it, fire: ct, gW: dt, rAF: ft })
        );
      })(e, e.document, Date);
      (e.lazySizes = r), t.exports && (t.exports = r);
    })('undefined' != typeof window ? window : {});
  },
  function (t, e, n) {
    var r = n(33),
      i = n(34),
      o = n(15),
      a = n(35);
    (t.exports = function (t, e) {
      return r(t) || i(t, e) || o(t, e) || a();
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    var r = n(24),
      i = n(25),
      o = n(15),
      a = n(26);
    (t.exports = function (t) {
      return r(t) || i(t) || o(t) || a();
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    var r, i, o;
    window,
      (i = [n(8), n(41), n(43), n(44), n(45), n(46), n(47)]),
      void 0 ===
        (o =
          'function' ==
          typeof (r = function (t) {
            return t;
          })
            ? r.apply(e, i)
            : r) || (t.exports = o);
  },
  function (t, e, n) {
    var r, i, o;
    (o = window),
      (r = [n(37)]),
      void 0 ===
        (i = function (t) {
          return (function (t, e) {
            'use strict';
            var n = {
                extend: function (t, e) {
                  for (var n in e) t[n] = e[n];
                  return t;
                },
                modulo: function (t, e) {
                  return ((t % e) + e) % e;
                },
              },
              r = Array.prototype.slice;
            (n.makeArray = function (t) {
              return Array.isArray(t) ? t : null == t ? [] : 'object' == typeof t && 'number' == typeof t.length ? r.call(t) : [t];
            }),
              (n.removeFrom = function (t, e) {
                var n = t.indexOf(e);
                -1 != n && t.splice(n, 1);
              }),
              (n.getParent = function (t, n) {
                for (; t.parentNode && t != document.body; ) if (((t = t.parentNode), e(t, n))) return t;
              }),
              (n.getQueryElement = function (t) {
                return 'string' == typeof t ? document.querySelector(t) : t;
              }),
              (n.handleEvent = function (t) {
                var e = 'on' + t.type;
                this[e] && this[e](t);
              }),
              (n.filterFindElements = function (t, r) {
                t = n.makeArray(t);
                var i = [];
                return (
                  t.forEach(function (t) {
                    if (t instanceof HTMLElement)
                      if (r) {
                        e(t, r) && i.push(t);
                        for (var n = t.querySelectorAll(r), o = 0; o < n.length; o++) i.push(n[o]);
                      } else i.push(t);
                  }),
                  i
                );
              }),
              (n.debounceMethod = function (t, e, n) {
                n = n || 100;
                var r = t.prototype[e],
                  i = e + 'Timeout';
                t.prototype[e] = function () {
                  var t = this[i];
                  clearTimeout(t);
                  var e = arguments,
                    o = this;
                  this[i] = setTimeout(function () {
                    r.apply(o, e), delete o[i];
                  }, n);
                };
              }),
              (n.docReady = function (t) {
                var e = document.readyState;
                'complete' == e || 'interactive' == e ? setTimeout(t) : document.addEventListener('DOMContentLoaded', t);
              }),
              (n.toDashed = function (t) {
                return t
                  .replace(/(.)([A-Z])/g, function (t, e, n) {
                    return e + '-' + n;
                  })
                  .toLowerCase();
              });
            var i = t.console;
            return (
              (n.htmlInit = function (e, r) {
                n.docReady(function () {
                  var o = n.toDashed(r),
                    a = 'data-' + o,
                    s = document.querySelectorAll('[' + a + ']'),
                    c = document.querySelectorAll('.js-' + o),
                    u = n.makeArray(s).concat(n.makeArray(c)),
                    l = a + '-options',
                    d = t.jQuery;
                  u.forEach(function (t) {
                    var n,
                      o = t.getAttribute(a) || t.getAttribute(l);
                    try {
                      n = o && JSON.parse(o);
                    } catch (e) {
                      return void (i && i.error('Error parsing ' + a + ' on ' + t.className + ': ' + e));
                    }
                    var s = new e(t, n);
                    d && d.data(t, r, s);
                  });
                });
              }),
              n
            );
          })(o, t);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    'use strict';
    (t.exports = o), (t.exports.isMobile = o), (t.exports.default = o);
    var r =
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
      i =
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
    function o(t) {
      t || (t = {});
      var e = t.ua;
      if (
        (e || 'undefined' == typeof navigator || (e = navigator.userAgent),
        e && e.headers && 'string' == typeof e.headers['user-agent'] && (e = e.headers['user-agent']),
        'string' != typeof e)
      )
        return !1;
      var n = t.tablet ? i.test(e) : r.test(e);
      return !n && t.tablet && t.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== e.indexOf('Macintosh') && -1 !== e.indexOf('Safari') && (n = !0), n;
    }
  },
  function (t, e, n) {
    (function (e) {
      t.exports = (function () {
        'use strict';
        function t(e) {
          return (t =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t;
                })(e);
        }
        function n(t, e, n) {
          return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = n), t;
        }
        function r(t, e) {
          var n = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t);
            e &&
              (r = r.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })),
              n.push.apply(n, r);
          }
          return n;
        }
        function i(t) {
          for (var e = 1; e < arguments.length; e++) {
            var i = null != arguments[e] ? arguments[e] : {};
            e % 2
              ? r(Object(i), !0).forEach(function (e) {
                  n(t, e, i[e]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i))
              : r(Object(i)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
                });
          }
          return t;
        }
        function o(t) {
          return (
            (function (t) {
              if (Array.isArray(t)) return a(t);
            })(t) ||
            (function (t) {
              if ('undefined' != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
            })(t) ||
            (function (t, e) {
              if (t) {
                if ('string' == typeof t) return a(t, e);
                var n = Object.prototype.toString.call(t).slice(8, -1);
                return (
                  'Object' === n && t.constructor && (n = t.constructor.name),
                  'Map' === n || 'Set' === n ? Array.from(t) : 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0
                );
              }
            })(t) ||
            (function () {
              throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
            })()
          );
        }
        function a(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
          return r;
        }
        function s(t, e) {
          if (!Array.isArray(t) || !t.length) return t;
          var n,
            r,
            o = i(i({}, { strictlyTwoElementsInRangeArrays: !1, progressFn: null }), e);
          if (
            o.strictlyTwoElementsInRangeArrays &&
            !t.every(function (t, e) {
              return 2 === t.length || ((n = e), (r = t.length), !1);
            })
          )
            throw new TypeError(
              'ranges-sort: [THROW_ID_03] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, '
                .concat(n, 'th range (')
                .concat(JSON.stringify(t[n], null, 4), ') has not two but ')
                .concat(r, ' elements!')
            );
          if (
            !t.every(function (t, e) {
              return !(!Number.isInteger(t[0]) || t[0] < 0 || !Number.isInteger(t[1]) || t[1] < 0) || ((n = e), !1);
            })
          )
            throw new TypeError(
              'ranges-sort: [THROW_ID_04] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, '
                .concat(n, 'th range (')
                .concat(JSON.stringify(t[n], null, 4), ') does not consist of only natural numbers!')
            );
          var a = t.length * t.length,
            s = 0;
          return Array.from(t).sort(function (t, e) {
            return o.progressFn && ((s += 1), o.progressFn(Math.floor((100 * s) / a))), t[0] === e[0] ? (t[1] < e[1] ? -1 : t[1] > e[1] ? 1 : 0) : t[0] < e[0] ? -1 : 1;
          });
        }
        function c(e, n) {
          function r(t) {
            return 'string' == typeof t;
          }
          function a(e) {
            return e && 'object' === t(e) && !Array.isArray(e);
          }
          if (!Array.isArray(e) || !e.length) return e;
          var c,
            u = { mergeType: 1, progressFn: null, joinRangesThatTouchEdges: !0 };
          if (n) {
            if (!a(n))
              throw new Error(
                'emlint: [THROW_ID_03] the second input argument must be a plain object. It was given as:\n'.concat(JSON.stringify(n, null, 4), ' (type ').concat(t(n), ')')
              );
            if ((c = i(i({}, u), n)).progressFn && a(c.progressFn) && !Object.keys(c.progressFn).length) c.progressFn = null;
            else if (c.progressFn && 'function' != typeof c.progressFn)
              throw new Error(
                'ranges-merge: [THROW_ID_01] opts.progressFn must be a function! It was given of a type: "'
                  .concat(t(c.progressFn), '", equal to ')
                  .concat(JSON.stringify(c.progressFn, null, 4))
              );
            if (c.mergeType && 1 !== c.mergeType && 2 !== c.mergeType)
              if (r(c.mergeType) && '1' === c.mergeType.trim()) c.mergeType = 1;
              else {
                if (!r(c.mergeType) || '2' !== c.mergeType.trim())
                  throw new Error(
                    'ranges-merge: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'
                      .concat(t(c.mergeType), '", equal to ')
                      .concat(JSON.stringify(c.mergeType, null, 4))
                  );
                c.mergeType = 2;
              }
            if ('boolean' != typeof c.joinRangesThatTouchEdges)
              throw new Error(
                'ranges-merge: [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: "'
                  .concat(t(c.joinRangesThatTouchEdges), '", equal to ')
                  .concat(JSON.stringify(c.joinRangesThatTouchEdges, null, 4))
              );
          } else c = i({}, u);
          for (
            var l,
              d,
              f,
              h = e
                .map(function (t) {
                  return o(t);
                })
                .filter(function (t) {
                  return void 0 !== t[2] || t[0] !== t[1];
                }),
              p =
                (l = c.progressFn
                  ? s(h, {
                      progressFn: function (t) {
                        (f = Math.floor(t / 5)) !== d && ((d = f), c.progressFn(f));
                      },
                    })
                  : s(h)).length - 1,
              g = p;
            g > 0;
            g--
          )
            c.progressFn && (f = Math.floor(78 * (1 - g / p)) + 21) !== d && f > d && ((d = f), c.progressFn(f)),
              (l[g][0] <= l[g - 1][0] || (!c.joinRangesThatTouchEdges && l[g][0] < l[g - 1][1]) || (c.joinRangesThatTouchEdges && l[g][0] <= l[g - 1][1])) &&
                ((l[g - 1][0] = Math.min(l[g][0], l[g - 1][0])),
                (l[g - 1][1] = Math.max(l[g][1], l[g - 1][1])),
                void 0 !== l[g][2] &&
                  (l[g - 1][0] >= l[g][0] || l[g - 1][1] <= l[g][1]) &&
                  null !== l[g - 1][2] &&
                  (null === l[g][2] && null !== l[g - 1][2]
                    ? (l[g - 1][2] = null)
                    : void 0 !== l[g - 1][2]
                    ? 2 === c.mergeType && l[g - 1][0] === l[g][0]
                      ? (l[g - 1][2] = l[g][2])
                      : (l[g - 1][2] += l[g][2])
                    : (l[g - 1][2] = l[g][2])),
                l.splice(g, 1),
                (g = l.length));
          return l;
        }
        function u(e, n, r) {
          var i,
            o = 0,
            a = 0;
          if (0 === arguments.length) throw new Error('ranges-apply: [THROW_ID_01] inputs missing!');
          if (
            !(function (t) {
              return 'string' == typeof t;
            })(e)
          )
            throw new TypeError(
              "ranges-apply: [THROW_ID_02] first input argument must be a string! Currently it's: ".concat(t(e), ', equal to: ').concat(JSON.stringify(e, null, 4))
            );
          if (null === n) return e;
          if (!Array.isArray(n))
            throw new TypeError(
              "ranges-apply: [THROW_ID_03] second input argument must be an array (or null)! Currently it's: ".concat(t(n), ', equal to: ').concat(JSON.stringify(n, null, 4))
            );
          if (r && 'function' != typeof r)
            throw new TypeError(
              "ranges-apply: [THROW_ID_04] the third input argument must be a function (or falsey)! Currently it's: "
                .concat(t(r), ', equal to: ')
                .concat(JSON.stringify(r, null, 4))
            );
          var s = (i =
              Array.isArray(n) && ((Number.isInteger(n[0]) && n[0] >= 0) || /^\d*$/.test(n[0])) && ((Number.isInteger(n[1]) && n[1] >= 0) || /^\d*$/.test(n[1]))
                ? [Array.from(n)]
                : Array.from(n)).length,
            u = 0;
          i.forEach(function (e, n) {
            if ((r && (o = Math.floor((u / s) * 10)) !== a && ((a = o), r(o)), !Array.isArray(e)))
              throw new TypeError(
                'ranges-apply: [THROW_ID_05] ranges array, second input arg., has '
                  .concat(n, 'th element not an array: ')
                  .concat(JSON.stringify(e, null, 4), ', which is ')
                  .concat(t(e))
              );
            if (!Number.isInteger(e[0]) || e[0] < 0) {
              if (!/^\d*$/.test(e[0]))
                throw new TypeError(
                  'ranges-apply: [THROW_ID_06] ranges array, second input arg. has '
                    .concat(n, 'th element, array [')
                    .concat(e[0], ',')
                    .concat(e[1], ']. That array has first element not an integer, but ')
                    .concat(t(e[0]), ', equal to: ')
                    .concat(JSON.stringify(e[0], null, 4), ". Computer doesn't like this.")
                );
              i[n][0] = Number.parseInt(i[n][0], 10);
            }
            if (!Number.isInteger(e[1])) {
              if (!/^\d*$/.test(e[1]))
                throw new TypeError(
                  'ranges-apply: [THROW_ID_07] ranges array, second input arg. has '
                    .concat(n, 'th element, array [')
                    .concat(e[0], ',')
                    .concat(e[1], ']. That array has second element not an integer, but ')
                    .concat(t(e[1]), ', equal to: ')
                    .concat(JSON.stringify(e[1], null, 4), ". Computer doesn't like this.")
                );
              i[n][1] = Number.parseInt(i[n][1], 10);
            }
            u += 1;
          });
          var l = c(i, {
              progressFn: function (t) {
                r && (o = 10 + Math.floor(t / 10)) !== a && ((a = o), r(o));
              },
            }),
            d = l.length;
          if (d > 0) {
            var f = e.slice(l[d - 1][1]);
            (e = l.reduce(function (t, n, i, s) {
              r && (o = 20 + Math.floor((i / d) * 80)) !== a && ((a = o), r(o));
              var c = 0 === i ? 0 : s[i - 1][1],
                u = s[i][0];
              return (
                t +
                e.slice(c, u) +
                ((function (t) {
                  return null != t;
                })(s[i][2])
                  ? s[i][2]
                  : '')
              );
            }, '')),
              (e += f);
          }
          return e;
        }
        function l(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            n = arguments.length > 2 ? arguments[2] : void 0;
          if (
            !(
              n.trim() ||
              (t.length && '\n' !== n && ' ' !== n && ' ' === (e ? t[t.length - 1] : t[0])) ||
              (t.length && '\n' === (e ? t[t.length - 1] : t[0]) && '\n' !== n && ' ' !== n)
            )
          )
            if (e) {
              if (('\n' === n || ' ' === n) && t.length && ' ' === t[t.length - 1]) for (; t.length && ' ' === t[t.length - 1]; ) t.pop();
              t.push(' ' === n || '\n' === n ? n : ' ');
            } else {
              if (('\n' === n || ' ' === n) && t.length && ' ' === t[0]) for (; t.length && ' ' === t[0]; ) t.shift();
              t.unshift(' ' === n || '\n' === n ? n : ' ');
            }
        }
        function d(t, e) {
          if ('string' == typeof t && t.length) {
            var n,
              r,
              i = !1;
            if ((t.includes('\r\n') && (i = !0), (n = e && 'number' == typeof e ? e : 1), '' === t.trim())) {
              var o = [];
              for (
                r = n,
                  Array.from(t).forEach(function (t) {
                    ('\n' !== t || r) && ('\n' === t && (r -= 1), l(o, !0, t));
                  });
                o.length > 1 && ' ' === o[o.length - 1];

              )
                o.pop();
              return o.join('');
            }
            var a = [];
            if (((r = n), '' === t[0].trim())) for (var s = 0, c = t.length; s < c && !t[s].trim(); s++) ('\n' !== t[s] || r) && ('\n' === t[s] && (r -= 1), l(a, !0, t[s]));
            var u = [];
            if (((r = n), '' === t.slice(-1).trim())) for (var d = t.length; d-- && !t[d].trim(); ) ('\n' !== t[d] || r) && ('\n' === t[d] && (r -= 1), l(u, !1, t[d]));
            return i ? ''.concat(a.join('')).concat(t.trim()).concat(u.join('')).replace(/\n/g, '\r\n') : a.join('') + t.trim() + u.join('');
          }
          return t;
        }
        function f(t) {
          return null != t;
        }
        function h(t) {
          return Number.isInteger(t) && t >= 0;
        }
        function p(t) {
          return 'string' == typeof t;
        }
        function g(t) {
          return /^\d*$/.test(t) ? parseInt(t, 10) : t;
        }
        var v,
          m,
          y = (function () {
            function e(n) {
              !(function (t, e) {
                if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
              })(this, e);
              var r = i(i({}, { limitToBeAddedWhitespace: !1, limitLinebreaksCount: 1, mergeType: 1 }), n);
              if (r.mergeType && 1 !== r.mergeType && 2 !== r.mergeType)
                if (p(r.mergeType) && '1' === r.mergeType.trim()) r.mergeType = 1;
                else {
                  if (!p(r.mergeType) || '2' !== r.mergeType.trim())
                    throw new Error(
                      'ranges-push: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: "'
                        .concat(t(r.mergeType), '", equal to ')
                        .concat(JSON.stringify(r.mergeType, null, 4))
                    );
                  r.mergeType = 2;
                }
              this.opts = r;
            }
            var n;
            return (
              (n = [
                {
                  key: 'add',
                  value: function (e, n, r) {
                    for (var i = this, a = arguments.length, s = new Array(a > 3 ? a - 3 : 0), c = 3; c < a; c++) s[c - 3] = arguments[c];
                    if (s.length > 0)
                      throw new TypeError(
                        "ranges-push/Ranges/add(): [THROW_ID_03] Please don't overload the add() method. From the 4th input argument onwards we see these redundant arguments: ".concat(
                          JSON.stringify(s, null, 4)
                        )
                      );
                    if (f(e) || f(n)) {
                      if (f(e) && !f(n)) {
                        if (Array.isArray(e)) {
                          if (e.length) {
                            if (
                              e.some(function (t) {
                                return Array.isArray(t);
                              })
                            )
                              return void e.forEach(function (t) {
                                Array.isArray(t) && i.add.apply(i, o(t));
                              });
                            e.length > 1 && h(g(e[0])) && h(g(e[1])) && this.add.apply(this, o(e));
                          }
                          return;
                        }
                        throw new TypeError(
                          'ranges-push/Ranges/add(): [THROW_ID_12] the first input argument, "from" is set ('
                            .concat(JSON.stringify(e, null, 0), ') but second-one, "to" is not (')
                            .concat(JSON.stringify(n, null, 0), ')')
                        );
                      }
                      if (!f(e) && f(n))
                        throw new TypeError(
                          'ranges-push/Ranges/add(): [THROW_ID_13] the second input argument, "to" is set ('
                            .concat(JSON.stringify(n, null, 0), ') but first-one, "from" is not (')
                            .concat(JSON.stringify(e, null, 0), ')')
                        );
                      var u = /^\d*$/.test(e) ? parseInt(e, 10) : e,
                        l = /^\d*$/.test(n) ? parseInt(n, 10) : n;
                      if ((h(r) && (r = String(r)), !h(u) || !h(l)))
                        throw h(u) && u >= 0
                          ? new TypeError(
                              'ranges-push/Ranges/add(): [THROW_ID_10] "to" value, the second input argument, must be a natural number or zero! Currently it\'s of a type "'
                                .concat(t(l), '" equal to: ')
                                .concat(JSON.stringify(l, null, 4))
                            )
                          : new TypeError(
                              'ranges-push/Ranges/add(): [THROW_ID_09] "from" value, the first input argument, must be a natural number or zero! Currently it\'s of a type "'
                                .concat(t(u), '" equal to: ')
                                .concat(JSON.stringify(u, null, 4))
                            );
                      if (f(r) && !p(r) && !h(r))
                        throw new TypeError(
                          'ranges-push/Ranges/add(): [THROW_ID_08] The third argument, the value to add, was given not as string but '
                            .concat(t(r), ', equal to:\n')
                            .concat(JSON.stringify(r, null, 4))
                        );
                      if (f(this.slices) && Array.isArray(this.last()) && u === this.last()[1]) {
                        if (((this.last()[1] = l), this.last()[2], null !== this.last()[2] && f(r))) {
                          var v = !(f(this.last()[2]) && this.last()[2].length > 0) || (this.opts && this.opts.mergeType && 1 !== this.opts.mergeType) ? r : this.last()[2] + r;
                          this.opts.limitToBeAddedWhitespace && (v = d(v, this.opts.limitLinebreaksCount)), (p(v) && !v.length) || (this.last()[2] = v);
                        }
                      } else {
                        this.slices || (this.slices = []);
                        var m = void 0 === r || (p(r) && !r.length) ? [u, l] : [u, l, this.opts.limitToBeAddedWhitespace ? d(r, this.opts.limitLinebreaksCount) : r];
                        this.slices.push(m);
                      }
                    }
                  },
                },
                {
                  key: 'push',
                  value: function (t, e, n) {
                    for (var r = arguments.length, i = new Array(r > 3 ? r - 3 : 0), o = 3; o < r; o++) i[o - 3] = arguments[o];
                    this.add.apply(this, [t, e, n].concat(i));
                  },
                },
                {
                  key: 'current',
                  value: function () {
                    var t = this;
                    return null != this.slices
                      ? ((this.slices = c(this.slices, { mergeType: this.opts.mergeType })),
                        this.opts.limitToBeAddedWhitespace
                          ? this.slices.map(function (e) {
                              return f(e[2]) ? [e[0], e[1], d(e[2], t.opts.limitLinebreaksCount)] : e;
                            })
                          : this.slices)
                      : null;
                  },
                },
                {
                  key: 'wipe',
                  value: function () {
                    this.slices = void 0;
                  },
                },
                {
                  key: 'replace',
                  value: function (t) {
                    if (Array.isArray(t) && t.length) {
                      if (!Array.isArray(t[0]) || !h(t[0][0]))
                        throw new Error(
                          'ranges-push/Ranges/replace(): [THROW_ID_11] Single range was given but we expected array of arrays! The first element, '.concat(
                            JSON.stringify(t[0], null, 4),
                            ' should be an array and its first element should be an integer, a string index.'
                          )
                        );
                      this.slices = Array.from(t);
                    } else this.slices = void 0;
                  },
                },
                {
                  key: 'last',
                  value: function () {
                    return void 0 !== this.slices && Array.isArray(this.slices) ? this.slices[this.slices.length - 1] : null;
                  },
                },
              ]) &&
                (function (t, e) {
                  for (var n = 0; n < e.length; n++) {
                    var r = e[n];
                    (r.enumerable = r.enumerable || !1), (r.configurable = !0), 'value' in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                  }
                })(e.prototype, n),
              e
            );
          })(),
          b = Function.prototype,
          w = Object.prototype,
          _ = b.toString,
          E = w.hasOwnProperty,
          k = _.call(Object),
          A = w.toString,
          T =
            ((v = Object.getPrototypeOf),
            (m = Object),
            function (t) {
              return v(m(t));
            }),
          x = function (e) {
            if (
              !(function (e) {
                return !!e && 'object' == t(e);
              })(e) ||
              '[object Object]' != A.call(e) ||
              (function (t) {
                var e = !1;
                if (null != t && 'function' != typeof t.toString)
                  try {
                    e = !!(t + '');
                  } catch (t) {}
                return e;
              })(e)
            )
              return !1;
            var n = T(e);
            if (null === n) return !0;
            var r = E.call(n, 'constructor') && n.constructor;
            return 'function' == typeof r && r instanceof r && _.call(r) == k;
          },
          S = 'undefined' != typeof globalThis ? globalThis : 'undefined' != typeof window ? window : void 0 !== e ? e : 'undefined' != typeof self ? self : {};
        function C(t) {
          return (t && t.default) || t;
        }
        var O = /^\s+|\s+$/g,
          L = '[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]',
          q = '\\ud83c[\\udffb-\\udfff]',
          D = '[^\\ud800-\\udfff]',
          P = '(?:\\ud83c[\\udde6-\\uddff]){2}',
          I = '[\\ud800-\\udbff][\\udc00-\\udfff]',
          M = '(?:' + L + '|' + q + ')?',
          N = '[\\ufe0e\\ufe0f]?' + M + '(?:\\u200d(?:' + [D, P, I].join('|') + ')[\\ufe0e\\ufe0f]?' + M + ')*',
          j = '(?:' + [D + L + '?', L, P, I, '[\\ud800-\\udfff]'].join('|') + ')',
          R = RegExp(q + '(?=' + q + ')|' + j + N, 'g'),
          B = RegExp('[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0\\ufe0e\\ufe0f]'),
          z = 'object' == t(S) && S && S.Object === Object && S,
          H = 'object' == ('undefined' == typeof self ? 'undefined' : t(self)) && self && self.Object === Object && self,
          F = z || H || Function('return this')();
        function V(t, e, n) {
          if (e != e)
            return (function (t, e, n, r) {
              for (var i = t.length, o = n + -1; ++o < i; ) if (e(t[o], o, t)) return o;
              return -1;
            })(t, U, n);
          for (var r = n - 1, i = t.length; ++r < i; ) if (t[r] === e) return r;
          return -1;
        }
        function U(t) {
          return t != t;
        }
        function W(t) {
          return (function (t) {
            return B.test(t);
          })(t)
            ? (function (t) {
                return t.match(R) || [];
              })(t)
            : (function (t) {
                return t.split('');
              })(t);
        }
        var G = Object.prototype.toString,
          $ = F.Symbol,
          J = $ ? $.prototype : void 0,
          Y = J ? J.toString : void 0;
        function Q(e) {
          if ('string' == typeof e) return e;
          if (
            (function (e) {
              return (
                'symbol' == t(e) ||
                ((function (e) {
                  return !!e && 'object' == t(e);
                })(e) &&
                  '[object Symbol]' == G.call(e))
              );
            })(e)
          )
            return Y ? Y.call(e) : '';
          var n = e + '';
          return '0' == n && 1 / e == -1 / 0 ? '-0' : n;
        }
        var X = function (t, e, n) {
            var r;
            if ((t = null == (r = t) ? '' : Q(r)) && (n || void 0 === e)) return t.replace(O, '');
            if (!t || !(e = Q(e))) return t;
            var i = W(t),
              o = W(e);
            return (function (t, e, n) {
              var r = t.length;
              return (
                (n = void 0 === n ? r : n),
                !e && n >= r
                  ? t
                  : (function (t, e, n) {
                      var r = -1,
                        i = t.length;
                      e < 0 && (e = -e > i ? 0 : i + e), (n = n > i ? i : n) < 0 && (n += i), (i = e > n ? 0 : (n - e) >>> 0), (e >>>= 0);
                      for (var o = Array(i); ++r < i; ) o[r] = t[r + e];
                      return o;
                    })(t, e, n)
              );
            })(
              i,
              (function (t, e) {
                for (var n = -1, r = t.length; ++n < r && V(e, t[n], 0) > -1; );
                return n;
              })(i, o),
              (function (t, e) {
                for (var n = t.length; n-- && V(e, t[n], 0) > -1; );
                return n;
              })(i, o) + 1
            ).join('');
          },
          Z = /^\[object .+?Constructor\]$/,
          K = 'object' == t(S) && S && S.Object === Object && S,
          tt = 'object' == ('undefined' == typeof self ? 'undefined' : t(self)) && self && self.Object === Object && self,
          et = K || tt || Function('return this')();
        function nt(t, e) {
          return (
            !(!t || !t.length) &&
            (function (t, e, n) {
              if (e != e)
                return (function (t, e, n, r) {
                  for (var i = t.length, o = -1; ++o < i; ) if (e(t[o], o, t)) return o;
                  return -1;
                })(t, rt);
              for (var r = -1, i = t.length; ++r < i; ) if (t[r] === e) return r;
              return -1;
            })(t, e) > -1
          );
        }
        function rt(t) {
          return t != t;
        }
        function it(t, e) {
          return t.has(e);
        }
        var ot,
          at = Array.prototype,
          st = Function.prototype,
          ct = Object.prototype,
          ut = et['__core-js_shared__'],
          lt = (ot = /[^.]+$/.exec((ut && ut.keys && ut.keys.IE_PROTO) || '')) ? 'Symbol(src)_1.' + ot : '',
          dt = st.toString,
          ft = ct.hasOwnProperty,
          ht = ct.toString,
          pt = RegExp(
            '^' +
              dt
                .call(ft)
                .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
                .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
              '$'
          ),
          gt = at.splice,
          vt = Math.max,
          mt = Tt(et, 'Map'),
          yt = Tt(Object, 'create');
        function bt(t) {
          var e = -1,
            n = t ? t.length : 0;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function wt(t) {
          var e = -1,
            n = t ? t.length : 0;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function _t(t) {
          var e = -1,
            n = t ? t.length : 0;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function Et(t) {
          var e = -1,
            n = t ? t.length : 0;
          for (this.__data__ = new _t(); ++e < n; ) this.add(t[e]);
        }
        function kt(t, e) {
          for (var n, r, i = t.length; i--; ) if ((n = t[i][0]) === (r = e) || (n != n && r != r)) return i;
          return -1;
        }
        function At(e, n) {
          var r,
            i,
            o = e.__data__;
          return ('string' == (i = t((r = n))) || 'number' == i || 'symbol' == i || 'boolean' == i ? '__proto__' !== r : null === r)
            ? o['string' == typeof n ? 'string' : 'hash']
            : o.map;
        }
        function Tt(t, e) {
          var n = (function (t, e) {
            return null == t ? void 0 : t[e];
          })(t, e);
          return (function (t) {
            return (
              !(
                !St(t) ||
                (function (t) {
                  return !!lt && lt in t;
                })(t)
              ) &&
              (xt(t) ||
              (function (t) {
                var e = !1;
                if (null != t && 'function' != typeof t.toString)
                  try {
                    e = !!(t + '');
                  } catch (t) {}
                return e;
              })(t)
                ? pt
                : Z
              ).test(
                (function (t) {
                  if (null != t) {
                    try {
                      return dt.call(t);
                    } catch (t) {}
                    try {
                      return t + '';
                    } catch (t) {}
                  }
                  return '';
                })(t)
              )
            );
          })(n)
            ? n
            : void 0;
        }
        function xt(t) {
          var e = St(t) ? ht.call(t) : '';
          return '[object Function]' == e || '[object GeneratorFunction]' == e;
        }
        function St(e) {
          var n = t(e);
          return !!e && ('object' == n || 'function' == n);
        }
        (bt.prototype.clear = function () {
          this.__data__ = yt ? yt(null) : {};
        }),
          (bt.prototype.delete = function (t) {
            return this.has(t) && delete this.__data__[t];
          }),
          (bt.prototype.get = function (t) {
            var e = this.__data__;
            if (yt) {
              var n = e[t];
              return '__lodash_hash_undefined__' === n ? void 0 : n;
            }
            return ft.call(e, t) ? e[t] : void 0;
          }),
          (bt.prototype.has = function (t) {
            var e = this.__data__;
            return yt ? void 0 !== e[t] : ft.call(e, t);
          }),
          (bt.prototype.set = function (t, e) {
            return (this.__data__[t] = yt && void 0 === e ? '__lodash_hash_undefined__' : e), this;
          }),
          (wt.prototype.clear = function () {
            this.__data__ = [];
          }),
          (wt.prototype.delete = function (t) {
            var e = this.__data__,
              n = kt(e, t);
            return !(n < 0 || (n == e.length - 1 ? e.pop() : gt.call(e, n, 1), 0));
          }),
          (wt.prototype.get = function (t) {
            var e = this.__data__,
              n = kt(e, t);
            return n < 0 ? void 0 : e[n][1];
          }),
          (wt.prototype.has = function (t) {
            return kt(this.__data__, t) > -1;
          }),
          (wt.prototype.set = function (t, e) {
            var n = this.__data__,
              r = kt(n, t);
            return r < 0 ? n.push([t, e]) : (n[r][1] = e), this;
          }),
          (_t.prototype.clear = function () {
            this.__data__ = { hash: new bt(), map: new (mt || wt)(), string: new bt() };
          }),
          (_t.prototype.delete = function (t) {
            return At(this, t).delete(t);
          }),
          (_t.prototype.get = function (t) {
            return At(this, t).get(t);
          }),
          (_t.prototype.has = function (t) {
            return At(this, t).has(t);
          }),
          (_t.prototype.set = function (t, e) {
            return At(this, t).set(t, e), this;
          }),
          (Et.prototype.add = Et.prototype.push =
            function (t) {
              return this.__data__.set(t, '__lodash_hash_undefined__'), this;
            }),
          (Et.prototype.has = function (t) {
            return this.__data__.has(t);
          });
        var Ct = (function (t, e) {
            return (
              (e = vt(void 0 === e ? t.length - 1 : e, 0)),
              function () {
                for (var n = arguments, r = -1, i = vt(n.length - e, 0), o = Array(i); ++r < i; ) o[r] = n[e + r];
                r = -1;
                for (var a = Array(e + 1); ++r < e; ) a[r] = n[r];
                return (
                  (a[e] = o),
                  (function (t, e, n) {
                    switch (n.length) {
                      case 0:
                        return t.call(e);
                      case 1:
                        return t.call(e, n[0]);
                      case 2:
                        return t.call(e, n[0], n[1]);
                      case 3:
                        return t.call(e, n[0], n[1], n[2]);
                    }
                    return t.apply(e, n);
                  })(t, this, a)
                );
              }
            );
          })(function (e, n) {
            return (function (e) {
              return !!e && 'object' == t(e);
            })((r = e)) &&
              (function (t) {
                return (
                  null != t &&
                  (function (t) {
                    return 'number' == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
                  })(t.length) &&
                  !xt(t)
                );
              })(r)
              ? (function (t, e, n, r) {
                  var i = -1,
                    o = nt,
                    a = !0,
                    s = t.length,
                    c = [],
                    u = e.length;
                  if (!s) return c;
                  e.length >= 200 && ((o = it), (a = !1), (e = new Et(e)));
                  t: for (; ++i < s; ) {
                    var l = t[i],
                      d = l;
                    if (((l = 0 !== l ? l : 0), a && d == d)) {
                      for (var f = u; f--; ) if (e[f] === d) continue t;
                      c.push(l);
                    } else o(e, d, r) || c.push(l);
                  }
                  return c;
                })(e, n)
              : [];
            var r;
          }),
          Ot = 2147483647,
          Lt = /^xn--/,
          qt = /[^\x20-\x7E]/,
          Dt = /[\x2E\u3002\uFF0E\uFF61]/g,
          Pt = { overflow: 'Overflow: input needs wider integers to process', 'not-basic': 'Illegal input >= 0x80 (not a basic code point)', 'invalid-input': 'Invalid input' },
          It = Math.floor,
          Mt = String.fromCharCode;
        function Nt(t) {
          throw new RangeError(Pt[t]);
        }
        function jt(t, e) {
          for (var n = t.length, r = []; n--; ) r[n] = e(t[n]);
          return r;
        }
        function Rt(t, e) {
          var n = t.split('@'),
            r = '';
          return n.length > 1 && ((r = n[0] + '@'), (t = n[1])), r + jt((t = t.replace(Dt, '.')).split('.'), e).join('.');
        }
        function Bt(t) {
          for (var e, n, r = [], i = 0, o = t.length; i < o; )
            (e = t.charCodeAt(i++)) >= 55296 && e <= 56319 && i < o
              ? 56320 == (64512 & (n = t.charCodeAt(i++)))
                ? r.push(((1023 & e) << 10) + (1023 & n) + 65536)
                : (r.push(e), i--)
              : r.push(e);
          return r;
        }
        function zt(t) {
          return jt(t, function (t) {
            var e = '';
            return t > 65535 && ((e += Mt((((t -= 65536) >>> 10) & 1023) | 55296)), (t = 56320 | (1023 & t))), e + Mt(t);
          }).join('');
        }
        function Ht(t, e) {
          return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
        }
        function Ft(t, e, n) {
          var r = 0;
          for (t = n ? It(t / 700) : t >> 1, t += It(t / e); t > 455; r += 36) t = It(t / 35);
          return It(r + (36 * t) / (t + 38));
        }
        function Vt(t) {
          var e,
            n,
            r,
            i,
            o,
            a,
            s,
            c,
            u,
            l,
            d,
            f = [],
            h = t.length,
            p = 0,
            g = 128,
            v = 72;
          for ((n = t.lastIndexOf('-')) < 0 && (n = 0), r = 0; r < n; ++r) t.charCodeAt(r) >= 128 && Nt('not-basic'), f.push(t.charCodeAt(r));
          for (i = n > 0 ? n + 1 : 0; i < h; ) {
            for (
              o = p, a = 1, s = 36;
              i >= h && Nt('invalid-input'),
                ((c = (d = t.charCodeAt(i++)) - 48 < 10 ? d - 22 : d - 65 < 26 ? d - 65 : d - 97 < 26 ? d - 97 : 36) >= 36 || c > It((Ot - p) / a)) && Nt('overflow'),
                (p += c * a),
                !(c < (u = s <= v ? 1 : s >= v + 26 ? 26 : s - v));
              s += 36
            )
              a > It(Ot / (l = 36 - u)) && Nt('overflow'), (a *= l);
            (v = Ft(p - o, (e = f.length + 1), 0 == o)), It(p / e) > Ot - g && Nt('overflow'), (g += It(p / e)), (p %= e), f.splice(p++, 0, g);
          }
          return zt(f);
        }
        function Ut(t) {
          var e,
            n,
            r,
            i,
            o,
            a,
            s,
            c,
            u,
            l,
            d,
            f,
            h,
            p,
            g,
            v = [];
          for (f = (t = Bt(t)).length, e = 128, n = 0, o = 72, a = 0; a < f; ++a) (d = t[a]) < 128 && v.push(Mt(d));
          for (r = i = v.length, i && v.push('-'); r < f; ) {
            for (s = Ot, a = 0; a < f; ++a) (d = t[a]) >= e && d < s && (s = d);
            for (s - e > It((Ot - n) / (h = r + 1)) && Nt('overflow'), n += (s - e) * h, e = s, a = 0; a < f; ++a)
              if (((d = t[a]) < e && ++n > Ot && Nt('overflow'), d == e)) {
                for (c = n, u = 36; !(c < (l = u <= o ? 1 : u >= o + 26 ? 26 : u - o)); u += 36) (g = c - l), (p = 36 - l), v.push(Mt(Ht(l + (g % p), 0))), (c = It(g / p));
                v.push(Mt(Ht(c, 0))), (o = Ft(n, h, r == i)), (n = 0), ++r;
              }
            ++n, ++e;
          }
          return v.join('');
        }
        var Wt = {
            version: '1.4.1',
            ucs2: { decode: Bt, encode: zt },
            toASCII: function (t) {
              return Rt(t, function (t) {
                return qt.test(t) ? 'xn--' + Ut(t) : t;
              });
            },
            toUnicode: function (t) {
              return Rt(t, function (t) {
                return Lt.test(t) ? Vt(t.slice(4).toLowerCase()) : t;
              });
            },
            encode: Ut,
            decode: Vt,
          },
          Gt =
            (C(
              Object.freeze({
                __proto__: null,
                default: {
                  9: 'Tab;',
                  10: 'NewLine;',
                  33: 'excl;',
                  34: 'quot;',
                  35: 'num;',
                  36: 'dollar;',
                  37: 'percnt;',
                  38: 'amp;',
                  39: 'apos;',
                  40: 'lpar;',
                  41: 'rpar;',
                  42: 'midast;',
                  43: 'plus;',
                  44: 'comma;',
                  46: 'period;',
                  47: 'sol;',
                  58: 'colon;',
                  59: 'semi;',
                  60: 'lt;',
                  61: 'equals;',
                  62: 'gt;',
                  63: 'quest;',
                  64: 'commat;',
                  91: 'lsqb;',
                  92: 'bsol;',
                  93: 'rsqb;',
                  94: 'Hat;',
                  95: 'UnderBar;',
                  96: 'grave;',
                  123: 'lcub;',
                  124: 'VerticalLine;',
                  125: 'rcub;',
                  160: 'NonBreakingSpace;',
                  161: 'iexcl;',
                  162: 'cent;',
                  163: 'pound;',
                  164: 'curren;',
                  165: 'yen;',
                  166: 'brvbar;',
                  167: 'sect;',
                  168: 'uml;',
                  169: 'copy;',
                  170: 'ordf;',
                  171: 'laquo;',
                  172: 'not;',
                  173: 'shy;',
                  174: 'reg;',
                  175: 'strns;',
                  176: 'deg;',
                  177: 'pm;',
                  178: 'sup2;',
                  179: 'sup3;',
                  180: 'DiacriticalAcute;',
                  181: 'micro;',
                  182: 'para;',
                  183: 'middot;',
                  184: 'Cedilla;',
                  185: 'sup1;',
                  186: 'ordm;',
                  187: 'raquo;',
                  188: 'frac14;',
                  189: 'half;',
                  190: 'frac34;',
                  191: 'iquest;',
                  192: 'Agrave;',
                  193: 'Aacute;',
                  194: 'Acirc;',
                  195: 'Atilde;',
                  196: 'Auml;',
                  197: 'Aring;',
                  198: 'AElig;',
                  199: 'Ccedil;',
                  200: 'Egrave;',
                  201: 'Eacute;',
                  202: 'Ecirc;',
                  203: 'Euml;',
                  204: 'Igrave;',
                  205: 'Iacute;',
                  206: 'Icirc;',
                  207: 'Iuml;',
                  208: 'ETH;',
                  209: 'Ntilde;',
                  210: 'Ograve;',
                  211: 'Oacute;',
                  212: 'Ocirc;',
                  213: 'Otilde;',
                  214: 'Ouml;',
                  215: 'times;',
                  216: 'Oslash;',
                  217: 'Ugrave;',
                  218: 'Uacute;',
                  219: 'Ucirc;',
                  220: 'Uuml;',
                  221: 'Yacute;',
                  222: 'THORN;',
                  223: 'szlig;',
                  224: 'agrave;',
                  225: 'aacute;',
                  226: 'acirc;',
                  227: 'atilde;',
                  228: 'auml;',
                  229: 'aring;',
                  230: 'aelig;',
                  231: 'ccedil;',
                  232: 'egrave;',
                  233: 'eacute;',
                  234: 'ecirc;',
                  235: 'euml;',
                  236: 'igrave;',
                  237: 'iacute;',
                  238: 'icirc;',
                  239: 'iuml;',
                  240: 'eth;',
                  241: 'ntilde;',
                  242: 'ograve;',
                  243: 'oacute;',
                  244: 'ocirc;',
                  245: 'otilde;',
                  246: 'ouml;',
                  247: 'divide;',
                  248: 'oslash;',
                  249: 'ugrave;',
                  250: 'uacute;',
                  251: 'ucirc;',
                  252: 'uuml;',
                  253: 'yacute;',
                  254: 'thorn;',
                  255: 'yuml;',
                  256: 'Amacr;',
                  257: 'amacr;',
                  258: 'Abreve;',
                  259: 'abreve;',
                  260: 'Aogon;',
                  261: 'aogon;',
                  262: 'Cacute;',
                  263: 'cacute;',
                  264: 'Ccirc;',
                  265: 'ccirc;',
                  266: 'Cdot;',
                  267: 'cdot;',
                  268: 'Ccaron;',
                  269: 'ccaron;',
                  270: 'Dcaron;',
                  271: 'dcaron;',
                  272: 'Dstrok;',
                  273: 'dstrok;',
                  274: 'Emacr;',
                  275: 'emacr;',
                  278: 'Edot;',
                  279: 'edot;',
                  280: 'Eogon;',
                  281: 'eogon;',
                  282: 'Ecaron;',
                  283: 'ecaron;',
                  284: 'Gcirc;',
                  285: 'gcirc;',
                  286: 'Gbreve;',
                  287: 'gbreve;',
                  288: 'Gdot;',
                  289: 'gdot;',
                  290: 'Gcedil;',
                  292: 'Hcirc;',
                  293: 'hcirc;',
                  294: 'Hstrok;',
                  295: 'hstrok;',
                  296: 'Itilde;',
                  297: 'itilde;',
                  298: 'Imacr;',
                  299: 'imacr;',
                  302: 'Iogon;',
                  303: 'iogon;',
                  304: 'Idot;',
                  305: 'inodot;',
                  306: 'IJlig;',
                  307: 'ijlig;',
                  308: 'Jcirc;',
                  309: 'jcirc;',
                  310: 'Kcedil;',
                  311: 'kcedil;',
                  312: 'kgreen;',
                  313: 'Lacute;',
                  314: 'lacute;',
                  315: 'Lcedil;',
                  316: 'lcedil;',
                  317: 'Lcaron;',
                  318: 'lcaron;',
                  319: 'Lmidot;',
                  320: 'lmidot;',
                  321: 'Lstrok;',
                  322: 'lstrok;',
                  323: 'Nacute;',
                  324: 'nacute;',
                  325: 'Ncedil;',
                  326: 'ncedil;',
                  327: 'Ncaron;',
                  328: 'ncaron;',
                  329: 'napos;',
                  330: 'ENG;',
                  331: 'eng;',
                  332: 'Omacr;',
                  333: 'omacr;',
                  336: 'Odblac;',
                  337: 'odblac;',
                  338: 'OElig;',
                  339: 'oelig;',
                  340: 'Racute;',
                  341: 'racute;',
                  342: 'Rcedil;',
                  343: 'rcedil;',
                  344: 'Rcaron;',
                  345: 'rcaron;',
                  346: 'Sacute;',
                  347: 'sacute;',
                  348: 'Scirc;',
                  349: 'scirc;',
                  350: 'Scedil;',
                  351: 'scedil;',
                  352: 'Scaron;',
                  353: 'scaron;',
                  354: 'Tcedil;',
                  355: 'tcedil;',
                  356: 'Tcaron;',
                  357: 'tcaron;',
                  358: 'Tstrok;',
                  359: 'tstrok;',
                  360: 'Utilde;',
                  361: 'utilde;',
                  362: 'Umacr;',
                  363: 'umacr;',
                  364: 'Ubreve;',
                  365: 'ubreve;',
                  366: 'Uring;',
                  367: 'uring;',
                  368: 'Udblac;',
                  369: 'udblac;',
                  370: 'Uogon;',
                  371: 'uogon;',
                  372: 'Wcirc;',
                  373: 'wcirc;',
                  374: 'Ycirc;',
                  375: 'ycirc;',
                  376: 'Yuml;',
                  377: 'Zacute;',
                  378: 'zacute;',
                  379: 'Zdot;',
                  380: 'zdot;',
                  381: 'Zcaron;',
                  382: 'zcaron;',
                  402: 'fnof;',
                  437: 'imped;',
                  501: 'gacute;',
                  567: 'jmath;',
                  710: 'circ;',
                  711: 'Hacek;',
                  728: 'breve;',
                  729: 'dot;',
                  730: 'ring;',
                  731: 'ogon;',
                  732: 'tilde;',
                  733: 'DiacriticalDoubleAcute;',
                  785: 'DownBreve;',
                  913: 'Alpha;',
                  914: 'Beta;',
                  915: 'Gamma;',
                  916: 'Delta;',
                  917: 'Epsilon;',
                  918: 'Zeta;',
                  919: 'Eta;',
                  920: 'Theta;',
                  921: 'Iota;',
                  922: 'Kappa;',
                  923: 'Lambda;',
                  924: 'Mu;',
                  925: 'Nu;',
                  926: 'Xi;',
                  927: 'Omicron;',
                  928: 'Pi;',
                  929: 'Rho;',
                  931: 'Sigma;',
                  932: 'Tau;',
                  933: 'Upsilon;',
                  934: 'Phi;',
                  935: 'Chi;',
                  936: 'Psi;',
                  937: 'Omega;',
                  945: 'alpha;',
                  946: 'beta;',
                  947: 'gamma;',
                  948: 'delta;',
                  949: 'epsilon;',
                  950: 'zeta;',
                  951: 'eta;',
                  952: 'theta;',
                  953: 'iota;',
                  954: 'kappa;',
                  955: 'lambda;',
                  956: 'mu;',
                  957: 'nu;',
                  958: 'xi;',
                  959: 'omicron;',
                  960: 'pi;',
                  961: 'rho;',
                  962: 'varsigma;',
                  963: 'sigma;',
                  964: 'tau;',
                  965: 'upsilon;',
                  966: 'phi;',
                  967: 'chi;',
                  968: 'psi;',
                  969: 'omega;',
                  977: 'vartheta;',
                  978: 'upsih;',
                  981: 'varphi;',
                  982: 'varpi;',
                  988: 'Gammad;',
                  989: 'gammad;',
                  1008: 'varkappa;',
                  1009: 'varrho;',
                  1013: 'varepsilon;',
                  1014: 'bepsi;',
                  1025: 'IOcy;',
                  1026: 'DJcy;',
                  1027: 'GJcy;',
                  1028: 'Jukcy;',
                  1029: 'DScy;',
                  1030: 'Iukcy;',
                  1031: 'YIcy;',
                  1032: 'Jsercy;',
                  1033: 'LJcy;',
                  1034: 'NJcy;',
                  1035: 'TSHcy;',
                  1036: 'KJcy;',
                  1038: 'Ubrcy;',
                  1039: 'DZcy;',
                  1040: 'Acy;',
                  1041: 'Bcy;',
                  1042: 'Vcy;',
                  1043: 'Gcy;',
                  1044: 'Dcy;',
                  1045: 'IEcy;',
                  1046: 'ZHcy;',
                  1047: 'Zcy;',
                  1048: 'Icy;',
                  1049: 'Jcy;',
                  1050: 'Kcy;',
                  1051: 'Lcy;',
                  1052: 'Mcy;',
                  1053: 'Ncy;',
                  1054: 'Ocy;',
                  1055: 'Pcy;',
                  1056: 'Rcy;',
                  1057: 'Scy;',
                  1058: 'Tcy;',
                  1059: 'Ucy;',
                  1060: 'Fcy;',
                  1061: 'KHcy;',
                  1062: 'TScy;',
                  1063: 'CHcy;',
                  1064: 'SHcy;',
                  1065: 'SHCHcy;',
                  1066: 'HARDcy;',
                  1067: 'Ycy;',
                  1068: 'SOFTcy;',
                  1069: 'Ecy;',
                  1070: 'YUcy;',
                  1071: 'YAcy;',
                  1072: 'acy;',
                  1073: 'bcy;',
                  1074: 'vcy;',
                  1075: 'gcy;',
                  1076: 'dcy;',
                  1077: 'iecy;',
                  1078: 'zhcy;',
                  1079: 'zcy;',
                  1080: 'icy;',
                  1081: 'jcy;',
                  1082: 'kcy;',
                  1083: 'lcy;',
                  1084: 'mcy;',
                  1085: 'ncy;',
                  1086: 'ocy;',
                  1087: 'pcy;',
                  1088: 'rcy;',
                  1089: 'scy;',
                  1090: 'tcy;',
                  1091: 'ucy;',
                  1092: 'fcy;',
                  1093: 'khcy;',
                  1094: 'tscy;',
                  1095: 'chcy;',
                  1096: 'shcy;',
                  1097: 'shchcy;',
                  1098: 'hardcy;',
                  1099: 'ycy;',
                  1100: 'softcy;',
                  1101: 'ecy;',
                  1102: 'yucy;',
                  1103: 'yacy;',
                  1105: 'iocy;',
                  1106: 'djcy;',
                  1107: 'gjcy;',
                  1108: 'jukcy;',
                  1109: 'dscy;',
                  1110: 'iukcy;',
                  1111: 'yicy;',
                  1112: 'jsercy;',
                  1113: 'ljcy;',
                  1114: 'njcy;',
                  1115: 'tshcy;',
                  1116: 'kjcy;',
                  1118: 'ubrcy;',
                  1119: 'dzcy;',
                  8194: 'ensp;',
                  8195: 'emsp;',
                  8196: 'emsp13;',
                  8197: 'emsp14;',
                  8199: 'numsp;',
                  8200: 'puncsp;',
                  8201: 'ThinSpace;',
                  8202: 'VeryThinSpace;',
                  8203: 'ZeroWidthSpace;',
                  8204: 'zwnj;',
                  8205: 'zwj;',
                  8206: 'lrm;',
                  8207: 'rlm;',
                  8208: 'hyphen;',
                  8211: 'ndash;',
                  8212: 'mdash;',
                  8213: 'horbar;',
                  8214: 'Vert;',
                  8216: 'OpenCurlyQuote;',
                  8217: 'rsquor;',
                  8218: 'sbquo;',
                  8220: 'OpenCurlyDoubleQuote;',
                  8221: 'rdquor;',
                  8222: 'ldquor;',
                  8224: 'dagger;',
                  8225: 'ddagger;',
                  8226: 'bullet;',
                  8229: 'nldr;',
                  8230: 'mldr;',
                  8240: 'permil;',
                  8241: 'pertenk;',
                  8242: 'prime;',
                  8243: 'Prime;',
                  8244: 'tprime;',
                  8245: 'bprime;',
                  8249: 'lsaquo;',
                  8250: 'rsaquo;',
                  8254: 'OverBar;',
                  8257: 'caret;',
                  8259: 'hybull;',
                  8260: 'frasl;',
                  8271: 'bsemi;',
                  8279: 'qprime;',
                  8287: 'MediumSpace;',
                  8288: 'NoBreak;',
                  8289: 'ApplyFunction;',
                  8290: 'it;',
                  8291: 'InvisibleComma;',
                  8364: 'euro;',
                  8411: 'TripleDot;',
                  8412: 'DotDot;',
                  8450: 'Copf;',
                  8453: 'incare;',
                  8458: 'gscr;',
                  8459: 'Hscr;',
                  8460: 'Poincareplane;',
                  8461: 'quaternions;',
                  8462: 'planckh;',
                  8463: 'plankv;',
                  8464: 'Iscr;',
                  8465: 'imagpart;',
                  8466: 'Lscr;',
                  8467: 'ell;',
                  8469: 'Nopf;',
                  8470: 'numero;',
                  8471: 'copysr;',
                  8472: 'wp;',
                  8473: 'primes;',
                  8474: 'rationals;',
                  8475: 'Rscr;',
                  8476: 'Rfr;',
                  8477: 'Ropf;',
                  8478: 'rx;',
                  8482: 'trade;',
                  8484: 'Zopf;',
                  8487: 'mho;',
                  8488: 'Zfr;',
                  8489: 'iiota;',
                  8492: 'Bscr;',
                  8493: 'Cfr;',
                  8495: 'escr;',
                  8496: 'expectation;',
                  8497: 'Fscr;',
                  8499: 'phmmat;',
                  8500: 'oscr;',
                  8501: 'aleph;',
                  8502: 'beth;',
                  8503: 'gimel;',
                  8504: 'daleth;',
                  8517: 'DD;',
                  8518: 'DifferentialD;',
                  8519: 'exponentiale;',
                  8520: 'ImaginaryI;',
                  8531: 'frac13;',
                  8532: 'frac23;',
                  8533: 'frac15;',
                  8534: 'frac25;',
                  8535: 'frac35;',
                  8536: 'frac45;',
                  8537: 'frac16;',
                  8538: 'frac56;',
                  8539: 'frac18;',
                  8540: 'frac38;',
                  8541: 'frac58;',
                  8542: 'frac78;',
                  8592: 'slarr;',
                  8593: 'uparrow;',
                  8594: 'srarr;',
                  8595: 'ShortDownArrow;',
                  8596: 'leftrightarrow;',
                  8597: 'varr;',
                  8598: 'UpperLeftArrow;',
                  8599: 'UpperRightArrow;',
                  8600: 'searrow;',
                  8601: 'swarrow;',
                  8602: 'nleftarrow;',
                  8603: 'nrightarrow;',
                  8605: 'rightsquigarrow;',
                  8606: 'twoheadleftarrow;',
                  8607: 'Uarr;',
                  8608: 'twoheadrightarrow;',
                  8609: 'Darr;',
                  8610: 'leftarrowtail;',
                  8611: 'rightarrowtail;',
                  8612: 'mapstoleft;',
                  8613: 'UpTeeArrow;',
                  8614: 'RightTeeArrow;',
                  8615: 'mapstodown;',
                  8617: 'larrhk;',
                  8618: 'rarrhk;',
                  8619: 'looparrowleft;',
                  8620: 'rarrlp;',
                  8621: 'leftrightsquigarrow;',
                  8622: 'nleftrightarrow;',
                  8624: 'lsh;',
                  8625: 'rsh;',
                  8626: 'ldsh;',
                  8627: 'rdsh;',
                  8629: 'crarr;',
                  8630: 'curvearrowleft;',
                  8631: 'curvearrowright;',
                  8634: 'olarr;',
                  8635: 'orarr;',
                  8636: 'lharu;',
                  8637: 'lhard;',
                  8638: 'upharpoonright;',
                  8639: 'upharpoonleft;',
                  8640: 'RightVector;',
                  8641: 'rightharpoondown;',
                  8642: 'RightDownVector;',
                  8643: 'LeftDownVector;',
                  8644: 'rlarr;',
                  8645: 'UpArrowDownArrow;',
                  8646: 'lrarr;',
                  8647: 'llarr;',
                  8648: 'uuarr;',
                  8649: 'rrarr;',
                  8650: 'downdownarrows;',
                  8651: 'ReverseEquilibrium;',
                  8652: 'rlhar;',
                  8653: 'nLeftarrow;',
                  8654: 'nLeftrightarrow;',
                  8655: 'nRightarrow;',
                  8656: 'Leftarrow;',
                  8657: 'Uparrow;',
                  8658: 'Rightarrow;',
                  8659: 'Downarrow;',
                  8660: 'Leftrightarrow;',
                  8661: 'vArr;',
                  8662: 'nwArr;',
                  8663: 'neArr;',
                  8664: 'seArr;',
                  8665: 'swArr;',
                  8666: 'Lleftarrow;',
                  8667: 'Rrightarrow;',
                  8669: 'zigrarr;',
                  8676: 'LeftArrowBar;',
                  8677: 'RightArrowBar;',
                  8693: 'duarr;',
                  8701: 'loarr;',
                  8702: 'roarr;',
                  8703: 'hoarr;',
                  8704: 'forall;',
                  8705: 'complement;',
                  8706: 'PartialD;',
                  8707: 'Exists;',
                  8708: 'NotExists;',
                  8709: 'varnothing;',
                  8711: 'nabla;',
                  8712: 'isinv;',
                  8713: 'notinva;',
                  8715: 'SuchThat;',
                  8716: 'NotReverseElement;',
                  8719: 'Product;',
                  8720: 'Coproduct;',
                  8721: 'sum;',
                  8722: 'minus;',
                  8723: 'mp;',
                  8724: 'plusdo;',
                  8726: 'ssetmn;',
                  8727: 'lowast;',
                  8728: 'SmallCircle;',
                  8730: 'Sqrt;',
                  8733: 'vprop;',
                  8734: 'infin;',
                  8735: 'angrt;',
                  8736: 'angle;',
                  8737: 'measuredangle;',
                  8738: 'angsph;',
                  8739: 'VerticalBar;',
                  8740: 'nsmid;',
                  8741: 'spar;',
                  8742: 'nspar;',
                  8743: 'wedge;',
                  8744: 'vee;',
                  8745: 'cap;',
                  8746: 'cup;',
                  8747: 'Integral;',
                  8748: 'Int;',
                  8749: 'tint;',
                  8750: 'oint;',
                  8751: 'DoubleContourIntegral;',
                  8752: 'Cconint;',
                  8753: 'cwint;',
                  8754: 'cwconint;',
                  8755: 'CounterClockwiseContourIntegral;',
                  8756: 'therefore;',
                  8757: 'because;',
                  8758: 'ratio;',
                  8759: 'Proportion;',
                  8760: 'minusd;',
                  8762: 'mDDot;',
                  8763: 'homtht;',
                  8764: 'Tilde;',
                  8765: 'bsim;',
                  8766: 'mstpos;',
                  8767: 'acd;',
                  8768: 'wreath;',
                  8769: 'nsim;',
                  8770: 'esim;',
                  8771: 'TildeEqual;',
                  8772: 'nsimeq;',
                  8773: 'TildeFullEqual;',
                  8774: 'simne;',
                  8775: 'NotTildeFullEqual;',
                  8776: 'TildeTilde;',
                  8777: 'NotTildeTilde;',
                  8778: 'approxeq;',
                  8779: 'apid;',
                  8780: 'bcong;',
                  8781: 'CupCap;',
                  8782: 'HumpDownHump;',
                  8783: 'HumpEqual;',
                  8784: 'esdot;',
                  8785: 'eDot;',
                  8786: 'fallingdotseq;',
                  8787: 'risingdotseq;',
                  8788: 'coloneq;',
                  8789: 'eqcolon;',
                  8790: 'eqcirc;',
                  8791: 'cire;',
                  8793: 'wedgeq;',
                  8794: 'veeeq;',
                  8796: 'trie;',
                  8799: 'questeq;',
                  8800: 'NotEqual;',
                  8801: 'equiv;',
                  8802: 'NotCongruent;',
                  8804: 'leq;',
                  8805: 'GreaterEqual;',
                  8806: 'LessFullEqual;',
                  8807: 'GreaterFullEqual;',
                  8808: 'lneqq;',
                  8809: 'gneqq;',
                  8810: 'NestedLessLess;',
                  8811: 'NestedGreaterGreater;',
                  8812: 'twixt;',
                  8813: 'NotCupCap;',
                  8814: 'NotLess;',
                  8815: 'NotGreater;',
                  8816: 'NotLessEqual;',
                  8817: 'NotGreaterEqual;',
                  8818: 'lsim;',
                  8819: 'gtrsim;',
                  8820: 'NotLessTilde;',
                  8821: 'NotGreaterTilde;',
                  8822: 'lg;',
                  8823: 'gtrless;',
                  8824: 'ntlg;',
                  8825: 'ntgl;',
                  8826: 'Precedes;',
                  8827: 'Succeeds;',
                  8828: 'PrecedesSlantEqual;',
                  8829: 'SucceedsSlantEqual;',
                  8830: 'prsim;',
                  8831: 'succsim;',
                  8832: 'nprec;',
                  8833: 'nsucc;',
                  8834: 'subset;',
                  8835: 'supset;',
                  8836: 'nsub;',
                  8837: 'nsup;',
                  8838: 'SubsetEqual;',
                  8839: 'supseteq;',
                  8840: 'nsubseteq;',
                  8841: 'nsupseteq;',
                  8842: 'subsetneq;',
                  8843: 'supsetneq;',
                  8845: 'cupdot;',
                  8846: 'uplus;',
                  8847: 'SquareSubset;',
                  8848: 'SquareSuperset;',
                  8849: 'SquareSubsetEqual;',
                  8850: 'SquareSupersetEqual;',
                  8851: 'SquareIntersection;',
                  8852: 'SquareUnion;',
                  8853: 'oplus;',
                  8854: 'ominus;',
                  8855: 'otimes;',
                  8856: 'osol;',
                  8857: 'odot;',
                  8858: 'ocir;',
                  8859: 'oast;',
                  8861: 'odash;',
                  8862: 'plusb;',
                  8863: 'minusb;',
                  8864: 'timesb;',
                  8865: 'sdotb;',
                  8866: 'vdash;',
                  8867: 'LeftTee;',
                  8868: 'top;',
                  8869: 'UpTee;',
                  8871: 'models;',
                  8872: 'vDash;',
                  8873: 'Vdash;',
                  8874: 'Vvdash;',
                  8875: 'VDash;',
                  8876: 'nvdash;',
                  8877: 'nvDash;',
                  8878: 'nVdash;',
                  8879: 'nVDash;',
                  8880: 'prurel;',
                  8882: 'vltri;',
                  8883: 'vrtri;',
                  8884: 'trianglelefteq;',
                  8885: 'trianglerighteq;',
                  8886: 'origof;',
                  8887: 'imof;',
                  8888: 'mumap;',
                  8889: 'hercon;',
                  8890: 'intercal;',
                  8891: 'veebar;',
                  8893: 'barvee;',
                  8894: 'angrtvb;',
                  8895: 'lrtri;',
                  8896: 'xwedge;',
                  8897: 'xvee;',
                  8898: 'xcap;',
                  8899: 'xcup;',
                  8900: 'diamond;',
                  8901: 'sdot;',
                  8902: 'Star;',
                  8903: 'divonx;',
                  8904: 'bowtie;',
                  8905: 'ltimes;',
                  8906: 'rtimes;',
                  8907: 'lthree;',
                  8908: 'rthree;',
                  8909: 'bsime;',
                  8910: 'cuvee;',
                  8911: 'cuwed;',
                  8912: 'Subset;',
                  8913: 'Supset;',
                  8914: 'Cap;',
                  8915: 'Cup;',
                  8916: 'pitchfork;',
                  8917: 'epar;',
                  8918: 'ltdot;',
                  8919: 'gtrdot;',
                  8920: 'Ll;',
                  8921: 'ggg;',
                  8922: 'LessEqualGreater;',
                  8923: 'gtreqless;',
                  8926: 'curlyeqprec;',
                  8927: 'curlyeqsucc;',
                  8928: 'nprcue;',
                  8929: 'nsccue;',
                  8930: 'nsqsube;',
                  8931: 'nsqsupe;',
                  8934: 'lnsim;',
                  8935: 'gnsim;',
                  8936: 'prnsim;',
                  8937: 'succnsim;',
                  8938: 'ntriangleleft;',
                  8939: 'ntriangleright;',
                  8940: 'ntrianglelefteq;',
                  8941: 'ntrianglerighteq;',
                  8942: 'vellip;',
                  8943: 'ctdot;',
                  8944: 'utdot;',
                  8945: 'dtdot;',
                  8946: 'disin;',
                  8947: 'isinsv;',
                  8948: 'isins;',
                  8949: 'isindot;',
                  8950: 'notinvc;',
                  8951: 'notinvb;',
                  8953: 'isinE;',
                  8954: 'nisd;',
                  8955: 'xnis;',
                  8956: 'nis;',
                  8957: 'notnivc;',
                  8958: 'notnivb;',
                  8965: 'barwedge;',
                  8966: 'doublebarwedge;',
                  8968: 'LeftCeiling;',
                  8969: 'RightCeiling;',
                  8970: 'lfloor;',
                  8971: 'RightFloor;',
                  8972: 'drcrop;',
                  8973: 'dlcrop;',
                  8974: 'urcrop;',
                  8975: 'ulcrop;',
                  8976: 'bnot;',
                  8978: 'profline;',
                  8979: 'profsurf;',
                  8981: 'telrec;',
                  8982: 'target;',
                  8988: 'ulcorner;',
                  8989: 'urcorner;',
                  8990: 'llcorner;',
                  8991: 'lrcorner;',
                  8994: 'sfrown;',
                  8995: 'ssmile;',
                  9005: 'cylcty;',
                  9006: 'profalar;',
                  9014: 'topbot;',
                  9021: 'ovbar;',
                  9023: 'solbar;',
                  9084: 'angzarr;',
                  9136: 'lmoustache;',
                  9137: 'rmoustache;',
                  9140: 'tbrk;',
                  9141: 'UnderBracket;',
                  9142: 'bbrktbrk;',
                  9180: 'OverParenthesis;',
                  9181: 'UnderParenthesis;',
                  9182: 'OverBrace;',
                  9183: 'UnderBrace;',
                  9186: 'trpezium;',
                  9191: 'elinters;',
                  9251: 'blank;',
                  9416: 'oS;',
                  9472: 'HorizontalLine;',
                  9474: 'boxv;',
                  9484: 'boxdr;',
                  9488: 'boxdl;',
                  9492: 'boxur;',
                  9496: 'boxul;',
                  9500: 'boxvr;',
                  9508: 'boxvl;',
                  9516: 'boxhd;',
                  9524: 'boxhu;',
                  9532: 'boxvh;',
                  9552: 'boxH;',
                  9553: 'boxV;',
                  9554: 'boxdR;',
                  9555: 'boxDr;',
                  9556: 'boxDR;',
                  9557: 'boxdL;',
                  9558: 'boxDl;',
                  9559: 'boxDL;',
                  9560: 'boxuR;',
                  9561: 'boxUr;',
                  9562: 'boxUR;',
                  9563: 'boxuL;',
                  9564: 'boxUl;',
                  9565: 'boxUL;',
                  9566: 'boxvR;',
                  9567: 'boxVr;',
                  9568: 'boxVR;',
                  9569: 'boxvL;',
                  9570: 'boxVl;',
                  9571: 'boxVL;',
                  9572: 'boxHd;',
                  9573: 'boxhD;',
                  9574: 'boxHD;',
                  9575: 'boxHu;',
                  9576: 'boxhU;',
                  9577: 'boxHU;',
                  9578: 'boxvH;',
                  9579: 'boxVh;',
                  9580: 'boxVH;',
                  9600: 'uhblk;',
                  9604: 'lhblk;',
                  9608: 'block;',
                  9617: 'blk14;',
                  9618: 'blk12;',
                  9619: 'blk34;',
                  9633: 'square;',
                  9642: 'squf;',
                  9643: 'EmptyVerySmallSquare;',
                  9645: 'rect;',
                  9646: 'marker;',
                  9649: 'fltns;',
                  9651: 'xutri;',
                  9652: 'utrif;',
                  9653: 'utri;',
                  9656: 'rtrif;',
                  9657: 'triangleright;',
                  9661: 'xdtri;',
                  9662: 'dtrif;',
                  9663: 'triangledown;',
                  9666: 'ltrif;',
                  9667: 'triangleleft;',
                  9674: 'lozenge;',
                  9675: 'cir;',
                  9708: 'tridot;',
                  9711: 'xcirc;',
                  9720: 'ultri;',
                  9721: 'urtri;',
                  9722: 'lltri;',
                  9723: 'EmptySmallSquare;',
                  9724: 'FilledSmallSquare;',
                  9733: 'starf;',
                  9734: 'star;',
                  9742: 'phone;',
                  9792: 'female;',
                  9794: 'male;',
                  9824: 'spadesuit;',
                  9827: 'clubsuit;',
                  9829: 'heartsuit;',
                  9830: 'diams;',
                  9834: 'sung;',
                  9837: 'flat;',
                  9838: 'natural;',
                  9839: 'sharp;',
                  10003: 'checkmark;',
                  10007: 'cross;',
                  10016: 'maltese;',
                  10038: 'sext;',
                  10072: 'VerticalSeparator;',
                  10098: 'lbbrk;',
                  10099: 'rbbrk;',
                  10184: 'bsolhsub;',
                  10185: 'suphsol;',
                  10214: 'lobrk;',
                  10215: 'robrk;',
                  10216: 'LeftAngleBracket;',
                  10217: 'RightAngleBracket;',
                  10218: 'Lang;',
                  10219: 'Rang;',
                  10220: 'loang;',
                  10221: 'roang;',
                  10229: 'xlarr;',
                  10230: 'xrarr;',
                  10231: 'xharr;',
                  10232: 'xlArr;',
                  10233: 'xrArr;',
                  10234: 'xhArr;',
                  10236: 'xmap;',
                  10239: 'dzigrarr;',
                  10498: 'nvlArr;',
                  10499: 'nvrArr;',
                  10500: 'nvHarr;',
                  10501: 'Map;',
                  10508: 'lbarr;',
                  10509: 'rbarr;',
                  10510: 'lBarr;',
                  10511: 'rBarr;',
                  10512: 'RBarr;',
                  10513: 'DDotrahd;',
                  10514: 'UpArrowBar;',
                  10515: 'DownArrowBar;',
                  10518: 'Rarrtl;',
                  10521: 'latail;',
                  10522: 'ratail;',
                  10523: 'lAtail;',
                  10524: 'rAtail;',
                  10525: 'larrfs;',
                  10526: 'rarrfs;',
                  10527: 'larrbfs;',
                  10528: 'rarrbfs;',
                  10531: 'nwarhk;',
                  10532: 'nearhk;',
                  10533: 'searhk;',
                  10534: 'swarhk;',
                  10535: 'nwnear;',
                  10536: 'toea;',
                  10537: 'tosa;',
                  10538: 'swnwar;',
                  10547: 'rarrc;',
                  10549: 'cudarrr;',
                  10550: 'ldca;',
                  10551: 'rdca;',
                  10552: 'cudarrl;',
                  10553: 'larrpl;',
                  10556: 'curarrm;',
                  10557: 'cularrp;',
                  10565: 'rarrpl;',
                  10568: 'harrcir;',
                  10569: 'Uarrocir;',
                  10570: 'lurdshar;',
                  10571: 'ldrushar;',
                  10574: 'LeftRightVector;',
                  10575: 'RightUpDownVector;',
                  10576: 'DownLeftRightVector;',
                  10577: 'LeftUpDownVector;',
                  10578: 'LeftVectorBar;',
                  10579: 'RightVectorBar;',
                  10580: 'RightUpVectorBar;',
                  10581: 'RightDownVectorBar;',
                  10582: 'DownLeftVectorBar;',
                  10583: 'DownRightVectorBar;',
                  10584: 'LeftUpVectorBar;',
                  10585: 'LeftDownVectorBar;',
                  10586: 'LeftTeeVector;',
                  10587: 'RightTeeVector;',
                  10588: 'RightUpTeeVector;',
                  10589: 'RightDownTeeVector;',
                  10590: 'DownLeftTeeVector;',
                  10591: 'DownRightTeeVector;',
                  10592: 'LeftUpTeeVector;',
                  10593: 'LeftDownTeeVector;',
                  10594: 'lHar;',
                  10595: 'uHar;',
                  10596: 'rHar;',
                  10597: 'dHar;',
                  10598: 'luruhar;',
                  10599: 'ldrdhar;',
                  10600: 'ruluhar;',
                  10601: 'rdldhar;',
                  10602: 'lharul;',
                  10603: 'llhard;',
                  10604: 'rharul;',
                  10605: 'lrhard;',
                  10606: 'UpEquilibrium;',
                  10607: 'ReverseUpEquilibrium;',
                  10608: 'RoundImplies;',
                  10609: 'erarr;',
                  10610: 'simrarr;',
                  10611: 'larrsim;',
                  10612: 'rarrsim;',
                  10613: 'rarrap;',
                  10614: 'ltlarr;',
                  10616: 'gtrarr;',
                  10617: 'subrarr;',
                  10619: 'suplarr;',
                  10620: 'lfisht;',
                  10621: 'rfisht;',
                  10622: 'ufisht;',
                  10623: 'dfisht;',
                  10629: 'lopar;',
                  10630: 'ropar;',
                  10635: 'lbrke;',
                  10636: 'rbrke;',
                  10637: 'lbrkslu;',
                  10638: 'rbrksld;',
                  10639: 'lbrksld;',
                  10640: 'rbrkslu;',
                  10641: 'langd;',
                  10642: 'rangd;',
                  10643: 'lparlt;',
                  10644: 'rpargt;',
                  10645: 'gtlPar;',
                  10646: 'ltrPar;',
                  10650: 'vzigzag;',
                  10652: 'vangrt;',
                  10653: 'angrtvbd;',
                  10660: 'ange;',
                  10661: 'range;',
                  10662: 'dwangle;',
                  10663: 'uwangle;',
                  10664: 'angmsdaa;',
                  10665: 'angmsdab;',
                  10666: 'angmsdac;',
                  10667: 'angmsdad;',
                  10668: 'angmsdae;',
                  10669: 'angmsdaf;',
                  10670: 'angmsdag;',
                  10671: 'angmsdah;',
                  10672: 'bemptyv;',
                  10673: 'demptyv;',
                  10674: 'cemptyv;',
                  10675: 'raemptyv;',
                  10676: 'laemptyv;',
                  10677: 'ohbar;',
                  10678: 'omid;',
                  10679: 'opar;',
                  10681: 'operp;',
                  10683: 'olcross;',
                  10684: 'odsold;',
                  10686: 'olcir;',
                  10687: 'ofcir;',
                  10688: 'olt;',
                  10689: 'ogt;',
                  10690: 'cirscir;',
                  10691: 'cirE;',
                  10692: 'solb;',
                  10693: 'bsolb;',
                  10697: 'boxbox;',
                  10701: 'trisb;',
                  10702: 'rtriltri;',
                  10703: 'LeftTriangleBar;',
                  10704: 'RightTriangleBar;',
                  10716: 'iinfin;',
                  10717: 'infintie;',
                  10718: 'nvinfin;',
                  10723: 'eparsl;',
                  10724: 'smeparsl;',
                  10725: 'eqvparsl;',
                  10731: 'lozf;',
                  10740: 'RuleDelayed;',
                  10742: 'dsol;',
                  10752: 'xodot;',
                  10753: 'xoplus;',
                  10754: 'xotime;',
                  10756: 'xuplus;',
                  10758: 'xsqcup;',
                  10764: 'qint;',
                  10765: 'fpartint;',
                  10768: 'cirfnint;',
                  10769: 'awint;',
                  10770: 'rppolint;',
                  10771: 'scpolint;',
                  10772: 'npolint;',
                  10773: 'pointint;',
                  10774: 'quatint;',
                  10775: 'intlarhk;',
                  10786: 'pluscir;',
                  10787: 'plusacir;',
                  10788: 'simplus;',
                  10789: 'plusdu;',
                  10790: 'plussim;',
                  10791: 'plustwo;',
                  10793: 'mcomma;',
                  10794: 'minusdu;',
                  10797: 'loplus;',
                  10798: 'roplus;',
                  10799: 'Cross;',
                  10800: 'timesd;',
                  10801: 'timesbar;',
                  10803: 'smashp;',
                  10804: 'lotimes;',
                  10805: 'rotimes;',
                  10806: 'otimesas;',
                  10807: 'Otimes;',
                  10808: 'odiv;',
                  10809: 'triplus;',
                  10810: 'triminus;',
                  10811: 'tritime;',
                  10812: 'iprod;',
                  10815: 'amalg;',
                  10816: 'capdot;',
                  10818: 'ncup;',
                  10819: 'ncap;',
                  10820: 'capand;',
                  10821: 'cupor;',
                  10822: 'cupcap;',
                  10823: 'capcup;',
                  10824: 'cupbrcap;',
                  10825: 'capbrcup;',
                  10826: 'cupcup;',
                  10827: 'capcap;',
                  10828: 'ccups;',
                  10829: 'ccaps;',
                  10832: 'ccupssm;',
                  10835: 'And;',
                  10836: 'Or;',
                  10837: 'andand;',
                  10838: 'oror;',
                  10839: 'orslope;',
                  10840: 'andslope;',
                  10842: 'andv;',
                  10843: 'orv;',
                  10844: 'andd;',
                  10845: 'ord;',
                  10847: 'wedbar;',
                  10854: 'sdote;',
                  10858: 'simdot;',
                  10861: 'congdot;',
                  10862: 'easter;',
                  10863: 'apacir;',
                  10864: 'apE;',
                  10865: 'eplus;',
                  10866: 'pluse;',
                  10867: 'Esim;',
                  10868: 'Colone;',
                  10869: 'Equal;',
                  10871: 'eDDot;',
                  10872: 'equivDD;',
                  10873: 'ltcir;',
                  10874: 'gtcir;',
                  10875: 'ltquest;',
                  10876: 'gtquest;',
                  10877: 'LessSlantEqual;',
                  10878: 'GreaterSlantEqual;',
                  10879: 'lesdot;',
                  10880: 'gesdot;',
                  10881: 'lesdoto;',
                  10882: 'gesdoto;',
                  10883: 'lesdotor;',
                  10884: 'gesdotol;',
                  10885: 'lessapprox;',
                  10886: 'gtrapprox;',
                  10887: 'lneq;',
                  10888: 'gneq;',
                  10889: 'lnapprox;',
                  10890: 'gnapprox;',
                  10891: 'lesseqqgtr;',
                  10892: 'gtreqqless;',
                  10893: 'lsime;',
                  10894: 'gsime;',
                  10895: 'lsimg;',
                  10896: 'gsiml;',
                  10897: 'lgE;',
                  10898: 'glE;',
                  10899: 'lesges;',
                  10900: 'gesles;',
                  10901: 'eqslantless;',
                  10902: 'eqslantgtr;',
                  10903: 'elsdot;',
                  10904: 'egsdot;',
                  10905: 'el;',
                  10906: 'eg;',
                  10909: 'siml;',
                  10910: 'simg;',
                  10911: 'simlE;',
                  10912: 'simgE;',
                  10913: 'LessLess;',
                  10914: 'GreaterGreater;',
                  10916: 'glj;',
                  10917: 'gla;',
                  10918: 'ltcc;',
                  10919: 'gtcc;',
                  10920: 'lescc;',
                  10921: 'gescc;',
                  10922: 'smt;',
                  10923: 'lat;',
                  10924: 'smte;',
                  10925: 'late;',
                  10926: 'bumpE;',
                  10927: 'preceq;',
                  10928: 'succeq;',
                  10931: 'prE;',
                  10932: 'scE;',
                  10933: 'prnE;',
                  10934: 'succneqq;',
                  10935: 'precapprox;',
                  10936: 'succapprox;',
                  10937: 'prnap;',
                  10938: 'succnapprox;',
                  10939: 'Pr;',
                  10940: 'Sc;',
                  10941: 'subdot;',
                  10942: 'supdot;',
                  10943: 'subplus;',
                  10944: 'supplus;',
                  10945: 'submult;',
                  10946: 'supmult;',
                  10947: 'subedot;',
                  10948: 'supedot;',
                  10949: 'subseteqq;',
                  10950: 'supseteqq;',
                  10951: 'subsim;',
                  10952: 'supsim;',
                  10955: 'subsetneqq;',
                  10956: 'supsetneqq;',
                  10959: 'csub;',
                  10960: 'csup;',
                  10961: 'csube;',
                  10962: 'csupe;',
                  10963: 'subsup;',
                  10964: 'supsub;',
                  10965: 'subsub;',
                  10966: 'supsup;',
                  10967: 'suphsub;',
                  10968: 'supdsub;',
                  10969: 'forkv;',
                  10970: 'topfork;',
                  10971: 'mlcp;',
                  10980: 'DoubleLeftTee;',
                  10982: 'Vdashl;',
                  10983: 'Barv;',
                  10984: 'vBar;',
                  10985: 'vBarv;',
                  10987: 'Vbar;',
                  10988: 'Not;',
                  10989: 'bNot;',
                  10990: 'rnmid;',
                  10991: 'cirmid;',
                  10992: 'midcir;',
                  10993: 'topcir;',
                  10994: 'nhpar;',
                  10995: 'parsim;',
                  11005: 'parsl;',
                  64256: 'fflig;',
                  64257: 'filig;',
                  64258: 'fllig;',
                  64259: 'ffilig;',
                  64260: 'ffllig;',
                },
              })
            ),
            C(
              Object.freeze({
                __proto__: null,
                Aacute: 'Á',
                aacute: 'á',
                Acirc: 'Â',
                acirc: 'â',
                acute: '´',
                AElig: 'Æ',
                aelig: 'æ',
                Agrave: 'À',
                agrave: 'à',
                AMP: '&',
                amp: '&',
                Aring: 'Å',
                aring: 'å',
                Atilde: 'Ã',
                atilde: 'ã',
                Auml: 'Ä',
                auml: 'ä',
                brvbar: '¦',
                Ccedil: 'Ç',
                ccedil: 'ç',
                cedil: '¸',
                cent: '¢',
                COPY: '©',
                copy: '©',
                curren: '¤',
                deg: '°',
                divide: '÷',
                Eacute: 'É',
                eacute: 'é',
                Ecirc: 'Ê',
                ecirc: 'ê',
                Egrave: 'È',
                egrave: 'è',
                ETH: 'Ð',
                eth: 'ð',
                Euml: 'Ë',
                euml: 'ë',
                frac12: '½',
                frac14: '¼',
                frac34: '¾',
                GT: '>',
                gt: '>',
                Iacute: 'Í',
                iacute: 'í',
                Icirc: 'Î',
                icirc: 'î',
                iexcl: '¡',
                Igrave: 'Ì',
                igrave: 'ì',
                iquest: '¿',
                Iuml: 'Ï',
                iuml: 'ï',
                laquo: '«',
                LT: '<',
                lt: '<',
                macr: '¯',
                micro: 'µ',
                middot: '·',
                nbsp: ' ',
                not: '¬',
                Ntilde: 'Ñ',
                ntilde: 'ñ',
                Oacute: 'Ó',
                oacute: 'ó',
                Ocirc: 'Ô',
                ocirc: 'ô',
                Ograve: 'Ò',
                ograve: 'ò',
                ordf: 'ª',
                ordm: 'º',
                Oslash: 'Ø',
                oslash: 'ø',
                Otilde: 'Õ',
                otilde: 'õ',
                Ouml: 'Ö',
                ouml: 'ö',
                para: '¶',
                plusmn: '±',
                pound: '£',
                QUOT: '"',
                quot: '"',
                raquo: '»',
                REG: '®',
                reg: '®',
                sect: '§',
                shy: '­',
                sup1: '¹',
                sup2: '²',
                sup3: '³',
                szlig: 'ß',
                THORN: 'Þ',
                thorn: 'þ',
                times: '×',
                Uacute: 'Ú',
                uacute: 'ú',
                Ucirc: 'Û',
                ucirc: 'û',
                Ugrave: 'Ù',
                ugrave: 'ù',
                uml: '¨',
                Uuml: 'Ü',
                uuml: 'ü',
                Yacute: 'Ý',
                yacute: 'ý',
                yen: '¥',
                yuml: 'ÿ',
                default: {
                  'Aacute;': 'Á',
                  Aacute: 'Á',
                  'aacute;': 'á',
                  aacute: 'á',
                  'Abreve;': 'Ă',
                  'abreve;': 'ă',
                  'ac;': '∾',
                  'acd;': '∿',
                  'acE;': '∾̳',
                  'Acirc;': 'Â',
                  Acirc: 'Â',
                  'acirc;': 'â',
                  acirc: 'â',
                  'acute;': '´',
                  acute: '´',
                  'Acy;': 'А',
                  'acy;': 'а',
                  'AElig;': 'Æ',
                  AElig: 'Æ',
                  'aelig;': 'æ',
                  aelig: 'æ',
                  'af;': '⁡',
                  'Afr;': '𝔄',
                  'afr;': '𝔞',
                  'Agrave;': 'À',
                  Agrave: 'À',
                  'agrave;': 'à',
                  agrave: 'à',
                  'alefsym;': 'ℵ',
                  'aleph;': 'ℵ',
                  'Alpha;': 'Α',
                  'alpha;': 'α',
                  'Amacr;': 'Ā',
                  'amacr;': 'ā',
                  'amalg;': '⨿',
                  'AMP;': '&',
                  AMP: '&',
                  'amp;': '&',
                  amp: '&',
                  'And;': '⩓',
                  'and;': '∧',
                  'andand;': '⩕',
                  'andd;': '⩜',
                  'andslope;': '⩘',
                  'andv;': '⩚',
                  'ang;': '∠',
                  'ange;': '⦤',
                  'angle;': '∠',
                  'angmsd;': '∡',
                  'angmsdaa;': '⦨',
                  'angmsdab;': '⦩',
                  'angmsdac;': '⦪',
                  'angmsdad;': '⦫',
                  'angmsdae;': '⦬',
                  'angmsdaf;': '⦭',
                  'angmsdag;': '⦮',
                  'angmsdah;': '⦯',
                  'angrt;': '∟',
                  'angrtvb;': '⊾',
                  'angrtvbd;': '⦝',
                  'angsph;': '∢',
                  'angst;': 'Å',
                  'angzarr;': '⍼',
                  'Aogon;': 'Ą',
                  'aogon;': 'ą',
                  'Aopf;': '𝔸',
                  'aopf;': '𝕒',
                  'ap;': '≈',
                  'apacir;': '⩯',
                  'apE;': '⩰',
                  'ape;': '≊',
                  'apid;': '≋',
                  'apos;': "'",
                  'ApplyFunction;': '⁡',
                  'approx;': '≈',
                  'approxeq;': '≊',
                  'Aring;': 'Å',
                  Aring: 'Å',
                  'aring;': 'å',
                  aring: 'å',
                  'Ascr;': '𝒜',
                  'ascr;': '𝒶',
                  'Assign;': '≔',
                  'ast;': '*',
                  'asymp;': '≈',
                  'asympeq;': '≍',
                  'Atilde;': 'Ã',
                  Atilde: 'Ã',
                  'atilde;': 'ã',
                  atilde: 'ã',
                  'Auml;': 'Ä',
                  Auml: 'Ä',
                  'auml;': 'ä',
                  auml: 'ä',
                  'awconint;': '∳',
                  'awint;': '⨑',
                  'backcong;': '≌',
                  'backepsilon;': '϶',
                  'backprime;': '‵',
                  'backsim;': '∽',
                  'backsimeq;': '⋍',
                  'Backslash;': '∖',
                  'Barv;': '⫧',
                  'barvee;': '⊽',
                  'Barwed;': '⌆',
                  'barwed;': '⌅',
                  'barwedge;': '⌅',
                  'bbrk;': '⎵',
                  'bbrktbrk;': '⎶',
                  'bcong;': '≌',
                  'Bcy;': 'Б',
                  'bcy;': 'б',
                  'bdquo;': '„',
                  'becaus;': '∵',
                  'Because;': '∵',
                  'because;': '∵',
                  'bemptyv;': '⦰',
                  'bepsi;': '϶',
                  'bernou;': 'ℬ',
                  'Bernoullis;': 'ℬ',
                  'Beta;': 'Β',
                  'beta;': 'β',
                  'beth;': 'ℶ',
                  'between;': '≬',
                  'Bfr;': '𝔅',
                  'bfr;': '𝔟',
                  'bigcap;': '⋂',
                  'bigcirc;': '◯',
                  'bigcup;': '⋃',
                  'bigodot;': '⨀',
                  'bigoplus;': '⨁',
                  'bigotimes;': '⨂',
                  'bigsqcup;': '⨆',
                  'bigstar;': '★',
                  'bigtriangledown;': '▽',
                  'bigtriangleup;': '△',
                  'biguplus;': '⨄',
                  'bigvee;': '⋁',
                  'bigwedge;': '⋀',
                  'bkarow;': '⤍',
                  'blacklozenge;': '⧫',
                  'blacksquare;': '▪',
                  'blacktriangle;': '▴',
                  'blacktriangledown;': '▾',
                  'blacktriangleleft;': '◂',
                  'blacktriangleright;': '▸',
                  'blank;': '␣',
                  'blk12;': '▒',
                  'blk14;': '░',
                  'blk34;': '▓',
                  'block;': '█',
                  'bne;': '=⃥',
                  'bnequiv;': '≡⃥',
                  'bNot;': '⫭',
                  'bnot;': '⌐',
                  'Bopf;': '𝔹',
                  'bopf;': '𝕓',
                  'bot;': '⊥',
                  'bottom;': '⊥',
                  'bowtie;': '⋈',
                  'boxbox;': '⧉',
                  'boxDL;': '╗',
                  'boxDl;': '╖',
                  'boxdL;': '╕',
                  'boxdl;': '┐',
                  'boxDR;': '╔',
                  'boxDr;': '╓',
                  'boxdR;': '╒',
                  'boxdr;': '┌',
                  'boxH;': '═',
                  'boxh;': '─',
                  'boxHD;': '╦',
                  'boxHd;': '╤',
                  'boxhD;': '╥',
                  'boxhd;': '┬',
                  'boxHU;': '╩',
                  'boxHu;': '╧',
                  'boxhU;': '╨',
                  'boxhu;': '┴',
                  'boxminus;': '⊟',
                  'boxplus;': '⊞',
                  'boxtimes;': '⊠',
                  'boxUL;': '╝',
                  'boxUl;': '╜',
                  'boxuL;': '╛',
                  'boxul;': '┘',
                  'boxUR;': '╚',
                  'boxUr;': '╙',
                  'boxuR;': '╘',
                  'boxur;': '└',
                  'boxV;': '║',
                  'boxv;': '│',
                  'boxVH;': '╬',
                  'boxVh;': '╫',
                  'boxvH;': '╪',
                  'boxvh;': '┼',
                  'boxVL;': '╣',
                  'boxVl;': '╢',
                  'boxvL;': '╡',
                  'boxvl;': '┤',
                  'boxVR;': '╠',
                  'boxVr;': '╟',
                  'boxvR;': '╞',
                  'boxvr;': '├',
                  'bprime;': '‵',
                  'Breve;': '˘',
                  'breve;': '˘',
                  'brvbar;': '¦',
                  brvbar: '¦',
                  'Bscr;': 'ℬ',
                  'bscr;': '𝒷',
                  'bsemi;': '⁏',
                  'bsim;': '∽',
                  'bsime;': '⋍',
                  'bsol;': '\\',
                  'bsolb;': '⧅',
                  'bsolhsub;': '⟈',
                  'bull;': '•',
                  'bullet;': '•',
                  'bump;': '≎',
                  'bumpE;': '⪮',
                  'bumpe;': '≏',
                  'Bumpeq;': '≎',
                  'bumpeq;': '≏',
                  'Cacute;': 'Ć',
                  'cacute;': 'ć',
                  'Cap;': '⋒',
                  'cap;': '∩',
                  'capand;': '⩄',
                  'capbrcup;': '⩉',
                  'capcap;': '⩋',
                  'capcup;': '⩇',
                  'capdot;': '⩀',
                  'CapitalDifferentialD;': 'ⅅ',
                  'caps;': '∩︀',
                  'caret;': '⁁',
                  'caron;': 'ˇ',
                  'Cayleys;': 'ℭ',
                  'ccaps;': '⩍',
                  'Ccaron;': 'Č',
                  'ccaron;': 'č',
                  'Ccedil;': 'Ç',
                  Ccedil: 'Ç',
                  'ccedil;': 'ç',
                  ccedil: 'ç',
                  'Ccirc;': 'Ĉ',
                  'ccirc;': 'ĉ',
                  'Cconint;': '∰',
                  'ccups;': '⩌',
                  'ccupssm;': '⩐',
                  'Cdot;': 'Ċ',
                  'cdot;': 'ċ',
                  'cedil;': '¸',
                  cedil: '¸',
                  'Cedilla;': '¸',
                  'cemptyv;': '⦲',
                  'cent;': '¢',
                  cent: '¢',
                  'CenterDot;': '·',
                  'centerdot;': '·',
                  'Cfr;': 'ℭ',
                  'cfr;': '𝔠',
                  'CHcy;': 'Ч',
                  'chcy;': 'ч',
                  'check;': '✓',
                  'checkmark;': '✓',
                  'Chi;': 'Χ',
                  'chi;': 'χ',
                  'cir;': '○',
                  'circ;': 'ˆ',
                  'circeq;': '≗',
                  'circlearrowleft;': '↺',
                  'circlearrowright;': '↻',
                  'circledast;': '⊛',
                  'circledcirc;': '⊚',
                  'circleddash;': '⊝',
                  'CircleDot;': '⊙',
                  'circledR;': '®',
                  'circledS;': 'Ⓢ',
                  'CircleMinus;': '⊖',
                  'CirclePlus;': '⊕',
                  'CircleTimes;': '⊗',
                  'cirE;': '⧃',
                  'cire;': '≗',
                  'cirfnint;': '⨐',
                  'cirmid;': '⫯',
                  'cirscir;': '⧂',
                  'ClockwiseContourIntegral;': '∲',
                  'CloseCurlyDoubleQuote;': '”',
                  'CloseCurlyQuote;': '’',
                  'clubs;': '♣',
                  'clubsuit;': '♣',
                  'Colon;': '∷',
                  'colon;': ':',
                  'Colone;': '⩴',
                  'colone;': '≔',
                  'coloneq;': '≔',
                  'comma;': ',',
                  'commat;': '@',
                  'comp;': '∁',
                  'compfn;': '∘',
                  'complement;': '∁',
                  'complexes;': 'ℂ',
                  'cong;': '≅',
                  'congdot;': '⩭',
                  'Congruent;': '≡',
                  'Conint;': '∯',
                  'conint;': '∮',
                  'ContourIntegral;': '∮',
                  'Copf;': 'ℂ',
                  'copf;': '𝕔',
                  'coprod;': '∐',
                  'Coproduct;': '∐',
                  'COPY;': '©',
                  COPY: '©',
                  'copy;': '©',
                  copy: '©',
                  'copysr;': '℗',
                  'CounterClockwiseContourIntegral;': '∳',
                  'crarr;': '↵',
                  'Cross;': '⨯',
                  'cross;': '✗',
                  'Cscr;': '𝒞',
                  'cscr;': '𝒸',
                  'csub;': '⫏',
                  'csube;': '⫑',
                  'csup;': '⫐',
                  'csupe;': '⫒',
                  'ctdot;': '⋯',
                  'cudarrl;': '⤸',
                  'cudarrr;': '⤵',
                  'cuepr;': '⋞',
                  'cuesc;': '⋟',
                  'cularr;': '↶',
                  'cularrp;': '⤽',
                  'Cup;': '⋓',
                  'cup;': '∪',
                  'cupbrcap;': '⩈',
                  'CupCap;': '≍',
                  'cupcap;': '⩆',
                  'cupcup;': '⩊',
                  'cupdot;': '⊍',
                  'cupor;': '⩅',
                  'cups;': '∪︀',
                  'curarr;': '↷',
                  'curarrm;': '⤼',
                  'curlyeqprec;': '⋞',
                  'curlyeqsucc;': '⋟',
                  'curlyvee;': '⋎',
                  'curlywedge;': '⋏',
                  'curren;': '¤',
                  curren: '¤',
                  'curvearrowleft;': '↶',
                  'curvearrowright;': '↷',
                  'cuvee;': '⋎',
                  'cuwed;': '⋏',
                  'cwconint;': '∲',
                  'cwint;': '∱',
                  'cylcty;': '⌭',
                  'Dagger;': '‡',
                  'dagger;': '†',
                  'daleth;': 'ℸ',
                  'Darr;': '↡',
                  'dArr;': '⇓',
                  'darr;': '↓',
                  'dash;': '‐',
                  'Dashv;': '⫤',
                  'dashv;': '⊣',
                  'dbkarow;': '⤏',
                  'dblac;': '˝',
                  'Dcaron;': 'Ď',
                  'dcaron;': 'ď',
                  'Dcy;': 'Д',
                  'dcy;': 'д',
                  'DD;': 'ⅅ',
                  'dd;': 'ⅆ',
                  'ddagger;': '‡',
                  'ddarr;': '⇊',
                  'DDotrahd;': '⤑',
                  'ddotseq;': '⩷',
                  'deg;': '°',
                  deg: '°',
                  'Del;': '∇',
                  'Delta;': 'Δ',
                  'delta;': 'δ',
                  'demptyv;': '⦱',
                  'dfisht;': '⥿',
                  'Dfr;': '𝔇',
                  'dfr;': '𝔡',
                  'dHar;': '⥥',
                  'dharl;': '⇃',
                  'dharr;': '⇂',
                  'DiacriticalAcute;': '´',
                  'DiacriticalDot;': '˙',
                  'DiacriticalDoubleAcute;': '˝',
                  'DiacriticalGrave;': '`',
                  'DiacriticalTilde;': '˜',
                  'diam;': '⋄',
                  'Diamond;': '⋄',
                  'diamond;': '⋄',
                  'diamondsuit;': '♦',
                  'diams;': '♦',
                  'die;': '¨',
                  'DifferentialD;': 'ⅆ',
                  'digamma;': 'ϝ',
                  'disin;': '⋲',
                  'div;': '÷',
                  'divide;': '÷',
                  divide: '÷',
                  'divideontimes;': '⋇',
                  'divonx;': '⋇',
                  'DJcy;': 'Ђ',
                  'djcy;': 'ђ',
                  'dlcorn;': '⌞',
                  'dlcrop;': '⌍',
                  'dollar;': '$',
                  'Dopf;': '𝔻',
                  'dopf;': '𝕕',
                  'Dot;': '¨',
                  'dot;': '˙',
                  'DotDot;': '⃜',
                  'doteq;': '≐',
                  'doteqdot;': '≑',
                  'DotEqual;': '≐',
                  'dotminus;': '∸',
                  'dotplus;': '∔',
                  'dotsquare;': '⊡',
                  'doublebarwedge;': '⌆',
                  'DoubleContourIntegral;': '∯',
                  'DoubleDot;': '¨',
                  'DoubleDownArrow;': '⇓',
                  'DoubleLeftArrow;': '⇐',
                  'DoubleLeftRightArrow;': '⇔',
                  'DoubleLeftTee;': '⫤',
                  'DoubleLongLeftArrow;': '⟸',
                  'DoubleLongLeftRightArrow;': '⟺',
                  'DoubleLongRightArrow;': '⟹',
                  'DoubleRightArrow;': '⇒',
                  'DoubleRightTee;': '⊨',
                  'DoubleUpArrow;': '⇑',
                  'DoubleUpDownArrow;': '⇕',
                  'DoubleVerticalBar;': '∥',
                  'DownArrow;': '↓',
                  'Downarrow;': '⇓',
                  'downarrow;': '↓',
                  'DownArrowBar;': '⤓',
                  'DownArrowUpArrow;': '⇵',
                  'DownBreve;': '̑',
                  'downdownarrows;': '⇊',
                  'downharpoonleft;': '⇃',
                  'downharpoonright;': '⇂',
                  'DownLeftRightVector;': '⥐',
                  'DownLeftTeeVector;': '⥞',
                  'DownLeftVector;': '↽',
                  'DownLeftVectorBar;': '⥖',
                  'DownRightTeeVector;': '⥟',
                  'DownRightVector;': '⇁',
                  'DownRightVectorBar;': '⥗',
                  'DownTee;': '⊤',
                  'DownTeeArrow;': '↧',
                  'drbkarow;': '⤐',
                  'drcorn;': '⌟',
                  'drcrop;': '⌌',
                  'Dscr;': '𝒟',
                  'dscr;': '𝒹',
                  'DScy;': 'Ѕ',
                  'dscy;': 'ѕ',
                  'dsol;': '⧶',
                  'Dstrok;': 'Đ',
                  'dstrok;': 'đ',
                  'dtdot;': '⋱',
                  'dtri;': '▿',
                  'dtrif;': '▾',
                  'duarr;': '⇵',
                  'duhar;': '⥯',
                  'dwangle;': '⦦',
                  'DZcy;': 'Џ',
                  'dzcy;': 'џ',
                  'dzigrarr;': '⟿',
                  'Eacute;': 'É',
                  Eacute: 'É',
                  'eacute;': 'é',
                  eacute: 'é',
                  'easter;': '⩮',
                  'Ecaron;': 'Ě',
                  'ecaron;': 'ě',
                  'ecir;': '≖',
                  'Ecirc;': 'Ê',
                  Ecirc: 'Ê',
                  'ecirc;': 'ê',
                  ecirc: 'ê',
                  'ecolon;': '≕',
                  'Ecy;': 'Э',
                  'ecy;': 'э',
                  'eDDot;': '⩷',
                  'Edot;': 'Ė',
                  'eDot;': '≑',
                  'edot;': 'ė',
                  'ee;': 'ⅇ',
                  'efDot;': '≒',
                  'Efr;': '𝔈',
                  'efr;': '𝔢',
                  'eg;': '⪚',
                  'Egrave;': 'È',
                  Egrave: 'È',
                  'egrave;': 'è',
                  egrave: 'è',
                  'egs;': '⪖',
                  'egsdot;': '⪘',
                  'el;': '⪙',
                  'Element;': '∈',
                  'elinters;': '⏧',
                  'ell;': 'ℓ',
                  'els;': '⪕',
                  'elsdot;': '⪗',
                  'Emacr;': 'Ē',
                  'emacr;': 'ē',
                  'empty;': '∅',
                  'emptyset;': '∅',
                  'EmptySmallSquare;': '◻',
                  'emptyv;': '∅',
                  'EmptyVerySmallSquare;': '▫',
                  'emsp;': ' ',
                  'emsp13;': ' ',
                  'emsp14;': ' ',
                  'ENG;': 'Ŋ',
                  'eng;': 'ŋ',
                  'ensp;': ' ',
                  'Eogon;': 'Ę',
                  'eogon;': 'ę',
                  'Eopf;': '𝔼',
                  'eopf;': '𝕖',
                  'epar;': '⋕',
                  'eparsl;': '⧣',
                  'eplus;': '⩱',
                  'epsi;': 'ε',
                  'Epsilon;': 'Ε',
                  'epsilon;': 'ε',
                  'epsiv;': 'ϵ',
                  'eqcirc;': '≖',
                  'eqcolon;': '≕',
                  'eqsim;': '≂',
                  'eqslantgtr;': '⪖',
                  'eqslantless;': '⪕',
                  'Equal;': '⩵',
                  'equals;': '=',
                  'EqualTilde;': '≂',
                  'equest;': '≟',
                  'Equilibrium;': '⇌',
                  'equiv;': '≡',
                  'equivDD;': '⩸',
                  'eqvparsl;': '⧥',
                  'erarr;': '⥱',
                  'erDot;': '≓',
                  'Escr;': 'ℰ',
                  'escr;': 'ℯ',
                  'esdot;': '≐',
                  'Esim;': '⩳',
                  'esim;': '≂',
                  'Eta;': 'Η',
                  'eta;': 'η',
                  'ETH;': 'Ð',
                  ETH: 'Ð',
                  'eth;': 'ð',
                  eth: 'ð',
                  'Euml;': 'Ë',
                  Euml: 'Ë',
                  'euml;': 'ë',
                  euml: 'ë',
                  'euro;': '€',
                  'excl;': '!',
                  'exist;': '∃',
                  'Exists;': '∃',
                  'expectation;': 'ℰ',
                  'ExponentialE;': 'ⅇ',
                  'exponentiale;': 'ⅇ',
                  'fallingdotseq;': '≒',
                  'Fcy;': 'Ф',
                  'fcy;': 'ф',
                  'female;': '♀',
                  'ffilig;': 'ﬃ',
                  'fflig;': 'ﬀ',
                  'ffllig;': 'ﬄ',
                  'Ffr;': '𝔉',
                  'ffr;': '𝔣',
                  'filig;': 'ﬁ',
                  'FilledSmallSquare;': '◼',
                  'FilledVerySmallSquare;': '▪',
                  'fjlig;': 'fj',
                  'flat;': '♭',
                  'fllig;': 'ﬂ',
                  'fltns;': '▱',
                  'fnof;': 'ƒ',
                  'Fopf;': '𝔽',
                  'fopf;': '𝕗',
                  'ForAll;': '∀',
                  'forall;': '∀',
                  'fork;': '⋔',
                  'forkv;': '⫙',
                  'Fouriertrf;': 'ℱ',
                  'fpartint;': '⨍',
                  'frac12;': '½',
                  frac12: '½',
                  'frac13;': '⅓',
                  'frac14;': '¼',
                  frac14: '¼',
                  'frac15;': '⅕',
                  'frac16;': '⅙',
                  'frac18;': '⅛',
                  'frac23;': '⅔',
                  'frac25;': '⅖',
                  'frac34;': '¾',
                  frac34: '¾',
                  'frac35;': '⅗',
                  'frac38;': '⅜',
                  'frac45;': '⅘',
                  'frac56;': '⅚',
                  'frac58;': '⅝',
                  'frac78;': '⅞',
                  'frasl;': '⁄',
                  'frown;': '⌢',
                  'Fscr;': 'ℱ',
                  'fscr;': '𝒻',
                  'gacute;': 'ǵ',
                  'Gamma;': 'Γ',
                  'gamma;': 'γ',
                  'Gammad;': 'Ϝ',
                  'gammad;': 'ϝ',
                  'gap;': '⪆',
                  'Gbreve;': 'Ğ',
                  'gbreve;': 'ğ',
                  'Gcedil;': 'Ģ',
                  'Gcirc;': 'Ĝ',
                  'gcirc;': 'ĝ',
                  'Gcy;': 'Г',
                  'gcy;': 'г',
                  'Gdot;': 'Ġ',
                  'gdot;': 'ġ',
                  'gE;': '≧',
                  'ge;': '≥',
                  'gEl;': '⪌',
                  'gel;': '⋛',
                  'geq;': '≥',
                  'geqq;': '≧',
                  'geqslant;': '⩾',
                  'ges;': '⩾',
                  'gescc;': '⪩',
                  'gesdot;': '⪀',
                  'gesdoto;': '⪂',
                  'gesdotol;': '⪄',
                  'gesl;': '⋛︀',
                  'gesles;': '⪔',
                  'Gfr;': '𝔊',
                  'gfr;': '𝔤',
                  'Gg;': '⋙',
                  'gg;': '≫',
                  'ggg;': '⋙',
                  'gimel;': 'ℷ',
                  'GJcy;': 'Ѓ',
                  'gjcy;': 'ѓ',
                  'gl;': '≷',
                  'gla;': '⪥',
                  'glE;': '⪒',
                  'glj;': '⪤',
                  'gnap;': '⪊',
                  'gnapprox;': '⪊',
                  'gnE;': '≩',
                  'gne;': '⪈',
                  'gneq;': '⪈',
                  'gneqq;': '≩',
                  'gnsim;': '⋧',
                  'Gopf;': '𝔾',
                  'gopf;': '𝕘',
                  'grave;': '`',
                  'GreaterEqual;': '≥',
                  'GreaterEqualLess;': '⋛',
                  'GreaterFullEqual;': '≧',
                  'GreaterGreater;': '⪢',
                  'GreaterLess;': '≷',
                  'GreaterSlantEqual;': '⩾',
                  'GreaterTilde;': '≳',
                  'Gscr;': '𝒢',
                  'gscr;': 'ℊ',
                  'gsim;': '≳',
                  'gsime;': '⪎',
                  'gsiml;': '⪐',
                  'GT;': '>',
                  GT: '>',
                  'Gt;': '≫',
                  'gt;': '>',
                  gt: '>',
                  'gtcc;': '⪧',
                  'gtcir;': '⩺',
                  'gtdot;': '⋗',
                  'gtlPar;': '⦕',
                  'gtquest;': '⩼',
                  'gtrapprox;': '⪆',
                  'gtrarr;': '⥸',
                  'gtrdot;': '⋗',
                  'gtreqless;': '⋛',
                  'gtreqqless;': '⪌',
                  'gtrless;': '≷',
                  'gtrsim;': '≳',
                  'gvertneqq;': '≩︀',
                  'gvnE;': '≩︀',
                  'Hacek;': 'ˇ',
                  'hairsp;': ' ',
                  'half;': '½',
                  'hamilt;': 'ℋ',
                  'HARDcy;': 'Ъ',
                  'hardcy;': 'ъ',
                  'hArr;': '⇔',
                  'harr;': '↔',
                  'harrcir;': '⥈',
                  'harrw;': '↭',
                  'Hat;': '^',
                  'hbar;': 'ℏ',
                  'Hcirc;': 'Ĥ',
                  'hcirc;': 'ĥ',
                  'hearts;': '♥',
                  'heartsuit;': '♥',
                  'hellip;': '…',
                  'hercon;': '⊹',
                  'Hfr;': 'ℌ',
                  'hfr;': '𝔥',
                  'HilbertSpace;': 'ℋ',
                  'hksearow;': '⤥',
                  'hkswarow;': '⤦',
                  'hoarr;': '⇿',
                  'homtht;': '∻',
                  'hookleftarrow;': '↩',
                  'hookrightarrow;': '↪',
                  'Hopf;': 'ℍ',
                  'hopf;': '𝕙',
                  'horbar;': '―',
                  'HorizontalLine;': '─',
                  'Hscr;': 'ℋ',
                  'hscr;': '𝒽',
                  'hslash;': 'ℏ',
                  'Hstrok;': 'Ħ',
                  'hstrok;': 'ħ',
                  'HumpDownHump;': '≎',
                  'HumpEqual;': '≏',
                  'hybull;': '⁃',
                  'hyphen;': '‐',
                  'Iacute;': 'Í',
                  Iacute: 'Í',
                  'iacute;': 'í',
                  iacute: 'í',
                  'ic;': '⁣',
                  'Icirc;': 'Î',
                  Icirc: 'Î',
                  'icirc;': 'î',
                  icirc: 'î',
                  'Icy;': 'И',
                  'icy;': 'и',
                  'Idot;': 'İ',
                  'IEcy;': 'Е',
                  'iecy;': 'е',
                  'iexcl;': '¡',
                  iexcl: '¡',
                  'iff;': '⇔',
                  'Ifr;': 'ℑ',
                  'ifr;': '𝔦',
                  'Igrave;': 'Ì',
                  Igrave: 'Ì',
                  'igrave;': 'ì',
                  igrave: 'ì',
                  'ii;': 'ⅈ',
                  'iiiint;': '⨌',
                  'iiint;': '∭',
                  'iinfin;': '⧜',
                  'iiota;': '℩',
                  'IJlig;': 'Ĳ',
                  'ijlig;': 'ĳ',
                  'Im;': 'ℑ',
                  'Imacr;': 'Ī',
                  'imacr;': 'ī',
                  'image;': 'ℑ',
                  'ImaginaryI;': 'ⅈ',
                  'imagline;': 'ℐ',
                  'imagpart;': 'ℑ',
                  'imath;': 'ı',
                  'imof;': '⊷',
                  'imped;': 'Ƶ',
                  'Implies;': '⇒',
                  'in;': '∈',
                  'incare;': '℅',
                  'infin;': '∞',
                  'infintie;': '⧝',
                  'inodot;': 'ı',
                  'Int;': '∬',
                  'int;': '∫',
                  'intcal;': '⊺',
                  'integers;': 'ℤ',
                  'Integral;': '∫',
                  'intercal;': '⊺',
                  'Intersection;': '⋂',
                  'intlarhk;': '⨗',
                  'intprod;': '⨼',
                  'InvisibleComma;': '⁣',
                  'InvisibleTimes;': '⁢',
                  'IOcy;': 'Ё',
                  'iocy;': 'ё',
                  'Iogon;': 'Į',
                  'iogon;': 'į',
                  'Iopf;': '𝕀',
                  'iopf;': '𝕚',
                  'Iota;': 'Ι',
                  'iota;': 'ι',
                  'iprod;': '⨼',
                  'iquest;': '¿',
                  iquest: '¿',
                  'Iscr;': 'ℐ',
                  'iscr;': '𝒾',
                  'isin;': '∈',
                  'isindot;': '⋵',
                  'isinE;': '⋹',
                  'isins;': '⋴',
                  'isinsv;': '⋳',
                  'isinv;': '∈',
                  'it;': '⁢',
                  'Itilde;': 'Ĩ',
                  'itilde;': 'ĩ',
                  'Iukcy;': 'І',
                  'iukcy;': 'і',
                  'Iuml;': 'Ï',
                  Iuml: 'Ï',
                  'iuml;': 'ï',
                  iuml: 'ï',
                  'Jcirc;': 'Ĵ',
                  'jcirc;': 'ĵ',
                  'Jcy;': 'Й',
                  'jcy;': 'й',
                  'Jfr;': '𝔍',
                  'jfr;': '𝔧',
                  'jmath;': 'ȷ',
                  'Jopf;': '𝕁',
                  'jopf;': '𝕛',
                  'Jscr;': '𝒥',
                  'jscr;': '𝒿',
                  'Jsercy;': 'Ј',
                  'jsercy;': 'ј',
                  'Jukcy;': 'Є',
                  'jukcy;': 'є',
                  'Kappa;': 'Κ',
                  'kappa;': 'κ',
                  'kappav;': 'ϰ',
                  'Kcedil;': 'Ķ',
                  'kcedil;': 'ķ',
                  'Kcy;': 'К',
                  'kcy;': 'к',
                  'Kfr;': '𝔎',
                  'kfr;': '𝔨',
                  'kgreen;': 'ĸ',
                  'KHcy;': 'Х',
                  'khcy;': 'х',
                  'KJcy;': 'Ќ',
                  'kjcy;': 'ќ',
                  'Kopf;': '𝕂',
                  'kopf;': '𝕜',
                  'Kscr;': '𝒦',
                  'kscr;': '𝓀',
                  'lAarr;': '⇚',
                  'Lacute;': 'Ĺ',
                  'lacute;': 'ĺ',
                  'laemptyv;': '⦴',
                  'lagran;': 'ℒ',
                  'Lambda;': 'Λ',
                  'lambda;': 'λ',
                  'Lang;': '⟪',
                  'lang;': '⟨',
                  'langd;': '⦑',
                  'langle;': '⟨',
                  'lap;': '⪅',
                  'Laplacetrf;': 'ℒ',
                  'laquo;': '«',
                  laquo: '«',
                  'Larr;': '↞',
                  'lArr;': '⇐',
                  'larr;': '←',
                  'larrb;': '⇤',
                  'larrbfs;': '⤟',
                  'larrfs;': '⤝',
                  'larrhk;': '↩',
                  'larrlp;': '↫',
                  'larrpl;': '⤹',
                  'larrsim;': '⥳',
                  'larrtl;': '↢',
                  'lat;': '⪫',
                  'lAtail;': '⤛',
                  'latail;': '⤙',
                  'late;': '⪭',
                  'lates;': '⪭︀',
                  'lBarr;': '⤎',
                  'lbarr;': '⤌',
                  'lbbrk;': '❲',
                  'lbrace;': '{',
                  'lbrack;': '[',
                  'lbrke;': '⦋',
                  'lbrksld;': '⦏',
                  'lbrkslu;': '⦍',
                  'Lcaron;': 'Ľ',
                  'lcaron;': 'ľ',
                  'Lcedil;': 'Ļ',
                  'lcedil;': 'ļ',
                  'lceil;': '⌈',
                  'lcub;': '{',
                  'Lcy;': 'Л',
                  'lcy;': 'л',
                  'ldca;': '⤶',
                  'ldquo;': '“',
                  'ldquor;': '„',
                  'ldrdhar;': '⥧',
                  'ldrushar;': '⥋',
                  'ldsh;': '↲',
                  'lE;': '≦',
                  'le;': '≤',
                  'LeftAngleBracket;': '⟨',
                  'LeftArrow;': '←',
                  'Leftarrow;': '⇐',
                  'leftarrow;': '←',
                  'LeftArrowBar;': '⇤',
                  'LeftArrowRightArrow;': '⇆',
                  'leftarrowtail;': '↢',
                  'LeftCeiling;': '⌈',
                  'LeftDoubleBracket;': '⟦',
                  'LeftDownTeeVector;': '⥡',
                  'LeftDownVector;': '⇃',
                  'LeftDownVectorBar;': '⥙',
                  'LeftFloor;': '⌊',
                  'leftharpoondown;': '↽',
                  'leftharpoonup;': '↼',
                  'leftleftarrows;': '⇇',
                  'LeftRightArrow;': '↔',
                  'Leftrightarrow;': '⇔',
                  'leftrightarrow;': '↔',
                  'leftrightarrows;': '⇆',
                  'leftrightharpoons;': '⇋',
                  'leftrightsquigarrow;': '↭',
                  'LeftRightVector;': '⥎',
                  'LeftTee;': '⊣',
                  'LeftTeeArrow;': '↤',
                  'LeftTeeVector;': '⥚',
                  'leftthreetimes;': '⋋',
                  'LeftTriangle;': '⊲',
                  'LeftTriangleBar;': '⧏',
                  'LeftTriangleEqual;': '⊴',
                  'LeftUpDownVector;': '⥑',
                  'LeftUpTeeVector;': '⥠',
                  'LeftUpVector;': '↿',
                  'LeftUpVectorBar;': '⥘',
                  'LeftVector;': '↼',
                  'LeftVectorBar;': '⥒',
                  'lEg;': '⪋',
                  'leg;': '⋚',
                  'leq;': '≤',
                  'leqq;': '≦',
                  'leqslant;': '⩽',
                  'les;': '⩽',
                  'lescc;': '⪨',
                  'lesdot;': '⩿',
                  'lesdoto;': '⪁',
                  'lesdotor;': '⪃',
                  'lesg;': '⋚︀',
                  'lesges;': '⪓',
                  'lessapprox;': '⪅',
                  'lessdot;': '⋖',
                  'lesseqgtr;': '⋚',
                  'lesseqqgtr;': '⪋',
                  'LessEqualGreater;': '⋚',
                  'LessFullEqual;': '≦',
                  'LessGreater;': '≶',
                  'lessgtr;': '≶',
                  'LessLess;': '⪡',
                  'lesssim;': '≲',
                  'LessSlantEqual;': '⩽',
                  'LessTilde;': '≲',
                  'lfisht;': '⥼',
                  'lfloor;': '⌊',
                  'Lfr;': '𝔏',
                  'lfr;': '𝔩',
                  'lg;': '≶',
                  'lgE;': '⪑',
                  'lHar;': '⥢',
                  'lhard;': '↽',
                  'lharu;': '↼',
                  'lharul;': '⥪',
                  'lhblk;': '▄',
                  'LJcy;': 'Љ',
                  'ljcy;': 'љ',
                  'Ll;': '⋘',
                  'll;': '≪',
                  'llarr;': '⇇',
                  'llcorner;': '⌞',
                  'Lleftarrow;': '⇚',
                  'llhard;': '⥫',
                  'lltri;': '◺',
                  'Lmidot;': 'Ŀ',
                  'lmidot;': 'ŀ',
                  'lmoust;': '⎰',
                  'lmoustache;': '⎰',
                  'lnap;': '⪉',
                  'lnapprox;': '⪉',
                  'lnE;': '≨',
                  'lne;': '⪇',
                  'lneq;': '⪇',
                  'lneqq;': '≨',
                  'lnsim;': '⋦',
                  'loang;': '⟬',
                  'loarr;': '⇽',
                  'lobrk;': '⟦',
                  'LongLeftArrow;': '⟵',
                  'Longleftarrow;': '⟸',
                  'longleftarrow;': '⟵',
                  'LongLeftRightArrow;': '⟷',
                  'Longleftrightarrow;': '⟺',
                  'longleftrightarrow;': '⟷',
                  'longmapsto;': '⟼',
                  'LongRightArrow;': '⟶',
                  'Longrightarrow;': '⟹',
                  'longrightarrow;': '⟶',
                  'looparrowleft;': '↫',
                  'looparrowright;': '↬',
                  'lopar;': '⦅',
                  'Lopf;': '𝕃',
                  'lopf;': '𝕝',
                  'loplus;': '⨭',
                  'lotimes;': '⨴',
                  'lowast;': '∗',
                  'lowbar;': '_',
                  'LowerLeftArrow;': '↙',
                  'LowerRightArrow;': '↘',
                  'loz;': '◊',
                  'lozenge;': '◊',
                  'lozf;': '⧫',
                  'lpar;': '(',
                  'lparlt;': '⦓',
                  'lrarr;': '⇆',
                  'lrcorner;': '⌟',
                  'lrhar;': '⇋',
                  'lrhard;': '⥭',
                  'lrm;': '‎',
                  'lrtri;': '⊿',
                  'lsaquo;': '‹',
                  'Lscr;': 'ℒ',
                  'lscr;': '𝓁',
                  'Lsh;': '↰',
                  'lsh;': '↰',
                  'lsim;': '≲',
                  'lsime;': '⪍',
                  'lsimg;': '⪏',
                  'lsqb;': '[',
                  'lsquo;': '‘',
                  'lsquor;': '‚',
                  'Lstrok;': 'Ł',
                  'lstrok;': 'ł',
                  'LT;': '<',
                  LT: '<',
                  'Lt;': '≪',
                  'lt;': '<',
                  lt: '<',
                  'ltcc;': '⪦',
                  'ltcir;': '⩹',
                  'ltdot;': '⋖',
                  'lthree;': '⋋',
                  'ltimes;': '⋉',
                  'ltlarr;': '⥶',
                  'ltquest;': '⩻',
                  'ltri;': '◃',
                  'ltrie;': '⊴',
                  'ltrif;': '◂',
                  'ltrPar;': '⦖',
                  'lurdshar;': '⥊',
                  'luruhar;': '⥦',
                  'lvertneqq;': '≨︀',
                  'lvnE;': '≨︀',
                  'macr;': '¯',
                  macr: '¯',
                  'male;': '♂',
                  'malt;': '✠',
                  'maltese;': '✠',
                  'Map;': '⤅',
                  'map;': '↦',
                  'mapsto;': '↦',
                  'mapstodown;': '↧',
                  'mapstoleft;': '↤',
                  'mapstoup;': '↥',
                  'marker;': '▮',
                  'mcomma;': '⨩',
                  'Mcy;': 'М',
                  'mcy;': 'м',
                  'mdash;': '—',
                  'mDDot;': '∺',
                  'measuredangle;': '∡',
                  'MediumSpace;': ' ',
                  'Mellintrf;': 'ℳ',
                  'Mfr;': '𝔐',
                  'mfr;': '𝔪',
                  'mho;': '℧',
                  'micro;': 'µ',
                  micro: 'µ',
                  'mid;': '∣',
                  'midast;': '*',
                  'midcir;': '⫰',
                  'middot;': '·',
                  middot: '·',
                  'minus;': '−',
                  'minusb;': '⊟',
                  'minusd;': '∸',
                  'minusdu;': '⨪',
                  'MinusPlus;': '∓',
                  'mlcp;': '⫛',
                  'mldr;': '…',
                  'mnplus;': '∓',
                  'models;': '⊧',
                  'Mopf;': '𝕄',
                  'mopf;': '𝕞',
                  'mp;': '∓',
                  'Mscr;': 'ℳ',
                  'mscr;': '𝓂',
                  'mstpos;': '∾',
                  'Mu;': 'Μ',
                  'mu;': 'μ',
                  'multimap;': '⊸',
                  'mumap;': '⊸',
                  'nabla;': '∇',
                  'Nacute;': 'Ń',
                  'nacute;': 'ń',
                  'nang;': '∠⃒',
                  'nap;': '≉',
                  'napE;': '⩰̸',
                  'napid;': '≋̸',
                  'napos;': 'ŉ',
                  'napprox;': '≉',
                  'natur;': '♮',
                  'natural;': '♮',
                  'naturals;': 'ℕ',
                  'nbsp;': ' ',
                  nbsp: ' ',
                  'nbump;': '≎̸',
                  'nbumpe;': '≏̸',
                  'ncap;': '⩃',
                  'Ncaron;': 'Ň',
                  'ncaron;': 'ň',
                  'Ncedil;': 'Ņ',
                  'ncedil;': 'ņ',
                  'ncong;': '≇',
                  'ncongdot;': '⩭̸',
                  'ncup;': '⩂',
                  'Ncy;': 'Н',
                  'ncy;': 'н',
                  'ndash;': '–',
                  'ne;': '≠',
                  'nearhk;': '⤤',
                  'neArr;': '⇗',
                  'nearr;': '↗',
                  'nearrow;': '↗',
                  'nedot;': '≐̸',
                  'NegativeMediumSpace;': '​',
                  'NegativeThickSpace;': '​',
                  'NegativeThinSpace;': '​',
                  'NegativeVeryThinSpace;': '​',
                  'nequiv;': '≢',
                  'nesear;': '⤨',
                  'nesim;': '≂̸',
                  'NestedGreaterGreater;': '≫',
                  'NestedLessLess;': '≪',
                  'NewLine;': '\n',
                  'nexist;': '∄',
                  'nexists;': '∄',
                  'Nfr;': '𝔑',
                  'nfr;': '𝔫',
                  'ngE;': '≧̸',
                  'nge;': '≱',
                  'ngeq;': '≱',
                  'ngeqq;': '≧̸',
                  'ngeqslant;': '⩾̸',
                  'nges;': '⩾̸',
                  'nGg;': '⋙̸',
                  'ngsim;': '≵',
                  'nGt;': '≫⃒',
                  'ngt;': '≯',
                  'ngtr;': '≯',
                  'nGtv;': '≫̸',
                  'nhArr;': '⇎',
                  'nharr;': '↮',
                  'nhpar;': '⫲',
                  'ni;': '∋',
                  'nis;': '⋼',
                  'nisd;': '⋺',
                  'niv;': '∋',
                  'NJcy;': 'Њ',
                  'njcy;': 'њ',
                  'nlArr;': '⇍',
                  'nlarr;': '↚',
                  'nldr;': '‥',
                  'nlE;': '≦̸',
                  'nle;': '≰',
                  'nLeftarrow;': '⇍',
                  'nleftarrow;': '↚',
                  'nLeftrightarrow;': '⇎',
                  'nleftrightarrow;': '↮',
                  'nleq;': '≰',
                  'nleqq;': '≦̸',
                  'nleqslant;': '⩽̸',
                  'nles;': '⩽̸',
                  'nless;': '≮',
                  'nLl;': '⋘̸',
                  'nlsim;': '≴',
                  'nLt;': '≪⃒',
                  'nlt;': '≮',
                  'nltri;': '⋪',
                  'nltrie;': '⋬',
                  'nLtv;': '≪̸',
                  'nmid;': '∤',
                  'NoBreak;': '⁠',
                  'NonBreakingSpace;': ' ',
                  'Nopf;': 'ℕ',
                  'nopf;': '𝕟',
                  'Not;': '⫬',
                  'not;': '¬',
                  not: '¬',
                  'NotCongruent;': '≢',
                  'NotCupCap;': '≭',
                  'NotDoubleVerticalBar;': '∦',
                  'NotElement;': '∉',
                  'NotEqual;': '≠',
                  'NotEqualTilde;': '≂̸',
                  'NotExists;': '∄',
                  'NotGreater;': '≯',
                  'NotGreaterEqual;': '≱',
                  'NotGreaterFullEqual;': '≧̸',
                  'NotGreaterGreater;': '≫̸',
                  'NotGreaterLess;': '≹',
                  'NotGreaterSlantEqual;': '⩾̸',
                  'NotGreaterTilde;': '≵',
                  'NotHumpDownHump;': '≎̸',
                  'NotHumpEqual;': '≏̸',
                  'notin;': '∉',
                  'notindot;': '⋵̸',
                  'notinE;': '⋹̸',
                  'notinva;': '∉',
                  'notinvb;': '⋷',
                  'notinvc;': '⋶',
                  'NotLeftTriangle;': '⋪',
                  'NotLeftTriangleBar;': '⧏̸',
                  'NotLeftTriangleEqual;': '⋬',
                  'NotLess;': '≮',
                  'NotLessEqual;': '≰',
                  'NotLessGreater;': '≸',
                  'NotLessLess;': '≪̸',
                  'NotLessSlantEqual;': '⩽̸',
                  'NotLessTilde;': '≴',
                  'NotNestedGreaterGreater;': '⪢̸',
                  'NotNestedLessLess;': '⪡̸',
                  'notni;': '∌',
                  'notniva;': '∌',
                  'notnivb;': '⋾',
                  'notnivc;': '⋽',
                  'NotPrecedes;': '⊀',
                  'NotPrecedesEqual;': '⪯̸',
                  'NotPrecedesSlantEqual;': '⋠',
                  'NotReverseElement;': '∌',
                  'NotRightTriangle;': '⋫',
                  'NotRightTriangleBar;': '⧐̸',
                  'NotRightTriangleEqual;': '⋭',
                  'NotSquareSubset;': '⊏̸',
                  'NotSquareSubsetEqual;': '⋢',
                  'NotSquareSuperset;': '⊐̸',
                  'NotSquareSupersetEqual;': '⋣',
                  'NotSubset;': '⊂⃒',
                  'NotSubsetEqual;': '⊈',
                  'NotSucceeds;': '⊁',
                  'NotSucceedsEqual;': '⪰̸',
                  'NotSucceedsSlantEqual;': '⋡',
                  'NotSucceedsTilde;': '≿̸',
                  'NotSuperset;': '⊃⃒',
                  'NotSupersetEqual;': '⊉',
                  'NotTilde;': '≁',
                  'NotTildeEqual;': '≄',
                  'NotTildeFullEqual;': '≇',
                  'NotTildeTilde;': '≉',
                  'NotVerticalBar;': '∤',
                  'npar;': '∦',
                  'nparallel;': '∦',
                  'nparsl;': '⫽⃥',
                  'npart;': '∂̸',
                  'npolint;': '⨔',
                  'npr;': '⊀',
                  'nprcue;': '⋠',
                  'npre;': '⪯̸',
                  'nprec;': '⊀',
                  'npreceq;': '⪯̸',
                  'nrArr;': '⇏',
                  'nrarr;': '↛',
                  'nrarrc;': '⤳̸',
                  'nrarrw;': '↝̸',
                  'nRightarrow;': '⇏',
                  'nrightarrow;': '↛',
                  'nrtri;': '⋫',
                  'nrtrie;': '⋭',
                  'nsc;': '⊁',
                  'nsccue;': '⋡',
                  'nsce;': '⪰̸',
                  'Nscr;': '𝒩',
                  'nscr;': '𝓃',
                  'nshortmid;': '∤',
                  'nshortparallel;': '∦',
                  'nsim;': '≁',
                  'nsime;': '≄',
                  'nsimeq;': '≄',
                  'nsmid;': '∤',
                  'nspar;': '∦',
                  'nsqsube;': '⋢',
                  'nsqsupe;': '⋣',
                  'nsub;': '⊄',
                  'nsubE;': '⫅̸',
                  'nsube;': '⊈',
                  'nsubset;': '⊂⃒',
                  'nsubseteq;': '⊈',
                  'nsubseteqq;': '⫅̸',
                  'nsucc;': '⊁',
                  'nsucceq;': '⪰̸',
                  'nsup;': '⊅',
                  'nsupE;': '⫆̸',
                  'nsupe;': '⊉',
                  'nsupset;': '⊃⃒',
                  'nsupseteq;': '⊉',
                  'nsupseteqq;': '⫆̸',
                  'ntgl;': '≹',
                  'Ntilde;': 'Ñ',
                  Ntilde: 'Ñ',
                  'ntilde;': 'ñ',
                  ntilde: 'ñ',
                  'ntlg;': '≸',
                  'ntriangleleft;': '⋪',
                  'ntrianglelefteq;': '⋬',
                  'ntriangleright;': '⋫',
                  'ntrianglerighteq;': '⋭',
                  'Nu;': 'Ν',
                  'nu;': 'ν',
                  'num;': '#',
                  'numero;': '№',
                  'numsp;': ' ',
                  'nvap;': '≍⃒',
                  'nVDash;': '⊯',
                  'nVdash;': '⊮',
                  'nvDash;': '⊭',
                  'nvdash;': '⊬',
                  'nvge;': '≥⃒',
                  'nvgt;': '>⃒',
                  'nvHarr;': '⤄',
                  'nvinfin;': '⧞',
                  'nvlArr;': '⤂',
                  'nvle;': '≤⃒',
                  'nvlt;': '<⃒',
                  'nvltrie;': '⊴⃒',
                  'nvrArr;': '⤃',
                  'nvrtrie;': '⊵⃒',
                  'nvsim;': '∼⃒',
                  'nwarhk;': '⤣',
                  'nwArr;': '⇖',
                  'nwarr;': '↖',
                  'nwarrow;': '↖',
                  'nwnear;': '⤧',
                  'Oacute;': 'Ó',
                  Oacute: 'Ó',
                  'oacute;': 'ó',
                  oacute: 'ó',
                  'oast;': '⊛',
                  'ocir;': '⊚',
                  'Ocirc;': 'Ô',
                  Ocirc: 'Ô',
                  'ocirc;': 'ô',
                  ocirc: 'ô',
                  'Ocy;': 'О',
                  'ocy;': 'о',
                  'odash;': '⊝',
                  'Odblac;': 'Ő',
                  'odblac;': 'ő',
                  'odiv;': '⨸',
                  'odot;': '⊙',
                  'odsold;': '⦼',
                  'OElig;': 'Œ',
                  'oelig;': 'œ',
                  'ofcir;': '⦿',
                  'Ofr;': '𝔒',
                  'ofr;': '𝔬',
                  'ogon;': '˛',
                  'Ograve;': 'Ò',
                  Ograve: 'Ò',
                  'ograve;': 'ò',
                  ograve: 'ò',
                  'ogt;': '⧁',
                  'ohbar;': '⦵',
                  'ohm;': 'Ω',
                  'oint;': '∮',
                  'olarr;': '↺',
                  'olcir;': '⦾',
                  'olcross;': '⦻',
                  'oline;': '‾',
                  'olt;': '⧀',
                  'Omacr;': 'Ō',
                  'omacr;': 'ō',
                  'Omega;': 'Ω',
                  'omega;': 'ω',
                  'Omicron;': 'Ο',
                  'omicron;': 'ο',
                  'omid;': '⦶',
                  'ominus;': '⊖',
                  'Oopf;': '𝕆',
                  'oopf;': '𝕠',
                  'opar;': '⦷',
                  'OpenCurlyDoubleQuote;': '“',
                  'OpenCurlyQuote;': '‘',
                  'operp;': '⦹',
                  'oplus;': '⊕',
                  'Or;': '⩔',
                  'or;': '∨',
                  'orarr;': '↻',
                  'ord;': '⩝',
                  'order;': 'ℴ',
                  'orderof;': 'ℴ',
                  'ordf;': 'ª',
                  ordf: 'ª',
                  'ordm;': 'º',
                  ordm: 'º',
                  'origof;': '⊶',
                  'oror;': '⩖',
                  'orslope;': '⩗',
                  'orv;': '⩛',
                  'oS;': 'Ⓢ',
                  'Oscr;': '𝒪',
                  'oscr;': 'ℴ',
                  'Oslash;': 'Ø',
                  Oslash: 'Ø',
                  'oslash;': 'ø',
                  oslash: 'ø',
                  'osol;': '⊘',
                  'Otilde;': 'Õ',
                  Otilde: 'Õ',
                  'otilde;': 'õ',
                  otilde: 'õ',
                  'Otimes;': '⨷',
                  'otimes;': '⊗',
                  'otimesas;': '⨶',
                  'Ouml;': 'Ö',
                  Ouml: 'Ö',
                  'ouml;': 'ö',
                  ouml: 'ö',
                  'ovbar;': '⌽',
                  'OverBar;': '‾',
                  'OverBrace;': '⏞',
                  'OverBracket;': '⎴',
                  'OverParenthesis;': '⏜',
                  'par;': '∥',
                  'para;': '¶',
                  para: '¶',
                  'parallel;': '∥',
                  'parsim;': '⫳',
                  'parsl;': '⫽',
                  'part;': '∂',
                  'PartialD;': '∂',
                  'Pcy;': 'П',
                  'pcy;': 'п',
                  'percnt;': '%',
                  'period;': '.',
                  'permil;': '‰',
                  'perp;': '⊥',
                  'pertenk;': '‱',
                  'Pfr;': '𝔓',
                  'pfr;': '𝔭',
                  'Phi;': 'Φ',
                  'phi;': 'φ',
                  'phiv;': 'ϕ',
                  'phmmat;': 'ℳ',
                  'phone;': '☎',
                  'Pi;': 'Π',
                  'pi;': 'π',
                  'pitchfork;': '⋔',
                  'piv;': 'ϖ',
                  'planck;': 'ℏ',
                  'planckh;': 'ℎ',
                  'plankv;': 'ℏ',
                  'plus;': '+',
                  'plusacir;': '⨣',
                  'plusb;': '⊞',
                  'pluscir;': '⨢',
                  'plusdo;': '∔',
                  'plusdu;': '⨥',
                  'pluse;': '⩲',
                  'PlusMinus;': '±',
                  'plusmn;': '±',
                  plusmn: '±',
                  'plussim;': '⨦',
                  'plustwo;': '⨧',
                  'pm;': '±',
                  'Poincareplane;': 'ℌ',
                  'pointint;': '⨕',
                  'Popf;': 'ℙ',
                  'popf;': '𝕡',
                  'pound;': '£',
                  pound: '£',
                  'Pr;': '⪻',
                  'pr;': '≺',
                  'prap;': '⪷',
                  'prcue;': '≼',
                  'prE;': '⪳',
                  'pre;': '⪯',
                  'prec;': '≺',
                  'precapprox;': '⪷',
                  'preccurlyeq;': '≼',
                  'Precedes;': '≺',
                  'PrecedesEqual;': '⪯',
                  'PrecedesSlantEqual;': '≼',
                  'PrecedesTilde;': '≾',
                  'preceq;': '⪯',
                  'precnapprox;': '⪹',
                  'precneqq;': '⪵',
                  'precnsim;': '⋨',
                  'precsim;': '≾',
                  'Prime;': '″',
                  'prime;': '′',
                  'primes;': 'ℙ',
                  'prnap;': '⪹',
                  'prnE;': '⪵',
                  'prnsim;': '⋨',
                  'prod;': '∏',
                  'Product;': '∏',
                  'profalar;': '⌮',
                  'profline;': '⌒',
                  'profsurf;': '⌓',
                  'prop;': '∝',
                  'Proportion;': '∷',
                  'Proportional;': '∝',
                  'propto;': '∝',
                  'prsim;': '≾',
                  'prurel;': '⊰',
                  'Pscr;': '𝒫',
                  'pscr;': '𝓅',
                  'Psi;': 'Ψ',
                  'psi;': 'ψ',
                  'puncsp;': ' ',
                  'Qfr;': '𝔔',
                  'qfr;': '𝔮',
                  'qint;': '⨌',
                  'Qopf;': 'ℚ',
                  'qopf;': '𝕢',
                  'qprime;': '⁗',
                  'Qscr;': '𝒬',
                  'qscr;': '𝓆',
                  'quaternions;': 'ℍ',
                  'quatint;': '⨖',
                  'quest;': '?',
                  'questeq;': '≟',
                  'QUOT;': '"',
                  QUOT: '"',
                  'quot;': '"',
                  quot: '"',
                  'rAarr;': '⇛',
                  'race;': '∽̱',
                  'Racute;': 'Ŕ',
                  'racute;': 'ŕ',
                  'radic;': '√',
                  'raemptyv;': '⦳',
                  'Rang;': '⟫',
                  'rang;': '⟩',
                  'rangd;': '⦒',
                  'range;': '⦥',
                  'rangle;': '⟩',
                  'raquo;': '»',
                  raquo: '»',
                  'Rarr;': '↠',
                  'rArr;': '⇒',
                  'rarr;': '→',
                  'rarrap;': '⥵',
                  'rarrb;': '⇥',
                  'rarrbfs;': '⤠',
                  'rarrc;': '⤳',
                  'rarrfs;': '⤞',
                  'rarrhk;': '↪',
                  'rarrlp;': '↬',
                  'rarrpl;': '⥅',
                  'rarrsim;': '⥴',
                  'Rarrtl;': '⤖',
                  'rarrtl;': '↣',
                  'rarrw;': '↝',
                  'rAtail;': '⤜',
                  'ratail;': '⤚',
                  'ratio;': '∶',
                  'rationals;': 'ℚ',
                  'RBarr;': '⤐',
                  'rBarr;': '⤏',
                  'rbarr;': '⤍',
                  'rbbrk;': '❳',
                  'rbrace;': '}',
                  'rbrack;': ']',
                  'rbrke;': '⦌',
                  'rbrksld;': '⦎',
                  'rbrkslu;': '⦐',
                  'Rcaron;': 'Ř',
                  'rcaron;': 'ř',
                  'Rcedil;': 'Ŗ',
                  'rcedil;': 'ŗ',
                  'rceil;': '⌉',
                  'rcub;': '}',
                  'Rcy;': 'Р',
                  'rcy;': 'р',
                  'rdca;': '⤷',
                  'rdldhar;': '⥩',
                  'rdquo;': '”',
                  'rdquor;': '”',
                  'rdsh;': '↳',
                  'Re;': 'ℜ',
                  'real;': 'ℜ',
                  'realine;': 'ℛ',
                  'realpart;': 'ℜ',
                  'reals;': 'ℝ',
                  'rect;': '▭',
                  'REG;': '®',
                  REG: '®',
                  'reg;': '®',
                  reg: '®',
                  'ReverseElement;': '∋',
                  'ReverseEquilibrium;': '⇋',
                  'ReverseUpEquilibrium;': '⥯',
                  'rfisht;': '⥽',
                  'rfloor;': '⌋',
                  'Rfr;': 'ℜ',
                  'rfr;': '𝔯',
                  'rHar;': '⥤',
                  'rhard;': '⇁',
                  'rharu;': '⇀',
                  'rharul;': '⥬',
                  'Rho;': 'Ρ',
                  'rho;': 'ρ',
                  'rhov;': 'ϱ',
                  'RightAngleBracket;': '⟩',
                  'RightArrow;': '→',
                  'Rightarrow;': '⇒',
                  'rightarrow;': '→',
                  'RightArrowBar;': '⇥',
                  'RightArrowLeftArrow;': '⇄',
                  'rightarrowtail;': '↣',
                  'RightCeiling;': '⌉',
                  'RightDoubleBracket;': '⟧',
                  'RightDownTeeVector;': '⥝',
                  'RightDownVector;': '⇂',
                  'RightDownVectorBar;': '⥕',
                  'RightFloor;': '⌋',
                  'rightharpoondown;': '⇁',
                  'rightharpoonup;': '⇀',
                  'rightleftarrows;': '⇄',
                  'rightleftharpoons;': '⇌',
                  'rightrightarrows;': '⇉',
                  'rightsquigarrow;': '↝',
                  'RightTee;': '⊢',
                  'RightTeeArrow;': '↦',
                  'RightTeeVector;': '⥛',
                  'rightthreetimes;': '⋌',
                  'RightTriangle;': '⊳',
                  'RightTriangleBar;': '⧐',
                  'RightTriangleEqual;': '⊵',
                  'RightUpDownVector;': '⥏',
                  'RightUpTeeVector;': '⥜',
                  'RightUpVector;': '↾',
                  'RightUpVectorBar;': '⥔',
                  'RightVector;': '⇀',
                  'RightVectorBar;': '⥓',
                  'ring;': '˚',
                  'risingdotseq;': '≓',
                  'rlarr;': '⇄',
                  'rlhar;': '⇌',
                  'rlm;': '‏',
                  'rmoust;': '⎱',
                  'rmoustache;': '⎱',
                  'rnmid;': '⫮',
                  'roang;': '⟭',
                  'roarr;': '⇾',
                  'robrk;': '⟧',
                  'ropar;': '⦆',
                  'Ropf;': 'ℝ',
                  'ropf;': '𝕣',
                  'roplus;': '⨮',
                  'rotimes;': '⨵',
                  'RoundImplies;': '⥰',
                  'rpar;': ')',
                  'rpargt;': '⦔',
                  'rppolint;': '⨒',
                  'rrarr;': '⇉',
                  'Rrightarrow;': '⇛',
                  'rsaquo;': '›',
                  'Rscr;': 'ℛ',
                  'rscr;': '𝓇',
                  'Rsh;': '↱',
                  'rsh;': '↱',
                  'rsqb;': ']',
                  'rsquo;': '’',
                  'rsquor;': '’',
                  'rthree;': '⋌',
                  'rtimes;': '⋊',
                  'rtri;': '▹',
                  'rtrie;': '⊵',
                  'rtrif;': '▸',
                  'rtriltri;': '⧎',
                  'RuleDelayed;': '⧴',
                  'ruluhar;': '⥨',
                  'rx;': '℞',
                  'Sacute;': 'Ś',
                  'sacute;': 'ś',
                  'sbquo;': '‚',
                  'Sc;': '⪼',
                  'sc;': '≻',
                  'scap;': '⪸',
                  'Scaron;': 'Š',
                  'scaron;': 'š',
                  'sccue;': '≽',
                  'scE;': '⪴',
                  'sce;': '⪰',
                  'Scedil;': 'Ş',
                  'scedil;': 'ş',
                  'Scirc;': 'Ŝ',
                  'scirc;': 'ŝ',
                  'scnap;': '⪺',
                  'scnE;': '⪶',
                  'scnsim;': '⋩',
                  'scpolint;': '⨓',
                  'scsim;': '≿',
                  'Scy;': 'С',
                  'scy;': 'с',
                  'sdot;': '⋅',
                  'sdotb;': '⊡',
                  'sdote;': '⩦',
                  'searhk;': '⤥',
                  'seArr;': '⇘',
                  'searr;': '↘',
                  'searrow;': '↘',
                  'sect;': '§',
                  sect: '§',
                  'semi;': ';',
                  'seswar;': '⤩',
                  'setminus;': '∖',
                  'setmn;': '∖',
                  'sext;': '✶',
                  'Sfr;': '𝔖',
                  'sfr;': '𝔰',
                  'sfrown;': '⌢',
                  'sharp;': '♯',
                  'SHCHcy;': 'Щ',
                  'shchcy;': 'щ',
                  'SHcy;': 'Ш',
                  'shcy;': 'ш',
                  'ShortDownArrow;': '↓',
                  'ShortLeftArrow;': '←',
                  'shortmid;': '∣',
                  'shortparallel;': '∥',
                  'ShortRightArrow;': '→',
                  'ShortUpArrow;': '↑',
                  'shy;': '­',
                  shy: '­',
                  'Sigma;': 'Σ',
                  'sigma;': 'σ',
                  'sigmaf;': 'ς',
                  'sigmav;': 'ς',
                  'sim;': '∼',
                  'simdot;': '⩪',
                  'sime;': '≃',
                  'simeq;': '≃',
                  'simg;': '⪞',
                  'simgE;': '⪠',
                  'siml;': '⪝',
                  'simlE;': '⪟',
                  'simne;': '≆',
                  'simplus;': '⨤',
                  'simrarr;': '⥲',
                  'slarr;': '←',
                  'SmallCircle;': '∘',
                  'smallsetminus;': '∖',
                  'smashp;': '⨳',
                  'smeparsl;': '⧤',
                  'smid;': '∣',
                  'smile;': '⌣',
                  'smt;': '⪪',
                  'smte;': '⪬',
                  'smtes;': '⪬︀',
                  'SOFTcy;': 'Ь',
                  'softcy;': 'ь',
                  'sol;': '/',
                  'solb;': '⧄',
                  'solbar;': '⌿',
                  'Sopf;': '𝕊',
                  'sopf;': '𝕤',
                  'spades;': '♠',
                  'spadesuit;': '♠',
                  'spar;': '∥',
                  'sqcap;': '⊓',
                  'sqcaps;': '⊓︀',
                  'sqcup;': '⊔',
                  'sqcups;': '⊔︀',
                  'Sqrt;': '√',
                  'sqsub;': '⊏',
                  'sqsube;': '⊑',
                  'sqsubset;': '⊏',
                  'sqsubseteq;': '⊑',
                  'sqsup;': '⊐',
                  'sqsupe;': '⊒',
                  'sqsupset;': '⊐',
                  'sqsupseteq;': '⊒',
                  'squ;': '□',
                  'Square;': '□',
                  'square;': '□',
                  'SquareIntersection;': '⊓',
                  'SquareSubset;': '⊏',
                  'SquareSubsetEqual;': '⊑',
                  'SquareSuperset;': '⊐',
                  'SquareSupersetEqual;': '⊒',
                  'SquareUnion;': '⊔',
                  'squarf;': '▪',
                  'squf;': '▪',
                  'srarr;': '→',
                  'Sscr;': '𝒮',
                  'sscr;': '𝓈',
                  'ssetmn;': '∖',
                  'ssmile;': '⌣',
                  'sstarf;': '⋆',
                  'Star;': '⋆',
                  'star;': '☆',
                  'starf;': '★',
                  'straightepsilon;': 'ϵ',
                  'straightphi;': 'ϕ',
                  'strns;': '¯',
                  'Sub;': '⋐',
                  'sub;': '⊂',
                  'subdot;': '⪽',
                  'subE;': '⫅',
                  'sube;': '⊆',
                  'subedot;': '⫃',
                  'submult;': '⫁',
                  'subnE;': '⫋',
                  'subne;': '⊊',
                  'subplus;': '⪿',
                  'subrarr;': '⥹',
                  'Subset;': '⋐',
                  'subset;': '⊂',
                  'subseteq;': '⊆',
                  'subseteqq;': '⫅',
                  'SubsetEqual;': '⊆',
                  'subsetneq;': '⊊',
                  'subsetneqq;': '⫋',
                  'subsim;': '⫇',
                  'subsub;': '⫕',
                  'subsup;': '⫓',
                  'succ;': '≻',
                  'succapprox;': '⪸',
                  'succcurlyeq;': '≽',
                  'Succeeds;': '≻',
                  'SucceedsEqual;': '⪰',
                  'SucceedsSlantEqual;': '≽',
                  'SucceedsTilde;': '≿',
                  'succeq;': '⪰',
                  'succnapprox;': '⪺',
                  'succneqq;': '⪶',
                  'succnsim;': '⋩',
                  'succsim;': '≿',
                  'SuchThat;': '∋',
                  'Sum;': '∑',
                  'sum;': '∑',
                  'sung;': '♪',
                  'Sup;': '⋑',
                  'sup;': '⊃',
                  'sup1;': '¹',
                  sup1: '¹',
                  'sup2;': '²',
                  sup2: '²',
                  'sup3;': '³',
                  sup3: '³',
                  'supdot;': '⪾',
                  'supdsub;': '⫘',
                  'supE;': '⫆',
                  'supe;': '⊇',
                  'supedot;': '⫄',
                  'Superset;': '⊃',
                  'SupersetEqual;': '⊇',
                  'suphsol;': '⟉',
                  'suphsub;': '⫗',
                  'suplarr;': '⥻',
                  'supmult;': '⫂',
                  'supnE;': '⫌',
                  'supne;': '⊋',
                  'supplus;': '⫀',
                  'Supset;': '⋑',
                  'supset;': '⊃',
                  'supseteq;': '⊇',
                  'supseteqq;': '⫆',
                  'supsetneq;': '⊋',
                  'supsetneqq;': '⫌',
                  'supsim;': '⫈',
                  'supsub;': '⫔',
                  'supsup;': '⫖',
                  'swarhk;': '⤦',
                  'swArr;': '⇙',
                  'swarr;': '↙',
                  'swarrow;': '↙',
                  'swnwar;': '⤪',
                  'szlig;': 'ß',
                  szlig: 'ß',
                  'Tab;': '\t',
                  'target;': '⌖',
                  'Tau;': 'Τ',
                  'tau;': 'τ',
                  'tbrk;': '⎴',
                  'Tcaron;': 'Ť',
                  'tcaron;': 'ť',
                  'Tcedil;': 'Ţ',
                  'tcedil;': 'ţ',
                  'Tcy;': 'Т',
                  'tcy;': 'т',
                  'tdot;': '⃛',
                  'telrec;': '⌕',
                  'Tfr;': '𝔗',
                  'tfr;': '𝔱',
                  'there4;': '∴',
                  'Therefore;': '∴',
                  'therefore;': '∴',
                  'Theta;': 'Θ',
                  'theta;': 'θ',
                  'thetasym;': 'ϑ',
                  'thetav;': 'ϑ',
                  'thickapprox;': '≈',
                  'thicksim;': '∼',
                  'ThickSpace;': '  ',
                  'thinsp;': ' ',
                  'ThinSpace;': ' ',
                  'thkap;': '≈',
                  'thksim;': '∼',
                  'THORN;': 'Þ',
                  THORN: 'Þ',
                  'thorn;': 'þ',
                  thorn: 'þ',
                  'Tilde;': '∼',
                  'tilde;': '˜',
                  'TildeEqual;': '≃',
                  'TildeFullEqual;': '≅',
                  'TildeTilde;': '≈',
                  'times;': '×',
                  times: '×',
                  'timesb;': '⊠',
                  'timesbar;': '⨱',
                  'timesd;': '⨰',
                  'tint;': '∭',
                  'toea;': '⤨',
                  'top;': '⊤',
                  'topbot;': '⌶',
                  'topcir;': '⫱',
                  'Topf;': '𝕋',
                  'topf;': '𝕥',
                  'topfork;': '⫚',
                  'tosa;': '⤩',
                  'tprime;': '‴',
                  'TRADE;': '™',
                  'trade;': '™',
                  'triangle;': '▵',
                  'triangledown;': '▿',
                  'triangleleft;': '◃',
                  'trianglelefteq;': '⊴',
                  'triangleq;': '≜',
                  'triangleright;': '▹',
                  'trianglerighteq;': '⊵',
                  'tridot;': '◬',
                  'trie;': '≜',
                  'triminus;': '⨺',
                  'TripleDot;': '⃛',
                  'triplus;': '⨹',
                  'trisb;': '⧍',
                  'tritime;': '⨻',
                  'trpezium;': '⏢',
                  'Tscr;': '𝒯',
                  'tscr;': '𝓉',
                  'TScy;': 'Ц',
                  'tscy;': 'ц',
                  'TSHcy;': 'Ћ',
                  'tshcy;': 'ћ',
                  'Tstrok;': 'Ŧ',
                  'tstrok;': 'ŧ',
                  'twixt;': '≬',
                  'twoheadleftarrow;': '↞',
                  'twoheadrightarrow;': '↠',
                  'Uacute;': 'Ú',
                  Uacute: 'Ú',
                  'uacute;': 'ú',
                  uacute: 'ú',
                  'Uarr;': '↟',
                  'uArr;': '⇑',
                  'uarr;': '↑',
                  'Uarrocir;': '⥉',
                  'Ubrcy;': 'Ў',
                  'ubrcy;': 'ў',
                  'Ubreve;': 'Ŭ',
                  'ubreve;': 'ŭ',
                  'Ucirc;': 'Û',
                  Ucirc: 'Û',
                  'ucirc;': 'û',
                  ucirc: 'û',
                  'Ucy;': 'У',
                  'ucy;': 'у',
                  'udarr;': '⇅',
                  'Udblac;': 'Ű',
                  'udblac;': 'ű',
                  'udhar;': '⥮',
                  'ufisht;': '⥾',
                  'Ufr;': '𝔘',
                  'ufr;': '𝔲',
                  'Ugrave;': 'Ù',
                  Ugrave: 'Ù',
                  'ugrave;': 'ù',
                  ugrave: 'ù',
                  'uHar;': '⥣',
                  'uharl;': '↿',
                  'uharr;': '↾',
                  'uhblk;': '▀',
                  'ulcorn;': '⌜',
                  'ulcorner;': '⌜',
                  'ulcrop;': '⌏',
                  'ultri;': '◸',
                  'Umacr;': 'Ū',
                  'umacr;': 'ū',
                  'uml;': '¨',
                  uml: '¨',
                  'UnderBar;': '_',
                  'UnderBrace;': '⏟',
                  'UnderBracket;': '⎵',
                  'UnderParenthesis;': '⏝',
                  'Union;': '⋃',
                  'UnionPlus;': '⊎',
                  'Uogon;': 'Ų',
                  'uogon;': 'ų',
                  'Uopf;': '𝕌',
                  'uopf;': '𝕦',
                  'UpArrow;': '↑',
                  'Uparrow;': '⇑',
                  'uparrow;': '↑',
                  'UpArrowBar;': '⤒',
                  'UpArrowDownArrow;': '⇅',
                  'UpDownArrow;': '↕',
                  'Updownarrow;': '⇕',
                  'updownarrow;': '↕',
                  'UpEquilibrium;': '⥮',
                  'upharpoonleft;': '↿',
                  'upharpoonright;': '↾',
                  'uplus;': '⊎',
                  'UpperLeftArrow;': '↖',
                  'UpperRightArrow;': '↗',
                  'Upsi;': 'ϒ',
                  'upsi;': 'υ',
                  'upsih;': 'ϒ',
                  'Upsilon;': 'Υ',
                  'upsilon;': 'υ',
                  'UpTee;': '⊥',
                  'UpTeeArrow;': '↥',
                  'upuparrows;': '⇈',
                  'urcorn;': '⌝',
                  'urcorner;': '⌝',
                  'urcrop;': '⌎',
                  'Uring;': 'Ů',
                  'uring;': 'ů',
                  'urtri;': '◹',
                  'Uscr;': '𝒰',
                  'uscr;': '𝓊',
                  'utdot;': '⋰',
                  'Utilde;': 'Ũ',
                  'utilde;': 'ũ',
                  'utri;': '▵',
                  'utrif;': '▴',
                  'uuarr;': '⇈',
                  'Uuml;': 'Ü',
                  Uuml: 'Ü',
                  'uuml;': 'ü',
                  uuml: 'ü',
                  'uwangle;': '⦧',
                  'vangrt;': '⦜',
                  'varepsilon;': 'ϵ',
                  'varkappa;': 'ϰ',
                  'varnothing;': '∅',
                  'varphi;': 'ϕ',
                  'varpi;': 'ϖ',
                  'varpropto;': '∝',
                  'vArr;': '⇕',
                  'varr;': '↕',
                  'varrho;': 'ϱ',
                  'varsigma;': 'ς',
                  'varsubsetneq;': '⊊︀',
                  'varsubsetneqq;': '⫋︀',
                  'varsupsetneq;': '⊋︀',
                  'varsupsetneqq;': '⫌︀',
                  'vartheta;': 'ϑ',
                  'vartriangleleft;': '⊲',
                  'vartriangleright;': '⊳',
                  'Vbar;': '⫫',
                  'vBar;': '⫨',
                  'vBarv;': '⫩',
                  'Vcy;': 'В',
                  'vcy;': 'в',
                  'VDash;': '⊫',
                  'Vdash;': '⊩',
                  'vDash;': '⊨',
                  'vdash;': '⊢',
                  'Vdashl;': '⫦',
                  'Vee;': '⋁',
                  'vee;': '∨',
                  'veebar;': '⊻',
                  'veeeq;': '≚',
                  'vellip;': '⋮',
                  'Verbar;': '‖',
                  'verbar;': '|',
                  'Vert;': '‖',
                  'vert;': '|',
                  'VerticalBar;': '∣',
                  'VerticalLine;': '|',
                  'VerticalSeparator;': '❘',
                  'VerticalTilde;': '≀',
                  'VeryThinSpace;': ' ',
                  'Vfr;': '𝔙',
                  'vfr;': '𝔳',
                  'vltri;': '⊲',
                  'vnsub;': '⊂⃒',
                  'vnsup;': '⊃⃒',
                  'Vopf;': '𝕍',
                  'vopf;': '𝕧',
                  'vprop;': '∝',
                  'vrtri;': '⊳',
                  'Vscr;': '𝒱',
                  'vscr;': '𝓋',
                  'vsubnE;': '⫋︀',
                  'vsubne;': '⊊︀',
                  'vsupnE;': '⫌︀',
                  'vsupne;': '⊋︀',
                  'Vvdash;': '⊪',
                  'vzigzag;': '⦚',
                  'Wcirc;': 'Ŵ',
                  'wcirc;': 'ŵ',
                  'wedbar;': '⩟',
                  'Wedge;': '⋀',
                  'wedge;': '∧',
                  'wedgeq;': '≙',
                  'weierp;': '℘',
                  'Wfr;': '𝔚',
                  'wfr;': '𝔴',
                  'Wopf;': '𝕎',
                  'wopf;': '𝕨',
                  'wp;': '℘',
                  'wr;': '≀',
                  'wreath;': '≀',
                  'Wscr;': '𝒲',
                  'wscr;': '𝓌',
                  'xcap;': '⋂',
                  'xcirc;': '◯',
                  'xcup;': '⋃',
                  'xdtri;': '▽',
                  'Xfr;': '𝔛',
                  'xfr;': '𝔵',
                  'xhArr;': '⟺',
                  'xharr;': '⟷',
                  'Xi;': 'Ξ',
                  'xi;': 'ξ',
                  'xlArr;': '⟸',
                  'xlarr;': '⟵',
                  'xmap;': '⟼',
                  'xnis;': '⋻',
                  'xodot;': '⨀',
                  'Xopf;': '𝕏',
                  'xopf;': '𝕩',
                  'xoplus;': '⨁',
                  'xotime;': '⨂',
                  'xrArr;': '⟹',
                  'xrarr;': '⟶',
                  'Xscr;': '𝒳',
                  'xscr;': '𝓍',
                  'xsqcup;': '⨆',
                  'xuplus;': '⨄',
                  'xutri;': '△',
                  'xvee;': '⋁',
                  'xwedge;': '⋀',
                  'Yacute;': 'Ý',
                  Yacute: 'Ý',
                  'yacute;': 'ý',
                  yacute: 'ý',
                  'YAcy;': 'Я',
                  'yacy;': 'я',
                  'Ycirc;': 'Ŷ',
                  'ycirc;': 'ŷ',
                  'Ycy;': 'Ы',
                  'ycy;': 'ы',
                  'yen;': '¥',
                  yen: '¥',
                  'Yfr;': '𝔜',
                  'yfr;': '𝔶',
                  'YIcy;': 'Ї',
                  'yicy;': 'ї',
                  'Yopf;': '𝕐',
                  'yopf;': '𝕪',
                  'Yscr;': '𝒴',
                  'yscr;': '𝓎',
                  'YUcy;': 'Ю',
                  'yucy;': 'ю',
                  'Yuml;': 'Ÿ',
                  'yuml;': 'ÿ',
                  yuml: 'ÿ',
                  'Zacute;': 'Ź',
                  'zacute;': 'ź',
                  'Zcaron;': 'Ž',
                  'zcaron;': 'ž',
                  'Zcy;': 'З',
                  'zcy;': 'з',
                  'Zdot;': 'Ż',
                  'zdot;': 'ż',
                  'zeetrf;': 'ℨ',
                  'ZeroWidthSpace;': '​',
                  'Zeta;': 'Ζ',
                  'zeta;': 'ζ',
                  'Zfr;': 'ℨ',
                  'zfr;': '𝔷',
                  'ZHcy;': 'Ж',
                  'zhcy;': 'ж',
                  'zigrarr;': '⇝',
                  'Zopf;': 'ℤ',
                  'zopf;': '𝕫',
                  'Zscr;': '𝒵',
                  'zscr;': '𝓏',
                  'zwj;': '‍',
                  'zwnj;': '‌',
                },
              })
            )),
          $t = function (t) {
            if ('string' != typeof t) throw new TypeError('Expected a String');
            return t.replace(/&(#?[^;\W]+;?)/g, function (t, e) {
              var n;
              if ((n = /^#(\d+);?$/.exec(e))) return Wt.ucs2.encode([parseInt(n[1], 10)]);
              if ((n = /^#[Xx]([A-Fa-f0-9]+);?/.exec(e))) return Wt.ucs2.encode([parseInt(n[1], 16)]);
              var r = /;$/.test(e),
                i = r ? e.replace(/;$/, '') : e,
                o = Gt[i] || (r && Gt[e]);
              return 'number' == typeof o ? Wt.ucs2.encode([o]) : 'string' == typeof o ? o : '&' + e;
            });
          };
        function Jt(t, e) {
          return (function (t, e, n) {
            if ('string' != typeof t || !t.length) return null;
            if (((e && 'number' == typeof e) || (e = 0), !t[e + 1])) return null;
            if (t[e + 1] && t[e + 1].trim()) return e + 1;
            if (t[e + 2] && t[e + 2].trim()) return e + 2;
            for (var r = e + 1, i = t.length; r < i; r++) if (t[r] && t[r].trim()) return r;
            return null;
          })(t, e);
        }
        function Yt(e, n) {
          if (!e) return [];
          if (Array.isArray(e))
            return e.filter(function (t) {
              return 'string' == typeof t && t.trim();
            });
          if ('string' == typeof e) return e.trim() ? [e] : [];
          throw new TypeError(
            'string-strip-html/stripHtml(): [THROW_ID_03] '
              .concat(n, " must be array containing zero or more strings or something falsey. Currently it's equal to: ")
              .concat(e, ', that a type of ')
              .concat(t(e), '.')
          );
        }
        return (
          (function (t, e, n) {
            t(
              (n = {
                path: void 0,
                exports: {},
                require: function (t, e) {
                  return (function () {
                    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
                  })(null == e && n.path);
                },
              }),
              n.exports
            ),
              n.exports;
          })(function (e, n) {
            var r = '[object Arguments]',
              i = '[object Function]',
              o = '[object GeneratorFunction]',
              a = '[object Map]',
              s = '[object Set]',
              c = /\w*$/,
              u = /^\[object .+?Constructor\]$/,
              l = /^(?:0|[1-9]\d*)$/,
              d = {};
            (d[r] =
              d['[object Array]'] =
              d['[object ArrayBuffer]'] =
              d['[object DataView]'] =
              d['[object Boolean]'] =
              d['[object Date]'] =
              d['[object Float32Array]'] =
              d['[object Float64Array]'] =
              d['[object Int8Array]'] =
              d['[object Int16Array]'] =
              d['[object Int32Array]'] =
              d[a] =
              d['[object Number]'] =
              d['[object Object]'] =
              d['[object RegExp]'] =
              d[s] =
              d['[object String]'] =
              d['[object Symbol]'] =
              d['[object Uint8Array]'] =
              d['[object Uint8ClampedArray]'] =
              d['[object Uint16Array]'] =
              d['[object Uint32Array]'] =
                !0),
              (d['[object Error]'] = d[i] = d['[object WeakMap]'] = !1);
            var f = 'object' == t(S) && S && S.Object === Object && S,
              h = 'object' == ('undefined' == typeof self ? 'undefined' : t(self)) && self && self.Object === Object && self,
              p = f || h || Function('return this')(),
              g = n && !n.nodeType && n,
              v = g && e && !e.nodeType && e,
              m = v && v.exports === g;
            function y(t, e) {
              return t.set(e[0], e[1]), t;
            }
            function b(t, e) {
              return t.add(e), t;
            }
            function w(t, e, n, r) {
              var i = -1,
                o = t ? t.length : 0;
              for (r && o && (n = t[++i]); ++i < o; ) n = e(n, t[i], i, t);
              return n;
            }
            function _(t) {
              var e = !1;
              if (null != t && 'function' != typeof t.toString)
                try {
                  e = !!(t + '');
                } catch (t) {}
              return e;
            }
            function E(t) {
              var e = -1,
                n = Array(t.size);
              return (
                t.forEach(function (t, r) {
                  n[++e] = [r, t];
                }),
                n
              );
            }
            function k(t, e) {
              return function (n) {
                return t(e(n));
              };
            }
            function A(t) {
              var e = -1,
                n = Array(t.size);
              return (
                t.forEach(function (t) {
                  n[++e] = t;
                }),
                n
              );
            }
            var T = Array.prototype,
              x = Function.prototype,
              C = Object.prototype,
              O = p['__core-js_shared__'],
              L = (function () {
                var t = /[^.]+$/.exec((O && O.keys && O.keys.IE_PROTO) || '');
                return t ? 'Symbol(src)_1.' + t : '';
              })(),
              q = x.toString,
              D = C.hasOwnProperty,
              P = C.toString,
              I = RegExp(
                '^' +
                  q
                    .call(D)
                    .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
                    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
                  '$'
              ),
              M = m ? p.Buffer : void 0,
              N = p.Symbol,
              j = p.Uint8Array,
              R = k(Object.getPrototypeOf, Object),
              B = Object.create,
              z = C.propertyIsEnumerable,
              H = T.splice,
              F = Object.getOwnPropertySymbols,
              V = M ? M.isBuffer : void 0,
              U = k(Object.keys, Object),
              W = gt(p, 'DataView'),
              G = gt(p, 'Map'),
              $ = gt(p, 'Promise'),
              J = gt(p, 'Set'),
              Y = gt(p, 'WeakMap'),
              Q = gt(Object, 'create'),
              X = wt(W),
              Z = wt(G),
              K = wt($),
              tt = wt(J),
              et = wt(Y),
              nt = N ? N.prototype : void 0,
              rt = nt ? nt.valueOf : void 0;
            function it(t) {
              var e = -1,
                n = t ? t.length : 0;
              for (this.clear(); ++e < n; ) {
                var r = t[e];
                this.set(r[0], r[1]);
              }
            }
            function ot(t) {
              var e = -1,
                n = t ? t.length : 0;
              for (this.clear(); ++e < n; ) {
                var r = t[e];
                this.set(r[0], r[1]);
              }
            }
            function at(t) {
              var e = -1,
                n = t ? t.length : 0;
              for (this.clear(); ++e < n; ) {
                var r = t[e];
                this.set(r[0], r[1]);
              }
            }
            function st(t) {
              this.__data__ = new ot(t);
            }
            function ct(e, n) {
              var i =
                  Et(e) ||
                  (function (e) {
                    return (
                      (function (e) {
                        return (
                          (function (e) {
                            return !!e && 'object' == t(e);
                          })(e) && kt(e)
                        );
                      })(e) &&
                      D.call(e, 'callee') &&
                      (!z.call(e, 'callee') || P.call(e) == r)
                    );
                  })(e)
                    ? (function (t, e) {
                        for (var n = -1, r = Array(t); ++n < t; ) r[n] = e(n);
                        return r;
                      })(e.length, String)
                    : [],
                o = i.length,
                a = !!o;
              for (var s in e) (!n && !D.call(e, s)) || (a && ('length' == s || yt(s, o))) || i.push(s);
              return i;
            }
            function ut(t, e, n) {
              var r = t[e];
              (D.call(t, e) && _t(r, n) && (void 0 !== n || e in t)) || (t[e] = n);
            }
            function lt(t, e) {
              for (var n = t.length; n--; ) if (_t(t[n][0], e)) return n;
              return -1;
            }
            function dt(t, e, n, u, l, f, h) {
              var p;
              if ((u && (p = f ? u(t, l, f, h) : u(t)), void 0 !== p)) return p;
              if (!xt(t)) return t;
              var g = Et(t);
              if (g) {
                if (
                  ((p = (function (t) {
                    var e = t.length,
                      n = t.constructor(e);
                    return e && 'string' == typeof t[0] && D.call(t, 'index') && ((n.index = t.index), (n.input = t.input)), n;
                  })(t)),
                  !e)
                )
                  return (function (t, e) {
                    var n = -1,
                      r = t.length;
                    for (e || (e = Array(r)); ++n < r; ) e[n] = t[n];
                    return e;
                  })(t, p);
              } else {
                var v = mt(t),
                  m = v == i || v == o;
                if (At(t))
                  return (function (t, e) {
                    if (e) return t.slice();
                    var n = new t.constructor(t.length);
                    return t.copy(n), n;
                  })(t, e);
                if ('[object Object]' == v || v == r || (m && !f)) {
                  if (_(t)) return f ? t : {};
                  if (
                    ((p = (function (t) {
                      return 'function' != typeof t.constructor || bt(t) ? {} : xt((e = R(t))) ? B(e) : {};
                      var e;
                    })(m ? {} : t)),
                    !e)
                  )
                    return (function (t, e) {
                      return ht(t, vt(t), e);
                    })(
                      t,
                      (function (t, e) {
                        return t && ht(e, St(e), t);
                      })(p, t)
                    );
                } else {
                  if (!d[v]) return f ? t : {};
                  p = (function (t, e, n, r) {
                    var i,
                      o = t.constructor;
                    switch (e) {
                      case '[object ArrayBuffer]':
                        return ft(t);
                      case '[object Boolean]':
                      case '[object Date]':
                        return new o(+t);
                      case '[object DataView]':
                        return (function (t, e) {
                          var n = r ? ft(t.buffer) : t.buffer;
                          return new t.constructor(n, t.byteOffset, t.byteLength);
                        })(t);
                      case '[object Float32Array]':
                      case '[object Float64Array]':
                      case '[object Int8Array]':
                      case '[object Int16Array]':
                      case '[object Int32Array]':
                      case '[object Uint8Array]':
                      case '[object Uint8ClampedArray]':
                      case '[object Uint16Array]':
                      case '[object Uint32Array]':
                        return (function (t, e) {
                          var n = r ? ft(t.buffer) : t.buffer;
                          return new t.constructor(n, t.byteOffset, t.length);
                        })(t);
                      case a:
                        return (function (t, e, n) {
                          return w(r ? n(E(t), !0) : E(t), y, new t.constructor());
                        })(t, 0, n);
                      case '[object Number]':
                      case '[object String]':
                        return new o(t);
                      case '[object RegExp]':
                        return (function (t) {
                          var e = new t.constructor(t.source, c.exec(t));
                          return (e.lastIndex = t.lastIndex), e;
                        })(t);
                      case s:
                        return (function (t, e, n) {
                          return w(r ? n(A(t), !0) : A(t), b, new t.constructor());
                        })(t, 0, n);
                      case '[object Symbol]':
                        return (i = t), rt ? Object(rt.call(i)) : {};
                    }
                  })(t, v, dt, e);
                }
              }
              h || (h = new st());
              var k = h.get(t);
              if (k) return k;
              if ((h.set(t, p), !g))
                var T = n
                  ? (function (t) {
                      return (function (t, e, n) {
                        var r = St(t);
                        return Et(t)
                          ? r
                          : (function (t, e) {
                              for (var n = -1, r = e.length, i = t.length; ++n < r; ) t[i + n] = e[n];
                              return t;
                            })(r, n(t));
                      })(t, 0, vt);
                    })(t)
                  : St(t);
              return (
                (function (t, e) {
                  for (var n = -1, r = t ? t.length : 0; ++n < r && !1 !== e(t[n], n); );
                })(T || t, function (r, i) {
                  T && (r = t[(i = r)]), ut(p, i, dt(r, e, n, u, i, t, h));
                }),
                p
              );
            }
            function ft(t) {
              var e = new t.constructor(t.byteLength);
              return new j(e).set(new j(t)), e;
            }
            function ht(t, e, n, r) {
              n || (n = {});
              for (var i = -1, o = e.length; ++i < o; ) {
                var a = e[i],
                  s = r ? r(n[a], t[a], a, n, t) : void 0;
                ut(n, a, void 0 === s ? t[a] : s);
              }
              return n;
            }
            function pt(e, n) {
              var r,
                i,
                o = e.__data__;
              return ('string' == (i = t((r = n))) || 'number' == i || 'symbol' == i || 'boolean' == i ? '__proto__' !== r : null === r)
                ? o['string' == typeof n ? 'string' : 'hash']
                : o.map;
            }
            function gt(t, e) {
              var n = (function (t, e) {
                return null == t ? void 0 : t[e];
              })(t, e);
              return (function (t) {
                return (
                  !(
                    !xt(t) ||
                    (function (t) {
                      return !!L && L in t;
                    })(t)
                  ) && (Tt(t) || _(t) ? I : u).test(wt(t))
                );
              })(n)
                ? n
                : void 0;
            }
            (it.prototype.clear = function () {
              this.__data__ = Q ? Q(null) : {};
            }),
              (it.prototype.delete = function (t) {
                return this.has(t) && delete this.__data__[t];
              }),
              (it.prototype.get = function (t) {
                var e = this.__data__;
                if (Q) {
                  var n = e[t];
                  return '__lodash_hash_undefined__' === n ? void 0 : n;
                }
                return D.call(e, t) ? e[t] : void 0;
              }),
              (it.prototype.has = function (t) {
                var e = this.__data__;
                return Q ? void 0 !== e[t] : D.call(e, t);
              }),
              (it.prototype.set = function (t, e) {
                return (this.__data__[t] = Q && void 0 === e ? '__lodash_hash_undefined__' : e), this;
              }),
              (ot.prototype.clear = function () {
                this.__data__ = [];
              }),
              (ot.prototype.delete = function (t) {
                var e = this.__data__,
                  n = lt(e, t);
                return !(n < 0 || (n == e.length - 1 ? e.pop() : H.call(e, n, 1), 0));
              }),
              (ot.prototype.get = function (t) {
                var e = this.__data__,
                  n = lt(e, t);
                return n < 0 ? void 0 : e[n][1];
              }),
              (ot.prototype.has = function (t) {
                return lt(this.__data__, t) > -1;
              }),
              (ot.prototype.set = function (t, e) {
                var n = this.__data__,
                  r = lt(n, t);
                return r < 0 ? n.push([t, e]) : (n[r][1] = e), this;
              }),
              (at.prototype.clear = function () {
                this.__data__ = { hash: new it(), map: new (G || ot)(), string: new it() };
              }),
              (at.prototype.delete = function (t) {
                return pt(this, t).delete(t);
              }),
              (at.prototype.get = function (t) {
                return pt(this, t).get(t);
              }),
              (at.prototype.has = function (t) {
                return pt(this, t).has(t);
              }),
              (at.prototype.set = function (t, e) {
                return pt(this, t).set(t, e), this;
              }),
              (st.prototype.clear = function () {
                this.__data__ = new ot();
              }),
              (st.prototype.delete = function (t) {
                return this.__data__.delete(t);
              }),
              (st.prototype.get = function (t) {
                return this.__data__.get(t);
              }),
              (st.prototype.has = function (t) {
                return this.__data__.has(t);
              }),
              (st.prototype.set = function (t, e) {
                var n = this.__data__;
                if (n instanceof ot) {
                  var r = n.__data__;
                  if (!G || r.length < 199) return r.push([t, e]), this;
                  n = this.__data__ = new at(r);
                }
                return n.set(t, e), this;
              });
            var vt = F
                ? k(F, Object)
                : function () {
                    return [];
                  },
              mt = function (t) {
                return P.call(t);
              };
            function yt(t, e) {
              return !!(e = null == e ? 9007199254740991 : e) && ('number' == typeof t || l.test(t)) && t > -1 && t % 1 == 0 && t < e;
            }
            function bt(t) {
              var e = t && t.constructor;
              return t === (('function' == typeof e && e.prototype) || C);
            }
            function wt(t) {
              if (null != t) {
                try {
                  return q.call(t);
                } catch (t) {}
                try {
                  return t + '';
                } catch (t) {}
              }
              return '';
            }
            function _t(t, e) {
              return t === e || (t != t && e != e);
            }
            ((W && '[object DataView]' != mt(new W(new ArrayBuffer(1)))) ||
              (G && mt(new G()) != a) ||
              ($ && '[object Promise]' != mt($.resolve())) ||
              (J && mt(new J()) != s) ||
              (Y && '[object WeakMap]' != mt(new Y()))) &&
              (mt = function (t) {
                var e = P.call(t),
                  n = '[object Object]' == e ? t.constructor : void 0,
                  r = n ? wt(n) : void 0;
                if (r)
                  switch (r) {
                    case X:
                      return '[object DataView]';
                    case Z:
                      return a;
                    case K:
                      return '[object Promise]';
                    case tt:
                      return s;
                    case et:
                      return '[object WeakMap]';
                  }
                return e;
              });
            var Et = Array.isArray;
            function kt(t) {
              return (
                null != t &&
                (function (t) {
                  return 'number' == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
                })(t.length) &&
                !Tt(t)
              );
            }
            var At =
              V ||
              function () {
                return !1;
              };
            function Tt(t) {
              var e = xt(t) ? P.call(t) : '';
              return e == i || e == o;
            }
            function xt(e) {
              var n = t(e);
              return !!e && ('object' == n || 'function' == n);
            }
            function St(t) {
              return kt(t)
                ? ct(t)
                : (function (t) {
                    if (!bt(t)) return U(t);
                    var e = [];
                    for (var n in Object(t)) D.call(t, n) && 'constructor' != n && e.push(n);
                    return e;
                  })(t);
            }
            e.exports = function (t) {
              return dt(t, !0, !0);
            };
          }),
          function e(n, r) {
            var a,
              s = new Set([
                '!doctype',
                'abbr',
                'address',
                'area',
                'article',
                'aside',
                'audio',
                'base',
                'bdi',
                'bdo',
                'blockquote',
                'body',
                'br',
                'button',
                'canvas',
                'caption',
                'cite',
                'code',
                'col',
                'colgroup',
                'data',
                'datalist',
                'dd',
                'del',
                'details',
                'dfn',
                'dialog',
                'div',
                'dl',
                'doctype',
                'dt',
                'em',
                'embed',
                'fieldset',
                'figcaption',
                'figure',
                'footer',
                'form',
                'h1',
                'h2',
                'h3',
                'h4',
                'h5',
                'h6',
                'head',
                'header',
                'hgroup',
                'hr',
                'html',
                'iframe',
                'img',
                'input',
                'ins',
                'kbd',
                'keygen',
                'label',
                'legend',
                'li',
                'link',
                'main',
                'map',
                'mark',
                'math',
                'menu',
                'menuitem',
                'meta',
                'meter',
                'nav',
                'noscript',
                'object',
                'ol',
                'optgroup',
                'option',
                'output',
                'param',
                'picture',
                'pre',
                'progress',
                'rb',
                'rp',
                'rt',
                'rtc',
                'ruby',
                'samp',
                'script',
                'section',
                'select',
                'slot',
                'small',
                'source',
                'span',
                'strong',
                'style',
                'sub',
                'summary',
                'sup',
                'svg',
                'table',
                'tbody',
                'td',
                'template',
                'textarea',
                'tfoot',
                'th',
                'thead',
                'time',
                'title',
                'tr',
                'track',
                'ul',
                'var',
                'video',
                'wbr',
                'xml',
              ]),
              c = new Set(['a', 'b', 'i', 'p', 'q', 's', 'u']),
              l = new Set(['.', ',', '?', ';', ')', '…', '"', '»']),
              d = new Set(['script', 'style', 'xml']),
              f = { attributes: [] },
              h = null,
              p = null,
              g = [],
              v = {},
              m = {},
              b = '',
              w = null;
            function _(t, e, r) {
              if (Array.isArray(e.stripTogetherWithTheirContents) && e.stripTogetherWithTheirContents.includes(f.name))
                if (
                  Array.isArray(g) &&
                  g.some(function (e) {
                    return e.name === f.name && e.lastClosingBracketAt < t;
                  })
                ) {
                  for (var i = g.length; i--; )
                    if (g[i].name === f.name) {
                      l.has(n[t])
                        ? e.cb({ tag: f, deleteFrom: g[i].lastOpeningBracketAt, deleteTo: t, insert: null, rangesArr: r, proposedReturn: [g[i].lastOpeningBracketAt, t, null] })
                        : e.cb({ tag: f, deleteFrom: g[i].lastOpeningBracketAt, deleteTo: t, insert: '', rangesArr: r, proposedReturn: [g[i].lastOpeningBracketAt, t, ''] }),
                        g.splice(i, 1);
                      break;
                    }
                } else g.push(f);
            }
            function E(t, e, n, r, i, o) {
              var a = '';
              if ((n < i && (a += t.slice(n, i)), r > o + 1)) {
                var s = t.slice(o + 1, r);
                s.includes('\n') && '<' === t[r] ? (a += ' ') : (a += s);
              }
              if (!l.has(t[e]) && '!' !== t[e]) {
                var c = a.match(/\n/g);
                return Array.isArray(c) && c.length ? (1 === c.length ? '\n' : 2 === c.length ? '\n\n' : '\n\n\n') : ' ';
              }
              return '';
            }
            function k(t) {
              if (
                (t.dumpLinkHrefsNearby.enabled &&
                  Object.keys(m).length &&
                  m.tagName === f.name &&
                  f.lastOpeningBracketAt &&
                  ((m.openingTagEnds && f.lastOpeningBracketAt > m.openingTagEnds) || !m.openingTagEnds) &&
                  (a = !0),
                a)
              ) {
                var e = t.dumpLinkHrefsNearby.putOnNewLine ? '\n\n' : '';
                b = ''.concat(e).concat(m.hrefValue).concat(e);
              }
            }
            if ('string' != typeof n)
              throw new TypeError(
                "string-strip-html/stripHtml(): [THROW_ID_01] Input must be string! Currently it's: ".concat(t(n).toLowerCase(), ', equal to:\n').concat(JSON.stringify(n, null, 4))
              );
            if (!n || !n.trim()) return n;
            if (null != r && !x(r))
              throw new TypeError(
                "string-strip-html/stripHtml(): [THROW_ID_02] Optional Options Object must be a plain object! Currently it's: "
                  .concat(t(r).toLowerCase(), ', equal to:\n')
                  .concat(JSON.stringify(r, null, 4))
              );
            function A() {
              a && ((m = {}), (a = !1));
            }
            var T = {
                ignoreTags: [],
                onlyStripTags: [],
                stripTogetherWithTheirContents: o(d),
                skipHtmlDecoding: !1,
                returnRangesOnly: !1,
                trimOnlySpaces: !1,
                dumpLinkHrefsNearby: { enabled: !1, putOnNewLine: !1, wrapHeads: '', wrapTails: '' },
                cb: null,
              },
              S = i(i({}, T), r);
            (S.ignoreTags = Yt(S.ignoreTags, 'opts.ignoreTags')), (S.onlyStripTags = Yt(S.onlyStripTags, 'opts.onlyStripTags'));
            var C = !!S.onlyStripTags.length;
            if (
              (S.onlyStripTags.length && S.ignoreTags.length && (S.onlyStripTags = Ct.apply(void 0, [S.onlyStripTags].concat(o(S.ignoreTags)))),
              x(S.dumpLinkHrefsNearby) || (S.dumpLinkHrefsNearby = i({}, T.dumpLinkHrefsNearby)),
              (S.dumpLinkHrefsNearby = T.dumpLinkHrefsNearby),
              x(r) && Object.prototype.hasOwnProperty.call(r, 'dumpLinkHrefsNearby') && null != r.dumpLinkHrefsNearby)
            )
              if (x(r.dumpLinkHrefsNearby)) S.dumpLinkHrefsNearby = i(i({}, T.dumpLinkHrefsNearby), r.dumpLinkHrefsNearby);
              else if (r.dumpLinkHrefsNearby)
                throw new TypeError(
                  "string-strip-html/stripHtml(): [THROW_ID_04] Optional Options Object's key dumpLinkHrefsNearby was set to "
                    .concat(t(r.dumpLinkHrefsNearby), ', equal to ')
                    .concat(JSON.stringify(r.dumpLinkHrefsNearby, null, 4), '. The only allowed value is a plain object. See the API reference.')
                );
            S.stripTogetherWithTheirContents
              ? 'string' == typeof S.stripTogetherWithTheirContents &&
                S.stripTogetherWithTheirContents.length > 0 &&
                (S.stripTogetherWithTheirContents = [S.stripTogetherWithTheirContents])
              : (S.stripTogetherWithTheirContents = []);
            var O = {};
            if (
              S.stripTogetherWithTheirContents &&
              Array.isArray(S.stripTogetherWithTheirContents) &&
              S.stripTogetherWithTheirContents.length &&
              !S.stripTogetherWithTheirContents.every(function (t, e) {
                return 'string' == typeof t || ((O.el = t), (O.i = e), !1);
              })
            )
              throw new TypeError(
                "string-strip-html/stripHtml(): [THROW_ID_06] Optional Options Object's key stripTogetherWithTheirContents was set to contain not just string elements! For example, element at index "
                  .concat(O.i, ' has a value ')
                  .concat(O.el, ' which is not string but ')
                  .concat(t(O.el).toLowerCase(), '.')
              );
            S.cb ||
              (S.cb = function (t) {
                var e = t.rangesArr,
                  n = t.proposedReturn;
                e.push.apply(e, o(n));
              });
            var L,
              q = new y({ limitToBeAddedWhitespace: !0, limitLinebreaksCount: 2 });
            if (!S.skipHtmlDecoding) for (; n !== $t(n); ) n = $t(n);
            S.trimOnlySpaces || (n = n.trim());
            for (var D = 0, P = n.length; D < P; D++) {
              if (
                (Object.keys(f).length > 1 && f.lastClosingBracketAt && f.lastClosingBracketAt < D && ' ' !== n[D] && null === w && (w = D),
                '>' === n[D] && (!f || Object.keys(f).length < 2) && D > 1)
              )
                for (
                  var I = D;
                  I-- &&
                  ((void 0 !== n[I - 1] && '>' !== n[I]) ||
                    'break' !==
                      (function () {
                        var t = void 0 === n[I - 1] ? I : I + 1,
                          r = n.slice(t, D + 1);
                        if (
                          n !== '<'.concat(X(r.trim(), '/>'), '>') &&
                          o(s).some(function (t) {
                            return (
                              X(
                                r
                                  .trim()
                                  .split(' ')
                                  .filter(function (t) {
                                    return t.trim();
                                  })
                                  .filter(function (t, e) {
                                    return 0 === e;
                                  }),
                                '/>'
                              ).toLowerCase() === t
                            );
                          }) &&
                          '' === e('<'.concat(r.trim(), '>'), S)
                        ) {
                          var i = E(n, D, t, D + 1, t, D + 1),
                            a = D + 1;
                          if (n[a] && !n[a].trim())
                            for (var c = a; c < P; c++)
                              if (n[c].trim()) {
                                a = c;
                                break;
                              }
                          S.cb({ tag: f, deleteFrom: t, deleteTo: a, insert: i, rangesArr: q, proposedReturn: [t, a, i] });
                        }
                        return 'break';
                      })());

                );
              if (
                ('/' !== n[D] || (f.quotes && f.quotes.value) || !Number.isInteger(f.lastOpeningBracketAt) || Number.isInteger(f.lastClosingBracketAt) || (f.slashPresent = D),
                '"' === n[D] || "'" === n[D])
              )
                if (f.nameStarts && f.quotes && f.quotes.value && f.quotes.value === n[D]) {
                  (v.valueEnds = D), (v.value = n.slice(v.valueStarts, D)), f.attributes.push(v), (v = {}), (f.quotes = void 0);
                  var M = void 0;
                  S.dumpLinkHrefsNearby.enabled &&
                    f.attributes.some(function (t) {
                      if (t.name && 'href' === t.name.toLowerCase())
                        return (
                          (M = ''
                            .concat(S.dumpLinkHrefsNearby.wrapHeads || '')
                            .concat(t.value)
                            .concat(S.dumpLinkHrefsNearby.wrapTails || '')),
                          !0
                        );
                    }) &&
                    (m = { tagName: f.name, hrefValue: M });
                } else
                  !f.quotes &&
                    f.nameStarts &&
                    ((f.quotes = {}),
                    (f.quotes.value = n[D]),
                    (f.quotes.start = D),
                    v.nameStarts && v.nameEnds && v.nameEnds < D && v.nameStarts < D && !v.valueStarts && (v.name = n.slice(v.nameStarts, v.nameEnds)));
              if (!(void 0 === f.nameStarts || void 0 !== f.nameEnds || (n[D].trim() && ((L = n[D]), /[-_A-Za-z0-9]/.test(L))))) {
                if (
                  ((f.nameEnds = D),
                  (f.name = n.slice(f.nameStarts, f.nameEnds + ('>' !== n[D] && '/' !== n[D] && void 0 === n[D + 1] ? 1 : 0))),
                  ('!' !== n[f.nameStarts - 1] && !f.name.replace(/-/g, '').length) || /^\d+$/.test(f.name[0]))
                ) {
                  f = {};
                  continue;
                }
                if ('<' === n[D]) {
                  k(S);
                  var N = E(n, D, f.leftOuterWhitespace, D, f.lastOpeningBracketAt, D);
                  S.cb({
                    tag: f,
                    deleteFrom: f.leftOuterWhitespace,
                    deleteTo: D,
                    insert: ''.concat(N).concat(b).concat(N),
                    rangesArr: q,
                    proposedReturn: [f.leftOuterWhitespace, D, ''.concat(N).concat(b).concat(N)],
                  }),
                    A(),
                    _(D, S, q);
                }
              }
              if (
                (f.quotes && f.quotes.start && f.quotes.start < D && !f.quotes.end && v.nameEnds && v.equalsAt && !v.valueStarts && (v.valueStarts = D),
                f.quotes || !v.nameEnds || '=' !== n[D] || v.valueStarts || v.equalsAt || (v.equalsAt = D),
                !f.quotes && v.nameStarts && v.nameEnds && !v.valueStarts && n[D].trim() && '=' !== n[D] && (f.attributes.push(v), (v = {})),
                f.quotes ||
                  !v.nameStarts ||
                  v.nameEnds ||
                  (n[D].trim()
                    ? '=' === n[D]
                      ? v.equalsAt || ((v.nameEnds = D), (v.equalsAt = D), (v.name = n.slice(v.nameStarts, v.nameEnds)))
                      : ('/' === n[D] || '>' === n[D] || '<' === n[D]) && ((v.nameEnds = D), (v.name = n.slice(v.nameStarts, v.nameEnds)), f.attributes.push(v), (v = {}))
                    : ((v.nameEnds = D), (v.name = n.slice(v.nameStarts, v.nameEnds)))),
                f.quotes || !(f.nameEnds < D) || n[D - 1].trim() || !n[D].trim() || '<>/!'.includes(n[D]) || v.nameStarts || f.lastClosingBracketAt || (v.nameStarts = D),
                null !== f.lastOpeningBracketAt && f.lastOpeningBracketAt < D && '/' === n[D] && f.onlyPlausible && (f.onlyPlausible = !1),
                null !== f.lastOpeningBracketAt &&
                  f.lastOpeningBracketAt < D &&
                  '/' !== n[D] &&
                  (void 0 === f.onlyPlausible && ((n[D].trim() && '<' !== n[D]) || f.slashPresent ? (f.onlyPlausible = !1) : (f.onlyPlausible = !0)),
                  n[D].trim() && void 0 === f.nameStarts && '<' !== n[D] && '/' !== n[D] && '>' !== n[D] && '!' !== n[D] && ((f.nameStarts = D), (f.nameContainsLetters = !1))),
                f.nameStarts && !f.quotes && n[D].toLowerCase() !== n[D].toUpperCase() && (f.nameContainsLetters = !0),
                '>' === n[D] &&
                  void 0 !== f.lastOpeningBracketAt &&
                  ((f.lastClosingBracketAt = D),
                  (w = null),
                  Object.keys(v).length && (f.attributes.push(v), (v = {})),
                  S.dumpLinkHrefsNearby.enabled && m.tagName && !m.openingTagEnds && (m.openingTagEnds = D)),
                void 0 !== f.lastOpeningBracketAt)
              )
                if (void 0 === f.lastClosingBracketAt) {
                  if (f.lastOpeningBracketAt < D && '<' !== n[D] && (void 0 === n[D + 1] || '<' === n[D + 1]) && f.nameContainsLetters) {
                    if (((f.name = n.slice(f.nameStarts, f.nameEnds ? f.nameEnds : D + 1).toLowerCase()), S.ignoreTags.includes(f.name) || (f.onlyPlausible && !s.has(f.name)))) {
                      (f = {}), (v = {});
                      continue;
                    }
                    if (((s.has(f.name) || c.has(f.name)) && (!1 === f.onlyPlausible || (!0 === f.onlyPlausible && f.attributes.length))) || void 0 === n[D + 1]) {
                      k(S);
                      var j = E(n, D, f.leftOuterWhitespace, D + 1, f.lastOpeningBracketAt, f.lastClosingBracketAt);
                      S.cb({
                        tag: f,
                        deleteFrom: f.leftOuterWhitespace,
                        deleteTo: D + 1,
                        insert: ''.concat(j).concat(b).concat(j),
                        rangesArr: q,
                        proposedReturn: [f.leftOuterWhitespace, D + 1, ''.concat(j).concat(b).concat(j)],
                      }),
                        A(),
                        _(D, S, q);
                    }
                  }
                } else if ((D > f.lastClosingBracketAt && n[D].trim()) || void 0 === n[D + 1]) {
                  var R = f.lastClosingBracketAt === D ? D + 1 : D;
                  if ((S.trimOnlySpaces && R === P - 1 && null !== w && w < D && (R = w), (!C && S.ignoreTags.includes(f.name)) || (C && !S.onlyStripTags.includes(f.name))))
                    S.cb({ tag: f, deleteFrom: null, deleteTo: null, insert: null, rangesArr: q, proposedReturn: [] }), (f = {}), (v = {});
                  else if (
                    !f.onlyPlausible ||
                    (0 === f.attributes.length && f.name && (s.has(f.name.toLowerCase()) || c.has(f.name.toLowerCase()))) ||
                    (f.attributes &&
                      f.attributes.some(function (t) {
                        return t.equalsAt;
                      }))
                  ) {
                    var B = E(n, D, f.leftOuterWhitespace, R, f.lastOpeningBracketAt, f.lastClosingBracketAt);
                    (b = ''), (a = !1), k(S);
                    var z = void 0;
                    (z =
                      'string' == typeof b && b.length
                        ? ''
                            .concat(B)
                            .concat(b)
                            .concat('\n\n' === B ? '\n' : B)
                        : B),
                      (0 !== f.leftOuterWhitespace && Jt(n, R - 1)) || (z = ''),
                      S.cb({ tag: f, deleteFrom: f.leftOuterWhitespace, deleteTo: R, insert: z, rangesArr: q, proposedReturn: [f.leftOuterWhitespace, R, z] }),
                      A(),
                      _(D, S, q);
                  } else f = {};
                  '>' !== n[D] && (f = {});
                }
              if ('<' === n[D] && '<' !== n[D - 1]) {
                if ('>' === n[Jt(n, D)]) continue;
                if (f.nameEnds && f.nameEnds < D && !f.lastClosingBracketAt && ((!0 === f.onlyPlausible && f.attributes && f.attributes.length) || !1 === f.onlyPlausible)) {
                  var H = E(n, D, f.leftOuterWhitespace, D, f.lastOpeningBracketAt, D);
                  S.cb({ tag: f, deleteFrom: f.leftOuterWhitespace, deleteTo: D, insert: H, rangesArr: q, proposedReturn: [f.leftOuterWhitespace, D, H] }),
                    _(D, S, q),
                    (f = {}),
                    (v = {});
                }
                if (
                  (void 0 !== f.lastOpeningBracketAt && f.onlyPlausible && f.name && !f.quotes && ((f.lastOpeningBracketAt = void 0), (f.onlyPlausible = !1)),
                  !((void 0 !== f.lastOpeningBracketAt && f.onlyPlausible) || f.quotes) &&
                    ((f.lastOpeningBracketAt = D),
                    (f.slashPresent = !1),
                    (f.attributes = []),
                    null === h ? (f.leftOuterWhitespace = D) : S.trimOnlySpaces && 0 === h ? (f.leftOuterWhitespace = p || D) : (f.leftOuterWhitespace = h),
                    '!--' ===
                      ''
                        .concat(n[D + 1])
                        .concat(n[D + 2])
                        .concat(n[D + 3]) ||
                      '![CDATA[' ===
                        ''
                          .concat(n[D + 1])
                          .concat(n[D + 2])
                          .concat(n[D + 3])
                          .concat(n[D + 4])
                          .concat(n[D + 5])
                          .concat(n[D + 6])
                          .concat(n[D + 7])
                          .concat(n[D + 8])))
                ) {
                  var F = !0;
                  '-' === n[D + 2] && (F = !1);
                  for (var V = void 0, U = D; U < P; U++)
                    if (
                      (((!V &&
                        F &&
                        ']]>' ===
                          ''
                            .concat(n[U - 2])
                            .concat(n[U - 1])
                            .concat(n[U])) ||
                        (!F &&
                          '--\x3e' ===
                            ''
                              .concat(n[U - 2])
                              .concat(n[U - 1])
                              .concat(n[U]))) &&
                        (V = U),
                      V && ((V < U && n[U].trim()) || void 0 === n[U + 1]))
                    ) {
                      var W = U;
                      ((void 0 === n[U + 1] && !n[U].trim()) || '>' === n[U]) && (W += 1);
                      var G = E(n, U, f.leftOuterWhitespace, W, f.lastOpeningBracketAt, V);
                      S.cb({ tag: f, deleteFrom: f.leftOuterWhitespace, deleteTo: W, insert: G, rangesArr: q, proposedReturn: [f.leftOuterWhitespace, W, G] }),
                        (D = U - 1),
                        '>' === n[U] && (D = U),
                        (f = {}),
                        (v = {});
                      break;
                    }
                }
              }
              '' === n[D].trim()
                ? null === h &&
                  ((h = D),
                  void 0 !== f.lastOpeningBracketAt &&
                    f.lastOpeningBracketAt < D &&
                    f.nameStarts &&
                    f.nameStarts < f.lastOpeningBracketAt &&
                    D === f.lastOpeningBracketAt + 1 &&
                    !g.some(function (t) {
                      return t.name === f.name;
                    }) &&
                    ((f.onlyPlausible = !0), (f.name = void 0), (f.nameStarts = void 0)))
                : null !== h &&
                  (!f.quotes &&
                    v.equalsAt > h - 1 &&
                    v.nameEnds &&
                    v.equalsAt > v.nameEnds &&
                    '"' !== n[D] &&
                    "'" !== n[D] &&
                    (x(v) && f.attributes.push(v), (v = {}), (f.equalsSpottedAt = void 0)),
                  (h = null)),
                ' ' === n[D] ? null === p && (p = D) : null !== p && (p = null);
            }
            if (q.current()) {
              if (S.returnRangesOnly) return q.current();
              var $ = u(n, q.current());
              return S.trimOnlySpaces ? X($, ' ') : $.trim();
            }
            return S.returnRangesOnly ? [] : S.trimOnlySpaces ? X(n, ' ') : n.trim();
          }
        );
      })();
    }.call(this, n(9)));
  },
  function (t, e, n) {
    var r, i, o;
    (o = window),
      (r = [n(11), n(16), n(5), n(38), n(39), n(40)]),
      void 0 ===
        (i = function (t, e, n, r, i, a) {
          return (function (t, e, n, r, i, o, a) {
            'use strict';
            var s = t.jQuery,
              c = t.getComputedStyle,
              u = t.console;
            function l(t, e) {
              for (t = r.makeArray(t); t.length; ) e.appendChild(t.shift());
            }
            var d = 0,
              f = {};
            function h(t, e) {
              var n = r.getQueryElement(t);
              if (n) {
                if (((this.element = n), this.element.flickityGUID)) {
                  var i = f[this.element.flickityGUID];
                  return i && i.option(e), i;
                }
                s && (this.$element = s(this.element)), (this.options = r.extend({}, this.constructor.defaults)), this.option(e), this._create();
              } else u && u.error('Bad element for Flickity: ' + (n || t));
            }
            (h.defaults = {
              accessibility: !0,
              cellAlign: 'center',
              freeScrollFriction: 0.075,
              friction: 0.28,
              namespaceJQueryEvents: !0,
              percentPosition: !0,
              resize: !0,
              selectedAttraction: 0.025,
              setGallerySize: !0,
            }),
              (h.createMethods = []);
            var p = h.prototype;
            r.extend(p, e.prototype),
              (p._create = function () {
                var e = (this.guid = ++d);
                for (var n in ((this.element.flickityGUID = e),
                (f[e] = this),
                (this.selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = this.options.rightToLeft ? 'right' : 'left'),
                (this.viewport = document.createElement('div')),
                (this.viewport.className = 'flickity-viewport'),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) && t.addEventListener('resize', this),
                this.options.on)) {
                  var r = this.options.on[n];
                  this.on(n, r);
                }
                h.createMethods.forEach(function (t) {
                  this[t]();
                }, this),
                  this.options.watchCSS ? this.watchCSS() : this.activate();
              }),
              (p.option = function (t) {
                r.extend(this.options, t);
              }),
              (p.activate = function () {
                this.isActive ||
                  ((this.isActive = !0),
                  this.element.classList.add('flickity-enabled'),
                  this.options.rightToLeft && this.element.classList.add('flickity-rtl'),
                  this.getSize(),
                  l(this._filterFindCellElements(this.element.children), this.slider),
                  this.viewport.appendChild(this.slider),
                  this.element.appendChild(this.viewport),
                  this.reloadCells(),
                  this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener('keydown', this)),
                  this.emitEvent('activate'),
                  this.selectInitialIndex(),
                  (this.isInitActivated = !0),
                  this.dispatchEvent('ready'));
              }),
              (p._createSlider = function () {
                var t = document.createElement('div');
                (t.className = 'flickity-slider'), (t.style[this.originSide] = 0), (this.slider = t);
              }),
              (p._filterFindCellElements = function (t) {
                return r.filterFindElements(t, this.options.cellSelector);
              }),
              (p.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize();
              }),
              (p._makeCells = function (t) {
                return this._filterFindCellElements(t).map(function (t) {
                  return new i(t, this);
                }, this);
              }),
              (p.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (p.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
              }),
              (p.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
              }),
              (p._positionCells = function (t) {
                (t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                var e = 0;
                if (t > 0) {
                  var n = this.cells[t - 1];
                  e = n.x + n.size.outerWidth;
                }
                for (var r = this.cells.length, i = t; i < r; i++) {
                  var o = this.cells[i];
                  o.setPosition(e), (e += o.size.outerWidth), (this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight));
                }
                (this.slideableWidth = e), this.updateSlides(), this._containSlides(), (this.slidesWidth = r ? this.getLastSlide().target - this.slides[0].target : 0);
              }),
              (p._sizeCells = function (t) {
                t.forEach(function (t) {
                  t.getSize();
                });
              }),
              (p.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                  var t = new o(this);
                  this.slides.push(t);
                  var e = 'left' == this.originSide ? 'marginRight' : 'marginLeft',
                    n = this._getCanCellFit();
                  this.cells.forEach(function (r, i) {
                    if (t.cells.length) {
                      var a = t.outerWidth - t.firstMargin + (r.size.outerWidth - r.size[e]);
                      n.call(this, i, a) || (t.updateTarget(), (t = new o(this)), this.slides.push(t)), t.addCell(r);
                    } else t.addCell(r);
                  }, this),
                    t.updateTarget(),
                    this.updateSelectedSlide();
                }
              }),
              (p._getCanCellFit = function () {
                var t = this.options.groupCells;
                if (!t)
                  return function () {
                    return !1;
                  };
                if ('number' == typeof t) {
                  var e = parseInt(t, 10);
                  return function (t) {
                    return t % e != 0;
                  };
                }
                var n = 'string' == typeof t && t.match(/^(\d+)%$/),
                  r = n ? parseInt(n[1], 10) / 100 : 1;
                return function (t, e) {
                  return e <= (this.size.innerWidth + 1) * r;
                };
              }),
              (p._init = p.reposition =
                function () {
                  this.positionCells(), this.positionSliderAtSelected();
                }),
              (p.getSize = function () {
                (this.size = n(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign);
              });
            var g = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
            return (
              (p.setCellAlign = function () {
                var t = g[this.options.cellAlign];
                this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
              }),
              (p.setGallerySize = function () {
                if (this.options.setGallerySize) {
                  var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                  this.viewport.style.height = t + 'px';
                }
              }),
              (p._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                  this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                  var t = this.cursorPosition,
                    e = this.cells.length - 1;
                  (this.beforeShiftCells = this._getGapCells(t, e, -1)), (t = this.size.innerWidth - this.cursorPosition), (this.afterShiftCells = this._getGapCells(t, 0, 1));
                }
              }),
              (p._getGapCells = function (t, e, n) {
                for (var r = []; t > 0; ) {
                  var i = this.cells[e];
                  if (!i) break;
                  r.push(i), (e += n), (t -= i.size.outerWidth);
                }
                return r;
              }),
              (p._containSlides = function () {
                if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                  var t = this.options.rightToLeft,
                    e = t ? 'marginRight' : 'marginLeft',
                    n = t ? 'marginLeft' : 'marginRight',
                    r = this.slideableWidth - this.getLastCell().size[n],
                    i = r < this.size.innerWidth,
                    o = this.cursorPosition + this.cells[0].size[e],
                    a = r - this.size.innerWidth * (1 - this.cellAlign);
                  this.slides.forEach(function (t) {
                    i ? (t.target = r * this.cellAlign) : ((t.target = Math.max(t.target, o)), (t.target = Math.min(t.target, a)));
                  }, this);
                }
              }),
              (p.dispatchEvent = function (t, e, n) {
                var r = e ? [e].concat(n) : n;
                if ((this.emitEvent(t, r), s && this.$element)) {
                  var i = (t += this.options.namespaceJQueryEvents ? '.flickity' : '');
                  if (e) {
                    var o = new s.Event(e);
                    (o.type = t), (i = o);
                  }
                  this.$element.trigger(i, n);
                }
              }),
              (p.select = function (t, e, n) {
                if (this.isActive && ((t = parseInt(t, 10)), this._wrapSelect(t), (this.options.wrapAround || e) && (t = r.modulo(t, this.slides.length)), this.slides[t])) {
                  var i = this.selectedIndex;
                  (this.selectedIndex = t),
                    this.updateSelectedSlide(),
                    n ? this.positionSliderAtSelected() : this.startAnimation(),
                    this.options.adaptiveHeight && this.setGallerySize(),
                    this.dispatchEvent('select', null, [t]),
                    t != i && this.dispatchEvent('change', null, [t]),
                    this.dispatchEvent('cellSelect');
                }
              }),
              (p._wrapSelect = function (t) {
                var e = this.slides.length;
                if (!(this.options.wrapAround && e > 1)) return t;
                var n = r.modulo(t, e),
                  i = Math.abs(n - this.selectedIndex),
                  o = Math.abs(n + e - this.selectedIndex),
                  a = Math.abs(n - e - this.selectedIndex);
                !this.isDragSelect && o < i ? (t += e) : !this.isDragSelect && a < i && (t -= e),
                  t < 0 ? (this.x -= this.slideableWidth) : t >= e && (this.x += this.slideableWidth);
              }),
              (p.previous = function (t, e) {
                this.select(this.selectedIndex - 1, t, e);
              }),
              (p.next = function (t, e) {
                this.select(this.selectedIndex + 1, t, e);
              }),
              (p.updateSelectedSlide = function () {
                var t = this.slides[this.selectedIndex];
                t &&
                  (this.unselectSelectedSlide(),
                  (this.selectedSlide = t),
                  t.select(),
                  (this.selectedCells = t.cells),
                  (this.selectedElements = t.getCellElements()),
                  (this.selectedCell = t.cells[0]),
                  (this.selectedElement = this.selectedElements[0]));
              }),
              (p.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
              }),
              (p.selectInitialIndex = function () {
                var t = this.options.initialIndex;
                if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
                else {
                  if (t && 'string' == typeof t && this.queryCell(t)) return void this.selectCell(t, !1, !0);
                  var e = 0;
                  t && this.slides[t] && (e = t), this.select(e, !1, !0);
                }
              }),
              (p.selectCell = function (t, e, n) {
                var r = this.queryCell(t);
                if (r) {
                  var i = this.getCellSlideIndex(r);
                  this.select(i, e, n);
                }
              }),
              (p.getCellSlideIndex = function (t) {
                for (var e = 0; e < this.slides.length; e++) if (-1 != this.slides[e].cells.indexOf(t)) return e;
              }),
              (p.getCell = function (t) {
                for (var e = 0; e < this.cells.length; e++) {
                  var n = this.cells[e];
                  if (n.element == t) return n;
                }
              }),
              (p.getCells = function (t) {
                t = r.makeArray(t);
                var e = [];
                return (
                  t.forEach(function (t) {
                    var n = this.getCell(t);
                    n && e.push(n);
                  }, this),
                  e
                );
              }),
              (p.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              (p.getParentCell = function (t) {
                return this.getCell(t) || ((t = r.getParent(t, '.flickity-slider > *')), this.getCell(t));
              }),
              (p.getAdjacentCellElements = function (t, e) {
                if (!t) return this.selectedSlide.getCellElements();
                e = void 0 === e ? this.selectedIndex : e;
                var n = this.slides.length;
                if (1 + 2 * t >= n) return this.getCellElements();
                for (var i = [], o = e - t; o <= e + t; o++) {
                  var a = this.options.wrapAround ? r.modulo(o, n) : o,
                    s = this.slides[a];
                  s && (i = i.concat(s.getCellElements()));
                }
                return i;
              }),
              (p.queryCell = function (t) {
                if ('number' == typeof t) return this.cells[t];
                if ('string' == typeof t) {
                  if (t.match(/^[#.]?[\d/]/)) return;
                  t = this.element.querySelector(t);
                }
                return this.getCell(t);
              }),
              (p.checkVisibility = function () {
                var t = this.viewport.getBoundingClientRect().x,
                  e = this.viewport.offsetWidth;
                this.options.wrapAround && (e -= 4),
                  this.cells.forEach(function (n) {
                    var r = n.element.getBoundingClientRect().x - t;
                    (r > -1 && r < 1) || (r + n.size.innerWidth > t && r + n.size.innerWidth < e) || (r > t && r < e)
                      ? (n.element.classList.add('is-visible'), n.element.removeAttribute('aria-hidden'), n.element.querySelectorAll('button, a').forEach((t) => (t.tabIndex = 0)))
                      : (n.element.classList.remove('is-visible'),
                        n.element.setAttribute('aria-hidden', !0),
                        n.element.querySelectorAll('button, a').forEach((t) => (t.tabIndex = -1)));
                  });
              }),
              (p.uiChange = function () {
                this.emitEvent('uiChange');
              }),
              (p.childUIPointerDown = function (t) {
                'touchstart' != t.type && t.preventDefault(), this.focus();
              }),
              (p.onresize = function () {
                this.watchCSS(), this.resize();
              }),
              r.debounceMethod(h, 'onresize', 150),
              (p.resize = function () {
                if (this.isActive) {
                  this.getSize(),
                    this.options.wrapAround && (this.x = r.modulo(this.x, this.slideableWidth)),
                    this.positionCells(),
                    this._getWrapShiftCells(),
                    this.setGallerySize(),
                    this.emitEvent('resize');
                  var t = this.selectedElements && this.selectedElements[0];
                  this.selectCell(t, !1, !0);
                }
              }),
              (p.watchCSS = function () {
                this.options.watchCSS && (-1 != c(this.element, ':after').content.indexOf('flickity') ? this.activate() : this.deactivate());
              }),
              (p.onkeydown = function (t) {
                var e = document.activeElement && document.activeElement != this.element;
                if (this.options.accessibility && !e) {
                  var n = h.keyboardHandlers[t.keyCode];
                  n && n.call(this);
                }
              }),
              (h.keyboardHandlers = {
                37: function () {
                  var t = this.options.rightToLeft ? 'next' : 'previous';
                  this.uiChange(), this[t]();
                },
                39: function () {
                  var t = this.options.rightToLeft ? 'previous' : 'next';
                  this.uiChange(), this[t]();
                },
              }),
              (p.focus = function () {
                var e = t.pageYOffset;
                this.element.focus({ preventScroll: !0 }), t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
              }),
              (p.deactivate = function () {
                this.isActive &&
                  (this.element.classList.remove('flickity-enabled'),
                  this.element.classList.remove('flickity-rtl'),
                  this.unselectSelectedSlide(),
                  this.cells.forEach(function (t) {
                    t.destroy();
                  }),
                  this.element.removeChild(this.viewport),
                  l(this.slider.children, this.element),
                  this.options.accessibility && (this.element.removeAttribute('tabIndex'), this.element.removeEventListener('keydown', this)),
                  (this.isActive = !1),
                  this.emitEvent('deactivate'));
              }),
              (p.destroy = function () {
                this.deactivate(),
                  t.removeEventListener('resize', this),
                  this.allOff(),
                  this.emitEvent('destroy'),
                  s && this.$element && s.removeData(this.element, 'flickity'),
                  delete this.element.flickityGUID,
                  delete f[this.guid];
              }),
              r.extend(p, a),
              (h.data = function (t) {
                var e = (t = r.getQueryElement(t)) && t.flickityGUID;
                return e && f[e];
              }),
              r.htmlInit(h, 'flickity'),
              s && s.bridget && s.bridget('flickity', h),
              (h.setJQuery = function (t) {
                s = t;
              }),
              (h.Cell = i),
              (h.Slide = o),
              h
            );
          })(o, t, e, n, r, i, a);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e) {
    var n;
    n = (function () {
      return this;
    })();
    try {
      n = n || new Function('return this')();
    } catch (t) {
      'object' == typeof window && (n = window);
    }
    t.exports = n;
  },
  function (t, e) {
    (t.exports = function (t, e, n) {
      return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = n), t;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    var r, i;
    'undefined' != typeof window && window,
      void 0 ===
        (i =
          'function' ==
          typeof (r = function () {
            'use strict';
            function t() {}
            var e = t.prototype;
            return (
              (e.on = function (t, e) {
                if (t && e) {
                  var n = (this._events = this._events || {}),
                    r = (n[t] = n[t] || []);
                  return -1 == r.indexOf(e) && r.push(e), this;
                }
              }),
              (e.once = function (t, e) {
                if (t && e) {
                  this.on(t, e);
                  var n = (this._onceEvents = this._onceEvents || {});
                  return ((n[t] = n[t] || {})[e] = !0), this;
                }
              }),
              (e.off = function (t, e) {
                var n = this._events && this._events[t];
                if (n && n.length) {
                  var r = n.indexOf(e);
                  return -1 != r && n.splice(r, 1), this;
                }
              }),
              (e.emitEvent = function (t, e) {
                var n = this._events && this._events[t];
                if (n && n.length) {
                  (n = n.slice(0)), (e = e || []);
                  for (var r = this._onceEvents && this._onceEvents[t], i = 0; i < n.length; i++) {
                    var o = n[i];
                    r && r[o] && (this.off(t, o), delete r[o]), o.apply(this, e);
                  }
                  return this;
                }
              }),
              (e.allOff = function () {
                delete this._events, delete this._onceEvents;
              }),
              t
            );
          })
            ? r.call(e, n, e, t)
            : r) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i, o;
    (o = window),
      (r = [n(11)]),
      void 0 ===
        (i = function (t) {
          return (function (t, e) {
            'use strict';
            function n() {}
            var r = (n.prototype = Object.create(e.prototype));
            (r.bindStartEvent = function (t) {
              this._bindStartEvent(t, !0);
            }),
              (r.unbindStartEvent = function (t) {
                this._bindStartEvent(t, !1);
              }),
              (r._bindStartEvent = function (e, n) {
                var r = (n = void 0 === n || n) ? 'addEventListener' : 'removeEventListener',
                  i = 'mousedown';
                t.PointerEvent ? (i = 'pointerdown') : 'ontouchstart' in t && (i = 'touchstart'), e[r](i, this);
              }),
              (r.handleEvent = function (t) {
                var e = 'on' + t.type;
                this[e] && this[e](t);
              }),
              (r.getTouch = function (t) {
                for (var e = 0; e < t.length; e++) {
                  var n = t[e];
                  if (n.identifier == this.pointerIdentifier) return n;
                }
              }),
              (r.onmousedown = function (t) {
                var e = t.button;
                (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
              }),
              (r.ontouchstart = function (t) {
                this._pointerDown(t, t.changedTouches[0]);
              }),
              (r.onpointerdown = function (t) {
                this._pointerDown(t, t);
              }),
              (r._pointerDown = function (t, e) {
                t.button ||
                  this.isPointerDown ||
                  ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier), this.pointerDown(t, e));
              }),
              (r.pointerDown = function (t, e) {
                this._bindPostStartEvents(t), this.emitEvent('pointerDown', [t, e]);
              });
            var i = { mousedown: ['mousemove', 'mouseup'], touchstart: ['touchmove', 'touchend', 'touchcancel'], pointerdown: ['pointermove', 'pointerup', 'pointercancel'] };
            return (
              (r._bindPostStartEvents = function (e) {
                if (e) {
                  var n = i[e.type];
                  n.forEach(function (e) {
                    t.addEventListener(e, this);
                  }, this),
                    (this._boundPointerEvents = n);
                }
              }),
              (r._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                  (this._boundPointerEvents.forEach(function (e) {
                    t.removeEventListener(e, this);
                  }, this),
                  delete this._boundPointerEvents);
              }),
              (r.onmousemove = function (t) {
                this._pointerMove(t, t);
              }),
              (r.onpointermove = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerMove(t, t);
              }),
              (r.ontouchmove = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerMove(t, e);
              }),
              (r._pointerMove = function (t, e) {
                this.pointerMove(t, e);
              }),
              (r.pointerMove = function (t, e) {
                this.emitEvent('pointerMove', [t, e]);
              }),
              (r.onmouseup = function (t) {
                this._pointerUp(t, t);
              }),
              (r.onpointerup = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
              }),
              (r.ontouchend = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerUp(t, e);
              }),
              (r._pointerUp = function (t, e) {
                this._pointerDone(), this.pointerUp(t, e);
              }),
              (r.pointerUp = function (t, e) {
                this.emitEvent('pointerUp', [t, e]);
              }),
              (r._pointerDone = function () {
                this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
              }),
              (r._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
              }),
              (r.pointerDone = function () {}),
              (r.onpointercancel = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t);
              }),
              (r.ontouchcancel = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerCancel(t, e);
              }),
              (r._pointerCancel = function (t, e) {
                this._pointerDone(), this.pointerCancel(t, e);
              }),
              (r.pointerCancel = function (t, e) {
                this.emitEvent('pointerCancel', [t, e]);
              }),
              (n.getPointerPoint = function (t) {
                return { x: t.pageX, y: t.pageY };
              }),
              n
            );
          })(o, t);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e) {
    var n,
      r,
      i = (t.exports = {});
    function o() {
      throw new Error('setTimeout has not been defined');
    }
    function a() {
      throw new Error('clearTimeout has not been defined');
    }
    function s(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout) return (n = setTimeout), setTimeout(t, 0);
      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }
    !(function () {
      try {
        n = 'function' == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }
      try {
        r = 'function' == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        r = a;
      }
    })();
    var c,
      u = [],
      l = !1,
      d = -1;
    function f() {
      l && c && ((l = !1), c.length ? (u = c.concat(u)) : (d = -1), u.length && h());
    }
    function h() {
      if (!l) {
        var t = s(f);
        l = !0;
        for (var e = u.length; e; ) {
          for (c = u, u = []; ++d < e; ) c && c[d].run();
          (d = -1), (e = u.length);
        }
        (c = null),
          (l = !1),
          (function (t) {
            if (r === clearTimeout) return clearTimeout(t);
            if ((r === a || !r) && clearTimeout) return (r = clearTimeout), clearTimeout(t);
            try {
              r(t);
            } catch (e) {
              try {
                return r.call(null, t);
              } catch (e) {
                return r.call(this, t);
              }
            }
          })(t);
      }
    }
    function p(t, e) {
      (this.fun = t), (this.array = e);
    }
    function g() {}
    (i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
      u.push(new p(t, e)), 1 !== u.length || l || s(h);
    }),
      (p.prototype.run = function () {
        this.fun.apply(null, this.array);
      }),
      (i.title = 'browser'),
      (i.browser = !0),
      (i.env = {}),
      (i.argv = []),
      (i.version = ''),
      (i.versions = {}),
      (i.on = g),
      (i.addListener = g),
      (i.once = g),
      (i.off = g),
      (i.removeListener = g),
      (i.removeAllListeners = g),
      (i.emit = g),
      (i.prependListener = g),
      (i.prependOnceListener = g),
      (i.listeners = function (t) {
        return [];
      }),
      (i.binding = function (t) {
        throw new Error('process.binding is not supported');
      }),
      (i.cwd = function () {
        return '/';
      }),
      (i.chdir = function (t) {
        throw new Error('process.chdir is not supported');
      }),
      (i.umask = function () {
        return 0;
      });
  },
  function (t, e) {
    (t.exports = function (t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    var r = n(14);
    (t.exports = function (t, e) {
      if (t) {
        if ('string' == typeof t) return r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return (
          'Object' === n && t.constructor && (n = t.constructor.name),
          'Map' === n || 'Set' === n ? Array.from(t) : 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0
        );
      }
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    var r, i;
    window,
      void 0 ===
        (i =
          'function' ==
          typeof (r = function () {
            'use strict';
            function t(t) {
              var e = parseFloat(t);
              return -1 == t.indexOf('%') && !isNaN(e) && e;
            }
            var e =
                'undefined' == typeof console
                  ? function () {}
                  : function (t) {
                      console.error(t);
                    },
              n = [
                'paddingLeft',
                'paddingRight',
                'paddingTop',
                'paddingBottom',
                'marginLeft',
                'marginRight',
                'marginTop',
                'marginBottom',
                'borderLeftWidth',
                'borderRightWidth',
                'borderTopWidth',
                'borderBottomWidth',
              ],
              r = n.length;
            function i(t) {
              var n = getComputedStyle(t);
              return n || e('Style returned ' + n + '. Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1'), n;
            }
            var o,
              a = !1;
            return function e(s) {
              if (
                ((function () {
                  if (!a) {
                    a = !0;
                    var n = document.createElement('div');
                    (n.style.width = '200px'),
                      (n.style.padding = '1px 2px 3px 4px'),
                      (n.style.borderStyle = 'solid'),
                      (n.style.borderWidth = '1px 2px 3px 4px'),
                      (n.style.boxSizing = 'border-box');
                    var r = document.body || document.documentElement;
                    r.appendChild(n);
                    var s = i(n);
                    (o = 200 == Math.round(t(s.width))), (e.isBoxSizeOuter = o), r.removeChild(n);
                  }
                })(),
                'string' == typeof s && (s = document.querySelector(s)),
                s && 'object' == typeof s && s.nodeType)
              ) {
                var c = i(s);
                if ('none' == c.display)
                  return (function () {
                    for (var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0; e < r; e++) t[n[e]] = 0;
                    return t;
                  })();
                var u = {};
                (u.width = s.offsetWidth), (u.height = s.offsetHeight);
                for (var l = (u.isBorderBox = 'border-box' == c.boxSizing), d = 0; d < r; d++) {
                  var f = n[d],
                    h = c[f],
                    p = parseFloat(h);
                  u[f] = isNaN(p) ? 0 : p;
                }
                var g = u.paddingLeft + u.paddingRight,
                  v = u.paddingTop + u.paddingBottom,
                  m = u.marginLeft + u.marginRight,
                  y = u.marginTop + u.marginBottom,
                  b = u.borderLeftWidth + u.borderRightWidth,
                  w = u.borderTopWidth + u.borderBottomWidth,
                  _ = l && o,
                  E = t(c.width);
                !1 !== E && (u.width = E + (_ ? 0 : g + b));
                var k = t(c.height);
                return (
                  !1 !== k && (u.height = k + (_ ? 0 : v + w)),
                  (u.innerWidth = u.width - (g + b)),
                  (u.innerHeight = u.height - (v + w)),
                  (u.outerWidth = u.width + m),
                  (u.outerHeight = u.height + y),
                  u
                );
              }
            };
          })
            ? r.call(e, n, e, t)
            : r) || (t.exports = i);
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 }),
      (e.formatMoney = function (t, e) {
        'string' == typeof t && (t = t.replace('.', ''));
        var n = '',
          r = /\{\{\s*(\w+)\s*\}\}/,
          i = e || '${{amount}}';
        function o(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ',',
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : '.';
          if (isNaN(t) || null == t) return 0;
          var i = (t = (t / 100).toFixed(e)).split('.');
          return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + n) + (i[1] ? r + i[1] : '');
        }
        switch (i.match(r)[1]) {
          case 'amount':
            n = o(t, 2);
            break;
          case 'amount_no_decimals':
            n = o(t, 0);
            break;
          case 'amount_with_comma_separator':
            n = o(t, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            n = o(t, 0, '.', ',');
        }
        return i.replace(r, n);
      });
  },
  function (t, e, n) {
    'use strict';
    (function (t) {
      var n = (function () {
          if ('undefined' != typeof Map) return Map;
          function t(t, e) {
            var n = -1;
            return (
              t.some(function (t, r) {
                return t[0] === e && ((n = r), !0);
              }),
              n
            );
          }
          return (function () {
            function e() {
              this.__entries__ = [];
            }
            return (
              Object.defineProperty(e.prototype, 'size', {
                get: function () {
                  return this.__entries__.length;
                },
                enumerable: !0,
                configurable: !0,
              }),
              (e.prototype.get = function (e) {
                var n = t(this.__entries__, e),
                  r = this.__entries__[n];
                return r && r[1];
              }),
              (e.prototype.set = function (e, n) {
                var r = t(this.__entries__, e);
                ~r ? (this.__entries__[r][1] = n) : this.__entries__.push([e, n]);
              }),
              (e.prototype.delete = function (e) {
                var n = this.__entries__,
                  r = t(n, e);
                ~r && n.splice(r, 1);
              }),
              (e.prototype.has = function (e) {
                return !!~t(this.__entries__, e);
              }),
              (e.prototype.clear = function () {
                this.__entries__.splice(0);
              }),
              (e.prototype.forEach = function (t, e) {
                void 0 === e && (e = null);
                for (var n = 0, r = this.__entries__; n < r.length; n++) {
                  var i = r[n];
                  t.call(e, i[1], i[0]);
                }
              }),
              e
            );
          })();
        })(),
        r = 'undefined' != typeof window && 'undefined' != typeof document && window.document === document,
        i =
          void 0 !== t && t.Math === Math
            ? t
            : 'undefined' != typeof self && self.Math === Math
            ? self
            : 'undefined' != typeof window && window.Math === Math
            ? window
            : Function('return this')(),
        o =
          'function' == typeof requestAnimationFrame
            ? requestAnimationFrame.bind(i)
            : function (t) {
                return setTimeout(function () {
                  return t(Date.now());
                }, 1e3 / 60);
              },
        a = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'],
        s = 'undefined' != typeof MutationObserver,
        c = (function () {
          function t() {
            (this.connected_ = !1),
              (this.mutationEventsAdded_ = !1),
              (this.mutationsObserver_ = null),
              (this.observers_ = []),
              (this.onTransitionEnd_ = this.onTransitionEnd_.bind(this)),
              (this.refresh = (function (t, e) {
                var n = !1,
                  r = !1,
                  i = 0;
                function a() {
                  n && ((n = !1), t()), r && c();
                }
                function s() {
                  o(a);
                }
                function c() {
                  var t = Date.now();
                  if (n) {
                    if (t - i < 2) return;
                    r = !0;
                  } else (n = !0), (r = !1), setTimeout(s, e);
                  i = t;
                }
                return c;
              })(this.refresh.bind(this), 20));
          }
          return (
            (t.prototype.addObserver = function (t) {
              ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
            }),
            (t.prototype.removeObserver = function (t) {
              var e = this.observers_,
                n = e.indexOf(t);
              ~n && e.splice(n, 1), !e.length && this.connected_ && this.disconnect_();
            }),
            (t.prototype.refresh = function () {
              this.updateObservers_() && this.refresh();
            }),
            (t.prototype.updateObservers_ = function () {
              var t = this.observers_.filter(function (t) {
                return t.gatherActive(), t.hasActive();
              });
              return (
                t.forEach(function (t) {
                  return t.broadcastActive();
                }),
                t.length > 0
              );
            }),
            (t.prototype.connect_ = function () {
              r &&
                !this.connected_ &&
                (document.addEventListener('transitionend', this.onTransitionEnd_),
                window.addEventListener('resize', this.refresh),
                s
                  ? ((this.mutationsObserver_ = new MutationObserver(this.refresh)),
                    this.mutationsObserver_.observe(document, { attributes: !0, childList: !0, characterData: !0, subtree: !0 }))
                  : (document.addEventListener('DOMSubtreeModified', this.refresh), (this.mutationEventsAdded_ = !0)),
                (this.connected_ = !0));
            }),
            (t.prototype.disconnect_ = function () {
              r &&
                this.connected_ &&
                (document.removeEventListener('transitionend', this.onTransitionEnd_),
                window.removeEventListener('resize', this.refresh),
                this.mutationsObserver_ && this.mutationsObserver_.disconnect(),
                this.mutationEventsAdded_ && document.removeEventListener('DOMSubtreeModified', this.refresh),
                (this.mutationsObserver_ = null),
                (this.mutationEventsAdded_ = !1),
                (this.connected_ = !1));
            }),
            (t.prototype.onTransitionEnd_ = function (t) {
              var e = t.propertyName,
                n = void 0 === e ? '' : e;
              a.some(function (t) {
                return !!~n.indexOf(t);
              }) && this.refresh();
            }),
            (t.getInstance = function () {
              return this.instance_ || (this.instance_ = new t()), this.instance_;
            }),
            (t.instance_ = null),
            t
          );
        })(),
        u = function (t, e) {
          for (var n = 0, r = Object.keys(e); n < r.length; n++) {
            var i = r[n];
            Object.defineProperty(t, i, { value: e[i], enumerable: !1, writable: !1, configurable: !0 });
          }
          return t;
        },
        l = function (t) {
          return (t && t.ownerDocument && t.ownerDocument.defaultView) || i;
        },
        d = v(0, 0, 0, 0);
      function f(t) {
        return parseFloat(t) || 0;
      }
      function h(t) {
        for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
        return e.reduce(function (e, n) {
          return e + f(t['border-' + n + '-width']);
        }, 0);
      }
      var p =
        'undefined' != typeof SVGGraphicsElement
          ? function (t) {
              return t instanceof l(t).SVGGraphicsElement;
            }
          : function (t) {
              return t instanceof l(t).SVGElement && 'function' == typeof t.getBBox;
            };
      function g(t) {
        return r
          ? p(t)
            ? (function (t) {
                var e = t.getBBox();
                return v(0, 0, e.width, e.height);
              })(t)
            : (function (t) {
                var e = t.clientWidth,
                  n = t.clientHeight;
                if (!e && !n) return d;
                var r = l(t).getComputedStyle(t),
                  i = (function (t) {
                    for (var e = {}, n = 0, r = ['top', 'right', 'bottom', 'left']; n < r.length; n++) {
                      var i = r[n],
                        o = t['padding-' + i];
                      e[i] = f(o);
                    }
                    return e;
                  })(r),
                  o = i.left + i.right,
                  a = i.top + i.bottom,
                  s = f(r.width),
                  c = f(r.height);
                if (
                  ('border-box' === r.boxSizing && (Math.round(s + o) !== e && (s -= h(r, 'left', 'right') + o), Math.round(c + a) !== n && (c -= h(r, 'top', 'bottom') + a)),
                  !(function (t) {
                    return t === l(t).document.documentElement;
                  })(t))
                ) {
                  var u = Math.round(s + o) - e,
                    p = Math.round(c + a) - n;
                  1 !== Math.abs(u) && (s -= u), 1 !== Math.abs(p) && (c -= p);
                }
                return v(i.left, i.top, s, c);
              })(t)
          : d;
      }
      function v(t, e, n, r) {
        return { x: t, y: e, width: n, height: r };
      }
      var m = (function () {
          function t(t) {
            (this.broadcastWidth = 0), (this.broadcastHeight = 0), (this.contentRect_ = v(0, 0, 0, 0)), (this.target = t);
          }
          return (
            (t.prototype.isActive = function () {
              var t = g(this.target);
              return (this.contentRect_ = t), t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
            }),
            (t.prototype.broadcastRect = function () {
              var t = this.contentRect_;
              return (this.broadcastWidth = t.width), (this.broadcastHeight = t.height), t;
            }),
            t
          );
        })(),
        y = function (t, e) {
          var n,
            r,
            i,
            o,
            a,
            s,
            c,
            l =
              ((r = (n = e).x),
              (i = n.y),
              (o = n.width),
              (a = n.height),
              (s = 'undefined' != typeof DOMRectReadOnly ? DOMRectReadOnly : Object),
              (c = Object.create(s.prototype)),
              u(c, { x: r, y: i, width: o, height: a, top: i, right: r + o, bottom: a + i, left: r }),
              c);
          u(this, { target: t, contentRect: l });
        },
        b = (function () {
          function t(t, e, r) {
            if (((this.activeObservations_ = []), (this.observations_ = new n()), 'function' != typeof t))
              throw new TypeError('The callback provided as parameter 1 is not a function.');
            (this.callback_ = t), (this.controller_ = e), (this.callbackCtx_ = r);
          }
          return (
            (t.prototype.observe = function (t) {
              if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
              if ('undefined' != typeof Element && Element instanceof Object) {
                if (!(t instanceof l(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var e = this.observations_;
                e.has(t) || (e.set(t, new m(t)), this.controller_.addObserver(this), this.controller_.refresh());
              }
            }),
            (t.prototype.unobserve = function (t) {
              if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
              if ('undefined' != typeof Element && Element instanceof Object) {
                if (!(t instanceof l(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var e = this.observations_;
                e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this));
              }
            }),
            (t.prototype.disconnect = function () {
              this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
            }),
            (t.prototype.gatherActive = function () {
              var t = this;
              this.clearActive(),
                this.observations_.forEach(function (e) {
                  e.isActive() && t.activeObservations_.push(e);
                });
            }),
            (t.prototype.broadcastActive = function () {
              if (this.hasActive()) {
                var t = this.callbackCtx_,
                  e = this.activeObservations_.map(function (t) {
                    return new y(t.target, t.broadcastRect());
                  });
                this.callback_.call(t, e, t), this.clearActive();
              }
            }),
            (t.prototype.clearActive = function () {
              this.activeObservations_.splice(0);
            }),
            (t.prototype.hasActive = function () {
              return this.activeObservations_.length > 0;
            }),
            t
          );
        })(),
        w = 'undefined' != typeof WeakMap ? new WeakMap() : new n(),
        _ = function t(e) {
          if (!(this instanceof t)) throw new TypeError('Cannot call a class as a function.');
          if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
          var n = c.getInstance(),
            r = new b(e, n, this);
          w.set(this, r);
        };
      ['observe', 'unobserve', 'disconnect'].forEach(function (t) {
        _.prototype[t] = function () {
          var e;
          return (e = w.get(this))[t].apply(e, arguments);
        };
      });
      var E = void 0 !== i.ResizeObserver ? i.ResizeObserver : _;
      e.a = E;
    }.call(this, n(9)));
  },
  function (t, e, n) {
    var r = n(36);
    (t.exports = function (t, e) {
      if (null == t) return {};
      var n,
        i,
        o = r(t, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        for (i = 0; i < a.length; i++) (n = a[i]), e.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]));
      }
      return o;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var r =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t;
            },
      i = s(n(48)),
      o = s(n(49)),
      a = s(n(51));
    function s(t) {
      return t && t.__esModule ? t : { default: t };
    }
    var c = void 0;
    (e.default = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        s = (0, i.default)();
      if ((c || (c = (0, o.default)(s)), e.events)) throw new Error('Event handlers cannot be overwritten.');
      if ('string' == typeof t && !document.getElementById(t)) throw new Error('Element "' + t + '" does not exist.');
      e.events = a.default.proxyEvents(s);
      var u = new Promise(function (n) {
          'object' === (void 0 === t ? 'undefined' : r(t)) && t.playVideo instanceof Function
            ? n(t)
            : c.then(function (r) {
                var i = new r.Player(t, e);
                return (
                  s.on('ready', function () {
                    n(i);
                  }),
                  null
                );
              });
        }),
        l = a.default.promisifyPlayer(u, n);
      return (l.on = s.on), (l.off = s.off), l;
    }),
      (t.exports = e.default);
  },
  function (t, e, n) {
    'use strict';
    (function (t, n) {
      function r(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          (r.enumerable = r.enumerable || !1), (r.configurable = !0), 'value' in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }
      var i = void 0 !== t && '[object global]' === {}.toString.call(t);
      function o(t, e) {
        return 0 === t.indexOf(e.toLowerCase()) ? t : ''.concat(e.toLowerCase()).concat(t.substr(0, 1).toUpperCase()).concat(t.substr(1));
      }
      function a(t) {
        return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(t);
      }
      function s() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.id,
          n = t.url,
          r = e || n;
        if (!r) throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
        if (
          (function (t) {
            return !isNaN(parseFloat(t)) && isFinite(t) && Math.floor(t) == t;
          })(r)
        )
          return 'https://vimeo.com/'.concat(r);
        if (a(r)) return r.replace('http:', 'https:');
        if (e) throw new TypeError('“'.concat(e, '” is not a valid video id.'));
        throw new TypeError('“'.concat(r, '” is not a vimeo.com url.'));
      }
      var c = void 0 !== Array.prototype.indexOf,
        u = 'undefined' != typeof window && void 0 !== window.postMessage;
      if (!(i || (c && u))) throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
      var l = 'undefined' != typeof globalThis ? globalThis : 'undefined' != typeof window ? window : void 0 !== t ? t : 'undefined' != typeof self ? self : {};
      !(function (t) {
        if (!t.WeakMap) {
          var e = Object.prototype.hasOwnProperty,
            n = function (t, e, n) {
              Object.defineProperty ? Object.defineProperty(t, e, { configurable: !0, writable: !0, value: n }) : (t[e] = n);
            };
          t.WeakMap = (function () {
            function t() {
              if (void 0 === this) throw new TypeError("Constructor WeakMap requires 'new'");
              if ((n(this, '_id', '_WeakMap' + '_' + o() + '.' + o()), arguments.length > 0)) throw new TypeError('WeakMap iterable is not supported');
            }
            function i(t, n) {
              if (!r(t) || !e.call(t, '_id')) throw new TypeError(n + ' method called on incompatible receiver ' + typeof t);
            }
            function o() {
              return Math.random().toString().substring(2);
            }
            return (
              n(t.prototype, 'delete', function (t) {
                if ((i(this, 'delete'), !r(t))) return !1;
                var e = t[this._id];
                return !(!e || e[0] !== t || (delete t[this._id], 0));
              }),
              n(t.prototype, 'get', function (t) {
                if ((i(this, 'get'), r(t))) {
                  var e = t[this._id];
                  return e && e[0] === t ? e[1] : void 0;
                }
              }),
              n(t.prototype, 'has', function (t) {
                if ((i(this, 'has'), !r(t))) return !1;
                var e = t[this._id];
                return !(!e || e[0] !== t);
              }),
              n(t.prototype, 'set', function (t, e) {
                if ((i(this, 'set'), !r(t))) throw new TypeError('Invalid value used as weak map key');
                var o = t[this._id];
                return o && o[0] === t ? ((o[1] = e), this) : (n(t, this._id, [t, e]), this);
              }),
              n(t, '_polyfill', !0),
              t
            );
          })();
        }
        function r(t) {
          return Object(t) === t;
        }
      })('undefined' != typeof self ? self : 'undefined' != typeof window ? window : l);
      var d = (function (t, e) {
          return (
            (function (t) {
              var e, r, i;
              (i = function () {
                var t,
                  e,
                  r,
                  i = Object.prototype.toString,
                  o =
                    void 0 !== n
                      ? function (t) {
                          return n(t);
                        }
                      : setTimeout;
                try {
                  Object.defineProperty({}, 'x', {}),
                    (t = function (t, e, n, r) {
                      return Object.defineProperty(t, e, { value: n, writable: !0, configurable: !1 !== r });
                    });
                } catch (e) {
                  t = function (t, e, n) {
                    return (t[e] = n), t;
                  };
                }
                function a(t, n) {
                  r.add(t, n), e || (e = o(r.drain));
                }
                function s(t) {
                  var e,
                    n = typeof t;
                  return null == t || ('object' != n && 'function' != n) || (e = t.then), 'function' == typeof e && e;
                }
                function c() {
                  for (var t = 0; t < this.chain.length; t++) u(this, 1 === this.state ? this.chain[t].success : this.chain[t].failure, this.chain[t]);
                  this.chain.length = 0;
                }
                function u(t, e, n) {
                  var r, i;
                  try {
                    !1 === e
                      ? n.reject(t.msg)
                      : (r = !0 === e ? t.msg : e.call(void 0, t.msg)) === n.promise
                      ? n.reject(TypeError('Promise-chain cycle'))
                      : (i = s(r))
                      ? i.call(r, n.resolve, n.reject)
                      : n.resolve(r);
                  } catch (t) {
                    n.reject(t);
                  }
                }
                function l(t) {
                  var e = this;
                  e.triggered || ((e.triggered = !0), e.def && (e = e.def), (e.msg = t), (e.state = 2), e.chain.length > 0 && a(c, e));
                }
                function d(t, e, n, r) {
                  for (var i = 0; i < e.length; i++)
                    !(function (i) {
                      t.resolve(e[i]).then(function (t) {
                        n(i, t);
                      }, r);
                    })(i);
                }
                function f(t) {
                  (this.def = t), (this.triggered = !1);
                }
                function h(t) {
                  (this.promise = t), (this.state = 0), (this.triggered = !1), (this.chain = []), (this.msg = void 0);
                }
                function p(t) {
                  if ('function' != typeof t) throw TypeError('Not a function');
                  if (0 !== this.__NPO__) throw TypeError('Not a promise');
                  this.__NPO__ = 1;
                  var e = new h(this);
                  (this.then = function (t, n) {
                    var r = { success: 'function' != typeof t || t, failure: 'function' == typeof n && n };
                    return (
                      (r.promise = new this.constructor(function (t, e) {
                        if ('function' != typeof t || 'function' != typeof e) throw TypeError('Not a function');
                        (r.resolve = t), (r.reject = e);
                      })),
                      e.chain.push(r),
                      0 !== e.state && a(c, e),
                      r.promise
                    );
                  }),
                    (this.catch = function (t) {
                      return this.then(void 0, t);
                    });
                  try {
                    t.call(
                      void 0,
                      function (t) {
                        (function t(e) {
                          var n,
                            r = this;
                          if (!r.triggered) {
                            (r.triggered = !0), r.def && (r = r.def);
                            try {
                              (n = s(e))
                                ? a(function () {
                                    var i = new f(r);
                                    try {
                                      n.call(
                                        e,
                                        function () {
                                          t.apply(i, arguments);
                                        },
                                        function () {
                                          l.apply(i, arguments);
                                        }
                                      );
                                    } catch (t) {
                                      l.call(i, t);
                                    }
                                  })
                                : ((r.msg = e), (r.state = 1), r.chain.length > 0 && a(c, r));
                            } catch (e) {
                              l.call(new f(r), e);
                            }
                          }
                        }.call(e, t));
                      },
                      function (t) {
                        l.call(e, t);
                      }
                    );
                  } catch (t) {
                    l.call(e, t);
                  }
                }
                r = (function () {
                  var t, n, r;
                  function i(t, e) {
                    (this.fn = t), (this.self = e), (this.next = void 0);
                  }
                  return {
                    add: function (e, o) {
                      (r = new i(e, o)), n ? (n.next = r) : (t = r), (n = r), (r = void 0);
                    },
                    drain: function () {
                      var r = t;
                      for (t = n = e = void 0; r; ) r.fn.call(r.self), (r = r.next);
                    },
                  };
                })();
                var g = t({}, 'constructor', p, !1);
                return (
                  (p.prototype = g),
                  t(g, '__NPO__', 0, !1),
                  t(p, 'resolve', function (t) {
                    return t && 'object' == typeof t && 1 === t.__NPO__
                      ? t
                      : new this(function (e, n) {
                          if ('function' != typeof e || 'function' != typeof n) throw TypeError('Not a function');
                          e(t);
                        });
                  }),
                  t(p, 'reject', function (t) {
                    return new this(function (e, n) {
                      if ('function' != typeof e || 'function' != typeof n) throw TypeError('Not a function');
                      n(t);
                    });
                  }),
                  t(p, 'all', function (t) {
                    var e = this;
                    return '[object Array]' != i.call(t)
                      ? e.reject(TypeError('Not an array'))
                      : 0 === t.length
                      ? e.resolve([])
                      : new e(function (n, r) {
                          if ('function' != typeof n || 'function' != typeof r) throw TypeError('Not a function');
                          var i = t.length,
                            o = Array(i),
                            a = 0;
                          d(
                            e,
                            t,
                            function (t, e) {
                              (o[t] = e), ++a === i && n(o);
                            },
                            r
                          );
                        });
                  }),
                  t(p, 'race', function (t) {
                    var e = this;
                    return '[object Array]' != i.call(t)
                      ? e.reject(TypeError('Not an array'))
                      : new e(function (n, r) {
                          if ('function' != typeof n || 'function' != typeof r) throw TypeError('Not a function');
                          d(
                            e,
                            t,
                            function (t, e) {
                              n(e);
                            },
                            r
                          );
                        });
                  }),
                  p
                );
              }),
                ((r = l)[(e = 'Promise')] = r[e] || i()),
                t.exports && (t.exports = r[e]);
            })((e = { exports: {} })),
            e.exports
          );
        })(),
        f = new WeakMap();
      function h(t, e, n) {
        var r = f.get(t.element) || {};
        e in r || (r[e] = []), r[e].push(n), f.set(t.element, r);
      }
      function p(t, e) {
        return (f.get(t.element) || {})[e] || [];
      }
      function g(t, e, n) {
        var r = f.get(t.element) || {};
        if (!r[e]) return !0;
        if (!n) return (r[e] = []), f.set(t.element, r), !0;
        var i = r[e].indexOf(n);
        return -1 !== i && r[e].splice(i, 1), f.set(t.element, r), r[e] && 0 === r[e].length;
      }
      var v = [
        'autopause',
        'autoplay',
        'background',
        'byline',
        'color',
        'controls',
        'dnt',
        'height',
        'id',
        'loop',
        'maxheight',
        'maxwidth',
        'muted',
        'playsinline',
        'portrait',
        'responsive',
        'speed',
        'texttrack',
        'title',
        'transparent',
        'url',
        'width',
      ];
      function m(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return v.reduce(function (e, n) {
          var r = t.getAttribute('data-vimeo-'.concat(n));
          return (r || '' === r) && (e[n] = '' === r ? 1 : r), e;
        }, e);
      }
      function y(t, e) {
        var n = t.html;
        if (!e) throw new TypeError('An element must be provided');
        if (null !== e.getAttribute('data-vimeo-initialized')) return e.querySelector('iframe');
        var r = document.createElement('div');
        return (r.innerHTML = n), e.appendChild(r.firstChild), e.setAttribute('data-vimeo-initialized', 'true'), e.querySelector('iframe');
      }
      function b(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 ? arguments[2] : void 0;
        return new Promise(function (r, i) {
          if (!a(t)) throw new TypeError('“'.concat(t, '” is not a vimeo.com url.'));
          var o = 'https://vimeo.com/api/oembed.json?url='.concat(encodeURIComponent(t));
          for (var s in e) e.hasOwnProperty(s) && (o += '&'.concat(s, '=').concat(encodeURIComponent(e[s])));
          var c = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
          c.open('GET', o, !0),
            (c.onload = function () {
              if (404 !== c.status)
                if (403 !== c.status)
                  try {
                    var e = JSON.parse(c.responseText);
                    if (403 === e.domain_status_code) return y(e, n), void i(new Error('“'.concat(t, '” is not embeddable.')));
                    r(e);
                  } catch (t) {
                    i(t);
                  }
                else i(new Error('“'.concat(t, '” is not embeddable.')));
              else i(new Error('“'.concat(t, '” was not found.')));
            }),
            (c.onerror = function () {
              var t = c.status ? ' ('.concat(c.status, ')') : '';
              i(new Error('There was an error fetching the embed code from Vimeo'.concat(t, '.')));
            }),
            c.send();
        });
      }
      function w(t) {
        if ('string' == typeof t)
          try {
            t = JSON.parse(t);
          } catch (t) {
            return console.warn(t), {};
          }
        return t;
      }
      function _(t, e, n) {
        if (t.element.contentWindow && t.element.contentWindow.postMessage) {
          var r = { method: e };
          void 0 !== n && (r.value = n);
          var i = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
          i >= 8 && i < 10 && (r = JSON.stringify(r)), t.element.contentWindow.postMessage(r, t.origin);
        }
      }
      var E = new WeakMap(),
        k = new WeakMap(),
        A = {},
        T = (function () {
          function t(e) {
            var n = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (
              ((function (t, e) {
                if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
              })(this, t),
              window.jQuery &&
                e instanceof jQuery &&
                (e.length > 1 && window.console && console.warn && console.warn('A jQuery object with multiple elements was passed, using the first element.'), (e = e[0])),
              'undefined' != typeof document && 'string' == typeof e && (e = document.getElementById(e)),
              !(function (t) {
                return Boolean(t && 1 === t.nodeType && 'nodeName' in t && t.ownerDocument && t.ownerDocument.defaultView);
              })(e))
            )
              throw new TypeError('You must pass either a valid element or a valid id.');
            if ('IFRAME' !== e.nodeName) {
              var i = e.querySelector('iframe');
              i && (e = i);
            }
            if ('IFRAME' === e.nodeName && !a(e.getAttribute('src') || '')) throw new Error('The player element passed isn’t a Vimeo embed.');
            if (E.has(e)) return E.get(e);
            (this._window = e.ownerDocument.defaultView), (this.element = e), (this.origin = '*');
            var o = new d(function (t, i) {
              if (
                ((n._onMessage = function (e) {
                  if (a(e.origin) && n.element.contentWindow === e.source) {
                    '*' === n.origin && (n.origin = e.origin);
                    var r = w(e.data);
                    if (r && 'error' === r.event && r.data && 'ready' === r.data.method) {
                      var o = new Error(r.data.message);
                      return (o.name = r.data.name), void i(o);
                    }
                    var s = r && 'ready' === r.event,
                      c = r && 'ping' === r.method;
                    if (s || c) return n.element.setAttribute('data-ready', 'true'), void t();
                    !(function (t, e) {
                      var n,
                        r = [];
                      if ((e = w(e)).event)
                        'error' === e.event &&
                          p(t, e.data.method).forEach(function (n) {
                            var r = new Error(e.data.message);
                            (r.name = e.data.name), n.reject(r), g(t, e.data.method, n);
                          }),
                          (r = p(t, 'event:'.concat(e.event))),
                          (n = e.data);
                      else if (e.method) {
                        var i = (function (t, e) {
                          var n = p(t, e);
                          if (n.length < 1) return !1;
                          var r = n.shift();
                          return g(t, e, r), r;
                        })(t, e.method);
                        i && (r.push(i), (n = e.value));
                      }
                      r.forEach(function (e) {
                        try {
                          if ('function' == typeof e) return void e.call(t, n);
                          e.resolve(n);
                        } catch (t) {}
                      });
                    })(n, r);
                  }
                }),
                n._window.addEventListener('message', n._onMessage),
                'IFRAME' !== n.element.nodeName)
              ) {
                var o = m(e, r);
                b(s(o), o, e)
                  .then(function (t) {
                    var r = y(t, e);
                    return (
                      (n.element = r),
                      (n._originalElement = e),
                      (function (t, e) {
                        var n = f.get(t);
                        f.set(e, n), f.delete(t);
                      })(e, r),
                      E.set(n.element, n),
                      t
                    );
                  })
                  .catch(i);
              }
            });
            if ((k.set(this, o), E.set(this.element, this), 'IFRAME' === this.element.nodeName && _(this, 'ping'), A.isEnabled)) {
              var c = function () {
                return A.exit();
              };
              A.on('fullscreenchange', function () {
                A.isFullscreen ? h(n, 'event:exitFullscreen', c) : g(n, 'event:exitFullscreen', c),
                  n.ready().then(function () {
                    _(n, 'fullscreenchange', A.isFullscreen);
                  });
              });
            }
            return this;
          }
          var e, n;
          return (
            (e = t),
            (n = [
              {
                key: 'callMethod',
                value: function (t) {
                  var e = this,
                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  return new d(function (r, i) {
                    return e
                      .ready()
                      .then(function () {
                        h(e, t, { resolve: r, reject: i }), _(e, t, n);
                      })
                      .catch(i);
                  });
                },
              },
              {
                key: 'get',
                value: function (t) {
                  var e = this;
                  return new d(function (n, r) {
                    return (
                      (t = o(t, 'get')),
                      e
                        .ready()
                        .then(function () {
                          h(e, t, { resolve: n, reject: r }), _(e, t);
                        })
                        .catch(r)
                    );
                  });
                },
              },
              {
                key: 'set',
                value: function (t, e) {
                  var n = this;
                  return new d(function (r, i) {
                    if (((t = o(t, 'set')), null == e)) throw new TypeError('There must be a value to set.');
                    return n
                      .ready()
                      .then(function () {
                        h(n, t, { resolve: r, reject: i }), _(n, t, e);
                      })
                      .catch(i);
                  });
                },
              },
              {
                key: 'on',
                value: function (t, e) {
                  if (!t) throw new TypeError('You must pass an event name.');
                  if (!e) throw new TypeError('You must pass a callback function.');
                  if ('function' != typeof e) throw new TypeError('The callback must be a function.');
                  0 === p(this, 'event:'.concat(t)).length && this.callMethod('addEventListener', t).catch(function () {}), h(this, 'event:'.concat(t), e);
                },
              },
              {
                key: 'off',
                value: function (t, e) {
                  if (!t) throw new TypeError('You must pass an event name.');
                  if (e && 'function' != typeof e) throw new TypeError('The callback must be a function.');
                  g(this, 'event:'.concat(t), e) && this.callMethod('removeEventListener', t).catch(function (t) {});
                },
              },
              {
                key: 'loadVideo',
                value: function (t) {
                  return this.callMethod('loadVideo', t);
                },
              },
              {
                key: 'ready',
                value: function () {
                  var t =
                    k.get(this) ||
                    new d(function (t, e) {
                      e(new Error('Unknown player. Probably unloaded.'));
                    });
                  return d.resolve(t);
                },
              },
              {
                key: 'addCuePoint',
                value: function (t) {
                  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  return this.callMethod('addCuePoint', { time: t, data: e });
                },
              },
              {
                key: 'removeCuePoint',
                value: function (t) {
                  return this.callMethod('removeCuePoint', t);
                },
              },
              {
                key: 'enableTextTrack',
                value: function (t, e) {
                  if (!t) throw new TypeError('You must pass a language.');
                  return this.callMethod('enableTextTrack', { language: t, kind: e });
                },
              },
              {
                key: 'disableTextTrack',
                value: function () {
                  return this.callMethod('disableTextTrack');
                },
              },
              {
                key: 'pause',
                value: function () {
                  return this.callMethod('pause');
                },
              },
              {
                key: 'play',
                value: function () {
                  return this.callMethod('play');
                },
              },
              {
                key: 'requestFullscreen',
                value: function () {
                  return A.isEnabled ? A.request(this.element) : this.callMethod('requestFullscreen');
                },
              },
              {
                key: 'exitFullscreen',
                value: function () {
                  return A.isEnabled ? A.exit() : this.callMethod('exitFullscreen');
                },
              },
              {
                key: 'getFullscreen',
                value: function () {
                  return A.isEnabled ? d.resolve(A.isFullscreen) : this.get('fullscreen');
                },
              },
              {
                key: 'requestPictureInPicture',
                value: function () {
                  return this.callMethod('requestPictureInPicture');
                },
              },
              {
                key: 'exitPictureInPicture',
                value: function () {
                  return this.callMethod('exitPictureInPicture');
                },
              },
              {
                key: 'getPictureInPicture',
                value: function () {
                  return this.get('pictureInPicture');
                },
              },
              {
                key: 'unload',
                value: function () {
                  return this.callMethod('unload');
                },
              },
              {
                key: 'destroy',
                value: function () {
                  var t = this;
                  return new d(function (e) {
                    if (
                      (k.delete(t),
                      E.delete(t.element),
                      t._originalElement && (E.delete(t._originalElement), t._originalElement.removeAttribute('data-vimeo-initialized')),
                      t.element && 'IFRAME' === t.element.nodeName && t.element.parentNode && t.element.parentNode.removeChild(t.element),
                      t.element && 'DIV' === t.element.nodeName && t.element.parentNode)
                    ) {
                      t.element.removeAttribute('data-vimeo-initialized');
                      var n = t.element.querySelector('iframe');
                      n && n.parentNode && n.parentNode.removeChild(n);
                    }
                    t._window.removeEventListener('message', t._onMessage), e();
                  });
                },
              },
              {
                key: 'getAutopause',
                value: function () {
                  return this.get('autopause');
                },
              },
              {
                key: 'setAutopause',
                value: function (t) {
                  return this.set('autopause', t);
                },
              },
              {
                key: 'getBuffered',
                value: function () {
                  return this.get('buffered');
                },
              },
              {
                key: 'getCameraProps',
                value: function () {
                  return this.get('cameraProps');
                },
              },
              {
                key: 'setCameraProps',
                value: function (t) {
                  return this.set('cameraProps', t);
                },
              },
              {
                key: 'getChapters',
                value: function () {
                  return this.get('chapters');
                },
              },
              {
                key: 'getCurrentChapter',
                value: function () {
                  return this.get('currentChapter');
                },
              },
              {
                key: 'getColor',
                value: function () {
                  return this.get('color');
                },
              },
              {
                key: 'setColor',
                value: function (t) {
                  return this.set('color', t);
                },
              },
              {
                key: 'getCuePoints',
                value: function () {
                  return this.get('cuePoints');
                },
              },
              {
                key: 'getCurrentTime',
                value: function () {
                  return this.get('currentTime');
                },
              },
              {
                key: 'setCurrentTime',
                value: function (t) {
                  return this.set('currentTime', t);
                },
              },
              {
                key: 'getDuration',
                value: function () {
                  return this.get('duration');
                },
              },
              {
                key: 'getEnded',
                value: function () {
                  return this.get('ended');
                },
              },
              {
                key: 'getLoop',
                value: function () {
                  return this.get('loop');
                },
              },
              {
                key: 'setLoop',
                value: function (t) {
                  return this.set('loop', t);
                },
              },
              {
                key: 'setMuted',
                value: function (t) {
                  return this.set('muted', t);
                },
              },
              {
                key: 'getMuted',
                value: function () {
                  return this.get('muted');
                },
              },
              {
                key: 'getPaused',
                value: function () {
                  return this.get('paused');
                },
              },
              {
                key: 'getPlaybackRate',
                value: function () {
                  return this.get('playbackRate');
                },
              },
              {
                key: 'setPlaybackRate',
                value: function (t) {
                  return this.set('playbackRate', t);
                },
              },
              {
                key: 'getPlayed',
                value: function () {
                  return this.get('played');
                },
              },
              {
                key: 'getQualities',
                value: function () {
                  return this.get('qualities');
                },
              },
              {
                key: 'getQuality',
                value: function () {
                  return this.get('quality');
                },
              },
              {
                key: 'setQuality',
                value: function (t) {
                  return this.set('quality', t);
                },
              },
              {
                key: 'getSeekable',
                value: function () {
                  return this.get('seekable');
                },
              },
              {
                key: 'getSeeking',
                value: function () {
                  return this.get('seeking');
                },
              },
              {
                key: 'getTextTracks',
                value: function () {
                  return this.get('textTracks');
                },
              },
              {
                key: 'getVideoEmbedCode',
                value: function () {
                  return this.get('videoEmbedCode');
                },
              },
              {
                key: 'getVideoId',
                value: function () {
                  return this.get('videoId');
                },
              },
              {
                key: 'getVideoTitle',
                value: function () {
                  return this.get('videoTitle');
                },
              },
              {
                key: 'getVideoWidth',
                value: function () {
                  return this.get('videoWidth');
                },
              },
              {
                key: 'getVideoHeight',
                value: function () {
                  return this.get('videoHeight');
                },
              },
              {
                key: 'getVideoUrl',
                value: function () {
                  return this.get('videoUrl');
                },
              },
              {
                key: 'getVolume',
                value: function () {
                  return this.get('volume');
                },
              },
              {
                key: 'setVolume',
                value: function (t) {
                  return this.set('volume', t);
                },
              },
            ]) && r(e.prototype, n),
            t
          );
        })();
      i ||
        ((A = (function () {
          var t = (function () {
              for (
                var t,
                  e = [
                    ['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
                    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
                    [
                      'webkitRequestFullScreen',
                      'webkitCancelFullScreen',
                      'webkitCurrentFullScreenElement',
                      'webkitCancelFullScreen',
                      'webkitfullscreenchange',
                      'webkitfullscreenerror',
                    ],
                    ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'],
                    ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError'],
                  ],
                  n = 0,
                  r = e.length,
                  i = {};
                n < r;
                n++
              )
                if ((t = e[n]) && t[1] in document) {
                  for (n = 0; n < t.length; n++) i[e[0][n]] = t[n];
                  return i;
                }
              return !1;
            })(),
            e = { fullscreenchange: t.fullscreenchange, fullscreenerror: t.fullscreenerror },
            n = {
              request: function (e) {
                return new Promise(function (r, i) {
                  var o = function t() {
                    n.off('fullscreenchange', t), r();
                  };
                  n.on('fullscreenchange', o);
                  var a = (e = e || document.documentElement)[t.requestFullscreen]();
                  a instanceof Promise && a.then(o).catch(i);
                });
              },
              exit: function () {
                return new Promise(function (e, r) {
                  if (n.isFullscreen) {
                    var i = function t() {
                      n.off('fullscreenchange', t), e();
                    };
                    n.on('fullscreenchange', i);
                    var o = document[t.exitFullscreen]();
                    o instanceof Promise && o.then(i).catch(r);
                  } else e();
                });
              },
              on: function (t, n) {
                var r = e[t];
                r && document.addEventListener(r, n);
              },
              off: function (t, n) {
                var r = e[t];
                r && document.removeEventListener(r, n);
              },
            };
          return (
            Object.defineProperties(n, {
              isFullscreen: {
                get: function () {
                  return Boolean(document[t.fullscreenElement]);
                },
              },
              element: {
                enumerable: !0,
                get: function () {
                  return document[t.fullscreenElement];
                },
              },
              isEnabled: {
                enumerable: !0,
                get: function () {
                  return Boolean(document[t.fullscreenEnabled]);
                },
              },
            }),
            n
          );
        })()),
        (function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document,
            e = [].slice.call(t.querySelectorAll('[data-vimeo-id], [data-vimeo-url]')),
            n = function (t) {
              'console' in window && console.error && console.error('There was an error creating an embed: '.concat(t));
            };
          e.forEach(function (t) {
            try {
              if (null !== t.getAttribute('data-vimeo-defer')) return;
              var e = m(t);
              b(s(e), e, t)
                .then(function (e) {
                  return y(e, t);
                })
                .catch(n);
            } catch (t) {
              n(t);
            }
          });
        })(),
        (function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document;
          if (!window.VimeoPlayerResizeEmbeds_) {
            window.VimeoPlayerResizeEmbeds_ = !0;
            window.addEventListener('message', function (e) {
              if (a(e.origin) && e.data && 'spacechange' === e.data.event)
                for (var n = t.querySelectorAll('iframe'), r = 0; r < n.length; r++)
                  if (n[r].contentWindow === e.source) {
                    n[r].parentElement.style.paddingBottom = ''.concat(e.data.data[0].bottom, 'px');
                    break;
                  }
            });
          }
        })()),
        (e.a = T);
    }.call(this, n(9), n(59).setImmediate));
  },
  function (t, e) {
    function n(e) {
      return (
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? ((t.exports = n =
              function (t) {
                return typeof t;
              }),
            (t.exports.default = t.exports),
            (t.exports.__esModule = !0))
          : ((t.exports = n =
              function (t) {
                return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t;
              }),
            (t.exports.default = t.exports),
            (t.exports.__esModule = !0)),
        n(e)
      );
    }
    (t.exports = n), (t.exports.default = t.exports), (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    (function (t, e, n) {
      !(function (t) {
        'use strict';
        var r,
          i = /^[a-z]+:/,
          o = /[-a-z0-9]+(\.[-a-z0-9])*:\d+/i,
          a = /\/\/(.*?)(?::(.*?))?@/,
          s = /^win/i,
          c = /:$/,
          u = /^\?/,
          l = /^#/,
          d = /(.*\/)/,
          f = /^\/{2,}/,
          h = /(^\/?)/,
          p = /'/g,
          g = /%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi,
          v = /%([cd][0-9a-f])%([89ab][0-9a-f])/gi,
          m = /%([0-7][0-9a-f])/gi,
          y = /\+/g,
          b = /^\w:$/,
          w = /[^/#?]/,
          _ = 'undefined' == typeof window && void 0 !== e && !0,
          E = !_ && t.navigator && t.navigator.userAgent && ~t.navigator.userAgent.indexOf('MSIE'),
          k = _ ? t.require : null,
          A = { protocol: 'protocol', host: 'hostname', port: 'port', path: 'pathname', query: 'search', hash: 'hash' },
          T = { ftp: 21, gopher: 70, http: 80, https: 443, ws: 80, wss: 443 };
        function x() {
          return _
            ? (r = r || 'file://' + (n.platform.match(s) ? '/' : '') + k('fs').realpathSync('.'))
            : 'about:srcdoc' === document.location.href
            ? self.parent.document.location.href
            : document.location.href;
        }
        function S(t) {
          return encodeURIComponent(t).replace(p, '%27');
        }
        function C(t) {
          return (t = (t = (t = t.replace(y, ' ')).replace(g, function (t, e, n, r) {
            var i = parseInt(e, 16) - 224,
              o = parseInt(n, 16) - 128;
            if (0 == i && o < 32) return t;
            var a = (i << 12) + (o << 6) + (parseInt(r, 16) - 128);
            return 65535 < a ? t : String.fromCharCode(a);
          })).replace(v, function (t, e, n) {
            var r = parseInt(e, 16) - 192;
            if (r < 2) return t;
            var i = parseInt(n, 16) - 128;
            return String.fromCharCode((r << 6) + i);
          })).replace(m, function (t, e) {
            return String.fromCharCode(parseInt(e, 16));
          });
        }
        function O(t) {
          for (var e = t.split('&'), n = 0, r = e.length; n < r; n++) {
            var i = e[n].split('='),
              o = decodeURIComponent(i[0].replace(y, ' '));
            if (o) {
              var a = void 0 !== i[1] ? C(i[1]) : null;
              void 0 === this[o] ? (this[o] = a) : (this[o] instanceof Array || (this[o] = [this[o]]), this[o].push(a));
            }
          }
        }
        function L(t, e) {
          !(function (t, e, n) {
            var r, s, p;
            (e = e || x()), _ ? (r = k('url').parse(e)) : ((r = document.createElement('a')).href = e);
            var g,
              v,
              m =
                ((v = { path: !0, query: !0, hash: !0 }),
                (g = e) && i.test(g) && ((v.protocol = !0), (v.host = !0), o.test(g) && (v.port = !0), a.test(g) && ((v.user = !0), (v.pass = !0))),
                v);
            for (s in ((p = e.match(a) || []), A)) m[s] ? (t[s] = r[A[s]] || '') : (t[s] = '');
            if (
              ((t.protocol = t.protocol.replace(c, '')),
              (t.query = t.query.replace(u, '')),
              (t.hash = C(t.hash.replace(l, ''))),
              (t.user = C(p[1] || '')),
              (t.pass = C(p[2] || '')),
              (t.port = T[t.protocol] == t.port || 0 == t.port ? '' : t.port),
              !m.protocol && w.test(e.charAt(0)) && (t.path = e.split('?')[0].split('#')[0]),
              !m.protocol && n)
            ) {
              var y = new L(x().match(d)[0]),
                b = y.path.split('/'),
                S = t.path.split('/'),
                q = ['protocol', 'user', 'pass', 'host', 'port'],
                D = q.length;
              for (b.pop(), s = 0; s < D; s++) t[q[s]] = y[q[s]];
              for (; '..' === S[0]; ) b.pop(), S.shift();
              t.path = ('/' !== e.charAt(0) ? b.join('/') : '') + '/' + S.join('/');
            }
            (t.path = t.path.replace(f, '/')), E && (t.path = t.path.replace(h, '/')), t.paths(t.paths()), (t.query = new O(t.query));
          })(this, t, !e);
        }
        (O.prototype.toString = function () {
          var t,
            e,
            n = '',
            r = S;
          for (t in this) {
            var i = this[t];
            if (!(i instanceof Function || void 0 === i))
              if (i instanceof Array) {
                var o = i.length;
                if (!o) {
                  n += (n ? '&' : '') + r(t) + '=';
                  continue;
                }
                for (e = 0; e < o; e++) {
                  var a = i[e];
                  void 0 !== a && ((n += n ? '&' : ''), (n += r(t) + (null === a ? '' : '=' + r(a))));
                }
              } else (n += n ? '&' : ''), (n += r(t) + (null === i ? '' : '=' + r(i)));
          }
          return n;
        }),
          (L.prototype.clearQuery = function () {
            for (var t in this.query) this.query[t] instanceof Function || delete this.query[t];
            return this;
          }),
          (L.prototype.queryLength = function () {
            var t = 0;
            for (var e in this.query) this.query[e] instanceof Function || t++;
            return t;
          }),
          (L.prototype.isEmptyQuery = function () {
            return 0 === this.queryLength();
          }),
          (L.prototype.paths = function (t) {
            var e,
              n = '',
              r = 0;
            if (t && t.length && t + '' !== t) {
              for (this.isAbsolute() && (n = '/'), e = t.length; r < e; r++) t[r] = !r && b.test(t[r]) ? t[r] : S(t[r]);
              this.path = n + t.join('/');
            }
            for (r = 0, e = (t = ('/' === this.path.charAt(0) ? this.path.slice(1) : this.path).split('/')).length; r < e; r++) t[r] = C(t[r]);
            return t;
          }),
          (L.prototype.encode = S),
          (L.prototype.decode = C),
          (L.prototype.isAbsolute = function () {
            return this.protocol || '/' === this.path.charAt(0);
          }),
          (L.prototype.toString = function () {
            return (
              (this.protocol && this.protocol + '://') +
              (this.user && S(this.user) + (this.pass && ':' + S(this.pass)) + '@') +
              (this.host && this.host) +
              (this.port && ':' + this.port) +
              (this.path && this.path) +
              (this.query.toString() && '?' + this.query) +
              (this.hash && '#' + S(this.hash))
            );
          }),
          (t[t.exports ? 'exports' : 'Url'] = L);
      })(t.exports ? t : window);
    }.call(this, n(61)(t), n(9), n(13)));
  },
  function (t, e, n) {
    var r = n(14);
    (t.exports = function (t) {
      if (Array.isArray(t)) return r(t);
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    (t.exports = function (t) {
      if (('undefined' != typeof Symbol && null != t[Symbol.iterator]) || null != t['@@iterator']) return Array.from(t);
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    (t.exports = function () {
      throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {},
  function (t, e, n) {
    var r, i, o, a, s;
    (a = 'undefined' != typeof window ? window : 0),
      (s = function (t, e, n, r) {
        'use strict';
        var i,
          o = e.createElement('a').style,
          a = 'objectFit' in o,
          s = /object-fit["']*\s*:\s*["']*(contain|cover)/,
          c = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
          u = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
          l = /\(|\)|'/,
          d = { center: 'center', '50% 50%': 'center' };
        function f(t, r) {
          var o,
            a,
            s,
            c,
            d = n.cfg,
            f = function () {
              var e = t.currentSrc || t.src;
              e && a !== e && ((a = e), (c.backgroundImage = 'url(' + (l.test(e) ? JSON.stringify(e) : e) + ')'), o || ((o = !0), n.rC(s, d.loadingClass), n.aC(s, d.loadedClass)));
            },
            h = function () {
              n.rAF(f);
            };
          (t._lazysizesParentFit = r.fit),
            t.addEventListener('lazyloaded', h, !0),
            t.addEventListener('load', h, !0),
            n.rAF(function () {
              var o = t,
                a = t.parentNode;
              'PICTURE' == a.nodeName.toUpperCase() && ((o = a), (a = a.parentNode)),
                (function (t) {
                  var e = t.previousElementSibling;
                  e &&
                    n.hC(e, i) &&
                    (e.parentNode.removeChild(e), (t.style.position = e.getAttribute('data-position') || ''), (t.style.visibility = e.getAttribute('data-visibility') || ''));
                })(o),
                i ||
                  (function () {
                    if (!i) {
                      var t = e.createElement('style');
                      (i = n.cfg.objectFitClass || 'lazysizes-display-clone'), e.querySelector('head').appendChild(t);
                    }
                  })(),
                (s = t.cloneNode(!1)),
                (c = s.style),
                s.addEventListener('load', function () {
                  var t = s.currentSrc || s.src;
                  t && t != u && ((s.src = u), (s.srcset = ''));
                }),
                n.rC(s, d.loadedClass),
                n.rC(s, d.lazyClass),
                n.rC(s, d.autosizesClass),
                n.aC(s, d.loadingClass),
                n.aC(s, i),
                ['data-parent-fit', 'data-parent-container', 'data-object-fit-polyfilled', d.srcsetAttr, d.srcAttr].forEach(function (t) {
                  s.removeAttribute(t);
                }),
                (s.src = u),
                (s.srcset = ''),
                (c.backgroundRepeat = 'no-repeat'),
                (c.backgroundPosition = r.position),
                (c.backgroundSize = r.fit),
                s.setAttribute('data-position', o.style.position),
                s.setAttribute('data-visibility', o.style.visibility),
                (o.style.visibility = 'hidden'),
                (o.style.position = 'absolute'),
                t.setAttribute('data-parent-fit', r.fit),
                t.setAttribute('data-parent-container', 'prev'),
                t.setAttribute('data-object-fit-polyfilled', ''),
                (t._objectFitPolyfilledDisplay = s),
                a.insertBefore(s, o),
                t._lazysizesParentFit && delete t._lazysizesParentFit,
                t.complete && f();
            });
        }
        if (!a || !(a && 'objectPosition' in o)) {
          var h = function (t) {
            if (t.detail.instance == n) {
              var e = t.target,
                r = (function (t) {
                  var e = (getComputedStyle(t, null) || {}).fontFamily || '',
                    n = e.match(s) || '',
                    r = (n && e.match(c)) || '';
                  return r && (r = r[1]), { fit: (n && n[1]) || '', position: d[r] || r || 'center' };
                })(e);
              return !(!r.fit || (a && 'center' == r.position) || (f(e, r), 0));
            }
          };
          t.addEventListener('lazybeforesizes', function (t) {
            if (t.detail.instance == n) {
              var e = t.target;
              null == e.getAttribute('data-object-fit-polyfilled') ||
                e._objectFitPolyfilledDisplay ||
                h(t) ||
                n.rAF(function () {
                  e.removeAttribute('data-object-fit-polyfilled');
                });
            }
          }),
            t.addEventListener('lazyunveilread', h, !0),
            r && r.detail && h(r);
        }
      }),
      a && ((s = s.bind(null, a, a.document)), t.exports ? s(n(1)) : ((i = [n(1)]), void 0 === (o = 'function' == typeof (r = s) ? r.apply(e, i) : r) || (t.exports = o)));
  },
  function (t, e, n) {
    var r, i, o, a, s;
    (a = 'undefined' != typeof window ? window : 0),
      (s = function (t, e, n) {
        'use strict';
        if (t.addEventListener) {
          var r = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
            i = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
            o = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
            a = /^picture$/i,
            s = n.cfg,
            c = {
              getParent: function (e, n) {
                var r = e,
                  i = e.parentNode;
                return (
                  (n && 'prev' != n) || !i || !a.test(i.nodeName || '') || (i = i.parentNode),
                  'self' != n && (r = 'prev' == n ? e.previousElementSibling : (n && (i.closest || t.jQuery) && (i.closest ? i.closest(n) : jQuery(i).closest(n)[0])) || i),
                  r
                );
              },
              getFit: function (t) {
                var e,
                  n,
                  r = getComputedStyle(t, null) || {},
                  a = r.content || r.fontFamily,
                  s = { fit: t._lazysizesParentFit || t.getAttribute('data-parent-fit') };
                return (
                  !s.fit && a && (e = a.match(i)) && (s.fit = e[1]),
                  s.fit
                    ? (!(n = t._lazysizesParentContainer || t.getAttribute('data-parent-container')) && a && (e = a.match(o)) && (n = e[1]), (s.parent = c.getParent(t, n)))
                    : (s.fit = r.objectFit),
                  s
                );
              },
              getImageRatio: function (e) {
                var n,
                  i,
                  o,
                  c,
                  u,
                  l,
                  d,
                  f = e.parentNode,
                  h = f && a.test(f.nodeName || '') ? f.querySelectorAll('source, img') : [e];
                for (n = 0; n < h.length; n++)
                  if (
                    ((i = (e = h[n]).getAttribute(s.srcsetAttr) || e.getAttribute('srcset') || e.getAttribute('data-pfsrcset') || e.getAttribute('data-risrcset') || ''),
                    (o = e._lsMedia || e.getAttribute('media')),
                    (o = s.customMedia[e.getAttribute('data-media') || o] || o),
                    i && (!o || ((t.matchMedia && matchMedia(o)) || {}).matches))
                  ) {
                    (c = parseFloat(e.getAttribute('data-aspectratio'))) ||
                      ((u = i.match(r)) ? ('w' == u[2] ? ((l = u[1]), (d = u[3])) : ((l = u[3]), (d = u[1]))) : ((l = e.getAttribute('width')), (d = e.getAttribute('height'))),
                      (c = l / d));
                    break;
                  }
                return c;
              },
              calculateSize: function (t, e) {
                var n,
                  r,
                  i,
                  o = this.getFit(t),
                  a = o.fit,
                  s = o.parent;
                return 'width' == a || (('contain' == a || 'cover' == a) && (r = this.getImageRatio(t)))
                  ? (s ? (e = s.clientWidth) : (s = t),
                    (i = e),
                    'width' == a ? (i = e) : (n = e / s.clientHeight) && (('cover' == a && n < r) || ('contain' == a && n > r)) && (i = e * (r / n)),
                    i)
                  : e;
              },
            };
          (n.parentFit = c),
            e.addEventListener('lazybeforesizes', function (t) {
              if (!t.defaultPrevented && t.detail.instance == n) {
                var e = t.target;
                t.detail.width = c.calculateSize(e, t.detail.width);
              }
            });
        }
      }),
      a && ((s = s.bind(null, a, a.document)), t.exports ? s(n(1)) : ((i = [n(1)]), void 0 === (o = 'function' == typeof (r = s) ? r.apply(e, i) : r) || (t.exports = o)));
  },
  function (t, e, n) {
    var r, i, o, a, s;
    (a = window),
      (s = (s = function (t, e, n) {
        'use strict';
        var r,
          i,
          o = n.cfg,
          a = { string: 1, number: 1 },
          s = /^\-*\+*\d+\.*\d*$/,
          c = /^picture$/i,
          u = /\s*\{\s*width\s*\}\s*/i,
          l = /\s*\{\s*height\s*\}\s*/i,
          d = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
          f = /^\[.*\]|\{.*\}$/,
          h = /^(?:auto|\d+(px)?)$/,
          p = e.createElement('a'),
          g = e.createElement('img'),
          v = 'srcset' in g && !('sizes' in g),
          m = !!t.HTMLPictureElement && !v;
        function y(e, n, r) {
          var o,
            a,
            u,
            l,
            h,
            p = t.getComputedStyle(e);
          if (r) {
            for (l in ((h = {}), r)) h[l] = r[l];
            r = h;
          } else (a = e.parentNode), (r = { isPicture: !(!a || !c.test(a.nodeName || '')) });
          for (o in ((u = function (t, n) {
            var o = e.getAttribute('data-' + t);
            if (!o) {
              var a = p.getPropertyValue('--ls-' + t);
              a && (o = a.trim());
            }
            if (o) {
              if ('true' == o) o = !0;
              else if ('false' == o) o = !1;
              else if (s.test(o)) o = parseFloat(o);
              else if ('function' == typeof i[t]) o = i[t](e, o);
              else if (f.test(o))
                try {
                  o = JSON.parse(o);
                } catch (t) {}
              r[t] = o;
            } else t in i && 'function' != typeof i[t] && !r[t] ? (r[t] = i[t]) : n && 'function' == typeof i[t] && (r[t] = i[t](e, o));
          }),
          i))
            u(o);
          return (
            n.replace(d, function (t, e) {
              e in r || u(e, !0);
            }),
            r
          );
        }
        function b(t, n, o) {
          var s = 0,
            c = 0,
            f = o;
          if (t) {
            if ('container' === n.ratio) {
              for (s = f.scrollWidth, c = f.scrollHeight; !((s && c) || f === e); ) (s = (f = f.parentNode).scrollWidth), (c = f.scrollHeight);
              s && c && (n.ratio = n.traditionalRatio ? c / s : s / c);
            }
            var h, g, m;
            (h = t),
              (g = n),
              ((m = []).srcset = []),
              g.absUrl && (p.setAttribute('href', h), (h = p.href)),
              (h = ((g.prefix || '') + h + (g.postfix || '')).replace(d, function (t, e) {
                return a[typeof g[e]] ? g[e] : t;
              })),
              g.widths.forEach(function (t) {
                var e = g.widthmap[t] || t,
                  n = g.aspectratio || g.ratio,
                  r = !g.aspectratio && i.traditionalRatio,
                  o = { u: h.replace(u, e).replace(l, n ? (r ? Math.round(t * n) : Math.round(t / n)) : ''), w: t };
                m.push(o), m.srcset.push((o.c = o.u + ' ' + t + 'w'));
              }),
              ((t = m).isPicture = n.isPicture),
              v && 'IMG' == o.nodeName.toUpperCase() ? o.removeAttribute(r.srcsetAttr) : o.setAttribute(r.srcsetAttr, t.srcset.join(', ')),
              Object.defineProperty(o, '_lazyrias', { value: t, writable: !0 });
          }
        }
        function w(t) {
          return t.getAttribute(t.getAttribute('data-srcattr') || i.srcAttr) || t.getAttribute(r.srcsetAttr) || t.getAttribute(r.srcAttr) || t.getAttribute('data-pfsrcset') || '';
        }
        !(function () {
          var t,
            e = { prefix: '', postfix: '', srcAttr: 'data-src', absUrl: !1, modifyOptions: function () {}, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 };
          for (t in ((r = n && n.cfg).supportsType ||
            (r.supportsType = function (t) {
              return !t;
            }),
          r.rias || (r.rias = {}),
          'widths' in (i = r.rias) ||
            ((i.widths = []),
            (function (t) {
              for (var e, n = 0; !e || e < 3e3; ) (n += 5) > 30 && (n += 1), (e = 36 * n), t.push(e);
            })(i.widths)),
          e))
            t in i || (i[t] = e[t]);
        })(),
          addEventListener(
            'lazybeforesizes',
            function (t) {
              var e, o, a, s, c, l, d, f, p, g, v, E, k;
              if (
                t.detail.instance == n &&
                ((e = t.target), t.detail.dataAttr && !t.defaultPrevented && !i.disabled && (p = e.getAttribute(r.sizesAttr) || e.getAttribute('sizes')) && h.test(p))
              ) {
                if (
                  ((a = (function (t, e) {
                    var r = y(t, e);
                    return i.modifyOptions.call(t, { target: t, details: r, detail: r }), n.fire(t, 'lazyriasmodifyoptions', r), r;
                  })(e, (o = w(e)))),
                  (v = u.test(a.prefix) || u.test(a.postfix)),
                  a.isPicture && (s = e.parentNode))
                )
                  for (l = 0, d = (c = s.getElementsByTagName('source')).length; l < d; l++) (v || u.test((f = w(c[l])))) && (b(f, y(c[l], f, a), c[l]), (E = !0));
                v || u.test(o) ? (b(o, a, e), (E = !0)) : E && (((k = []).srcset = []), (k.isPicture = !0), Object.defineProperty(e, '_lazyrias', { value: k, writable: !0 })),
                  E && (m ? e.removeAttribute(r.srcAttr) : 'auto' != p && ((g = { width: parseInt(p, 10) }), _({ target: e, detail: g })));
              }
            },
            !0
          );
        var _ = (function () {
          var i = function (t, e) {
              return t.w - e.w;
            },
            a = function (t, e) {
              var i;
              return (
                !t._lazyrias &&
                  n.pWS &&
                  (i = n.pWS(t.getAttribute(r.srcsetAttr || ''))).length &&
                  (Object.defineProperty(t, '_lazyrias', { value: i, writable: !0 }), e && t.parentNode && (i.isPicture = 'PICTURE' == t.parentNode.nodeName.toUpperCase())),
                t._lazyrias
              );
            },
            s = function (e, r) {
              var o, s, c, u, l, d;
              if ((l = e._lazyrias).isPicture && t.matchMedia)
                for (s = 0, c = (o = e.parentNode.getElementsByTagName('source')).length; s < c; s++)
                  if (a(o[s]) && !o[s].getAttribute('type') && (!(u = o[s].getAttribute('media')) || (matchMedia(u) || {}).matches)) {
                    l = o[s]._lazyrias;
                    break;
                  }
              return (
                (!l.w || l.w < r) &&
                  ((l.w = r),
                  (l.d = (function (e) {
                    var r = t.devicePixelRatio || 1,
                      i = n.getX && n.getX(e);
                    return Math.min(i || r, 2.4, r);
                  })(e)),
                  (d = (function (t) {
                    for (var e, n, r = t.length, i = t[r - 1], o = 0; o < r; o++)
                      if ((((i = t[o]).d = i.w / t.w), i.d >= t.d)) {
                        !i.cached &&
                          (e = t[o - 1]) &&
                          e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
                          ((n = Math.pow(e.d - 0.6, 1.6)), e.cached && (e.d += 0.15 * n), e.d + (i.d - t.d) * n > t.d && (i = e));
                        break;
                      }
                    return i;
                  })(l.sort(i)))),
                d
              );
            },
            c = function (i) {
              if (i.detail.instance == n) {
                var u,
                  l = i.target;
                v || !(t.respimage || t.picturefill || o.pf)
                  ? ('_lazyrias' in l || (i.detail.dataAttr && a(l, !0))) &&
                    (u = s(l, i.detail.width)) &&
                    u.u &&
                    l._lazyrias.cur != u.u &&
                    ((l._lazyrias.cur = u.u),
                    (u.cached = !0),
                    n.rAF(function () {
                      l.setAttribute(r.srcAttr, u.u), l.setAttribute('src', u.u);
                    }))
                  : e.removeEventListener('lazybeforesizes', c);
              }
            };
          return m ? (c = function () {}) : addEventListener('lazybeforesizes', c), c;
        })();
      }).bind(null, a, a.document)),
      t.exports ? s(n(1)) : ((i = [n(1)]), void 0 === (o = 'function' == typeof (r = s) ? r.apply(e, i) : r) || (t.exports = o));
  },
  function (t, e, n) {
    var r, i, o, a, s;
    (a = window),
      (s = (s = function (t, e, n) {
        'use strict';
        if (t.addEventListener) {
          var r = n.cfg,
            i = /\s+/g,
            o = /\s*\|\s+|\s+\|\s*/g,
            a = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
            s = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
            c = /\(|\)|'/,
            u = { contain: 1, cover: 1 },
            l = function (t, e) {
              if (e) {
                var n = e.match(s);
                n && n[1] ? t.setAttribute('type', n[1]) : t.setAttribute('media', r.customMedia[e] || e);
              }
            },
            d = function (t) {
              if (t.target._lazybgset) {
                var e = t.target,
                  r = e._lazybgset,
                  i = e.currentSrc || e.src;
                if (i) {
                  var o = c.test(i) ? JSON.stringify(i) : i,
                    a = n.fire(r, 'bgsetproxy', { src: i, useSrc: o, fullSrc: null });
                  a.defaultPrevented || (r.style.backgroundImage = a.detail.fullSrc || 'url(' + a.detail.useSrc + ')');
                }
                e._lazybgsetLoading && (n.fire(r, '_lazyloaded', {}, !1, !0), delete e._lazybgsetLoading);
              }
            };
          addEventListener('lazybeforeunveil', function (t) {
            var s, c, u;
            !t.defaultPrevented &&
              (s = t.target.getAttribute('data-bgset')) &&
              ((u = t.target),
              ((c = e.createElement('img')).alt = ''),
              (c._lazybgsetLoading = !0),
              (t.detail.firesLoad = !0),
              (function (t, n, s) {
                var c = e.createElement('picture'),
                  u = n.getAttribute(r.sizesAttr),
                  d = n.getAttribute('data-ratio'),
                  f = n.getAttribute('data-optimumx');
                n._lazybgset && n._lazybgset.parentNode == n && n.removeChild(n._lazybgset),
                  Object.defineProperty(s, '_lazybgset', { value: n, writable: !0 }),
                  Object.defineProperty(n, '_lazybgset', { value: c, writable: !0 }),
                  (t = t.replace(i, ' ').split(o)),
                  (c.style.display = 'none'),
                  (s.className = r.lazyClass),
                  1 != t.length || u || (u = 'auto'),
                  t.forEach(function (t) {
                    var n,
                      i = e.createElement('source');
                    u && 'auto' != u && i.setAttribute('sizes', u),
                      (n = t.match(a)) ? (i.setAttribute(r.srcsetAttr, n[1]), l(i, n[2]), l(i, n[3])) : i.setAttribute(r.srcsetAttr, t),
                      c.appendChild(i);
                  }),
                  u && (s.setAttribute(r.sizesAttr, u), n.removeAttribute(r.sizesAttr), n.removeAttribute('sizes')),
                  f && s.setAttribute('data-optimumx', f),
                  d && s.setAttribute('data-ratio', d),
                  c.appendChild(s),
                  n.appendChild(c);
              })(s, u, c),
              setTimeout(function () {
                n.loader.unveil(c),
                  n.rAF(function () {
                    n.fire(c, '_lazyloaded', {}, !0, !0), c.complete && d({ target: c });
                  });
              }));
          }),
            e.addEventListener('load', d, !0),
            t.addEventListener(
              'lazybeforesizes',
              function (t) {
                if (t.detail.instance == n && t.target._lazybgset && t.detail.dataAttr) {
                  var e = (function (t) {
                    var e;
                    return (
                      (e = (getComputedStyle(t) || { getPropertyValue: function () {} }).getPropertyValue('background-size')),
                      !u[e] && u[t.style.backgroundSize] && (e = t.style.backgroundSize),
                      e
                    );
                  })(t.target._lazybgset);
                  u[e] &&
                    ((t.target._lazysizesParentFit = e),
                    n.rAF(function () {
                      t.target.setAttribute('data-parent-fit', e), t.target._lazysizesParentFit && delete t.target._lazysizesParentFit;
                    }));
                }
              },
              !0
            ),
            e.documentElement.addEventListener('lazybeforesizes', function (t) {
              var e, r;
              !t.defaultPrevented &&
                t.target._lazybgset &&
                t.detail.instance == n &&
                (t.detail.width =
                  ((e = t.target._lazybgset), (r = n.gW(e, e.parentNode)), (!e._lazysizesWidth || r > e._lazysizesWidth) && (e._lazysizesWidth = r), e._lazysizesWidth));
            });
        }
      }).bind(null, a, a.document)),
      t.exports ? s(n(1)) : ((i = [n(1)]), void 0 === (o = 'function' == typeof (r = s) ? r.apply(e, i) : r) || (t.exports = o));
  },
  function (t, e, n) {
    var r, i, o, a, s;
    (a = 'undefined' != typeof window ? window : 0),
      (s = function (t, e, n) {
        'use strict';
        var r,
          i,
          o,
          a,
          s,
          c,
          u,
          l,
          d,
          f,
          h,
          p,
          g,
          v,
          m,
          y,
          b = n.cfg,
          w = e.createElement('img'),
          _ = 'sizes' in w && 'srcset' in w,
          E = /\s+\d+h/g,
          k =
            ((i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/),
            (o = Array.prototype.forEach),
            function () {
              var t = e.createElement('img'),
                r = function (t) {
                  var e,
                    n,
                    r = t.getAttribute(b.srcsetAttr);
                  r && (n = r.match(i)) && ((e = 'w' == n[2] ? n[1] / n[3] : n[3] / n[1]) && t.setAttribute('data-aspectratio', e), t.setAttribute(b.srcsetAttr, r.replace(E, '')));
                },
                a = function (t) {
                  if (t.detail.instance == n) {
                    var e = t.target.parentNode;
                    e && 'PICTURE' == e.nodeName && o.call(e.getElementsByTagName('source'), r), r(t.target);
                  }
                },
                s = function () {
                  t.currentSrc && e.removeEventListener('lazybeforeunveil', a);
                };
              e.addEventListener('lazybeforeunveil', a), (t.onload = s), (t.onerror = s), (t.srcset = 'data:,a 1w 1h'), t.complete && s();
            });
        b.supportsType ||
          (b.supportsType = function (t) {
            return !t;
          }),
          t.HTMLPictureElement && _
            ? !n.hasHDescriptorFix && e.msElementsFromPoint && ((n.hasHDescriptorFix = !0), k())
            : t.picturefill ||
              b.pf ||
              ((b.pf = function (e) {
                var n, i;
                if (!t.picturefill) for (n = 0, i = e.elements.length; n < i; n++) r(e.elements[n]);
              }),
              (l = function (t, e) {
                return t.w - e.w;
              }),
              (d = /^\s*\d+\.*\d*px\s*$/),
              (s = /(([^,\s].[^\s]+)\s+(\d+)w)/g),
              (c = /\s/),
              (u = function (t, e, n, r) {
                a.push({ c: e, u: n, w: 1 * r });
              }),
              (h = function () {
                var t, n, i;
                h.init ||
                  ((h.init = !0),
                  addEventListener(
                    'resize',
                    ((n = e.getElementsByClassName('lazymatchmedia')),
                    (i = function () {
                      var t, e;
                      for (t = 0, e = n.length; t < e; t++) r(n[t]);
                    }),
                    function () {
                      clearTimeout(t), (t = setTimeout(i, 66));
                    })
                  ));
              }),
              (p = function (e, r) {
                var i,
                  o = e.getAttribute('srcset') || e.getAttribute(b.srcsetAttr);
                !o && r && (o = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(b.srcAttr) || e.getAttribute('src')),
                  (e._lazypolyfill && e._lazypolyfill._set == o) ||
                    ((i = f(o || '')),
                    r && e.parentNode && ((i.isPicture = 'PICTURE' == e.parentNode.nodeName.toUpperCase()), i.isPicture && t.matchMedia && (n.aC(e, 'lazymatchmedia'), h())),
                    (i._set = o),
                    Object.defineProperty(e, '_lazypolyfill', { value: i, writable: !0 }));
              }),
              (g = function (e) {
                return t.matchMedia
                  ? (g = function (t) {
                      return !t || (matchMedia(t) || {}).matches;
                    })(e)
                  : !e;
              }),
              (v = function (e) {
                var r, i, o, a, s, c, u;
                if ((p((a = e), !0), (s = a._lazypolyfill).isPicture))
                  for (i = 0, o = (r = e.parentNode.getElementsByTagName('source')).length; i < o; i++)
                    if (b.supportsType(r[i].getAttribute('type'), e) && g(r[i].getAttribute('media'))) {
                      (a = r[i]), p(a), (s = a._lazypolyfill);
                      break;
                    }
                return (
                  s.length > 1
                    ? ((u = a.getAttribute('sizes') || ''),
                      (u = (d.test(u) && parseInt(u, 10)) || n.gW(e, e.parentNode)),
                      (s.d = (function (e) {
                        var r = t.devicePixelRatio || 1,
                          i = n.getX && n.getX(e);
                        return Math.min(i || r, 2.5, r);
                      })(e)),
                      !s.src || !s.w || s.w < u
                        ? ((s.w = u),
                          (c = (function (t) {
                            for (var e, n, r = t.length, i = t[r - 1], o = 0; o < r; o++)
                              if ((((i = t[o]).d = i.w / t.w), i.d >= t.d)) {
                                !i.cached &&
                                  (e = t[o - 1]) &&
                                  e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
                                  ((n = Math.pow(e.d - 0.6, 1.6)), e.cached && (e.d += 0.15 * n), e.d + (i.d - t.d) * n > t.d && (i = e));
                                break;
                              }
                            return i;
                          })(s.sort(l))),
                          (s.src = c))
                        : (c = s.src))
                    : (c = s[0]),
                  c
                );
              }),
              ((m = function (t) {
                if (!_ || !t.parentNode || 'PICTURE' == t.parentNode.nodeName.toUpperCase()) {
                  var e = v(t);
                  e && e.u && t._lazypolyfill.cur != e.u && ((t._lazypolyfill.cur = e.u), (e.cached = !0), t.setAttribute(b.srcAttr, e.u), t.setAttribute('src', e.u));
                }
              }).parse = f =
                function (t) {
                  return (a = []), (t = t.trim()).replace(E, '').replace(s, u), a.length || !t || c.test(t) || a.push({ c: t, u: t, w: 99 }), a;
                }),
              (r = m),
              b.loadedClass &&
                b.loadingClass &&
                ((y = []),
                ['img[sizes$="px"][srcset].', 'picture > img:not([srcset]).'].forEach(function (t) {
                  y.push(t + b.loadedClass), y.push(t + b.loadingClass);
                }),
                b.pf({ elements: e.querySelectorAll(y.join(', ')) })));
      }),
      a && ((s = s.bind(null, a, a.document)), t.exports ? s(n(1)) : ((i = [n(1)]), void 0 === (o = 'function' == typeof (r = s) ? r.apply(e, i) : r) || (t.exports = o)));
  },
  function (t, e) {
    (t.exports = function (t) {
      if (Array.isArray(t)) return t;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    (t.exports = function (t, e) {
      var n = t && (('undefined' != typeof Symbol && t[Symbol.iterator]) || t['@@iterator']);
      if (null != n) {
        var r,
          i,
          o = [],
          a = !0,
          s = !1;
        try {
          for (n = n.call(t); !(a = (r = n.next()).done) && (o.push(r.value), !e || o.length !== e); a = !0);
        } catch (t) {
          (s = !0), (i = t);
        } finally {
          try {
            a || null == n.return || n.return();
          } finally {
            if (s) throw i;
          }
        }
        return o;
      }
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    (t.exports = function () {
      throw new TypeError('Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    (t.exports = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        i = {},
        o = Object.keys(t);
      for (r = 0; r < o.length; r++) (n = o[r]), e.indexOf(n) >= 0 || (i[n] = t[n]);
      return i;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, n) {
    var r, i;
    !(function (o, a) {
      'use strict';
      void 0 ===
        (i =
          'function' ==
          typeof (r = function () {
            var t = (function () {
              var t = window.Element.prototype;
              if (t.matches) return 'matches';
              if (t.matchesSelector) return 'matchesSelector';
              for (var e = ['webkit', 'moz', 'ms', 'o'], n = 0; n < e.length; n++) {
                var r = e[n] + 'MatchesSelector';
                if (t[r]) return r;
              }
            })();
            return function (e, n) {
              return e[t](n);
            };
          })
            ? r.call(e, n, e, t)
            : r) || (t.exports = i);
    })(window);
  },
  function (t, e, n) {
    var r, i;
    window,
      (r = [n(16)]),
      void 0 ===
        (i = function (t) {
          return (function (t, e) {
            'use strict';
            function n(t, e) {
              (this.element = t), (this.parent = e), this.create();
            }
            var r = n.prototype;
            return (
              (r.create = function () {
                (this.element.style.position = 'absolute'), this.element.setAttribute('aria-hidden', 'true'), (this.x = 0), (this.shift = 0);
              }),
              (r.destroy = function () {
                this.unselect(), (this.element.style.position = '');
                var t = this.parent.originSide;
                (this.element.style[t] = ''), this.element.removeAttribute('aria-hidden');
              }),
              (r.getSize = function () {
                this.size = e(this.element);
              }),
              (r.setPosition = function (t) {
                (this.x = t), this.updateTarget(), this.renderPosition(t);
              }),
              (r.updateTarget = r.setDefaultTarget =
                function () {
                  var t = 'left' == this.parent.originSide ? 'marginLeft' : 'marginRight';
                  this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign;
                }),
              (r.renderPosition = function (t) {
                var e = this.parent.originSide;
                this.element.style[e] = this.parent.getPositionValue(t);
              }),
              (r.select = function () {
                this.element.classList.add('is-selected'), this.element.removeAttribute('aria-hidden');
              }),
              (r.unselect = function () {
                this.element.classList.remove('is-selected'), this.element.setAttribute('aria-hidden', 'true');
              }),
              (r.wrapShift = function (t) {
                (this.shift = t), this.renderPosition(this.x + this.parent.slideableWidth * t);
              }),
              (r.remove = function () {
                this.element.parentNode.removeChild(this.element);
              }),
              n
            );
          })(0, t);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i;
    window,
      void 0 ===
        (i =
          'function' ==
          typeof (r = function () {
            'use strict';
            function t(t) {
              (this.parent = t), (this.isOriginLeft = 'left' == t.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0);
            }
            var e = t.prototype;
            return (
              (e.addCell = function (t) {
                if ((this.cells.push(t), (this.outerWidth += t.size.outerWidth), (this.height = Math.max(t.size.outerHeight, this.height)), 1 == this.cells.length)) {
                  this.x = t.x;
                  var e = this.isOriginLeft ? 'marginLeft' : 'marginRight';
                  this.firstMargin = t.size[e];
                }
              }),
              (e.updateTarget = function () {
                var t = this.isOriginLeft ? 'marginRight' : 'marginLeft',
                  e = this.getLastCell(),
                  n = e ? e.size[t] : 0,
                  r = this.outerWidth - (this.firstMargin + n);
                this.target = this.x + this.firstMargin + r * this.parent.cellAlign;
              }),
              (e.getLastCell = function () {
                return this.cells[this.cells.length - 1];
              }),
              (e.select = function () {
                this.parent.checkVisibility(),
                  this.cells.forEach(function (t) {
                    t.select();
                  });
              }),
              (e.unselect = function () {
                this.cells.forEach(function (t) {
                  t.unselect();
                });
              }),
              (e.getCellElements = function () {
                return this.cells.map(function (t) {
                  return t.element;
                });
              }),
              t
            );
          })
            ? r.call(e, n, e, t)
            : r) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i;
    window,
      (r = [n(5)]),
      void 0 ===
        (i = function (t) {
          return (function (t, e) {
            'use strict';
            return {
              startAnimation: function () {
                this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
              },
              animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var t = this.x;
                if ((this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating)) {
                  var e = this;
                  requestAnimationFrame(function () {
                    e.animate();
                  });
                }
              },
              positionSlider: function () {
                var t = this.x;
                this.options.wrapAround && this.cells.length > 1 && ((t = e.modulo(t, this.slideableWidth)), (t -= this.slideableWidth), this.shiftWrapCells(t)),
                  this.setTranslateX(t, this.isAnimating),
                  this.dispatchScrollEvent();
              },
              setTranslateX: function (t, e) {
                (t += this.cursorPosition), (t = this.options.rightToLeft ? -t : t);
                var n = this.getPositionValue(t);
                this.slider.style.transform = e ? 'translate3d(' + n + ',0,0)' : 'translateX(' + n + ')';
              },
              dispatchScrollEvent: function () {
                var t = this.slides[0];
                if (t) {
                  var e = -this.x - t.target,
                    n = e / this.slidesWidth;
                  this.dispatchEvent('scroll', null, [n, e]);
                }
              },
              positionSliderAtSelected: function () {
                this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
              },
              getPositionValue: function (t) {
                return this.options.percentPosition ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + '%' : Math.round(t) + 'px';
              },
              settle: function (t) {
                !this.isPointerDown && Math.round(100 * this.x) == Math.round(100 * t) && this.restingFrames++,
                  this.restingFrames > 2 && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent('settle', null, [this.selectedIndex])),
                  this.checkVisibility();
              },
              shiftWrapCells: function (t) {
                var e = this.cursorPosition + t;
                this._shiftCells(this.beforeShiftCells, e, -1);
                var n = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, n, 1);
              },
              _shiftCells: function (t, e, n) {
                for (var r = 0; r < t.length; r++) {
                  var i = t[r],
                    o = e > 0 ? n : 0;
                  i.wrapShift(o), (e -= i.size.outerWidth);
                }
              },
              _unshiftCells: function (t) {
                if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
              },
              integratePhysics: function () {
                (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
              },
              applyForce: function (t) {
                this.velocity += t;
              },
              getFrictionFactor: function () {
                return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
              },
              getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
              },
              applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                  var t = this.dragX - this.x - this.velocity;
                  this.applyForce(t);
                }
              },
              applySelectedAttraction: function () {
                if ((!this.isDraggable || !this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                  var t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                  this.applyForce(t);
                }
              },
            };
          })(0, t);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i, o;
    (o = window),
      (r = [n(8), n(42), n(5)]),
      void 0 ===
        (i = function (t, e, n) {
          return (function (t, e, n, r) {
            'use strict';
            r.extend(e.defaults, { draggable: '>1', dragThreshold: 3 }), e.createMethods.push('_createDrag');
            var i = e.prototype;
            r.extend(i, n.prototype), (i._touchActionValue = 'pan-y');
            var o = 'createTouch' in document,
              a = !1;
            (i._createDrag = function () {
              this.on('activate', this.onActivateDrag),
                this.on('uiChange', this._uiChangeDrag),
                this.on('deactivate', this.onDeactivateDrag),
                this.on('cellChange', this.updateDraggable),
                o && !a && (t.addEventListener('touchmove', function () {}), (a = !0));
            }),
              (i.onActivateDrag = function () {
                (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
              }),
              (i.onDeactivateDrag = function () {
                this.unbindHandles(), this.element.classList.remove('is-draggable');
              }),
              (i.updateDraggable = function () {
                '>1' == this.options.draggable
                  ? (this.isDraggable = this.slides.length > 1)
                  : 'onOverflow' === this.options.draggable
                  ? (this.isDraggable = this.viewport.scrollWidth > this.viewport.offsetWidth)
                  : (this.isDraggable = this.options.draggable),
                  this.isDraggable ? this.element.classList.add('is-draggable') : this.element.classList.remove('is-draggable');
              }),
              (i.bindDrag = function () {
                (this.options.draggable = !0), this.updateDraggable();
              }),
              (i.unbindDrag = function () {
                (this.options.draggable = !1), this.updateDraggable();
              }),
              (i._uiChangeDrag = function () {
                delete this.isFreeScrolling;
              }),
              (i.pointerDown = function (e, n) {
                this.isDraggable
                  ? this.okayPointerDown(e) &&
                    (this._pointerDownPreventDefault(e),
                    this.pointerDownFocus(e),
                    document.activeElement != this.element && this.pointerDownBlur(),
                    (this.dragX = this.x),
                    this.viewport.classList.add('is-pointer-down'),
                    (this.pointerDownScroll = c()),
                    t.addEventListener('scroll', this),
                    this._pointerDownDefault(e, n))
                  : this._pointerDownDefault(e, n);
              }),
              (i._pointerDownDefault = function (t, e) {
                (this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }), this._bindPostStartEvents(t), this.dispatchEvent('pointerDown', t, [e]);
              });
            var s = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
            function c() {
              return { x: t.pageXOffset, y: t.pageYOffset };
            }
            return (
              (i.pointerDownFocus = function (t) {
                s[t.target.nodeName] || this.focus();
              }),
              (i._pointerDownPreventDefault = function (t) {
                var e = 'touchstart' == t.type,
                  n = 'touch' == t.pointerType,
                  r = s[t.target.nodeName];
                e || n || r || t.preventDefault();
              }),
              (i.hasDragStarted = function (t) {
                return Math.abs(t.x) > this.options.dragThreshold;
              }),
              (i.pointerUp = function (t, e) {
                delete this.isTouchScrolling, this.viewport.classList.remove('is-pointer-down'), this.dispatchEvent('pointerUp', t, [e]), this._dragPointerUp(t, e);
              }),
              (i.pointerDone = function () {
                t.removeEventListener('scroll', this), delete this.pointerDownScroll;
              }),
              (i.dragStart = function (e, n) {
                this.isDraggable && ((this.dragStartPosition = this.x), this.startAnimation(), t.removeEventListener('scroll', this), this.dispatchEvent('dragStart', e, [n]));
              }),
              (i.pointerMove = function (t, e) {
                var n = this._dragPointerMove(t, e);
                this.dispatchEvent('pointerMove', t, [e, n]), this._dragMove(t, e, n);
              }),
              (i.dragMove = function (t, e, n) {
                if (this.isDraggable) {
                  t.preventDefault(), (this.previousDragX = this.dragX);
                  var r = this.options.rightToLeft ? -1 : 1;
                  this.options.wrapAround && (n.x %= this.slideableWidth);
                  var i = this.dragStartPosition + n.x * r;
                  if (!this.options.wrapAround && this.slides.length) {
                    var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                    i = i > o ? 0.5 * (i + o) : i;
                    var a = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                    i = i < a ? 0.5 * (i + a) : i;
                  }
                  (this.dragX = i), (this.dragMoveTime = new Date()), this.dispatchEvent('dragMove', t, [e, n]);
                }
              }),
              (i.dragEnd = function (t, e) {
                if (this.isDraggable) {
                  this.options.freeScroll && (this.isFreeScrolling = !0);
                  var n = this.dragEndRestingSelect();
                  if (this.options.freeScroll && !this.options.wrapAround) {
                    var r = this.getRestingPosition();
                    this.isFreeScrolling = -r > this.slides[0].target && -r < this.getLastSlide().target;
                  } else this.options.freeScroll || n != this.selectedIndex || (n += this.dragEndBoostSelect());
                  delete this.previousDragX, (this.isDragSelect = this.options.wrapAround), this.select(n), delete this.isDragSelect, this.dispatchEvent('dragEnd', t, [e]);
                }
              }),
              (i.dragEndRestingSelect = function () {
                var t = this.getRestingPosition(),
                  e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                  n = this._getClosestResting(t, e, 1),
                  r = this._getClosestResting(t, e, -1);
                return n.distance < r.distance ? n.index : r.index;
              }),
              (i._getClosestResting = function (t, e, n) {
                for (
                  var r = this.selectedIndex,
                    i = 1 / 0,
                    o =
                      this.options.contain && !this.options.wrapAround
                        ? function (t, e) {
                            return t <= e;
                          }
                        : function (t, e) {
                            return t < e;
                          };
                  o(e, i) && ((r += n), (i = e), null !== (e = this.getSlideDistance(-t, r)));

                )
                  e = Math.abs(e);
                return { distance: i, index: r - n };
              }),
              (i.getSlideDistance = function (t, e) {
                var n = this.slides.length,
                  i = this.options.wrapAround && n > 1,
                  o = i ? r.modulo(e, n) : e,
                  a = this.slides[o];
                if (!a) return null;
                var s = i ? this.slideableWidth * Math.floor(e / n) : 0;
                return t - (a.target + s);
              }),
              (i.dragEndBoostSelect = function () {
                if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
                var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
                  e = this.previousDragX - this.dragX;
                return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
              }),
              (i.staticClick = function (t, e) {
                var n = this.getParentCell(t.target),
                  r = n && n.element,
                  i = n && this.cells.indexOf(n);
                this.dispatchEvent('staticClick', t, [e, r, i]);
              }),
              (i.onscroll = function () {
                var t = c(),
                  e = this.pointerDownScroll.x - t.x,
                  n = this.pointerDownScroll.y - t.y;
                (Math.abs(e) > 3 || Math.abs(n) > 3) && this._pointerDone();
              }),
              e
            );
          })(o, t, e, n);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i, o;
    (o = window),
      (r = [n(12)]),
      void 0 ===
        (i = function (t) {
          return (function (t, e) {
            'use strict';
            function n() {}
            var r = (n.prototype = Object.create(e.prototype));
            (r.bindHandles = function () {
              this._bindHandles(!0);
            }),
              (r.unbindHandles = function () {
                this._bindHandles(!1);
              }),
              (r._bindHandles = function (e) {
                for (var n = (e = void 0 === e || e) ? 'addEventListener' : 'removeEventListener', r = e ? this._touchActionValue : '', i = 0; i < this.handles.length; i++) {
                  var o = this.handles[i];
                  this._bindStartEvent(o, e), o[n]('click', this), t.PointerEvent && (o.style.touchAction = r);
                }
              }),
              (r._touchActionValue = 'none'),
              (r.pointerDown = function (t, e) {
                this.okayPointerDown(t) &&
                  ((this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }),
                  t.preventDefault(),
                  this.pointerDownBlur(),
                  this._bindPostStartEvents(t),
                  this.emitEvent('pointerDown', [t, e]));
              });
            var i = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
              o = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
            return (
              (r.okayPointerDown = function (t) {
                var e = i[t.target.nodeName],
                  n = o[t.target.type],
                  r = !e || n;
                return r || this._pointerReset(), r;
              }),
              (r.pointerDownBlur = function () {
                var t = document.activeElement;
                t && t.blur && t != document.body && t.blur();
              }),
              (r.pointerMove = function (t, e) {
                var n = this._dragPointerMove(t, e);
                this.emitEvent('pointerMove', [t, e, n]), this._dragMove(t, e, n);
              }),
              (r._dragPointerMove = function (t, e) {
                var n = { x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY };
                return !this.isDragging && this.hasDragStarted(n) && this._dragStart(t, e), n;
              }),
              (r.hasDragStarted = function (t) {
                return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
              }),
              (r.pointerUp = function (t, e) {
                this.emitEvent('pointerUp', [t, e]), this._dragPointerUp(t, e);
              }),
              (r._dragPointerUp = function (t, e) {
                this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
              }),
              (r._dragStart = function (t, e) {
                (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(t, e);
              }),
              (r.dragStart = function (t, e) {
                this.emitEvent('dragStart', [t, e]);
              }),
              (r._dragMove = function (t, e, n) {
                this.isDragging && this.dragMove(t, e, n);
              }),
              (r.dragMove = function (t, e, n) {
                t.preventDefault(), this.emitEvent('dragMove', [t, e, n]);
              }),
              (r._dragEnd = function (t, e) {
                (this.isDragging = !1),
                  setTimeout(
                    function () {
                      delete this.isPreventingClicks;
                    }.bind(this)
                  ),
                  this.dragEnd(t, e);
              }),
              (r.dragEnd = function (t, e) {
                this.emitEvent('dragEnd', [t, e]);
              }),
              (r.onclick = function (t) {
                this.isPreventingClicks && t.preventDefault();
              }),
              (r._staticClick = function (t, e) {
                (this.isIgnoringMouseUp && 'mouseup' == t.type) ||
                  (this.staticClick(t, e),
                  'mouseup' != t.type &&
                    ((this.isIgnoringMouseUp = !0),
                    setTimeout(
                      function () {
                        delete this.isIgnoringMouseUp;
                      }.bind(this),
                      400
                    )));
              }),
              (r.staticClick = function (t, e) {
                this.emitEvent('staticClick', [t, e]);
              }),
              (n.getPointerPoint = e.getPointerPoint),
              n
            );
          })(o, t);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i;
    window,
      (r = [n(8), n(12), n(5)]),
      void 0 ===
        (i = function (t, e, n) {
          return (function (t, e, n, r) {
            'use strict';
            var i = 'http://www.w3.org/2000/svg';
            function o(t, e) {
              (this.direction = t), (this.parent = e), this._create();
            }
            (o.prototype = Object.create(n.prototype)),
              (o.prototype._create = function () {
                (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
                var t = this.parent.options.rightToLeft ? 1 : -1;
                this.isLeft = this.direction == t;
                var e = (this.element = document.createElement('button'));
                (e.className = 'flickity-button flickity-prev-next-button'),
                  (e.className += this.isPrevious ? ' previous' : ' next'),
                  e.setAttribute('type', 'button'),
                  this.disable(),
                  e.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');
                var n = this.createSVG();
                e.appendChild(n), this.parent.on('select', this.update.bind(this)), this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
              }),
              (o.prototype.activate = function () {
                this.bindStartEvent(this.element), this.element.addEventListener('click', this), this.parent.element.appendChild(this.element);
              }),
              (o.prototype.deactivate = function () {
                this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener('click', this);
              }),
              (o.prototype.createSVG = function () {
                var t = document.createElementNS(i, 'svg');
                t.setAttribute('class', 'flickity-button-icon'), t.setAttribute('viewBox', '0 0 100 100');
                var e,
                  n = document.createElementNS(i, 'path'),
                  r =
                    'string' == typeof (e = this.parent.options.arrowShape)
                      ? e
                      : 'M ' +
                        e.x0 +
                        ',50 L ' +
                        e.x1 +
                        ',' +
                        (e.y1 + 50) +
                        ' L ' +
                        e.x2 +
                        ',' +
                        (e.y2 + 50) +
                        ' L ' +
                        e.x3 +
                        ',50  L ' +
                        e.x2 +
                        ',' +
                        (50 - e.y2) +
                        ' L ' +
                        e.x1 +
                        ',' +
                        (50 - e.y1) +
                        ' Z';
                return (
                  n.setAttribute('d', r), n.setAttribute('class', 'arrow'), this.isLeft || n.setAttribute('transform', 'translate(100, 100) rotate(180) '), t.appendChild(n), t
                );
              }),
              (o.prototype.handleEvent = r.handleEvent),
              (o.prototype.onclick = function () {
                if (this.isEnabled) {
                  this.parent.uiChange();
                  var t = this.isPrevious ? 'previous' : 'next';
                  this.parent[t]();
                }
              }),
              (o.prototype.enable = function () {
                this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
              }),
              (o.prototype.disable = function () {
                this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
              }),
              (o.prototype.update = function () {
                var t = this.parent.slides;
                if (this.parent.options.wrapAround && t.length > 1) this.enable();
                else {
                  var e = t.length ? t.length - 1 : 0,
                    n = this.isPrevious ? 0 : e;
                  this[this.parent.selectedIndex == n ? 'disable' : 'enable']();
                }
              }),
              (o.prototype.destroy = function () {
                this.deactivate(), this.allOff();
              }),
              r.extend(e.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
              e.createMethods.push('_createPrevNextButtons');
            var a = e.prototype;
            return (
              (a._createPrevNextButtons = function () {
                this.options.prevNextButtons && ((this.prevButton = new o(-1, this)), (this.nextButton = new o(1, this)), this.on('activate', this.activatePrevNextButtons));
              }),
              (a.activatePrevNextButtons = function () {
                this.prevButton.activate(), this.nextButton.activate(), this.on('deactivate', this.deactivatePrevNextButtons);
              }),
              (a.deactivatePrevNextButtons = function () {
                this.prevButton.deactivate(), this.nextButton.deactivate(), this.off('deactivate', this.deactivatePrevNextButtons);
              }),
              (e.PrevNextButton = o),
              e
            );
          })(0, t, e, n);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i;
    window,
      (r = [n(8), n(12), n(5)]),
      void 0 ===
        (i = function (t, e, n) {
          return (function (t, e, n, r) {
            'use strict';
            function i(t) {
              (this.parent = t), this._create();
            }
            (i.prototype = Object.create(n.prototype)),
              (i.prototype._create = function () {
                (this.holder = document.createElement('ol')),
                  (this.holder.className = 'flickity-page-dots'),
                  (this.dots = []),
                  (this.handleClick = this.onClick.bind(this)),
                  this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
              }),
              (i.prototype.activate = function () {
                this.setDots(), this.holder.addEventListener('click', this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder);
              }),
              (i.prototype.deactivate = function () {
                this.holder.removeEventListener('click', this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder);
              }),
              (i.prototype.setDots = function () {
                var t = this.parent.slides.length - this.dots.length;
                t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
              }),
              (i.prototype.addDots = function (t) {
                for (var e = document.createDocumentFragment(), n = [], r = this.dots.length, i = r + t, o = r; o < i; o++) {
                  var a = document.createElement('li');
                  (a.className = 'dot'), a.setAttribute('aria-label', 'Page dot ' + (o + 1)), e.appendChild(a), n.push(a);
                }
                this.holder.appendChild(e), (this.dots = this.dots.concat(n));
              }),
              (i.prototype.removeDots = function (t) {
                this.dots.splice(this.dots.length - t, t).forEach(function (t) {
                  this.holder.removeChild(t);
                }, this);
              }),
              (i.prototype.updateSelected = function () {
                this.selectedDot && ((this.selectedDot.className = 'dot'), this.selectedDot.removeAttribute('aria-current')),
                  this.dots.length &&
                    ((this.selectedDot = this.dots[this.parent.selectedIndex]),
                    (this.selectedDot.className = 'dot is-selected'),
                    this.selectedDot.setAttribute('aria-current', 'step'));
              }),
              (i.prototype.onTap = i.prototype.onClick =
                function (t) {
                  var e = t.target;
                  if ('LI' == e.nodeName) {
                    this.parent.uiChange();
                    var n = this.dots.indexOf(e);
                    this.parent.select(n);
                  }
                }),
              (i.prototype.destroy = function () {
                this.deactivate(), this.allOff();
              }),
              (e.PageDots = i),
              r.extend(e.defaults, { pageDots: !0 }),
              e.createMethods.push('_createPageDots');
            var o = e.prototype;
            return (
              (o._createPageDots = function () {
                this.options.pageDots &&
                  ((this.pageDots = new i(this)),
                  this.on('activate', this.activatePageDots),
                  this.on('select', this.updateSelectedPageDots),
                  this.on('cellChange', this.updatePageDots),
                  this.on('resize', this.updatePageDots),
                  this.on('deactivate', this.deactivatePageDots));
              }),
              (o.activatePageDots = function () {
                this.pageDots.activate();
              }),
              (o.updateSelectedPageDots = function () {
                this.pageDots.updateSelected();
              }),
              (o.updatePageDots = function () {
                this.pageDots.setDots();
              }),
              (o.deactivatePageDots = function () {
                this.pageDots.deactivate();
              }),
              (e.PageDots = i),
              e
            );
          })(0, t, e, n);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i;
    window,
      (r = [n(11), n(5), n(8)]),
      void 0 ===
        (i = function (t, e, n) {
          return (function (t, e, n) {
            'use strict';
            function r(t) {
              (this.parent = t), (this.state = 'stopped'), (this.onVisibilityChange = this.visibilityChange.bind(this)), (this.onVisibilityPlay = this.visibilityPlay.bind(this));
            }
            (r.prototype = Object.create(t.prototype)),
              (r.prototype.play = function () {
                'playing' != this.state &&
                  (document.hidden
                    ? document.addEventListener('visibilitychange', this.onVisibilityPlay)
                    : ((this.state = 'playing'), document.addEventListener('visibilitychange', this.onVisibilityChange), this.tick()));
              }),
              (r.prototype.tick = function () {
                if ('playing' == this.state) {
                  var t = this.parent.options.autoPlay;
                  t = 'number' == typeof t ? t : 3e3;
                  var e = this;
                  this.clear(),
                    (this.timeout = setTimeout(function () {
                      e.parent.next(!0), e.tick();
                    }, t));
                }
              }),
              (r.prototype.stop = function () {
                (this.state = 'stopped'), this.clear(), document.removeEventListener('visibilitychange', this.onVisibilityChange);
              }),
              (r.prototype.clear = function () {
                clearTimeout(this.timeout);
              }),
              (r.prototype.pause = function () {
                'playing' == this.state && ((this.state = 'paused'), this.clear());
              }),
              (r.prototype.unpause = function () {
                'paused' == this.state && this.play();
              }),
              (r.prototype.visibilityChange = function () {
                this[document.hidden ? 'pause' : 'unpause']();
              }),
              (r.prototype.visibilityPlay = function () {
                this.play(), document.removeEventListener('visibilitychange', this.onVisibilityPlay);
              }),
              e.extend(n.defaults, { pauseAutoPlayOnHover: !0 }),
              n.createMethods.push('_createPlayer');
            var i = n.prototype;
            return (
              (i._createPlayer = function () {
                (this.player = new r(this)),
                  this.on('activate', this.activatePlayer),
                  this.on('uiChange', this.stopPlayer),
                  this.on('pointerDown', this.stopPlayer),
                  this.on('deactivate', this.deactivatePlayer);
              }),
              (i.activatePlayer = function () {
                this.options.autoPlay && (this.player.play(), this.element.addEventListener('mouseenter', this));
              }),
              (i.playPlayer = function () {
                this.player.play();
              }),
              (i.stopPlayer = function () {
                this.player.stop();
              }),
              (i.pausePlayer = function () {
                this.player.pause();
              }),
              (i.unpausePlayer = function () {
                this.player.unpause();
              }),
              (i.deactivatePlayer = function () {
                this.player.stop(), this.element.removeEventListener('mouseenter', this);
              }),
              (i.onmouseenter = function () {
                this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener('mouseleave', this));
              }),
              (i.onmouseleave = function () {
                this.player.unpause(), this.element.removeEventListener('mouseleave', this);
              }),
              (n.Player = r),
              n
            );
          })(t, e, n);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i;
    window,
      (r = [n(8), n(5)]),
      void 0 ===
        (i = function (t, e) {
          return (function (t, e, n) {
            'use strict';
            var r = e.prototype;
            return (
              (r.insert = function (t, e) {
                var n = this._makeCells(t);
                if (n && n.length) {
                  var r = this.cells.length;
                  e = void 0 === e ? r : e;
                  var i = (function (t) {
                      var e = document.createDocumentFragment();
                      return (
                        t.forEach(function (t) {
                          e.appendChild(t.element);
                        }),
                        e
                      );
                    })(n),
                    o = e == r;
                  if (o) this.slider.appendChild(i);
                  else {
                    var a = this.cells[e].element;
                    this.slider.insertBefore(i, a);
                  }
                  if (0 === e) this.cells = n.concat(this.cells);
                  else if (o) this.cells = this.cells.concat(n);
                  else {
                    var s = this.cells.splice(e, r - e);
                    this.cells = this.cells.concat(n).concat(s);
                  }
                  this._sizeCells(n), this.cellChange(e, !0);
                }
              }),
              (r.append = function (t) {
                this.insert(t, this.cells.length);
              }),
              (r.prepend = function (t) {
                this.insert(t, 0);
              }),
              (r.remove = function (t) {
                var e = this.getCells(t);
                if (e && e.length) {
                  var r = this.cells.length - 1;
                  e.forEach(function (t) {
                    t.remove();
                    var e = this.cells.indexOf(t);
                    (r = Math.min(e, r)), n.removeFrom(this.cells, t);
                  }, this),
                    this.cellChange(r, !0);
                }
              }),
              (r.cellSizeChange = function (t) {
                var e = this.getCell(t);
                if (e) {
                  e.getSize();
                  var n = this.cells.indexOf(e);
                  this.cellChange(n);
                }
              }),
              (r.cellChange = function (t, e) {
                var n = this.selectedElement;
                this._positionCells(t), this._getWrapShiftCells(), this.setGallerySize();
                var r = this.getCell(n);
                r && (this.selectedIndex = this.getCellSlideIndex(r)),
                  (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                  this.emitEvent('cellChange', [t]),
                  this.select(this.selectedIndex),
                  e && this.positionSliderAtSelected();
              }),
              e
            );
          })(0, t, e);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    var r, i;
    window,
      (r = [n(8), n(5)]),
      void 0 ===
        (i = function (t, e) {
          return (function (t, e, n) {
            'use strict';
            e.createMethods.push('_createLazyload');
            var r = e.prototype;
            function i(t, e) {
              (this.img = t), (this.flickity = e), this.load();
            }
            return (
              (r._createLazyload = function () {
                this.on('select', this.lazyLoad);
              }),
              (r.lazyLoad = function () {
                var t = this.options.lazyLoad;
                if (t) {
                  var e = 'number' == typeof t ? t : 0,
                    r = this.getAdjacentCellElements(e),
                    o = [];
                  r.forEach(function (t) {
                    var e = (function (t) {
                      if ('IMG' == t.nodeName) {
                        var e = t.getAttribute('data-flickity-lazyload'),
                          r = t.getAttribute('data-flickity-lazyload-src'),
                          i = t.getAttribute('data-flickity-lazyload-srcset');
                        if (e || r || i) return [t];
                      }
                      var o = t.querySelectorAll('img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]');
                      return n.makeArray(o);
                    })(t);
                    o = o.concat(e);
                  }),
                    o.forEach(function (t) {
                      new i(t, this);
                    }, this);
                }
              }),
              (i.prototype.handleEvent = n.handleEvent),
              (i.prototype.load = function () {
                this.img.addEventListener('load', this), this.img.addEventListener('error', this);
                var t = this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src'),
                  e = this.img.getAttribute('data-flickity-lazyload-srcset');
                (this.img.src = t),
                  e && this.img.setAttribute('srcset', e),
                  this.img.removeAttribute('data-flickity-lazyload'),
                  this.img.removeAttribute('data-flickity-lazyload-src'),
                  this.img.removeAttribute('data-flickity-lazyload-srcset');
              }),
              (i.prototype.onload = function (t) {
                this.complete(t, 'flickity-lazyloaded');
              }),
              (i.prototype.onerror = function (t) {
                this.complete(t, 'flickity-lazyerror');
              }),
              (i.prototype.complete = function (t, e) {
                this.img.removeEventListener('load', this), this.img.removeEventListener('error', this);
                var n = this.flickity.getParentCell(this.img),
                  r = n && n.element;
                this.flickity.cellSizeChange(r), this.img.classList.add(e), this.flickity.dispatchEvent('lazyLoad', t, r);
              }),
              (e.LazyLoader = i),
              e
            );
          })(0, t, e);
        }.apply(e, r)) || (t.exports = i);
  },
  function (t, e, n) {
    'use strict';
    var r;
    (r = function () {
      var t = {},
        e = {};
      return (
        (t.on = function (t, n) {
          var r = { name: t, handler: n };
          return (e[t] = e[t] || []), e[t].unshift(r), r;
        }),
        (t.off = function (t) {
          var n = e[t.name].indexOf(t);
          -1 !== n && e[t.name].splice(n, 1);
        }),
        (t.trigger = function (t, n) {
          var r,
            i = e[t];
          if (i) for (r = i.length; r--; ) i[r].handler(n);
        }),
        t
      );
    }),
      (t.exports = r);
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var r,
      i = (r = n(50)) && r.__esModule ? r : { default: r };
    (e.default = function (t) {
      return new Promise(function (e) {
        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) e(window.YT);
        else {
          var n = 'http:' === window.location.protocol ? 'http:' : 'https:';
          (0, i.default)(n + '//www.youtube.com/iframe_api', function (e) {
            e && t.trigger('error', e);
          });
          var r = window.onYouTubeIframeAPIReady;
          window.onYouTubeIframeAPIReady = function () {
            r && r(), e(window.YT);
          };
        }
      });
    }),
      (t.exports = e.default);
  },
  function (t, e) {
    function n(t, e) {
      (t.onload = function () {
        (this.onerror = this.onload = null), e(null, t);
      }),
        (t.onerror = function () {
          (this.onerror = this.onload = null), e(new Error('Failed to load ' + this.src), t);
        });
    }
    t.exports = function (t, e, r) {
      var i = document.head || document.getElementsByTagName('head')[0],
        o = document.createElement('script');
      'function' == typeof e && ((r = e), (e = {})),
        (e = e || {}),
        (r = r || function () {}),
        (o.type = e.type || 'text/javascript'),
        (o.charset = e.charset || 'utf8'),
        (o.async = !('async' in e && !e.async)),
        (o.src = t),
        e.attrs &&
          (function (t, e) {
            for (var n in e) t.setAttribute(n, e[n]);
          })(o, e.attrs),
        e.text && (o.text = '' + e.text),
        ('onload' in o
          ? n
          : function (t, e) {
              t.onreadystatechange = function () {
                ('complete' != this.readyState && 'loaded' != this.readyState) || ((this.onreadystatechange = null), e(null, t));
              };
            })(o, r),
        o.onload || n(o, r),
        i.appendChild(o);
    };
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var r = s(n(52)),
      i = s(n(55)),
      o = s(n(56)),
      a = s(n(57));
    function s(t) {
      return t && t.__esModule ? t : { default: t };
    }
    var c = (0, r.default)('youtube-player'),
      u = {
        proxyEvents: function (t) {
          var e = {},
            n = function (n) {
              var r = 'on' + n.slice(0, 1).toUpperCase() + n.slice(1);
              e[r] = function (e) {
                c('event "%s"', r, e), t.trigger(n, e);
              };
            },
            r = !0,
            i = !1,
            a = void 0;
          try {
            for (var s, u = o.default[Symbol.iterator](); !(r = (s = u.next()).done); r = !0) n(s.value);
          } catch (t) {
            (i = !0), (a = t);
          } finally {
            try {
              !r && u.return && u.return();
            } finally {
              if (i) throw a;
            }
          }
          return e;
        },
        promisifyPlayer: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = {},
            r = function (r) {
              e && a.default[r]
                ? (n[r] = function () {
                    for (var e = arguments.length, n = Array(e), i = 0; i < e; i++) n[i] = arguments[i];
                    return t.then(function (t) {
                      var e = a.default[r],
                        i = t.getPlayerState(),
                        o = t[r].apply(t, n);
                      return e.stateChangeRequired || (Array.isArray(e.acceptableStates) && -1 === e.acceptableStates.indexOf(i))
                        ? new Promise(function (n) {
                            t.addEventListener('onStateChange', function r() {
                              var i = t.getPlayerState(),
                                o = void 0;
                              'number' == typeof e.timeout &&
                                (o = setTimeout(function () {
                                  t.removeEventListener('onStateChange', r), n();
                                }, e.timeout)),
                                Array.isArray(e.acceptableStates) && -1 !== e.acceptableStates.indexOf(i) && (t.removeEventListener('onStateChange', r), clearTimeout(o), n());
                            });
                          }).then(function () {
                            return o;
                          })
                        : o;
                    });
                  })
                : (n[r] = function () {
                    for (var e = arguments.length, n = Array(e), i = 0; i < e; i++) n[i] = arguments[i];
                    return t.then(function (t) {
                      return t[r].apply(t, n);
                    });
                  });
            },
            o = !0,
            s = !1,
            c = void 0;
          try {
            for (var u, l = i.default[Symbol.iterator](); !(o = (u = l.next()).done); o = !0) {
              r(u.value);
            }
          } catch (t) {
            (s = !0), (c = t);
          } finally {
            try {
              !o && l.return && l.return();
            } finally {
              if (s) throw c;
            }
          }
          return n;
        },
      };
    (e.default = u), (t.exports = e.default);
  },
  function (t, e, n) {
    (function (r) {
      function i() {
        var t;
        try {
          t = e.storage.debug;
        } catch (t) {}
        return !t && void 0 !== r && 'env' in r && (t = r.env.DEBUG), t;
      }
      ((e = t.exports = n(53)).log = function () {
        return 'object' == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
      }),
        (e.formatArgs = function (t) {
          var n = this.useColors;
          if (((t[0] = (n ? '%c' : '') + this.namespace + (n ? ' %c' : ' ') + t[0] + (n ? '%c ' : ' ') + '+' + e.humanize(this.diff)), n)) {
            var r = 'color: ' + this.color;
            t.splice(1, 0, r, 'color: inherit');
            var i = 0,
              o = 0;
            t[0].replace(/%[a-zA-Z%]/g, function (t) {
              '%%' !== t && (i++, '%c' === t && (o = i));
            }),
              t.splice(o, 0, r);
          }
        }),
        (e.save = function (t) {
          try {
            null == t ? e.storage.removeItem('debug') : (e.storage.debug = t);
          } catch (t) {}
        }),
        (e.load = i),
        (e.useColors = function () {
          return (
            !('undefined' == typeof window || !window.process || 'renderer' !== window.process.type) ||
            ('undefined' != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
            ('undefined' != typeof window && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
            ('undefined' != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
            ('undefined' != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))
          );
        }),
        (e.storage =
          'undefined' != typeof chrome && void 0 !== chrome.storage
            ? chrome.storage.local
            : (function () {
                try {
                  return window.localStorage;
                } catch (t) {}
              })()),
        (e.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson']),
        (e.formatters.j = function (t) {
          try {
            return JSON.stringify(t);
          } catch (t) {
            return '[UnexpectedJSONParseError]: ' + t.message;
          }
        }),
        e.enable(i());
    }.call(this, n(13)));
  },
  function (t, e, n) {
    var r;
    function i(t) {
      function n() {
        if (n.enabled) {
          var t = n,
            i = +new Date(),
            o = i - (r || i);
          (t.diff = o), (t.prev = r), (t.curr = i), (r = i);
          for (var a = new Array(arguments.length), s = 0; s < a.length; s++) a[s] = arguments[s];
          (a[0] = e.coerce(a[0])), 'string' != typeof a[0] && a.unshift('%O');
          var c = 0;
          (a[0] = a[0].replace(/%([a-zA-Z%])/g, function (n, r) {
            if ('%%' === n) return n;
            c++;
            var i = e.formatters[r];
            if ('function' == typeof i) {
              var o = a[c];
              (n = i.call(t, o)), a.splice(c, 1), c--;
            }
            return n;
          })),
            e.formatArgs.call(t, a),
            (n.log || e.log || console.log.bind(console)).apply(t, a);
        }
      }
      return (
        (n.namespace = t),
        (n.enabled = e.enabled(t)),
        (n.useColors = e.useColors()),
        (n.color = (function (t) {
          var n,
            r = 0;
          for (n in t) (r = (r << 5) - r + t.charCodeAt(n)), (r |= 0);
          return e.colors[Math.abs(r) % e.colors.length];
        })(t)),
        'function' == typeof e.init && e.init(n),
        n
      );
    }
    ((e = t.exports = i.debug = i.default = i).coerce = function (t) {
      return t instanceof Error ? t.stack || t.message : t;
    }),
      (e.disable = function () {
        e.enable('');
      }),
      (e.enable = function (t) {
        e.save(t), (e.names = []), (e.skips = []);
        for (var n = ('string' == typeof t ? t : '').split(/[\s,]+/), r = n.length, i = 0; i < r; i++)
          n[i] && ('-' === (t = n[i].replace(/\*/g, '.*?'))[0] ? e.skips.push(new RegExp('^' + t.substr(1) + '$')) : e.names.push(new RegExp('^' + t + '$')));
      }),
      (e.enabled = function (t) {
        var n, r;
        for (n = 0, r = e.skips.length; n < r; n++) if (e.skips[n].test(t)) return !1;
        for (n = 0, r = e.names.length; n < r; n++) if (e.names[n].test(t)) return !0;
        return !1;
      }),
      (e.humanize = n(54)),
      (e.names = []),
      (e.skips = []),
      (e.formatters = {});
  },
  function (t, e) {
    var n = 1e3,
      r = 6e4,
      i = 36e5,
      o = 24 * i;
    function a(t, e, n) {
      if (!(t < e)) return t < 1.5 * e ? Math.floor(t / e) + ' ' + n : Math.ceil(t / e) + ' ' + n + 's';
    }
    t.exports = function (t, e) {
      e = e || {};
      var s,
        c = typeof t;
      if ('string' === c && t.length > 0)
        return (function (t) {
          if (!((t = String(t)).length > 100)) {
            var e = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t);
            if (e) {
              var a = parseFloat(e[1]);
              switch ((e[2] || 'ms').toLowerCase()) {
                case 'years':
                case 'year':
                case 'yrs':
                case 'yr':
                case 'y':
                  return 315576e5 * a;
                case 'days':
                case 'day':
                case 'd':
                  return a * o;
                case 'hours':
                case 'hour':
                case 'hrs':
                case 'hr':
                case 'h':
                  return a * i;
                case 'minutes':
                case 'minute':
                case 'mins':
                case 'min':
                case 'm':
                  return a * r;
                case 'seconds':
                case 'second':
                case 'secs':
                case 'sec':
                case 's':
                  return a * n;
                case 'milliseconds':
                case 'millisecond':
                case 'msecs':
                case 'msec':
                case 'ms':
                  return a;
                default:
                  return;
              }
            }
          }
        })(t);
      if ('number' === c && !1 === isNaN(t))
        return e.long
          ? a((s = t), o, 'day') || a(s, i, 'hour') || a(s, r, 'minute') || a(s, n, 'second') || s + ' ms'
          : (function (t) {
              return t >= o ? Math.round(t / o) + 'd' : t >= i ? Math.round(t / i) + 'h' : t >= r ? Math.round(t / r) + 'm' : t >= n ? Math.round(t / n) + 's' : t + 'ms';
            })(t);
      throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(t));
    };
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 }),
      (e.default = [
        'cueVideoById',
        'loadVideoById',
        'cueVideoByUrl',
        'loadVideoByUrl',
        'playVideo',
        'pauseVideo',
        'stopVideo',
        'getVideoLoadedFraction',
        'cuePlaylist',
        'loadPlaylist',
        'nextVideo',
        'previousVideo',
        'playVideoAt',
        'setShuffle',
        'setLoop',
        'getPlaylist',
        'getPlaylistIndex',
        'setOption',
        'mute',
        'unMute',
        'isMuted',
        'setVolume',
        'getVolume',
        'seekTo',
        'getPlayerState',
        'getPlaybackRate',
        'setPlaybackRate',
        'getAvailablePlaybackRates',
        'getPlaybackQuality',
        'setPlaybackQuality',
        'getAvailableQualityLevels',
        'getCurrentTime',
        'getDuration',
        'removeEventListener',
        'getVideoUrl',
        'getVideoEmbedCode',
        'getOptions',
        'getOption',
        'addEventListener',
        'destroy',
        'setSize',
        'getIframe',
      ]),
      (t.exports = e.default);
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 }),
      (e.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange']),
      (t.exports = e.default);
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var r,
      i = (r = n(58)) && r.__esModule ? r : { default: r };
    (e.default = {
      pauseVideo: { acceptableStates: [i.default.ENDED, i.default.PAUSED], stateChangeRequired: !1 },
      playVideo: { acceptableStates: [i.default.ENDED, i.default.PLAYING], stateChangeRequired: !1 },
      seekTo: { acceptableStates: [i.default.ENDED, i.default.PLAYING, i.default.PAUSED], stateChangeRequired: !0, timeout: 3e3 },
    }),
      (t.exports = e.default);
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 }), (e.default = { BUFFERING: 3, ENDED: 0, PAUSED: 2, PLAYING: 1, UNSTARTED: -1, VIDEO_CUED: 5 }), (t.exports = e.default);
  },
  function (t, e, n) {
    (function (t) {
      var r = (void 0 !== t && t) || ('undefined' != typeof self && self) || window,
        i = Function.prototype.apply;
      function o(t, e) {
        (this._id = t), (this._clearFn = e);
      }
      (e.setTimeout = function () {
        return new o(i.call(setTimeout, r, arguments), clearTimeout);
      }),
        (e.setInterval = function () {
          return new o(i.call(setInterval, r, arguments), clearInterval);
        }),
        (e.clearTimeout = e.clearInterval =
          function (t) {
            t && t.close();
          }),
        (o.prototype.unref = o.prototype.ref = function () {}),
        (o.prototype.close = function () {
          this._clearFn.call(r, this._id);
        }),
        (e.enroll = function (t, e) {
          clearTimeout(t._idleTimeoutId), (t._idleTimeout = e);
        }),
        (e.unenroll = function (t) {
          clearTimeout(t._idleTimeoutId), (t._idleTimeout = -1);
        }),
        (e._unrefActive = e.active =
          function (t) {
            clearTimeout(t._idleTimeoutId);
            var e = t._idleTimeout;
            e >= 0 &&
              (t._idleTimeoutId = setTimeout(function () {
                t._onTimeout && t._onTimeout();
              }, e));
          }),
        n(60),
        (e.setImmediate = ('undefined' != typeof self && self.setImmediate) || (void 0 !== t && t.setImmediate) || (this && this.setImmediate)),
        (e.clearImmediate = ('undefined' != typeof self && self.clearImmediate) || (void 0 !== t && t.clearImmediate) || (this && this.clearImmediate));
    }.call(this, n(9)));
  },
  function (t, e, n) {
    (function (t, e) {
      !(function (t, n) {
        'use strict';
        if (!t.setImmediate) {
          var r,
            i,
            o,
            a,
            s,
            c = 1,
            u = {},
            l = !1,
            d = t.document,
            f = Object.getPrototypeOf && Object.getPrototypeOf(t);
          (f = f && f.setTimeout ? f : t),
            '[object process]' === {}.toString.call(t.process)
              ? (r = function (t) {
                  e.nextTick(function () {
                    p(t);
                  });
                })
              : (function () {
                  if (t.postMessage && !t.importScripts) {
                    var e = !0,
                      n = t.onmessage;
                    return (
                      (t.onmessage = function () {
                        e = !1;
                      }),
                      t.postMessage('', '*'),
                      (t.onmessage = n),
                      e
                    );
                  }
                })()
              ? ((a = 'setImmediate$' + Math.random() + '$'),
                (s = function (e) {
                  e.source === t && 'string' == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length));
                }),
                t.addEventListener ? t.addEventListener('message', s, !1) : t.attachEvent('onmessage', s),
                (r = function (e) {
                  t.postMessage(a + e, '*');
                }))
              : t.MessageChannel
              ? (((o = new MessageChannel()).port1.onmessage = function (t) {
                  p(t.data);
                }),
                (r = function (t) {
                  o.port2.postMessage(t);
                }))
              : d && 'onreadystatechange' in d.createElement('script')
              ? ((i = d.documentElement),
                (r = function (t) {
                  var e = d.createElement('script');
                  (e.onreadystatechange = function () {
                    p(t), (e.onreadystatechange = null), i.removeChild(e), (e = null);
                  }),
                    i.appendChild(e);
                }))
              : (r = function (t) {
                  setTimeout(p, 0, t);
                }),
            (f.setImmediate = function (t) {
              'function' != typeof t && (t = new Function('' + t));
              for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) e[n] = arguments[n + 1];
              var i = { callback: t, args: e };
              return (u[c] = i), r(c), c++;
            }),
            (f.clearImmediate = h);
        }
        function h(t) {
          delete u[t];
        }
        function p(t) {
          if (l) setTimeout(p, 0, t);
          else {
            var e = u[t];
            if (e) {
              l = !0;
              try {
                !(function (t) {
                  var e = t.callback,
                    n = t.args;
                  switch (n.length) {
                    case 0:
                      e();
                      break;
                    case 1:
                      e(n[0]);
                      break;
                    case 2:
                      e(n[0], n[1]);
                      break;
                    case 3:
                      e(n[0], n[1], n[2]);
                      break;
                    default:
                      e.apply(void 0, n);
                  }
                })(e);
              } finally {
                h(t), (l = !1);
              }
            }
          }
        }
      })('undefined' == typeof self ? (void 0 === t ? this : t) : self);
    }.call(this, n(9), n(13)));
  },
  function (t, e) {
    t.exports = function (t) {
      return (
        t.webpackPolyfill ||
          ((t.deprecate = function () {}),
          (t.paths = []),
          t.children || (t.children = []),
          Object.defineProperty(t, 'loaded', {
            enumerable: !0,
            get: function () {
              return t.l;
            },
          }),
          Object.defineProperty(t, 'id', {
            enumerable: !0,
            get: function () {
              return t.i;
            },
          }),
          (t.webpackPolyfill = 1)),
        t
      );
    };
  },
  function (t, e, n) {
    'use strict';
    function r(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element)) throw new TypeError('Theme Sections: Attempted to load section. The section container provided is not a DOM element.');
        if (null === t.getAttribute('data-section-id'))
          throw new Error('Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.');
        return t;
      })(t)),
        (this.id = t.getAttribute('data-section-id')),
        (this.extensions = []),
        Object.assign(
          this,
          (function (t) {
            if ((void 0 !== t && 'object' != typeof t) || null === t) throw new TypeError('Theme Sections: The properties object provided is not a valid');
            return t;
          })(e)
        ),
        this.onLoad();
    }
    n.r(e),
      (r.prototype = {
        onLoad: Function.prototype,
        onUnload: Function.prototype,
        onSelect: Function.prototype,
        onDeselect: Function.prototype,
        onBlockSelect: Function.prototype,
        onBlockDeselect: Function.prototype,
        extend: function (t) {
          this.extensions.push(t);
          var e = Object.assign({}, t);
          delete e.init, Object.assign(this, e), 'function' == typeof t.init && t.init.apply(this);
        },
      }),
      'function' != typeof Object.assign &&
        Object.defineProperty(Object, 'assign', {
          value: function (t) {
            if (null == t) throw new TypeError('Cannot convert undefined or null to object');
            for (var e = Object(t), n = 1; n < arguments.length; n++) {
              var r = arguments[n];
              if (null != r) for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
            }
            return e;
          },
          writable: !0,
          configurable: !0,
        }),
      (window.Shopify = window.Shopify || {}),
      (window.Shopify.theme = window.Shopify.theme || {}),
      (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
    var i = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
      o = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    function a(t, e) {
      (t = u(t)),
        void 0 === e && (e = document.querySelectorAll('[data-section-type]')),
        (e = l(e)),
        t.forEach(function (t) {
          var n = i[t];
          void 0 !== n &&
            (e = e.filter(function (e) {
              return !(s(e).length > 0 || null === e.getAttribute('data-section-type') || (e.getAttribute('data-section-type') === t && (o.push(new n(e)), 1)));
            }));
        });
    }
    function s(t) {
      var e = [];
      if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var n = t[0];
      return (
        t instanceof Element || n instanceof Element
          ? l(t).forEach(function (t) {
              e = e.concat(
                o.filter(function (e) {
                  return e.container === t;
                })
              );
            })
          : ('string' != typeof t && 'string' != typeof n) ||
            u(t).forEach(function (t) {
              e = e.concat(
                o.filter(function (e) {
                  return e.type === t;
                })
              );
            }),
        e
      );
    }
    function c(t) {
      for (var e, n = 0; n < o.length; n++)
        if (o[n].id === t) {
          e = o[n];
          break;
        }
      return e;
    }
    function u(t) {
      return (
        '*' === t
          ? (t = Object.keys(i))
          : 'string' == typeof t
          ? (t = [t])
          : t.constructor === r
          ? (t = [t.prototype.type])
          : Array.isArray(t) &&
            t[0].constructor === r &&
            (t = t.map(function (t) {
              return t.prototype.type;
            })),
        t.map(function (t) {
          return t.toLowerCase();
        })
      );
    }
    function l(t) {
      return (
        NodeList.prototype.isPrototypeOf(t) && t.length > 0
          ? (t = Array.prototype.slice.call(t))
          : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
          ? (t = [])
          : !Array.isArray(t) && t instanceof Element && (t = [t]),
        t
      );
    }
    function d(t, e) {
      return void 0 === e && (e = document), e.querySelector(t);
    }
    function f(t, e) {
      return void 0 === e && (e = document), [].slice.call(e.querySelectorAll(t));
    }
    function h(t, e) {
      return Array.isArray(t) ? t.forEach(e) : e(t);
    }
    function p(t) {
      return function (e, n, r) {
        return h(e, function (e) {
          return e[t + 'EventListener'](n, r);
        });
      };
    }
    function g(t, e, n) {
      return (
        p('add')(t, e, n),
        function () {
          return p('remove')(t, e, n);
        }
      );
    }
    function v(t) {
      return function (e) {
        var n = arguments;
        return h(e, function (e) {
          var r;
          return (r = e.classList)[t].apply(r, [].slice.call(n, 1));
        });
      };
    }
    function m(t) {
      v('add').apply(void 0, [t].concat([].slice.call(arguments, 1)));
    }
    function y(t) {
      v('remove').apply(void 0, [t].concat([].slice.call(arguments, 1)));
    }
    function b(t) {
      v('toggle').apply(void 0, [t].concat([].slice.call(arguments, 1)));
    }
    function w(t, e) {
      return t.classList.contains(e);
    }
    window.Shopify.designMode &&
      (document.addEventListener('shopify:section:load', function (t) {
        var e = t.detail.sectionId,
          n = t.target.querySelector('[data-section-id="' + e + '"]');
        null !== n && a(n.getAttribute('data-section-type'), n);
      }),
      document.addEventListener('shopify:section:unload', function (t) {
        var e = t.detail.sectionId,
          n = t.target.querySelector('[data-section-id="' + e + '"]');
        'object' == typeof s(n)[0] &&
          s(n).forEach(function (t) {
            var e = o
              .map(function (t) {
                return t.id;
              })
              .indexOf(t.id);
            o.splice(e, 1), t.onUnload();
          });
      }),
      document.addEventListener('shopify:section:select', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onSelect(t);
      }),
      document.addEventListener('shopify:section:deselect', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onDeselect(t);
      }),
      document.addEventListener('shopify:block:select', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onBlockSelect(t);
      }),
      document.addEventListener('shopify:block:deselect', function (t) {
        var e = c(t.detail.sectionId);
        'object' == typeof e && e.onBlockDeselect(t);
      }));
    var _,
      E = n(6),
      k = n.n(E),
      A = n(0),
      T = n.n(A),
      x = [
        'input',
        'select',
        'textarea',
        'a[href]',
        'button',
        '[tabindex]',
        'audio[controls]',
        'video[controls]',
        '[contenteditable]:not([contenteditable="false"])',
        'details>summary:first-of-type',
        'details',
      ],
      S = x.join(','),
      C = 'undefined' == typeof Element ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
      O = function (t) {
        var e = parseInt(t.getAttribute('tabindex'), 10);
        return isNaN(e)
          ? (function (t) {
              return 'true' === t.contentEditable;
            })(t)
            ? 0
            : ('AUDIO' !== t.nodeName && 'VIDEO' !== t.nodeName && 'DETAILS' !== t.nodeName) || null !== t.getAttribute('tabindex')
            ? t.tabIndex
            : 0
          : e;
      },
      L = function (t, e) {
        return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
      },
      q = function (t) {
        return 'INPUT' === t.tagName;
      },
      D = function (t, e) {
        return !(
          e.disabled ||
          (function (t) {
            return q(t) && 'hidden' === t.type;
          })(e) ||
          (function (t, e) {
            if ('hidden' === getComputedStyle(t).visibility) return !0;
            var n = C.call(t, 'details>summary:first-of-type') ? t.parentElement : t;
            if (C.call(n, 'details:not([open]) *')) return !0;
            if (e && 'full' !== e) {
              if ('non-zero-area' === e) {
                var r = t.getBoundingClientRect(),
                  i = r.width,
                  o = r.height;
                return 0 === i && 0 === o;
              }
            } else
              for (; t; ) {
                if ('none' === getComputedStyle(t).display) return !0;
                t = t.parentElement;
              }
            return !1;
          })(e, t.displayCheck) ||
          (function (t) {
            return (
              'DETAILS' === t.tagName &&
              Array.prototype.slice.apply(t.children).some(function (t) {
                return 'SUMMARY' === t.tagName;
              })
            );
          })(e)
        );
      },
      P = function (t, e) {
        return !(
          !D(t, e) ||
          (function (t) {
            return (
              (function (t) {
                return q(t) && 'radio' === t.type;
              })(t) &&
              !(function (t) {
                if (!t.name) return !0;
                var e,
                  n = t.form || t.ownerDocument,
                  r = function (t) {
                    return n.querySelectorAll('input[type="radio"][name="' + t + '"]');
                  };
                if ('undefined' != typeof window && void 0 !== window.CSS && 'function' == typeof window.CSS.escape) e = r(window.CSS.escape(t.name));
                else
                  try {
                    e = r(t.name);
                  } catch (t) {
                    return (
                      console.error(
                        'Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s',
                        t.message
                      ),
                      !1
                    );
                  }
                var i = (function (t, e) {
                  for (var n = 0; n < t.length; n++) if (t[n].checked && t[n].form === e) return t[n];
                })(e, t.form);
                return !i || i === t;
              })(t)
            );
          })(e) ||
          O(e) < 0
        );
      },
      I = x.concat('iframe').join(','),
      M = function (t, e) {
        if (((e = e || {}), !t)) throw new Error('No node provided');
        return !1 !== C.call(t, I) && D(e, t);
      };
    function N(t, e, n) {
      return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = n), t;
    }
    function j(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e &&
          (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    var R,
      B =
        ((R = []),
        {
          activateTrap: function (t) {
            if (R.length > 0) {
              var e = R[R.length - 1];
              e !== t && e.pause();
            }
            var n = R.indexOf(t);
            -1 === n || R.splice(n, 1), R.push(t);
          },
          deactivateTrap: function (t) {
            var e = R.indexOf(t);
            -1 !== e && R.splice(e, 1), R.length > 0 && R[R.length - 1].unpause();
          },
        }),
      z = function (t) {
        return setTimeout(t, 0);
      },
      H = function (t, e) {
        var n = -1;
        return (
          t.every(function (t, r) {
            return !e(t) || ((n = r), !1);
          }),
          n
        );
      },
      F = function (t) {
        for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
        return 'function' == typeof t ? t.apply(void 0, n) : t;
      },
      V = function (t, e) {
        var n,
          r = document,
          i = (function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2
                ? j(Object(n), !0).forEach(function (e) {
                    N(t, e, n[e]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
                : j(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                  });
            }
            return t;
          })({ returnFocusOnDeactivate: !0, escapeDeactivates: !0, delayInitialFocus: !0 }, e),
          o = { containers: [], tabbableGroups: [], nodeFocusedBeforeActivation: null, mostRecentlyFocusedNode: null, active: !1, paused: !1 },
          a = function (t) {
            return o.containers.some(function (e) {
              return e.contains(t);
            });
          },
          s = function (t) {
            var e = i[t];
            if (!e) return null;
            var n = e;
            if ('string' == typeof e && !(n = r.querySelector(e))) throw new Error('`'.concat(t, '` refers to no known node'));
            if ('function' == typeof e && !(n = e())) throw new Error('`'.concat(t, '` did not return a node'));
            return n;
          },
          c = function () {
            var t;
            if (null !== s('initialFocus')) t = s('initialFocus');
            else if (a(r.activeElement)) t = r.activeElement;
            else {
              var e = o.tabbableGroups[0];
              t = (e && e.firstTabbableNode) || s('fallbackFocus');
            }
            if (!t) throw new Error('Your focus-trap needs to have at least one focusable element');
            return t;
          },
          u = function () {
            if (
              ((o.tabbableGroups = o.containers
                .map(function (t) {
                  var e,
                    n,
                    r,
                    i =
                      ((n = []),
                      (r = []),
                      (function (t, e, n) {
                        var r = Array.prototype.slice.apply(t.querySelectorAll(S));
                        return e && C.call(t, S) && r.unshift(t), r.filter(n);
                      })(t, (e = e || {}).includeContainer, P.bind(null, e)).forEach(function (t, e) {
                        var i = O(t);
                        0 === i ? n.push(t) : r.push({ documentOrder: e, tabIndex: i, node: t });
                      }),
                      r
                        .sort(L)
                        .map(function (t) {
                          return t.node;
                        })
                        .concat(n));
                  if (i.length > 0) return { container: t, firstTabbableNode: i[0], lastTabbableNode: i[i.length - 1] };
                })
                .filter(function (t) {
                  return !!t;
                })),
              o.tabbableGroups.length <= 0 && !s('fallbackFocus'))
            )
              throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
          },
          l = function t(e) {
            e !== r.activeElement &&
              (e && e.focus
                ? (e.focus({ preventScroll: !!i.preventScroll }),
                  (o.mostRecentlyFocusedNode = e),
                  (function (t) {
                    return t.tagName && 'input' === t.tagName.toLowerCase() && 'function' == typeof t.select;
                  })(e) && e.select())
                : t(c()));
          },
          d = function (t) {
            a(t.target) ||
              (F(i.clickOutsideDeactivates, t) ? n.deactivate({ returnFocus: i.returnFocusOnDeactivate && !M(t.target) }) : F(i.allowOutsideClick, t) || t.preventDefault());
          },
          f = function (t) {
            var e = a(t.target);
            e || t.target instanceof Document ? e && (o.mostRecentlyFocusedNode = t.target) : (t.stopImmediatePropagation(), l(o.mostRecentlyFocusedNode || c()));
          },
          h = function (t) {
            if (
              !1 !== i.escapeDeactivates &&
              (function (t) {
                return 'Escape' === t.key || 'Esc' === t.key || 27 === t.keyCode;
              })(t)
            )
              return t.preventDefault(), void n.deactivate();
            (function (t) {
              return 'Tab' === t.key || 9 === t.keyCode;
            })(t) &&
              (function (t) {
                u();
                var e = null;
                if (o.tabbableGroups.length > 0) {
                  var n = H(o.tabbableGroups, function (e) {
                    return e.container.contains(t.target);
                  });
                  if (n < 0) e = t.shiftKey ? o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : o.tabbableGroups[0].firstTabbableNode;
                  else if (t.shiftKey) {
                    var r = H(o.tabbableGroups, function (e) {
                      var n = e.firstTabbableNode;
                      return t.target === n;
                    });
                    if ((r < 0 && o.tabbableGroups[n].container === t.target && (r = n), r >= 0)) {
                      var i = 0 === r ? o.tabbableGroups.length - 1 : r - 1;
                      e = o.tabbableGroups[i].lastTabbableNode;
                    }
                  } else {
                    var a = H(o.tabbableGroups, function (e) {
                      var n = e.lastTabbableNode;
                      return t.target === n;
                    });
                    if ((a < 0 && o.tabbableGroups[n].container === t.target && (a = n), a >= 0)) {
                      var c = a === o.tabbableGroups.length - 1 ? 0 : a + 1;
                      e = o.tabbableGroups[c].firstTabbableNode;
                    }
                  }
                } else e = s('fallbackFocus');
                e && (t.preventDefault(), l(e));
              })(t);
          },
          p = function (t) {
            F(i.clickOutsideDeactivates, t) || a(t.target) || F(i.allowOutsideClick, t) || (t.preventDefault(), t.stopImmediatePropagation());
          },
          g = function () {
            if (o.active)
              return (
                B.activateTrap(n),
                (_ = i.delayInitialFocus
                  ? z(function () {
                      l(c());
                    })
                  : l(c())),
                r.addEventListener('focusin', f, !0),
                r.addEventListener('mousedown', d, { capture: !0, passive: !1 }),
                r.addEventListener('touchstart', d, { capture: !0, passive: !1 }),
                r.addEventListener('click', p, { capture: !0, passive: !1 }),
                r.addEventListener('keydown', h, { capture: !0, passive: !1 }),
                n
              );
          },
          v = function () {
            if (o.active)
              return (
                r.removeEventListener('focusin', f, !0),
                r.removeEventListener('mousedown', d, !0),
                r.removeEventListener('touchstart', d, !0),
                r.removeEventListener('click', p, !0),
                r.removeEventListener('keydown', h, !0),
                n
              );
          };
        return (
          (n = {
            activate: function (t) {
              if (o.active) return this;
              u(), (o.active = !0), (o.paused = !1), (o.nodeFocusedBeforeActivation = r.activeElement);
              var e = t && t.onActivate ? t.onActivate : i.onActivate;
              return e && e(), g(), this;
            },
            deactivate: function (t) {
              if (!o.active) return this;
              clearTimeout(_), v(), (o.active = !1), (o.paused = !1), B.deactivateTrap(n);
              var e = t && void 0 !== t.onDeactivate ? t.onDeactivate : i.onDeactivate;
              return (
                e && e(),
                (t && void 0 !== t.returnFocus ? t.returnFocus : i.returnFocusOnDeactivate) &&
                  z(function () {
                    var t;
                    l(((t = o.nodeFocusedBeforeActivation), s('setReturnFocus') || t));
                  }),
                this
              );
            },
            pause: function () {
              return o.paused || !o.active || ((o.paused = !0), v()), this;
            },
            unpause: function () {
              return o.paused && o.active ? ((o.paused = !1), u(), g(), this) : this;
            },
            updateContainerElements: function (t) {
              var e = [].concat(t).filter(Boolean);
              return (
                (o.containers = e.map(function (t) {
                  return 'string' == typeof t ? r.querySelector(t) : t;
                })),
                o.active && u(),
                this
              );
            },
          }).updateContainerElements(t),
          n
        );
      },
      U = !1;
    if ('undefined' != typeof window) {
      var W = {
        get passive() {
          U = !0;
        },
      };
      window.addEventListener('testPassive', null, W), window.removeEventListener('testPassive', null, W);
    }
    var G =
        'undefined' != typeof window &&
        window.navigator &&
        window.navigator.platform &&
        (/iP(ad|hone|od)/.test(window.navigator.platform) || ('MacIntel' === window.navigator.platform && window.navigator.maxTouchPoints > 1)),
      $ = [],
      J = !1,
      Y = -1,
      Q = void 0,
      X = void 0,
      Z = function (t) {
        return $.some(function (e) {
          return !(!e.options.allowTouchMove || !e.options.allowTouchMove(t));
        });
      },
      K = function (t) {
        var e = t || window.event;
        return !!Z(e.target) || e.touches.length > 1 || (e.preventDefault && e.preventDefault(), !1);
      },
      tt = function (t, e) {
        if (t) {
          if (
            !$.some(function (e) {
              return e.targetElement === t;
            })
          ) {
            var n = { targetElement: t, options: e || {} };
            ($ = [].concat(
              (function (t) {
                if (Array.isArray(t)) {
                  for (var e = 0, n = Array(t.length); e < t.length; e++) n[e] = t[e];
                  return n;
                }
                return Array.from(t);
              })($),
              [n]
            )),
              G
                ? ((t.ontouchstart = function (t) {
                    1 === t.targetTouches.length && (Y = t.targetTouches[0].clientY);
                  }),
                  (t.ontouchmove = function (e) {
                    1 === e.targetTouches.length &&
                      (function (t, e) {
                        var n = t.targetTouches[0].clientY - Y;
                        !Z(t.target) &&
                          ((e && 0 === e.scrollTop && n > 0) ||
                          ((function (t) {
                            return !!t && t.scrollHeight - t.scrollTop <= t.clientHeight;
                          })(e) &&
                            n < 0)
                            ? K(t)
                            : t.stopPropagation());
                      })(e, t);
                  }),
                  J || (document.addEventListener('touchmove', K, U ? { passive: !1 } : void 0), (J = !0)))
                : (function (t) {
                    if (void 0 === X) {
                      var e = !!t && !0 === t.reserveScrollBarGap,
                        n = window.innerWidth - document.documentElement.clientWidth;
                      e && n > 0 && ((X = document.body.style.paddingRight), (document.body.style.paddingRight = n + 'px'));
                    }
                    void 0 === Q && ((Q = document.body.style.overflow), (document.body.style.overflow = 'hidden'));
                  })(e);
          }
        } else console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
      },
      et = function (t) {
        t
          ? (($ = $.filter(function (e) {
              return e.targetElement !== t;
            })),
            G
              ? ((t.ontouchstart = null), (t.ontouchmove = null), J && 0 === $.length && (document.removeEventListener('touchmove', K, U ? { passive: !1 } : void 0), (J = !1)))
              : $.length || (void 0 !== X && ((document.body.style.paddingRight = X), (X = void 0)), void 0 !== Q && ((document.body.style.overflow = Q), (Q = void 0))))
          : console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
      },
      nt = function (t) {
        if ('object' != typeof (e = t) || Array.isArray(e)) throw 'state should be an object';
        var e;
      },
      rt = function (t, e, n, r) {
        return ((i = t),
        i.reduce(function (t, e, n) {
          return t.indexOf(e) > -1 ? t : t.concat(e);
        }, []))
          .reduce(function (t, n) {
            return t.concat(e[n] || []);
          }, [])
          .map(function (t) {
            return t(n, r);
          });
        var i;
      },
      it = ut(),
      ot = it.on,
      at = it.emit,
      st = it.hydrate,
      ct = it.getState;
    function ut(t) {
      void 0 === t && (t = {});
      var e = {};
      return {
        getState: function () {
          return Object.assign({}, t);
        },
        hydrate: function (n) {
          return (
            nt(n),
            Object.assign(t, n),
            function () {
              var r = ['*'].concat(Object.keys(n));
              rt(r, e, t);
            }
          );
        },
        on: function (t, n) {
          return (
            (t = [].concat(t)).map(function (t) {
              return (e[t] = (e[t] || []).concat(n));
            }),
            function () {
              return t.map(function (t) {
                return e[t].splice(e[t].indexOf(n), 1);
              });
            }
          );
        },
        emit: function (n, r, i) {
          var o = ('*' === n ? [] : ['*']).concat(n);
          (r = 'function' == typeof r ? r(t) : r) && (nt(r), Object.assign(t, r), (o = o.concat(Object.keys(r)))), rt(o, e, t, i);
        },
      };
    }
    var lt = window,
      dt =
        'function' == typeof lt.Promise
          ? lt.Promise
          : function (t) {
              var e = function () {};
              return (
                t(function () {
                  e();
                }),
                {
                  then: function (t) {
                    e = t;
                  },
                }
              );
            },
      ft = [],
      ht = {
        add: function (t, e, n, r) {
          var i = { el: t, defaultStyle: e, timeoutId: n, onCancelled: r };
          this.remove(t), ft.push(i);
        },
        remove: function (t) {
          var e = ht.findIndex(t);
          if (-1 !== e) {
            var n = ft[e];
            clearTimeout(n.timeoutId), n.onCancelled(), ft.splice(e, 1);
          }
        },
        find: function (t) {
          return ft[ht.findIndex(t)];
        },
        findIndex: function (t) {
          var e = -1;
          return (
            ft.some(function (n, r) {
              return n.el === t && ((e = r), !0);
            }),
            e
          );
        },
      };
    function pt(t, e) {
      return (
        void 0 === e && (e = {}),
        new dt(function (n) {
          if (-1 === ht.findIndex(t)) {
            var r = mt(t),
              i = 'number' == typeof e.endHeight,
              o = e.display || 'block',
              a = e.duration || 400,
              s = e.onCancelled || function () {},
              c = t.getAttribute('style') || '',
              u = window.getComputedStyle(t),
              l = (function (t, e) {
                void 0 === e && (e = 'block');
                var n = t.getAttribute('style') || '',
                  r = window.getComputedStyle(t);
                (t.style.visibility = 'hidden'), (t.style.display = e);
                var i = bt(r.getPropertyValue('width'));
                (t.style.position = 'absolute'),
                  (t.style.width = i + 'px'),
                  (t.style.height = ''),
                  (t.style.minHeight = ''),
                  (t.style.paddingTop = ''),
                  (t.style.paddingBottom = ''),
                  (t.style.borderTopWidth = ''),
                  (t.style.borderBottomWidth = '');
                var o = bt(r.getPropertyValue('min-height')),
                  a = bt(r.getPropertyValue('padding-top')),
                  s = bt(r.getPropertyValue('padding-bottom')),
                  c = bt(r.getPropertyValue('border-top-width')),
                  u = bt(r.getPropertyValue('border-bottom-width')),
                  l = t.scrollHeight;
                return t.setAttribute('style', n), { height: l, minHeight: o, paddingTop: a, paddingBottom: s, borderTop: c, borderBottom: u };
              })(t, o),
              d = /border-box/.test(u.getPropertyValue('box-sizing')),
              f = l.height,
              h = l.minHeight,
              p = l.paddingTop,
              g = l.paddingBottom,
              v = l.borderTop,
              m = l.borderBottom,
              y = a + 'ms',
              b = 'cubic-bezier( 0.19, 1, 0.22, 1 )',
              w = ['height ' + y + ' ' + b, 'min-height ' + y + ' ' + b, 'padding ' + y + ' ' + b, 'border-width ' + y + ' ' + b].join(),
              _ = r ? u.height : '0px',
              E = r ? u.minHeight : '0px',
              k = r ? u.paddingTop : '0px',
              A = r ? u.paddingBottom : '0px',
              T = r ? u.borderTopWidth : '0px',
              x = r ? u.borderBottomWidth : '0px',
              S = i ? e.endHeight + 'px' : d ? f + v + m + 'px' : f - p - g + 'px',
              C = h + 'px',
              O = p + 'px',
              L = g + 'px',
              q = v + 'px',
              D = m + 'px';
            if (_ !== S || k !== O || A !== L || T !== q || x !== D) {
              requestAnimationFrame(function () {
                (t.style.height = _),
                  (t.style.minHeight = E),
                  (t.style.paddingTop = k),
                  (t.style.paddingBottom = A),
                  (t.style.borderTopWidth = T),
                  (t.style.borderBottomWidth = x),
                  (t.style.display = o),
                  (t.style.overflow = 'hidden'),
                  (t.style.visibility = 'visible'),
                  (t.style.transition = w),
                  (t.style.webkitTransition = w),
                  requestAnimationFrame(function () {
                    (t.style.height = S),
                      (t.style.minHeight = C),
                      (t.style.paddingTop = O),
                      (t.style.paddingBottom = L),
                      (t.style.borderTopWidth = q),
                      (t.style.borderBottomWidth = D);
                  });
              });
              var P = setTimeout(function () {
                yt(t), (t.style.display = o), i && ((t.style.height = e.endHeight + 'px'), (t.style.overflow = 'hidden')), ht.remove(t), n();
              }, a);
              ht.add(t, c, P, s);
            } else n();
          }
        })
      );
    }
    function gt(t, e) {
      return (
        void 0 === e && (e = {}),
        new dt(function (n) {
          if (-1 === ht.findIndex(t)) {
            var r = mt(t),
              i = e.display || 'block',
              o = e.duration || 400,
              a = e.onCancelled || function () {};
            if (r) {
              var s = t.getAttribute('style') || '',
                c = window.getComputedStyle(t),
                u = /border-box/.test(c.getPropertyValue('box-sizing')),
                l = bt(c.getPropertyValue('min-height')),
                d = bt(c.getPropertyValue('padding-top')),
                f = bt(c.getPropertyValue('padding-bottom')),
                h = bt(c.getPropertyValue('border-top-width')),
                p = bt(c.getPropertyValue('border-bottom-width')),
                g = t.scrollHeight,
                v = o + 'ms',
                m = 'cubic-bezier( 0.19, 1, 0.22, 1 )',
                y = ['height ' + v + ' ' + m, 'padding ' + v + ' ' + m, 'border-width ' + v + ' ' + m].join(),
                b = u ? g + h + p + 'px' : g - d - f + 'px',
                w = l + 'px',
                _ = d + 'px',
                E = f + 'px',
                k = h + 'px',
                A = p + 'px';
              requestAnimationFrame(function () {
                (t.style.height = b),
                  (t.style.minHeight = w),
                  (t.style.paddingTop = _),
                  (t.style.paddingBottom = E),
                  (t.style.borderTopWidth = k),
                  (t.style.borderBottomWidth = A),
                  (t.style.display = i),
                  (t.style.overflow = 'hidden'),
                  (t.style.transition = y),
                  (t.style.webkitTransition = y),
                  requestAnimationFrame(function () {
                    (t.style.height = '0'),
                      (t.style.minHeight = '0'),
                      (t.style.paddingTop = '0'),
                      (t.style.paddingBottom = '0'),
                      (t.style.borderTopWidth = '0'),
                      (t.style.borderBottomWidth = '0');
                  });
              });
              var T = setTimeout(function () {
                yt(t), (t.style.display = 'none'), ht.remove(t), n();
              }, o);
              ht.add(t, s, T, a);
            } else n();
          }
        })
      );
    }
    function vt(t) {
      if (ht.find(t)) {
        var e = window.getComputedStyle(t),
          n = e.height,
          r = e.paddingTop,
          i = e.paddingBottom,
          o = e.borderTopWidth,
          a = e.borderBottomWidth;
        yt(t),
          (t.style.height = n),
          (t.style.paddingTop = r),
          (t.style.paddingBottom = i),
          (t.style.borderTopWidth = o),
          (t.style.borderBottomWidth = a),
          (t.style.overflow = 'hidden'),
          ht.remove(t);
      }
    }
    function mt(t) {
      return 0 !== t.offsetHeight;
    }
    function yt(t) {
      (t.style.visibility = ''),
        (t.style.height = ''),
        (t.style.minHeight = ''),
        (t.style.paddingTop = ''),
        (t.style.paddingBottom = ''),
        (t.style.borderTopWidth = ''),
        (t.style.borderBottomWidth = ''),
        (t.style.overflow = ''),
        (t.style.transition = ''),
        (t.style.webkitTransition = '');
    }
    function bt(t) {
      return +t.replace(/px/, '');
    }
    function wt(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = Object.assign({ firstOpen: !0 }, e),
        r = t.map(function (t) {
          return (function (t, e) {
            var n = f('.accordion__label', t),
              r = f('.accordion__text', t);
            n.forEach(function (t) {
              if (((t.href = '#'), !d('.icon', t))) {
                var e = document.createElement('div');
                e.classList.add('icon'),
                  (e.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24"><path d="M7 10L12 15L17 10H7Z" fill="currentColor"/></svg>'),
                  t.append(e);
              }
            }),
              r.forEach(function (t) {
                return m(t, 'measure');
              });
            var i = g(n, 'click', function (t) {
              t.preventDefault();
              var e = t.currentTarget,
                n = e.parentNode,
                r = e.nextElementSibling;
              vt(r),
                mt(r)
                  ? (function (t, e, n) {
                      gt(n), e.setAttribute('data-open', !1), t.setAttribute('aria-expanded', !1), n.setAttribute('aria-hidden', !0);
                    })(e, n, r)
                  : o(e, n, r);
            });
            function o(t, e, n) {
              pt(n), e.setAttribute('data-open', !0), t.setAttribute('aria-expanded', !0), n.setAttribute('aria-hidden', !1);
            }
            if (e.firstOpen) {
              var a = n[0],
                s = a.parentNode,
                c = a.nextElementSibling;
              o(n[0], s, c);
            }
            return {
              destroy: function () {
                return function () {
                  return i();
                };
              },
            };
          })(t, n);
        });
      return {
        unload: function () {
          r.forEach(function (t) {
            return t.destroy();
          });
        },
      };
    }
    var _t = 'is-visible',
      Et = 'is-fixed',
      kt = n(3),
      At = n.n(kt);
    function Tt() {
      try {
        return localStorage.setItem('test', 'test'), localStorage.removeItem('test'), !0;
      } catch (t) {
        return !1;
      }
    }
    function xt(t) {
      if (Tt()) return JSON.parse(localStorage.getItem('neon_' + t));
    }
    function St(t, e) {
      if (Tt()) return localStorage.setItem('neon_' + t, e);
    }
    var Ct = window.theme.routes.cart || {},
      Ot = {
        base: ''.concat(Ct.base || '/cart', '.js'),
        add: ''.concat(Ct.add || '/cart/add', '.js'),
        change: ''.concat(Ct.change || '/cart/change', '.js'),
        clear: ''.concat(Ct.clear || '/cart/clear', '.js'),
      };
    function Lt(t) {
      var e = xt('cart_order') || [];
      return e.length
        ? ((t.sorted = At()(t.items).sort(function (t, n) {
            return e.indexOf(t.variant_id) - e.indexOf(n.variant_id);
          })),
          t)
        : ((t.sorted = t.items), t);
    }
    function qt(t, e) {
      return fetch(Ot.change, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: t, quantity: e }) })
        .then(function (t) {
          return t.json();
        })
        .then(function (t) {
          return at('cart:updated', { cart: Lt(t) }), Lt(t);
        });
    }
    function Dt(t, e) {
      return (
        at('cart:updating'),
        fetch(Ot.add, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: t, quantity: e }) })
          .then(function (t) {
            return t.json();
          })
          .then(function (t) {
            return Pt().then(function (e) {
              var n = xt('cart_order') || [],
                r = [t.variant_id].concat(
                  At()(
                    n.filter(function (e) {
                      return e !== t.variant_id;
                    })
                  )
                );
              return St('cart_order', JSON.stringify(r)), at('cart:updated', { cart: Lt(e) }), { item: t, cart: Lt(e) };
            });
          })
      );
    }
    function Pt() {
      return fetch(Ot.base, { method: 'GET', credentials: 'include' })
        .then(function (t) {
          return t.json();
        })
        .then(function (t) {
          return Lt(t);
        });
    }
    function It(t) {
      var e = [];
      return (
        Array.prototype.slice.call(t.elements).forEach(function (t) {
          !t.name ||
            t.disabled ||
            ['file', 'reset', 'submit', 'button'].indexOf(t.type) > -1 ||
            ('select-multiple' !== t.type
              ? (['checkbox', 'radio'].indexOf(t.type) > -1 && !t.checked) || e.push(encodeURIComponent(t.name) + '=' + encodeURIComponent(t.value))
              : Array.prototype.slice.call(t.options).forEach(function (n) {
                  n.selected && e.push(encodeURIComponent(t.name) + '=' + encodeURIComponent(n.value));
                }));
        }),
        e.join('&')
      );
    }
    var Mt = {
        addItem: function (t) {
          return (
            at('cart:updating'),
            fetch(Ot.add, {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
              body: It(t),
            })
              .then(function (t) {
                return (
                  'object' == typeof BOLD &&
                    BOLD.common &&
                    BOLD.common.eventEmitter &&
                    'function' == typeof BOLD.common.eventEmitter.emit &&
                    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded'),
                  t.json()
                );
              })
              .then(function (t) {
                if ('422' == t.status) throw (at('cart:stock-error'), { code: 422, message: t.description });
                return Pt().then(function (e) {
                  var n = xt('cart_order') || [],
                    r = [t.variant_id].concat(
                      At()(
                        n.filter(function (e) {
                          return e !== t.variant_id;
                        })
                      )
                    );
                  return St('cart_order', JSON.stringify(r)), at('cart:updated', { cart: Lt(e) }), { item: t, cart: Lt(e) };
                });
              })
          );
        },
        addItemById: Dt,
        addVariant: function (t, e) {
          var n = 'deny' === t.inventory_policy && 'shopify' === t.inventory_management ? t.inventory_quantity : null;
          return Pt().then(function (r) {
            var i =
              ((
                r.items.filter(function (e) {
                  return e.id === t.id;
                })[0] || {}
              ).quantity || 0) + e;
            if (null !== n && i > n) {
              var o = 'There are only '.concat(n, ' of that product available, requested ').concat(i, '.');
              throw new Error(o);
            }
            return Dt(t.id, e);
          });
        },
        get: Pt,
        updateItem: function (t, e) {
          return Pt().then(function (n) {
            for (var r = n.items, i = 0; i < r.length; i++)
              if (r[i].variant_id === parseInt(t))
                return (
                  window.BOLD &&
                    BOLD.common &&
                    BOLD.common.eventEmitter &&
                    'function' == typeof BOLD.common.eventEmitter.emit &&
                    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded'),
                  qt(i + 1, e)
                );
          });
        },
      },
      Nt = n(17),
      jt = function (t) {
        return Object(Nt.formatMoney)(t, window.theme.moneyFormat || '${{amount}}');
      },
      Rt = function (t) {
        return function (e) {
          return fetch(''.concat(window.theme.routes.products, '/').concat(t, '.js'))
            .then(function (t) {
              return t.json();
            })
            .then(function (t) {
              return e(t);
            })
            .catch(function (t) {
              return console.log(t.message);
            });
        };
      },
      Bt = function (t, e) {
        if ('string' != typeof t) throw new TypeError('Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered');
        if (void 0 !== i[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        function n(t) {
          r.call(this, t, e);
        }
        return (n.constructor = r), (n.prototype = Object.create(r.prototype)), (n.prototype.type = t), (i[t] = n);
      };
    function zt(t) {
      return t.replace(/http(s)?:/, '');
    }
    var Ht = window.theme.strings.products,
      Ft = 'unit-price--available',
      Vt = function (t, e) {
        var n = f('[data-unit-price-container]', t),
          r = f('[data-unit-price]', t),
          i = f('[data-unit-base]', t),
          o = !e || !e.unit_price;
        b(n, Ft, !o), e && e.unit_price && (Gt(r, jt(e.unit_price)), Gt(i, Wt(e.unit_price_measurement)));
      },
      Ut = function (t, e) {
        if (t && e) {
          var n = Ht.product.unitPrice;
          return '\n      <div class="unit-price '
            .concat(Ft, '">\n        <dt>\n          <span class="visually-hidden visually-hidden--inline">')
            .concat(n, '</span>\n        </dt>\n        <dd class="unit-price__price">\n          <span data-unit-price>')
            .concat(jt(t), '</span><span aria-hidden="true">/</span><span class="visually-hidden">')
            .concat(Ht.product.unitPriceSeparator, '&nbsp;</span><span data-unit-base>')
            .concat(Wt(e), '</span>\n        </dd>\n      </div>\n    ');
        }
        return '';
      },
      Wt = function (t) {
        return 1 === t.reference_value ? t.reference_unit : t.reference_value + t.reference_unit;
      },
      Gt = function (t, e) {
        t.forEach(function (t) {
          return (t.innerText = e);
        });
      },
      $t = 'is-visible',
      Jt = 'is-fixed',
      Yt = window.theme.strings.accessibility,
      Qt = function (t) {
        var e = d('.form-status', t);
        e && d('[data-form-status]', e).focus();
      };
    function Xt(t) {
      var e = d('.video-pause', t),
        n = t.getElementsByTagName('VIDEO')[0];
      if (e && n) {
        var r = g(e, 'click', function (t) {
          t.preventDefault(), n.paused ? (n.play(), (e.innerText = Yt.pause_video)) : (n.pause(), (e.innerText = Yt.play_video));
        });
        return function () {
          return r();
        };
      }
    }
    var Zt = 'section--contrast',
      Kt = 'shopify-section--contrast',
      te = 'logo-list',
      ee = 'shopify-section--logo-list',
      ne = 'hidden',
      re = (n(27), n(28), n(29), n(30), n(31), n(1), n(32), n(2)),
      ie = n.n(re),
      oe = n(18),
      ae = function (t) {
        return function (e) {
          e.preventDefault(), t();
        };
      },
      se = function (t) {
        return "[data-media-item-id='".concat(t, "']");
      },
      ce = '[data-product-media-wrapper]',
      ue = function (t, e) {
        var n = d(ce + se(e), t),
          r = d('.media', n),
          i = f(''.concat(ce, ':not(').concat(se(e), ')'), t);
        y(n, 'hidden');
        var o = d('[data-in-your-space]', t);
        o && 'model' === r.dataset.mediaType && o.setAttribute('data-shopify-model3d-id', r.dataset.mediaId),
          i.forEach(function (t) {
            return m(t, 'hidden');
          });
      },
      le = n(19),
      de = n.n(le);
    function fe(t, e) {
      if (null === e) return t;
      if ('master' === e) return he(t);
      const n = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (n) {
        const r = t.split(n[0]),
          i = n[0];
        return he(`${r[0]}_${e}${i}`);
      }
      return null;
    }
    function he(t) {
      return t.replace(/http(s)?:/, '');
    }
    var pe =
        '\n    <div class="icon">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M12 5v14M5 12h14"/>\n      </svg>\n    </div>\n  ',
      ge =
        '\n    <div class="icon">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14"/>\n      </svg>\n    </div>\n  ',
      ve =
        '\n    <div class="icon">\n      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>\n      </svg>\n    </div>\n  ',
      me = window.theme.strings;
    function ye(t, e) {
      return t ? e : '';
    }
    function be() {
      var t = Error.call(this);
      return (t.name = 'Server error'), (t.message = 'Something went wrong on the server'), (t.status = 500), t;
    }
    function we(t) {
      var e = Error.call(this);
      return (e.name = 'Not found'), (e.message = 'Not found'), (e.status = t), e;
    }
    function _e() {
      var t = Error.call(this);
      return (t.name = 'Server error'), (t.message = 'Something went wrong on the server'), (t.status = 500), t;
    }
    function Ee(t) {
      var e = Error.call(this);
      return (e.name = 'Content-Type error'), (e.message = 'Content-Type was not provided or is of wrong type'), (e.status = t), e;
    }
    function ke(t) {
      var e = Error.call(this);
      return (e.name = 'JSON parse error'), (e.message = 'JSON syntax error'), (e.status = t), e;
    }
    function Ae(t, e, n, r) {
      var i = Error.call(this);
      return (i.name = e), (i.message = n), (i.status = t), (i.retryAfter = r), i;
    }
    function Te(t, e, n) {
      var r = Error.call(this);
      return (r.name = e), (r.message = n), (r.status = t), r;
    }
    function xe(t, e, n) {
      var r = Error.call(this);
      return (r.name = e), (r.message = n), (r.status = t), r;
    }
    function Se() {
      this.events = {};
    }
    function Ce(t) {
      (this.eventName = t), (this.callbacks = []);
    }
    function Oe(t) {
      (this._store = {}), (this._keys = []), t && t.bucketSize ? (this.bucketSize = t.bucketSize) : (this.bucketSize = 20);
    }
    (Se.prototype.on = function (t, e) {
      var n = this.events[t];
      n || ((n = new Ce(t)), (this.events[t] = n)), n.registerCallback(e);
    }),
      (Se.prototype.off = function (t, e) {
        var n = this.events[t];
        n && n.callbacks.indexOf(e) > -1 && (n.unregisterCallback(e), 0 === n.callbacks.length && delete this.events[t]);
      }),
      (Se.prototype.dispatch = function (t, e) {
        var n = this.events[t];
        n && n.fire(e);
      }),
      (Ce.prototype.registerCallback = function (t) {
        this.callbacks.push(t);
      }),
      (Ce.prototype.unregisterCallback = function (t) {
        var e = this.callbacks.indexOf(t);
        e > -1 && this.callbacks.splice(e, 1);
      }),
      (Ce.prototype.fire = function (t) {
        this.callbacks.slice(0).forEach(function (e) {
          e(t);
        });
      }),
      (Oe.prototype.set = function (t, e) {
        if (this.count() >= this.bucketSize) {
          var n = this._keys.splice(0, 1);
          this.delete(n);
        }
        return this._keys.push(t), (this._store[t] = e), this._store;
      }),
      (Oe.prototype.get = function (t) {
        return this._store[t];
      }),
      (Oe.prototype.has = function (t) {
        return Boolean(this._store[t]);
      }),
      (Oe.prototype.count = function () {
        return Object.keys(this._store).length;
      }),
      (Oe.prototype.delete = function (t) {
        var e = Boolean(this._store[t]);
        return delete this._store[t], e && !this._store[t];
      });
    var Le,
      qe,
      De =
        ((Le = function (t, e, n, r, i) {
          var o = new XMLHttpRequest(),
            a = t + '/suggest.json';
          (o.onreadystatechange = function () {
            if (o.readyState !== XMLHttpRequest.DONE);
            else {
              var t = o.getResponseHeader('Content-Type');
              if (o.status >= 500) return void i(new _e());
              if (404 === o.status) return void i(new we(o.status));
              if ('string' != typeof t || null === t.toLowerCase().match('application/json')) return void i(new Ee(o.status));
              if (417 === o.status) {
                try {
                  var e = JSON.parse(o.responseText);
                  i(new Te(o.status, e.message, e.description));
                } catch (t) {
                  i(new ke(o.status));
                }
                return;
              }
              if (422 === o.status) {
                try {
                  var a = JSON.parse(o.responseText);
                  i(new xe(o.status, a.message, a.description));
                } catch (t) {
                  i(new ke(o.status));
                }
                return;
              }
              if (429 === o.status) {
                try {
                  var s = JSON.parse(o.responseText);
                  i(new Ae(o.status, s.message, s.description, o.getResponseHeader('Retry-After')));
                } catch (t) {
                  i(new ke(o.status));
                }
                return;
              }
              if (200 === o.status) {
                try {
                  var c = JSON.parse(o.responseText);
                  (c.query = n), r(c);
                } catch (t) {
                  i(new ke(o.status));
                }
                return;
              }
              try {
                var u = JSON.parse(o.responseText);
                i(new be(o.status, u.message, u.description));
              } catch (t) {
                i(new ke(o.status));
              }
            }
          }),
            o.open('get', a + '?q=' + encodeURIComponent(n) + '&' + e),
            o.setRequestHeader('Content-Type', 'application/json'),
            o.send();
        }),
        10,
        (qe = null),
        function () {
          var t = this,
            e = arguments;
          clearTimeout(qe),
            (qe = setTimeout(function () {
              (qe = null), Le.apply(t, e);
            }, 10));
        });
    function Pe(t) {
      if (!t) throw new TypeError('No config object was specified');
      var e = t;
      (this._retryAfter = null),
        (this._currentQuery = null),
        (this.dispatcher = new Se()),
        (this.cache = new Oe({ bucketSize: 40 })),
        (this.searchPath = e.search_path || '/search'),
        e.search_path && delete e.search_path,
        (this.configParams = (function t(e, n) {
          var r = '';
          return (
            (n = n || null),
            Object.keys(e).forEach(function (i) {
              var o = i + '=';
              switch (
                (n && (o = n + '[' + i + ']'),
                (function (t) {
                  return Object.prototype.toString.call(t).slice(8, -1).toLowerCase();
                })(e[i]))
              ) {
                case 'object':
                  r += t(e[i], n ? o : i);
                  break;
                case 'array':
                  r += o + '=' + e[i].join(',') + '&';
                  break;
                default:
                  n && (o += '='), (r += o + encodeURIComponent(e[i]) + '&');
              }
            }),
            r
          );
        })(e));
    }
    function Ie(t) {
      return 'string' != typeof t ? null : t.trim().replace(' ', '-').toLowerCase();
    }
    (Pe.SEARCH_PATH = '/search'),
      (Pe.TYPES = { PRODUCT: 'product', PAGE: 'page', ARTICLE: 'article', COLLECTION: 'collection' }),
      (Pe.FIELDS = {
        AUTHOR: 'author',
        BODY: 'body',
        PRODUCT_TYPE: 'product_type',
        TAG: 'tag',
        TITLE: 'title',
        VARIANTS_BARCODE: 'variants.barcode',
        VARIANTS_SKU: 'variants.sku',
        VARIANTS_TITLE: 'variants.title',
        VENDOR: 'vendor',
      }),
      (Pe.UNAVAILABLE_PRODUCTS = { SHOW: 'show', HIDE: 'hide', LAST: 'last' }),
      (Pe.prototype.query = function (t) {
        try {
          !(function (t) {
            var e;
            if (null == t) throw (((e = new TypeError("'query' is missing")).type = 'argument'), e);
            if ('string' != typeof t) throw (((e = new TypeError("'query' is not a string")).type = 'argument'), e);
          })(t);
        } catch (t) {
          return void this.dispatcher.dispatch('error', t);
        }
        if ('' === t) return this;
        this._currentQuery = Ie(t);
        var e = this.cache.get(this._currentQuery);
        return e
          ? (this.dispatcher.dispatch('success', e), this)
          : (De(
              this.searchPath,
              this.configParams,
              t,
              function (t) {
                this.cache.set(Ie(t.query), t), Ie(t.query) === this._currentQuery && ((this._retryAfter = null), this.dispatcher.dispatch('success', t));
              }.bind(this),
              function (t) {
                t.retryAfter && (this._retryAfter = t.retryAfter), this.dispatcher.dispatch('error', t);
              }.bind(this)
            ),
            this);
      }),
      (Pe.prototype.on = function (t, e) {
        return this.dispatcher.on(t, e), this;
      }),
      (Pe.prototype.off = function (t, e) {
        return this.dispatcher.off(t, e), this;
      });
    var Me = n(7),
      Ne = n.n(Me),
      je = window.theme.strings,
      Re = 'active',
      Be = 'visible';
    var ze = n(10),
      He = n.n(ze),
      Fe =
        '\n  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M3 7A2 2 0 0 0 1 9V17H3V13H5V17H7V9A2 2 0 0 0 5 7H3M3 9H5V11H3M15 10.5V9A2 2 0 0 0 13 7H9V17H13A2 2 0 0 0 15 15V13.5A1.54 1.54 0 0 0 13.5 12A1.54 1.54 0 0 0 15 10.5M13 15H11V13H13V15M13 11H11V9H13M19 7A2 2 0 0 0 17 9V15A2 2 0 0 0 19 17H21A2 2 0 0 0 23 15V14H21V15H19V9H21V10H23V9A2 2 0 0 0 21 7Z" fill="currentColor" />\n  </svg>\n',
      Ve = {
        el: { clear: '[data-search-clear]', input: '[data-input]', results: '[data-search-results]', search: '[data-search-submit]' },
        strings: { articles: 'Articles', pages: 'Pages', products: 'Products', view_all: 'View all', no_results: 'We found no search results' },
        headingMarkup: function (t) {
          return '<div class="quick-search__header ff-heading fs-heading-3-base">'.concat(t, '</div>');
        },
        resultMarkup: function (t) {
          var e = t.url,
            n = t.img,
            r = t.heading,
            i = t.subheading;
          return '\n  <a class="quick-search__result" href="'
            .concat(e, '">\n    <div class="quick-search__result-image">')
            .concat(n, '</div>\n    <div class="quick-search__result-details ff-body fs-body-small">\n      <div class="quick-search__result-heading">')
            .concat(r, '</div>\n      <div class="quick-search__result-subheading">')
            .concat(i, '</div>\n    </div>\n  </a>\n');
        },
        viewAllMarkup: function (t) {
          return '\n  <div class="quick-search__view-all ff-body fs-body-base">\n    <button type="submit" class="btn btn--text-link">'.concat(t, '</button>\n  </div>\n');
        },
      };
    function Ue(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e &&
          (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function We(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2
          ? Ue(Object(n), !0).forEach(function (e) {
              He()(t, e, n[e]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
          : Ue(Object(n)).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
            });
      }
      return t;
    }
    var Ge = 'active',
      $e = 'visible',
      Je = 'child-visible',
      Ye = function (t) {
        return t + 8 + 'px';
      };
    Bt('header', {
      onLoad: function () {
        var t = this,
          e = d('[data-js-cart-icon]', this.container),
          n = d('[data-js-cart-indicator]', e),
          r = d('[data-js-cart-count]', this.container),
          i = f('[data-js-menu-button]', this.container),
          o = f('[data-search]', this.container),
          a = d('[data-header-space]', document),
          s = (function (t) {
            var e = window.theme,
              n = V(t),
              r = 0,
              i = d('[data-main]', t),
              o = d('[data-primary-container]', t),
              a = d('.drawer-menu__form', t),
              s = d('[data-locale-input]', t),
              c = d('[data-currency-input]', t),
              u = d('[data-search-settings]', t),
              l = (function (t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  n = Object.assign(Ve, e),
                  r = '',
                  i = d(n.el.input, t),
                  o = d(n.el.results, t),
                  a = d(n.el.clear, t),
                  s = d(n.el.search, t),
                  c = d('[data-search-settings]', document),
                  u = g(i, 'input', function (t) {
                    var e = t.target.value;
                    '' === e && S(), b([a, s], 'visible', '' !== e), b(i, 'active', '' !== e), k.query(e);
                  }),
                  l = g(a, 'click', S),
                  f = JSON.parse(c.innerHTML),
                  h = f.limit,
                  p = f.show_articles,
                  v = f.show_pages,
                  w = f.show_price,
                  _ = f.show_vendor,
                  E = [p && Pe.TYPES.ARTICLE, v && Pe.TYPES.PAGE, Pe.TYPES.PRODUCT].filter(Boolean),
                  k = new Pe({
                    resources: {
                      type: E,
                      limit: h,
                      options: { unavailable_products: 'last', fields: [Pe.FIELDS.TITLE, Pe.FIELDS.PRODUCT_TYPE, Pe.FIELDS.VARIANTS_TITLE, Pe.FIELDS.VENDOR] },
                    },
                  });
                function A(t, e, r) {
                  return t.length < 1 ? '' : n.headingMarkup(e) + t.map(r).join('');
                }
                function T(t) {
                  var e,
                    i = t.url,
                    o = t.image,
                    a = t.featured_image,
                    s = t.heading,
                    c = t.subheading,
                    u = new RegExp('(' + r + ')', 'gi'),
                    l = s.replace(u, '<span class="hl">$1</span>'),
                    d = c.replace(u, '<span class="hl">$1</span>');
                  return (
                    (e =
                      a && a.url
                        ? '<img class="image__img lazyload" alt="'.concat(a.alt, '" data-src="').concat(fe(a.url, '120x'), '" />')
                        : o
                        ? '<img class="image__img lazyload" data-src="'.concat(fe(o, '120x'), '" />')
                        : Fe),
                    n.resultMarkup({ url: i, img: e, heading: l, subheading: d })
                  );
                }
                function x(t) {
                  var e = t.articles,
                    r = t.pages,
                    i = t.products,
                    a = '',
                    s = !(i.length || (e && e.length) || (r && r.length));
                  s && (a = '\n        <div class="quick-search__no-results">\n          '.concat(n.strings.no_results, '\n        </div>\n      ')),
                    i.length &&
                      (a = A(i, n.strings.products, function (t) {
                        var e = t.url,
                          n = t.image,
                          r = t.featured_image,
                          i = t.title,
                          o = t.price,
                          a = t.vendor,
                          s = jt(o * window.Shopify.currency.rate * 100);
                        return T({ url: e, image: n, featured_image: r, heading: i, subheading: [_ && a, w && Ne()(s)].filter(Boolean).join(' • ') });
                      })),
                    r &&
                      r.length &&
                      (a += A(r, n.strings.pages, function (t) {
                        var e = t.url,
                          n = t.image,
                          r = t.title,
                          i = t.body;
                        return T({ url: e, image: n, heading: r, subheading: Ne()(i) });
                      })),
                    e &&
                      e.length &&
                      (a += A(e, n.strings.articles, function (t) {
                        var e = t.url,
                          n = t.image,
                          r = t.title,
                          i = t.body;
                        return T({ url: e, image: n, heading: r, subheading: Ne()(i) });
                      }));
                  var c = s ? '' : n.viewAllMarkup(n.strings.view_all);
                  o.innerHTML = a + c;
                }
                function S(t) {
                  t && t.preventDefault(), C(), i.focus();
                }
                function C() {
                  (i.value = ''), y([o, a, s], 'visible'), y(i, 'active'), (o.innerHTML = '');
                }
                return (
                  k.on('success', function (t) {
                    var e = t.query,
                      n = t.resources.results;
                    (r = e), m(o, 'visible'), x(n);
                  }),
                  k.on('error', function (t) {
                    console.log('Search error:', t.message);
                  }),
                  {
                    destroy: function () {
                      u(), l();
                    },
                    clear: C,
                  }
                );
              })(
                t,
                We(
                  We({}, JSON.parse(u.innerHTML)),
                  {},
                  {
                    strings: {
                      articles: e.strings.search.headings.articles,
                      pages: e.strings.search.headings.pages,
                      products: e.strings.search.headings.products,
                      view_all: e.strings.search.view_all,
                      no_results: e.strings.search.no_results,
                    },
                  }
                )
              ),
              h = d('[data-overlay]', t),
              p = f('[data-item="parent"]', t),
              v = f('[data-item="back"]', t),
              w = f('[data-item="locale"]', t),
              _ = f('[data-item="currency"]', t),
              E = f('[data-drawer-close]', t),
              k = [
                g(h, 'click', A),
                g(E, 'click', A),
                g(t, 'keydown', function (t) {
                  27 === t.keyCode && A();
                }),
                g(p, 'click', function (e) {
                  e.preventDefault();
                  var n = e.currentTarget,
                    o = n.nextElementSibling,
                    a = d('.drawer-menu__link', o);
                  m(o, $e),
                    m(n.parentNode, Je),
                    o.hasAttribute('data-search-menu') && m(t, 'search-active'),
                    (i.style.height = Ye(o.offsetHeight)),
                    T((r += 1)),
                    n.setAttribute('aria-expanded', !0),
                    o.setAttribute('aria-hidden', !1),
                    setTimeout(function () {
                      a.focus();
                    }, 50);
                }),
                g(v, 'click', function (e) {
                  e.preventDefault();
                  var n = e.currentTarget.closest('[data-list-item]').closest('ul'),
                    o = d('.drawer-menu__link', n),
                    a = e.currentTarget.closest('ul'),
                    s = d('.drawer-menu__link', a.parentNode);
                  y(a, $e),
                    y(s.parentNode, Je),
                    T((r -= 1)),
                    s.setAttribute('aria-expanded', !1),
                    a.setAttribute('aria-hidden', !0),
                    (i.style.height = Ye(n.offsetHeight)),
                    a.hasAttribute('data-search-menu') && (l.clear(), y(t, 'search-active')),
                    setTimeout(function () {
                      o.focus();
                    }, 50);
                }),
                g(w, 'click', function (t) {
                  return x(t, s);
                }),
                g(_, 'click', function (t) {
                  return x(t, c);
                }),
              ];
            function A() {
              n.deactivate(),
                y(t, $e),
                setTimeout(function () {
                  y(t, Ge), et(t);
                }, 350);
            }
            function T(t) {
              (r = t), o.setAttribute('data-depth', t);
            }
            function x(t, e) {
              var n = t.currentTarget.dataset.value;
              (e.value = n), A(), a.submit();
            }
            return {
              close: A,
              destroy: function () {
                k.forEach(function (t) {
                  return t();
                }),
                  et(t),
                  l.destroy();
              },
              open: function () {
                m(t, Ge),
                  setTimeout(function () {
                    m(t, $e),
                      n.activate(),
                      tt(t, {
                        allowTouchMove: function (t) {
                          for (; t && t !== document.body; ) {
                            if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                            t = t.parentNode;
                          }
                        },
                        reserveScrollBarGap: !0,
                      }),
                      0 === r && (i.style.height = Ye(o.offsetHeight));
                  }, 50);
              },
            };
          })(d('[data-drawer-menu]')),
          c = (function (t) {
            var e = d('[data-overlay]', t),
              n = d('[data-input]', t),
              r = d('[data-clear]', t),
              i = d('[data-results]', t),
              o = d('[data-close-icon]', t),
              a = d('[data-search-settings]', document),
              s = JSON.parse(a.innerHTML),
              c = s.limit,
              u = s.show_articles,
              l = s.show_pages,
              f = s.show_price,
              h = s.show_vendor,
              p = '',
              v = [
                g([e, o], 'click', x),
                g(r, 'click', T),
                g(n, 'input', function (t) {
                  '' === t.target.value && T(), b(r, Be, '' !== t.target.value), b(n.parentNode, Re, '' !== t.target.value), E.query(t.target.value);
                }),
                g(t, 'keydown', function (t) {
                  27 === t.keyCode && x();
                }),
              ],
              w = V(t, { allowOutsideClick: !0 }),
              _ = [u && Pe.TYPES.ARTICLE, l && Pe.TYPES.PAGE, Pe.TYPES.PRODUCT].filter(Boolean),
              E = new Pe({
                resources: {
                  type: _,
                  limit: c,
                  options: { unavailable_products: 'last', fields: [Pe.FIELDS.TITLE, Pe.FIELDS.PRODUCT_TYPE, Pe.FIELDS.VARIANTS_TITLE, Pe.FIELDS.VENDOR] },
                },
              });
            function k(t, e, n) {
              return t.length < 1 ? '' : '<div class="quick-search__header ff-heading fs-heading-3-base">'.concat(e, '</div>') + t.map(n).join('');
            }
            function A(t) {
              var e,
                n = t.url,
                r = t.image,
                i = t.featured_image,
                o = t.heading,
                a = t.subheading,
                s = new RegExp('(' + p + ')', 'gi'),
                c = o.replace(s, '<span class="hl">$1</span>'),
                u = a.replace(s, '<span class="hl">$1</span>');
              return (
                (e =
                  i && i.url
                    ? '<img class="image__img lazyload" alt="'.concat(i.alt, '" data-src="').concat(fe(i.url, '120x'), '" />')
                    : r
                    ? '<img class="image__img lazyload" data-src="'.concat(fe(r, '120x'), '" />')
                    : '\n  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M3 7A2 2 0 0 0 1 9V17H3V13H5V17H7V9A2 2 0 0 0 5 7H3M3 9H5V11H3M15 10.5V9A2 2 0 0 0 13 7H9V17H13A2 2 0 0 0 15 15V13.5A1.54 1.54 0 0 0 13.5 12A1.54 1.54 0 0 0 15 10.5M13 15H11V13H13V15M13 11H11V9H13M19 7A2 2 0 0 0 17 9V15A2 2 0 0 0 19 17H21A2 2 0 0 0 23 15V14H21V15H19V9H21V10H23V9A2 2 0 0 0 21 7Z" fill="currentColor" />\n  </svg>\n'),
                '\n      <a class="quick-search__result" href="'
                  .concat(n, '">\n        <div class="quick-search__result-image">')
                  .concat(e, '</div>\n        <div class="quick-search__result-details ff-body fs-body-small">\n          <div class="quick-search__result-heading">')
                  .concat(c, '</div>\n          <div class="quick-search__result-subheading">')
                  .concat(u, '</div>\n        </div>\n      </a>\n  ')
              );
            }
            function T(t) {
              t && t.preventDefault(), (n.value = ''), y(r, Be), y(n.parentNode, Re), (i.innerHTML = ''), n.focus();
            }
            function x() {
              y(t, Be),
                w.deactivate(),
                setTimeout(function () {
                  y(t, Re), et(t);
                }, 350);
            }
            return (
              E.on('success', function (t) {
                var e = t.query,
                  n = t.resources.results;
                (p = e),
                  (function (t) {
                    var e = t.products,
                      n = t.articles,
                      r = t.pages,
                      o = '',
                      a = !(e.length || (n && n.length) || (r && r.length));
                    a && (o = '\n        <div class="quick-search__no-results">\n          '.concat(je.search.no_results, '\n        </div>\n      ')),
                      e.length &&
                        (o = k(e, je.search.headings.products, function (t) {
                          var e = t.url,
                            n = t.image,
                            r = t.featured_image,
                            i = t.title,
                            o = t.price,
                            a = t.vendor,
                            s = jt(o * window.Shopify.currency.rate * 100);
                          return A({ url: e, image: n, heading: i, featured_image: r, subheading: [h && a, f && Ne()(s)].filter(Boolean).join(' • ') });
                        })),
                      r &&
                        (o += k(r, je.search.headings.pages, function (t) {
                          var e = t.url,
                            n = t.image,
                            r = t.title,
                            i = t.body;
                          return A({ url: e, image: n, heading: r, subheading: Ne()(i) });
                        })),
                      n &&
                        (o += k(n, je.search.headings.articles, function (t) {
                          var e = t.url,
                            n = t.image,
                            r = t.title,
                            i = t.body;
                          return A({ url: e, image: n, heading: r, subheading: Ne()(i) });
                        }));
                    var s = a
                      ? ''
                      : '\n      <div class="quick-search__view-all ff-body fs-body-small">\n        <button type="submit" class="btn btn--text-link">'.concat(
                          je.search.view_all,
                          '</button>\n      </div>\n    '
                        );
                    i.innerHTML = o + s;
                  })(n);
              }),
              E.on('error', function (t) {
                console.log('Predictive Search Error:', t.message);
              }),
              {
                open: function () {
                  m(t, Re),
                    w.activate(),
                    setTimeout(function () {
                      n.focus(), tt(t, { reserveScrollBarGap: !0 }), m(t, Be);
                    }, 50);
                },
                close: x,
                destroy: function () {
                  x(),
                    v.forEach(function (t) {
                      return t();
                    });
                },
              }
            );
          })(d('[data-quick-search]', this.container)),
          u = (function (t) {
            var e = new T.a(t),
              n = d('[data-overlay]', t),
              r = d('[data-cart]', t),
              i = d('[data-items]', t),
              o = d('[data-empty]', t),
              a = d('[data-buy-now-button]', t),
              s = d('[data-footer]', t),
              c = d('[data-discounts]', s),
              u = d('[data-subtotal]', s),
              l = d('[data-close-icon]', t);
            e.on('click', 'button[data-decrease]', function (t, e) {
              t.preventDefault();
              var n = parseInt(e.closest('.quick-cart__item').dataset.quantity) - 1;
              Mt.updateItem(e.dataset.decrease, n);
            }),
              e.on('click', 'button[data-increase]', function (t, e) {
                t.preventDefault();
                var n = parseInt(e.closest('.quick-cart__item').dataset.quantity) + 1;
                Mt.updateItem(e.dataset.increase, n);
              }),
              e.on('click', 'button[data-remove]', function (t, e) {
                Mt.updateItem(e.dataset.remove, 0);
              });
            var f = V(t, { allowOutsideClick: !0 });
            Mt.get().then(w),
              ot('cart:updated', function (t) {
                return w(t.cart);
              });
            var h = [
              g([n, l], 'click', v),
              g(t, 'keydown', function (t) {
                27 === t.keyCode && v();
              }),
            ];
            function p() {
              m(t, 'active'),
                f.activate(),
                setTimeout(function () {
                  tt(t, {
                    allowTouchMove: function (t) {
                      for (; t && t !== document.body; ) {
                        if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                        t = t.parentNode;
                      }
                    },
                    reserveScrollBarGap: !0,
                  }),
                    m(t, 'visible'),
                    m(r, 'visible');
                }, 50);
            }
            function v() {
              y(t, 'visible'),
                setTimeout(function () {
                  y(t, 'active'), et(t), m(r, 'visible'), f.deactivate();
                }, 350);
            }
            function w(t) {
              var e,
                n = t.cart_level_discount_applications;
              (i.innerHTML = ye(
                (e = t.sorted).length > 0,
                e.reduce(function (t, e) {
                  return (
                    t +
                    (function (t) {
                      var e,
                        n,
                        r,
                        i = t.line_level_discount_allocations,
                        o = de()(t, ['line_level_discount_allocations']),
                        a = o.featured_image ? o.featured_image.url : o.image,
                        s = o.featured_image ? o.featured_image.alt : '',
                        c = ye(a, '<img class="image__img lazyload" alt="'.concat(s, '" data-src="').concat(fe(a, '240x'), '" />')),
                        u = o.selling_plan_allocation ? '<p class="fs-body-base c-subdued">'.concat(o.selling_plan_allocation.selling_plan.name, '</p>') : '';

                      const { properties } = t;
                      let itemProperties = '';
                      if (properties) {
                        itemProperties += `<div class="cart__item-properties fs-body-base">`;
                        for (const prop in properties) {
                          if (prop.charAt(0) === '_') continue;
                          itemProperties += `<span>${prop}: ${
                            properties[prop].includes('/uploads/') ? `<a href="${properties[prop]}" class="underline">download image</a>` : properties[prop]
                          }</span><br/>`;
                        }
                        itemProperties += `</div>`;
                      }
                      console.log('item quantity = ', o.quantity);
                      return '\n    <div class="quick-cart__item ff-body fs-body-base" data-id="'
                        .concat(o.variant_id, '" data-quantity="')
                        .concat(o.quantity, '">\n      <div class="quick-cart__item-left">\n        <a href="')
                        .concat(o.url, '">\n          <div class="quick-cart__image">')
                        .concat(c, '</div>\n        </a>\n      </div>\n      <div class="quick-cart__item-middle">\n        <h4 class="fs-body-bold"><a href="')
                        .concat(o.url, '">')
                        .concat(o.product_title, "</a></h4>\n        <div class='' data-item-key='" + o.key + "'>\n          ")
                        .concat(ye(o.original_price > o.final_price, '<s class="qty">'.concat(jt(o.original_price), '</s>')), '\n          ')
                        .concat(jt(o.final_price), '\n          ')
                        .concat(ye(o.quantity > 1, '<span class="c-subdued">x '.concat(o.quantity, '</span>')), '\n        </div>\n        ')
                        .concat(Ut(o.unit_price, o.unit_price_measurement), '\n        ')
                        .concat(
                          ((e = o),
                          (n = e.options_with_values),
                          (r = e.variant_title),
                          ye(
                            n.length > 0 && r,
                            n.reduce(function (t, e) {
                              var n = e.name,
                                r = e.value;
                              return t + '<div>'.concat(n, ': ').concat(r, '</div>');
                            }, '')
                          )),
                          '\n        '
                        )
                        .concat(itemProperties)
                        .concat(
                          (function (t) {
                            var e = t.map(function (t) {
                              var e = t.amount,
                                n = t.discount_application.title;
                              return '<li>'.concat(n, ' (-').concat(jt(e), ')</li>');
                            });
                            return ye(Boolean(t.length), '<ul class="quick-cart__item-discounts fs-body-small fs-body-base-ns c-subdued">'.concat(e, '</ul>'));
                          })(i),
                          '\n        '
                        )
                        .concat(
                          u,
                          '\n      </div>\n      <div class="quick-cart__control">\n        <div class="quick-cart__control-top">\n          <button class="quick-cart__button quick-cart__button-increase" data-increase="'
                        )
                        .concat(o.variant_id, '" aria-label="')
                        .concat(me.quickCart.addProductQuantity, '">\n            ')
                        .concat(pe, '\n          </button>\n          <button class="quick-cart__button quick-cart__button-decrease" data-decrease="')
                        .concat(o.variant_id, '" aria-label="')
                        .concat(me.quickCart.removeProductQuantity, '">\n            ')
                        .concat(ge, '\n          </button>\n          <button class="quick-cart__button quick-cart__button-remove" data-remove="')
                        .concat(o.variant_id, '" aria-label="')
                        .concat(me.quickCart.removeProduct, '">\n            ')
                        .concat(ve, '\n          </button>\n        </div>\n      </div>\n    </div>\n  ');
                    })(e)
                  );
                }, '')
              )),
                (c.innerHTML = (function (t) {
                  return ye(
                    Boolean(t.length),
                    '\n      <ul>\n        '.concat(
                      t.map(function (t) {
                        var e = t.title,
                          n = t.total_allocated_amount;
                        return '<div>'.concat(e, ' (-').concat(jt(n), ')</div>');
                      }),
                      '\n      </ul>\n    '
                    )
                  );
                })(n)),
                b(s, 'visible', t.sorted.length),
                b(o, 'visible', !t.sorted.length),
                b(c, 'visible', n.length),
                (u.innerHTML = jt(t.total_price)),
                t.sorted.length &&
                  (function (t) {
                    var e = t.items.reduce(function (e, n, r) {
                      var i = n.variant_id,
                        o = n.quantity;
                      return (
                        e +
                        ''
                          .concat(i, ':')
                          .concat(o)
                          .concat(r === t.items.length - 1 ? '' : ',')
                      );
                    }, '');
                    a.href = ''.concat(window.theme.routes.cart.base, '/').concat(e);
                  })(t);
            }
            return (
              ot('cart:open', function (t, e) {
                return e.flash, p();
              }),
              {
                open: p,
                close: v,
                destroy: function () {
                  h.forEach(function (t) {
                    return t();
                  });
                },
              }
            );
          })(d('[data-quick-cart]', this.container)),
          l = (function (t) {
            if (t) {
              var e = f('[data-parent]', t);
              if (e) {
                var n = new T.a(document.body);
                n.on('click', '*', function (t) {
                  return (function (t) {
                    t.target.closest('[data-submenu-parent]') || a();
                  })(t);
                });
                var r = [
                  g(e, 'click', function (t) {
                    t.preventDefault(), o(t.currentTarget.parentNode);
                  }),
                  g(t, 'keydown', function (t) {
                    27 === t.keyCode && a();
                  }),
                  g(f('.header__links-list > li > a', t), 'focus', function (t) {
                    i() && a();
                  }),
                  g(f('[data-link]', t), 'focus', function (t) {
                    if ((t.preventDefault(), i())) {
                      var e = t.currentTarget;
                      e.hasAttribute('data-parent') && o(e.parentNode),
                        f('[data-link]', e.parentNode.parentNode).forEach(function (t) {
                          return b(f('[data-submenu]', t.parentNode), 'active', t === e);
                        });
                    }
                  }),
                  g(f('[data-link]', t), 'focusout', function (t) {
                    i() && t.relatedTarget && !t.relatedTarget.hasAttribute('data-link') && a();
                  }),
                  g(t, 'scroll', function () {
                    document.documentElement.style.setProperty('--navigation-menu-offet', ''.concat(t.scrollLeft, 'px'));
                  }),
                ];
                return {
                  destroy: function () {
                    n.off(),
                      r.forEach(function (t) {
                        return t();
                      });
                  },
                };
              }
            }
            function i() {
              return w(document.body, 'user-is-tabbing');
            }
            function o(t) {
              var e = d('[data-submenu]', t),
                n = d('[data-link]', t);
              if (w(e, 'active')) {
                if (w(t.parentNode, 'header__links-list')) return void a();
                n.setAttribute('aria-expanded', !1), e.setAttribute('aria-hidden', !0), y(e, 'active');
              } else '1' === t.parentNode.dataset.depth ? a(t.parentNode) : a(), n.setAttribute('aria-expanded', !0), e.setAttribute('aria-hidden', !1), m(e, 'active');
            }
            function a() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t,
                n = f('[data-submenu]', e),
                r = f('[data-parent]', e);
              y(n, 'active'),
                n.forEach(function (t) {
                  return t.setAttribute('aria-hidden', !0);
                }),
                r.forEach(function (t) {
                  return t.setAttribute('aria-expanded', !1);
                });
            }
          })(d('[data-navigation]', this.container));
        (this.listeners = [
          ot('cart:updated', function (t) {
            var e = t.cart;
            y(n, 'visible'),
              setTimeout(function () {
                return m(n, 'visible');
              }, 500),
              (r.innerHTML = e.item_count);
          }),
          g(i, 'click', ae(s.open)),
          g(o, 'click', ae(c.open)),
          g(e, 'click', ae(u.open)),
        ]),
          (this.components = [s, c, u]),
          l && this.components.push(l),
          (this.io = new IntersectionObserver(function (e) {
            var n = ie()(e, 1)[0].isIntersecting;
            b(t.container, 'is-sticky', !n);
          })),
          this.io.observe(a),
          (this.ro = new oe.a(function (t) {
            var e,
              n = ie()(t, 1)[0].target;
            w(n, 'is-sticky') || ((e = n.offsetHeight), document.documentElement.style.setProperty('--height-header', e + 'px'));
          })),
          this.ro.observe(this.container);
      },
      onUnload: function () {
        this.listeners.forEach(function (t) {
          return t();
        }),
          this.components.forEach(function (t) {
            return t.destroy();
          }),
          this.io.disconnect(),
          this.ro.disconnect();
      },
    });
    var Qe = 'disclosure-list--visible';
    function Xe(t, e) {
      return t
        .map(function (t) {
          return t.contains(e);
        })
        .filter(Boolean);
    }
    Bt('footer', {
      crossBorder: {},
      onLoad: function () {
        var t = this,
          e = f('[data-header]', this.container);
        this.headerClick = g(e, 'click', function (t) {
          var e = t.currentTarget,
            n = e.nextElementSibling;
          b(e, 'open', !mt(n)), vt(n), mt(n) ? gt(n) : pt(n);
        });
        var n = f('[data-disclosure]', this.container);
        n &&
          n.forEach(function (e) {
            var n = e.dataset.disclosure;
            t.crossBorder[n] = (function (t) {
              var e = t.closest('.selectors-form'),
                n = d('[data-disclosure-list]', t),
                r = d('[data-disclosure-toggle]', t),
                i = d('[data-disclosure-input]', t),
                o = f('[data-disclosure-option]', t),
                a = [
                  g(r, 'click', function (t) {
                    var e = !0 === t.currentTarget.getAttribute('aria-expanded');
                    t.currentTarget.setAttribute('aria-expanded', !e), n.classList.toggle(Qe);
                  }),
                  g(o, 'click', function (t) {
                    t.preventDefault();
                    var n = t.currentTarget.dataset.value;
                    (i.value = n), e.submit();
                  }),
                  g(document, 'click', function (e) {
                    var r = Xe([t], e.target).length > 0;
                    n.classList.contains(Qe) && !r && s();
                  }),
                  g(r, 'focusout', function (e) {
                    0 === Xe([t], e.relatedTarget).length && s();
                  }),
                  g(n, 'focusout', function (e) {
                    var r = Xe([t], e.relatedTarget).length > 0;
                    n.classList.contains(Qe) && !r && s();
                  }),
                  g(t, 'keyup', function (t) {
                    27 === t.which && (s(), r.focus());
                  }),
                ];
              function s() {
                r.setAttribute('aria-expanded', !1), n.classList.remove(Qe);
              }
              return {
                unload: function () {
                  a.forEach(function (t) {
                    return t();
                  });
                },
              };
            })(e);
          });
      },
      onUnload: function () {
        var t = this;
        this.headerClick(),
          Object.keys(this.crossBorder).forEach(function (e) {
            return t.crossBorder[e].unload();
          });
      },
    });
    var Ze = function () {
      return xt('exit_intent');
    };
    Bt('popup', {
      onLoad: function () {
        var t = this,
          e = d('[data-close]', this.container),
          n = d('[data-overlay]', this.container);
        (this.closeClick = g([e, n], 'click', function (e) {
          e.preventDefault(), t.close();
        })),
          (this.bodyLeave = function () {});
        var r = this.container.dataset.timeout;
        !Ze() && k()()
          ? setTimeout(function () {
              return t.open();
            }, parseInt(r))
          : Ze() ||
            (this.bodyLeave = g(document.body, 'mouseout', function (e) {
              e.relatedTarget || e.toElement || (t.open(), t.bodyLeave());
            }));
      },
      open: function () {
        m(this.container, 'visible');
      },
      close: function () {
        St('exit_intent', !0), y(this.container, 'visible');
      },
      onSelect: function () {
        this.open();
      },
      onDeselect: function () {
        this.close();
      },
      onUnload: function () {
        this.closeClick(), this.bodyLeave();
      },
    });
    var Ke = n(4),
      tn = n.n(Ke);
    function en(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e &&
          (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function nn(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2
          ? en(Object(n), !0).forEach(function (e) {
              He()(t, e, n[e]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
          : en(Object(n)).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
            });
      }
      return t;
    }
    var rn = { adaptiveHeight: !1, draggable: !1, fade: !0, pageDots: !1, prevNextButtons: !1, wrapAround: !0, pauseAutoPlayOnHover: !window.Shopify.designMode };
    Bt('announcement-bar', {
      timer: null,
      listeners: [],
      onLoad: function () {
        var t = this,
          e = parseInt(this.container.dataset.timing),
          n = f('[data-announcement]', this.container);
        document.documentElement.style.setProperty('--announcement-height', this.container.offsetHeight + 'px'),
          n.length > 1
            ? ((this.slideshow = new tn.a(
                this.container,
                nn(
                  nn({}, rn),
                  {},
                  {
                    autoPlay: e,
                    on: {
                      change: function (t) {
                        n.forEach(function (e, n) {
                          return b(e, 'is-active', t === n);
                        });
                      },
                    },
                  }
                )
              )),
              this.slideshow.on('pointerUp', function () {
                return t.handleRestart();
              }),
              this.listeners.push(
                g(this.container, 'touchend', function () {
                  return t.handleRestart();
                })
              ))
            : m(n[0], 'is-active', 'is-selected');
      },
      handleRestart: function () {
        var t = this;
        clearTimeout(this.timer),
          (this.timer = setTimeout(function () {
            return t.slideshow.playPlayer();
          }, 3500));
      },
      onBlockSelect: function (t) {
        var e = t.target;
        this.slideshow && this.slideshow.pausePlayer(), this.slideshow && this.slideshow.select(e.dataset.index);
      },
      onBlockDeselect: function () {
        this.slideshow && this.slideshow.unpausePlayer();
      },
      onUnload: function () {
        this.slideshow && this.slideshow.destroy(),
          this.listeners.forEach(function (t) {
            return t();
          });
      },
    });
    var on = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = d('[data-slider]', t),
          r = d('[data-prev]', t),
          i = d('[data-next]', t),
          o = {
            adaptiveHeight: !window.matchMedia('(min-width: 45em)').matches,
            cellAlign: 'left',
            cellSelector: '[data-slide]',
            pageDots: !1,
            prevNextButtons: !1,
            contain: !0,
            imagesLoaded: !0,
            pauseAutoPlayOnHover: !window.Shopify.designMode,
            on: {
              ready: function () {
                s();
              },
            },
          },
          a = Object.assign({}, o, e);
        a.wrapAround || (r.disabled = !0);
        var s = function () {
            var e = d('.image__img, .placeholder-image', t).clientHeight / 2 - i.clientHeight / 2;
            (i.style.top = ''.concat(e, 'px')), (r.style.top = ''.concat(e, 'px')), y(i, 'hidden'), y(r, 'hidden');
          },
          c = new tn.a(n, a);
        a.wrapAround ||
          c.on('scroll', function (t) {
            var e = 100 * t;
            (r.disabled = e < 1), (i.disabled = e > 99);
          }),
          c.on('dragStart', function () {
            return c.slider.childNodes.forEach(function (t) {
              return f('a[href]', t).forEach(function (t) {
                return m(t, 'no-transition');
              });
            });
          }),
          c.on('dragEnd', function () {
            return setTimeout(function () {
              c.slider.childNodes.forEach(function (t) {
                return f('a[href]', t).forEach(function (t) {
                  return y(t, 'no-transition');
                });
              });
            }, 100);
          });
        var u = g(r, 'click', function () {
            return c.previous();
          }),
          l = g(i, 'click', function () {
            return c.next();
          });
        return {
          destroy: function () {
            (c.slides || {}).length > 1 && (u(), l()), c.destroy();
          },
          select: function (t) {
            return c.select(t);
          },
        };
      },
      an = function (t) {
        var e = 'true' === t.dataset.carouselWraps,
          n = on(t, { wrapAround: e });
        return {
          unload: function () {
            n.destroy();
          },
        };
      },
      sn = function (t) {
        var e = on(t, { wrapAround: !1, adaptiveHeight: !1 });
        return (
          window.matchMedia('(min-width: 45em)').matches || e.select(1),
          {
            unload: function () {
              e && e.destroy();
            },
          }
        );
      },
      cn = function (t) {
        var e = f('.faq__accordion-label', t),
          n = g(e, 'click', function (t) {
            t.preventDefault();
            var e = t.currentTarget,
              n = e.parentNode,
              o = e.nextElementSibling;
            mt(o) ? i(t.currentTarget, n, o) : r(t.currentTarget, n, o);
          }),
          r = function (t, e, n) {
            vt(n), pt(n), e.setAttribute('data-open', !0), t.setAttribute('aria-expanded', !0), n.setAttribute('aria-hidden', !1);
          },
          i = function (t, e, n) {
            vt(n), gt(n), e.setAttribute('data-open', !1), t.setAttribute('aria-expanded', !1), n.setAttribute('aria-hidden', !0);
          };
        return {
          open: r,
          closeAll: function () {
            e.forEach(function (t) {
              var e = t.parentNode,
                n = t.nextElementSibling;
              i(t, e, n);
            });
          },
          unload: function () {
            n();
          },
        };
      },
      un = function (t, e) {
        var n = f('.navigation-dot', t),
          r = [];
        n.forEach(function (t) {
          r.push(
            g(t, 'click', function (t) {
              return i(t);
            })
          );
        });
        var i = function (t) {
          if ((t.preventDefault(), !t.target.classList.contains('is-selected'))) {
            var n = t.target.dataset.slideIndex;
            e.select(n), e.pausePlayer();
          }
        };
        return {
          update: function (t) {
            n.forEach(function (t) {
              return y(t, 'is-selected');
            }),
              m(n[t], 'is-selected');
          },
          unload: function () {
            r.forEach(function (t) {
              return t();
            });
          },
        };
      },
      ln = function (t) {
        var e = d('[data-slider]', t),
          n = f('[data-slide]', t),
          r = [],
          i = new tn.a(e, {
            prevNextButtons: !1,
            adaptiveHeight: !1,
            wrapAround: !0,
            pageDots: !1,
            cellAlign: 'center',
            draggable: !1,
            pauseAutoPlayOnHover: !1,
            autoPlay: parseInt(e.dataset.timer),
          }),
          o = null;
        return (
          setTimeout(function () {
            i.resize();
          }, 250),
          n.length > 1 &&
            ((o = un(t, i)),
            i.on('select', function () {
              o.update(i.selectedIndex);
            })),
          {
            select: function (t) {
              i.select(t);
            },
            pause: function () {
              i.pausePlayer();
            },
            unpause: function () {
              i.unpausePlayer();
            },
            unload: function () {
              r.forEach(function (t) {
                return t();
              }),
                i.destroy(),
                o && o.unload();
            },
          }
        );
      },
      dn = {
        update: null,
        begin: null,
        loopBegin: null,
        changeBegin: null,
        change: null,
        changeComplete: null,
        loopComplete: null,
        complete: null,
        loop: 1,
        direction: 'normal',
        autoplay: !0,
        timelineOffset: 0,
      },
      fn = { duration: 1e3, delay: 0, endDelay: 0, easing: 'easeOutElastic(1, .5)', round: 0 },
      hn = [
        'translateX',
        'translateY',
        'translateZ',
        'rotate',
        'rotateX',
        'rotateY',
        'rotateZ',
        'scale',
        'scaleX',
        'scaleY',
        'scaleZ',
        'skew',
        'skewX',
        'skewY',
        'perspective',
        'matrix',
        'matrix3d',
      ],
      pn = { CSS: {}, springs: {} };
    function gn(t, e, n) {
      return Math.min(Math.max(t, e), n);
    }
    function vn(t, e) {
      return t.indexOf(e) > -1;
    }
    function mn(t, e) {
      return t.apply(null, e);
    }
    var yn = {
      arr: function (t) {
        return Array.isArray(t);
      },
      obj: function (t) {
        return vn(Object.prototype.toString.call(t), 'Object');
      },
      pth: function (t) {
        return yn.obj(t) && t.hasOwnProperty('totalLength');
      },
      svg: function (t) {
        return t instanceof SVGElement;
      },
      inp: function (t) {
        return t instanceof HTMLInputElement;
      },
      dom: function (t) {
        return t.nodeType || yn.svg(t);
      },
      str: function (t) {
        return 'string' == typeof t;
      },
      fnc: function (t) {
        return 'function' == typeof t;
      },
      und: function (t) {
        return void 0 === t;
      },
      nil: function (t) {
        return yn.und(t) || null === t;
      },
      hex: function (t) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t);
      },
      rgb: function (t) {
        return /^rgb/.test(t);
      },
      hsl: function (t) {
        return /^hsl/.test(t);
      },
      col: function (t) {
        return yn.hex(t) || yn.rgb(t) || yn.hsl(t);
      },
      key: function (t) {
        return !dn.hasOwnProperty(t) && !fn.hasOwnProperty(t) && 'targets' !== t && 'keyframes' !== t;
      },
    };
    function bn(t) {
      var e = /\(([^)]+)\)/.exec(t);
      return e
        ? e[1].split(',').map(function (t) {
            return parseFloat(t);
          })
        : [];
    }
    function wn(t, e) {
      var n = bn(t),
        r = gn(yn.und(n[0]) ? 1 : n[0], 0.1, 100),
        i = gn(yn.und(n[1]) ? 100 : n[1], 0.1, 100),
        o = gn(yn.und(n[2]) ? 10 : n[2], 0.1, 100),
        a = gn(yn.und(n[3]) ? 0 : n[3], 0.1, 100),
        s = Math.sqrt(i / r),
        c = o / (2 * Math.sqrt(i * r)),
        u = c < 1 ? s * Math.sqrt(1 - c * c) : 0,
        l = c < 1 ? (c * s - a) / u : -a + s;
      function d(t) {
        var n = e ? (e * t) / 1e3 : t;
        return (n = c < 1 ? Math.exp(-n * c * s) * (1 * Math.cos(u * n) + l * Math.sin(u * n)) : (1 + l * n) * Math.exp(-n * s)), 0 === t || 1 === t ? t : 1 - n;
      }
      return e
        ? d
        : function () {
            var e = pn.springs[t];
            if (e) return e;
            for (var n = 0, r = 0; ; )
              if (1 === d((n += 1 / 6))) {
                if (++r >= 16) break;
              } else r = 0;
            var i = n * (1 / 6) * 1e3;
            return (pn.springs[t] = i), i;
          };
    }
    function _n(t) {
      return (
        void 0 === t && (t = 10),
        function (e) {
          return Math.ceil(gn(e, 1e-6, 1) * t) * (1 / t);
        }
      );
    }
    var En,
      kn,
      An = (function () {
        function t(t, e) {
          return 1 - 3 * e + 3 * t;
        }
        function e(t, e) {
          return 3 * e - 6 * t;
        }
        function n(t) {
          return 3 * t;
        }
        function r(r, i, o) {
          return ((t(i, o) * r + e(i, o)) * r + n(i)) * r;
        }
        function i(r, i, o) {
          return 3 * t(i, o) * r * r + 2 * e(i, o) * r + n(i);
        }
        return function (t, e, n, o) {
          if (0 <= t && t <= 1 && 0 <= n && n <= 1) {
            var a = new Float32Array(11);
            if (t !== e || n !== o) for (var s = 0; s < 11; ++s) a[s] = r(0.1 * s, t, n);
            return function (i) {
              return (t === e && n === o) || 0 === i || 1 === i ? i : r(c(i), e, o);
            };
          }
          function c(e) {
            for (var o = 0, s = 1; 10 !== s && a[s] <= e; ++s) o += 0.1;
            var c = o + ((e - a[--s]) / (a[s + 1] - a[s])) * 0.1,
              u = i(c, t, n);
            return u >= 0.001
              ? (function (t, e, n, o) {
                  for (var a = 0; a < 4; ++a) {
                    var s = i(e, n, o);
                    if (0 === s) return e;
                    e -= (r(e, n, o) - t) / s;
                  }
                  return e;
                })(e, c, t, n)
              : 0 === u
              ? c
              : (function (t, e, n, i, o) {
                  var a,
                    s,
                    c = 0;
                  do {
                    (a = r((s = e + (n - e) / 2), i, o) - t) > 0 ? (n = s) : (e = s);
                  } while (Math.abs(a) > 1e-7 && ++c < 10);
                  return s;
                })(e, o, o + 0.1, t, n);
          }
        };
      })(),
      Tn =
        ((En = {
          linear: function () {
            return function (t) {
              return t;
            };
          },
        }),
        (kn = {
          Sine: function () {
            return function (t) {
              return 1 - Math.cos((t * Math.PI) / 2);
            };
          },
          Circ: function () {
            return function (t) {
              return 1 - Math.sqrt(1 - t * t);
            };
          },
          Back: function () {
            return function (t) {
              return t * t * (3 * t - 2);
            };
          },
          Bounce: function () {
            return function (t) {
              for (var e, n = 4; t < ((e = Math.pow(2, --n)) - 1) / 11; );
              return 1 / Math.pow(4, 3 - n) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2);
            };
          },
          Elastic: function (t, e) {
            void 0 === t && (t = 1), void 0 === e && (e = 0.5);
            var n = gn(t, 1, 10),
              r = gn(e, 0.1, 2);
            return function (t) {
              return 0 === t || 1 === t ? t : -n * Math.pow(2, 10 * (t - 1)) * Math.sin(((t - 1 - (r / (2 * Math.PI)) * Math.asin(1 / n)) * (2 * Math.PI)) / r);
            };
          },
        }),
        ['Quad', 'Cubic', 'Quart', 'Quint', 'Expo'].forEach(function (t, e) {
          kn[t] = function () {
            return function (t) {
              return Math.pow(t, e + 2);
            };
          };
        }),
        Object.keys(kn).forEach(function (t) {
          var e = kn[t];
          (En['easeIn' + t] = e),
            (En['easeOut' + t] = function (t, n) {
              return function (r) {
                return 1 - e(t, n)(1 - r);
              };
            }),
            (En['easeInOut' + t] = function (t, n) {
              return function (r) {
                return r < 0.5 ? e(t, n)(2 * r) / 2 : 1 - e(t, n)(-2 * r + 2) / 2;
              };
            }),
            (En['easeOutIn' + t] = function (t, n) {
              return function (r) {
                return r < 0.5 ? (1 - e(t, n)(1 - 2 * r)) / 2 : (e(t, n)(2 * r - 1) + 1) / 2;
              };
            });
        }),
        En);
    function xn(t, e) {
      if (yn.fnc(t)) return t;
      var n = t.split('(')[0],
        r = Tn[n],
        i = bn(t);
      switch (n) {
        case 'spring':
          return wn(t, e);
        case 'cubicBezier':
          return mn(An, i);
        case 'steps':
          return mn(_n, i);
        default:
          return mn(r, i);
      }
    }
    function Sn(t) {
      try {
        return document.querySelectorAll(t);
      } catch (t) {
        return;
      }
    }
    function Cn(t, e) {
      for (var n = t.length, r = arguments.length >= 2 ? arguments[1] : void 0, i = [], o = 0; o < n; o++)
        if (o in t) {
          var a = t[o];
          e.call(r, a, o, t) && i.push(a);
        }
      return i;
    }
    function On(t) {
      return t.reduce(function (t, e) {
        return t.concat(yn.arr(e) ? On(e) : e);
      }, []);
    }
    function Ln(t) {
      return yn.arr(t) ? t : (yn.str(t) && (t = Sn(t) || t), t instanceof NodeList || t instanceof HTMLCollection ? [].slice.call(t) : [t]);
    }
    function qn(t, e) {
      return t.some(function (t) {
        return t === e;
      });
    }
    function Dn(t) {
      var e = {};
      for (var n in t) e[n] = t[n];
      return e;
    }
    function Pn(t, e) {
      var n = Dn(t);
      for (var r in t) n[r] = e.hasOwnProperty(r) ? e[r] : t[r];
      return n;
    }
    function In(t, e) {
      var n = Dn(t);
      for (var r in e) n[r] = yn.und(t[r]) ? e[r] : t[r];
      return n;
    }
    function Mn(t) {
      var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t);
      if (e) return e[1];
    }
    function Nn(t, e) {
      return yn.fnc(t) ? t(e.target, e.id, e.total) : t;
    }
    function jn(t, e) {
      return t.getAttribute(e);
    }
    function Rn(t, e, n) {
      if (qn([n, 'deg', 'rad', 'turn'], Mn(e))) return e;
      var r = pn.CSS[e + n];
      if (!yn.und(r)) return r;
      var i = document.createElement(t.tagName),
        o = t.parentNode && t.parentNode !== document ? t.parentNode : document.body;
      o.appendChild(i), (i.style.position = 'absolute'), (i.style.width = 100 + n);
      var a = 100 / i.offsetWidth;
      o.removeChild(i);
      var s = a * parseFloat(e);
      return (pn.CSS[e + n] = s), s;
    }
    function Bn(t, e, n) {
      if (e in t.style) {
        var r = e.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
          i = t.style[e] || getComputedStyle(t).getPropertyValue(r) || '0';
        return n ? Rn(t, i, n) : i;
      }
    }
    function zn(t, e) {
      return yn.dom(t) && !yn.inp(t) && (!yn.nil(jn(t, e)) || (yn.svg(t) && t[e]))
        ? 'attribute'
        : yn.dom(t) && qn(hn, e)
        ? 'transform'
        : yn.dom(t) && 'transform' !== e && Bn(t, e)
        ? 'css'
        : null != t[e]
        ? 'object'
        : void 0;
    }
    function Hn(t) {
      if (yn.dom(t)) {
        for (var e, n = t.style.transform || '', r = /(\w+)\(([^)]*)\)/g, i = new Map(); (e = r.exec(n)); ) i.set(e[1], e[2]);
        return i;
      }
    }
    function Fn(t, e, n, r) {
      switch (zn(t, e)) {
        case 'transform':
          return (function (t, e, n, r) {
            var i = vn(e, 'scale')
                ? 1
                : 0 +
                  (function (t) {
                    return vn(t, 'translate') || 'perspective' === t ? 'px' : vn(t, 'rotate') || vn(t, 'skew') ? 'deg' : void 0;
                  })(e),
              o = Hn(t).get(e) || i;
            return n && (n.transforms.list.set(e, o), (n.transforms.last = e)), r ? Rn(t, o, r) : o;
          })(t, e, r, n);
        case 'css':
          return Bn(t, e, n);
        case 'attribute':
          return jn(t, e);
        default:
          return t[e] || 0;
      }
    }
    function Vn(t, e) {
      var n = /^(\*=|\+=|-=)/.exec(t);
      if (!n) return t;
      var r = Mn(t) || 0,
        i = parseFloat(e),
        o = parseFloat(t.replace(n[0], ''));
      switch (n[0][0]) {
        case '+':
          return i + o + r;
        case '-':
          return i - o + r;
        case '*':
          return i * o + r;
      }
    }
    function Un(t, e) {
      if (yn.col(t))
        return (function (t) {
          return yn.rgb(t)
            ? (n = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec((e = t)))
              ? 'rgba(' + n[1] + ',1)'
              : e
            : yn.hex(t)
            ? (function (t) {
                var e = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, n, r) {
                    return e + e + n + n + r + r;
                  }),
                  n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
                return 'rgba(' + parseInt(n[1], 16) + ',' + parseInt(n[2], 16) + ',' + parseInt(n[3], 16) + ',1)';
              })(t)
            : yn.hsl(t)
            ? (function (t) {
                var e,
                  n,
                  r,
                  i = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t),
                  o = parseInt(i[1], 10) / 360,
                  a = parseInt(i[2], 10) / 100,
                  s = parseInt(i[3], 10) / 100,
                  c = i[4] || 1;
                function u(t, e, n) {
                  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < 0.5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
                }
                if (0 == a) e = n = r = s;
                else {
                  var l = s < 0.5 ? s * (1 + a) : s + a - s * a,
                    d = 2 * s - l;
                  (e = u(d, l, o + 1 / 3)), (n = u(d, l, o)), (r = u(d, l, o - 1 / 3));
                }
                return 'rgba(' + 255 * e + ',' + 255 * n + ',' + 255 * r + ',' + c + ')';
              })(t)
            : void 0;
          var e, n;
        })(t);
      if (/\s/g.test(t)) return t;
      var n = Mn(t),
        r = n ? t.substr(0, t.length - n.length) : t;
      return e ? r + e : r;
    }
    function Wn(t, e) {
      return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
    }
    function Gn(t) {
      for (var e, n = t.points, r = 0, i = 0; i < n.numberOfItems; i++) {
        var o = n.getItem(i);
        i > 0 && (r += Wn(e, o)), (e = o);
      }
      return r;
    }
    function $n(t) {
      if (t.getTotalLength) return t.getTotalLength();
      switch (t.tagName.toLowerCase()) {
        case 'circle':
          return (function (t) {
            return 2 * Math.PI * jn(t, 'r');
          })(t);
        case 'rect':
          return (function (t) {
            return 2 * jn(t, 'width') + 2 * jn(t, 'height');
          })(t);
        case 'line':
          return (function (t) {
            return Wn({ x: jn(t, 'x1'), y: jn(t, 'y1') }, { x: jn(t, 'x2'), y: jn(t, 'y2') });
          })(t);
        case 'polyline':
          return Gn(t);
        case 'polygon':
          return (function (t) {
            var e = t.points;
            return Gn(t) + Wn(e.getItem(e.numberOfItems - 1), e.getItem(0));
          })(t);
      }
    }
    function Jn(t, e) {
      var n = e || {},
        r =
          n.el ||
          (function (t) {
            for (var e = t.parentNode; yn.svg(e) && yn.svg(e.parentNode); ) e = e.parentNode;
            return e;
          })(t),
        i = r.getBoundingClientRect(),
        o = jn(r, 'viewBox'),
        a = i.width,
        s = i.height,
        c = n.viewBox || (o ? o.split(' ') : [0, 0, a, s]);
      return { el: r, viewBox: c, x: c[0] / 1, y: c[1] / 1, w: a, h: s, vW: c[2], vH: c[3] };
    }
    function Yn(t, e, n) {
      function r(n) {
        void 0 === n && (n = 0);
        var r = e + n >= 1 ? e + n : 0;
        return t.el.getPointAtLength(r);
      }
      var i = Jn(t.el, t.svg),
        o = r(),
        a = r(-1),
        s = r(1),
        c = n ? 1 : i.w / i.vW,
        u = n ? 1 : i.h / i.vH;
      switch (t.property) {
        case 'x':
          return (o.x - i.x) * c;
        case 'y':
          return (o.y - i.y) * u;
        case 'angle':
          return (180 * Math.atan2(s.y - a.y, s.x - a.x)) / Math.PI;
      }
    }
    function Qn(t, e) {
      var n = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
        r = Un(yn.pth(t) ? t.totalLength : t, e) + '';
      return { original: r, numbers: r.match(n) ? r.match(n).map(Number) : [0], strings: yn.str(t) || e ? r.split(n) : [] };
    }
    function Xn(t) {
      return Cn(t ? On(yn.arr(t) ? t.map(Ln) : Ln(t)) : [], function (t, e, n) {
        return n.indexOf(t) === e;
      });
    }
    function Zn(t) {
      var e = Xn(t);
      return e.map(function (t, n) {
        return { target: t, id: n, total: e.length, transforms: { list: Hn(t) } };
      });
    }
    function Kn(t, e) {
      var n = Dn(e);
      if ((/^spring/.test(n.easing) && (n.duration = wn(n.easing)), yn.arr(t))) {
        var r = t.length;
        2 !== r || yn.obj(t[0]) ? yn.fnc(e.duration) || (n.duration = e.duration / r) : (t = { value: t });
      }
      var i = yn.arr(t) ? t : [t];
      return i
        .map(function (t, n) {
          var r = yn.obj(t) && !yn.pth(t) ? t : { value: t };
          return yn.und(r.delay) && (r.delay = n ? 0 : e.delay), yn.und(r.endDelay) && (r.endDelay = n === i.length - 1 ? e.endDelay : 0), r;
        })
        .map(function (t) {
          return In(t, n);
        });
    }
    var tr = {
      css: function (t, e, n) {
        return (t.style[e] = n);
      },
      attribute: function (t, e, n) {
        return t.setAttribute(e, n);
      },
      object: function (t, e, n) {
        return (t[e] = n);
      },
      transform: function (t, e, n, r, i) {
        if ((r.list.set(e, n), e === r.last || i)) {
          var o = '';
          r.list.forEach(function (t, e) {
            o += e + '(' + t + ') ';
          }),
            (t.style.transform = o);
        }
      },
    };
    function er(t, e) {
      Zn(t).forEach(function (t) {
        for (var n in e) {
          var r = Nn(e[n], t),
            i = t.target,
            o = Mn(r),
            a = Fn(i, n, o, t),
            s = Vn(Un(r, o || Mn(a)), a),
            c = zn(i, n);
          tr[c](i, n, s, t.transforms, !0);
        }
      });
    }
    function nr(t, e) {
      return Cn(
        On(
          t.map(function (t) {
            return e.map(function (e) {
              return (function (t, e) {
                var n = zn(t.target, e.name);
                if (n) {
                  var r = (function (t, e) {
                      var n;
                      return t.tweens.map(function (r) {
                        var i = (function (t, e) {
                            var n = {};
                            for (var r in t) {
                              var i = Nn(t[r], e);
                              yn.arr(i) &&
                                1 ===
                                  (i = i.map(function (t) {
                                    return Nn(t, e);
                                  })).length &&
                                (i = i[0]),
                                (n[r] = i);
                            }
                            return (n.duration = parseFloat(n.duration)), (n.delay = parseFloat(n.delay)), n;
                          })(r, e),
                          o = i.value,
                          a = yn.arr(o) ? o[1] : o,
                          s = Mn(a),
                          c = Fn(e.target, t.name, s, e),
                          u = n ? n.to.original : c,
                          l = yn.arr(o) ? o[0] : u,
                          d = Mn(l) || Mn(c),
                          f = s || d;
                        return (
                          yn.und(a) && (a = u),
                          (i.from = Qn(l, f)),
                          (i.to = Qn(Vn(a, l), f)),
                          (i.start = n ? n.end : 0),
                          (i.end = i.start + i.delay + i.duration + i.endDelay),
                          (i.easing = xn(i.easing, i.duration)),
                          (i.isPath = yn.pth(o)),
                          (i.isPathTargetInsideSVG = i.isPath && yn.svg(e.target)),
                          (i.isColor = yn.col(i.from.original)),
                          i.isColor && (i.round = 1),
                          (n = i),
                          i
                        );
                      });
                    })(e, t),
                    i = r[r.length - 1];
                  return { type: n, property: e.name, animatable: t, tweens: r, duration: i.end, delay: r[0].delay, endDelay: i.endDelay };
                }
              })(t, e);
            });
          })
        ),
        function (t) {
          return !yn.und(t);
        }
      );
    }
    function rr(t, e) {
      var n = t.length,
        r = function (t) {
          return t.timelineOffset ? t.timelineOffset : 0;
        },
        i = {};
      return (
        (i.duration = n
          ? Math.max.apply(
              Math,
              t.map(function (t) {
                return r(t) + t.duration;
              })
            )
          : e.duration),
        (i.delay = n
          ? Math.min.apply(
              Math,
              t.map(function (t) {
                return r(t) + t.delay;
              })
            )
          : e.delay),
        (i.endDelay = n
          ? i.duration -
            Math.max.apply(
              Math,
              t.map(function (t) {
                return r(t) + t.duration - t.endDelay;
              })
            )
          : e.endDelay),
        i
      );
    }
    var ir = 0,
      or = [],
      ar = (function () {
        var t;
        function e(n) {
          for (var r = or.length, i = 0; i < r; ) {
            var o = or[i];
            o.paused ? (or.splice(i, 1), r--) : (o.tick(n), i++);
          }
          t = i > 0 ? requestAnimationFrame(e) : void 0;
        }
        return (
          'undefined' != typeof document &&
            document.addEventListener('visibilitychange', function () {
              cr.suspendWhenDocumentHidden &&
                (sr()
                  ? (t = cancelAnimationFrame(t))
                  : (or.forEach(function (t) {
                      return t._onDocumentVisibility();
                    }),
                    ar()));
            }),
          function () {
            t || (sr() && cr.suspendWhenDocumentHidden) || !(or.length > 0) || (t = requestAnimationFrame(e));
          }
        );
      })();
    function sr() {
      return !!document && document.hidden;
    }
    function cr(t) {
      void 0 === t && (t = {});
      var e,
        n = 0,
        r = 0,
        i = 0,
        o = 0,
        a = null;
      function s(t) {
        var e =
          window.Promise &&
          new Promise(function (t) {
            return (a = t);
          });
        return (t.finished = e), e;
      }
      var c = (function (t) {
        var e = Pn(dn, t),
          n = Pn(fn, t),
          r = (function (t, e) {
            var n = [],
              r = e.keyframes;
            for (var i in (r &&
              (e = In(
                (function (t) {
                  for (
                    var e = Cn(
                        On(
                          t.map(function (t) {
                            return Object.keys(t);
                          })
                        ),
                        function (t) {
                          return yn.key(t);
                        }
                      ).reduce(function (t, e) {
                        return t.indexOf(e) < 0 && t.push(e), t;
                      }, []),
                      n = {},
                      r = function (r) {
                        var i = e[r];
                        n[i] = t.map(function (t) {
                          var e = {};
                          for (var n in t) yn.key(n) ? n == i && (e.value = t[n]) : (e[n] = t[n]);
                          return e;
                        });
                      },
                      i = 0;
                    i < e.length;
                    i++
                  )
                    r(i);
                  return n;
                })(r),
                e
              )),
            e))
              yn.key(i) && n.push({ name: i, tweens: Kn(e[i], t) });
            return n;
          })(n, t),
          i = Zn(t.targets),
          o = nr(i, r),
          a = rr(o, n),
          s = ir;
        return ir++, In(e, { id: s, children: [], animatables: i, animations: o, duration: a.duration, delay: a.delay, endDelay: a.endDelay });
      })(t);
      function u() {
        var t = c.direction;
        'alternate' !== t && (c.direction = 'normal' !== t ? 'normal' : 'reverse'),
          (c.reversed = !c.reversed),
          e.forEach(function (t) {
            return (t.reversed = c.reversed);
          });
      }
      function l(t) {
        return c.reversed ? c.duration - t : t;
      }
      function d() {
        (n = 0), (r = l(c.currentTime) * (1 / cr.speed));
      }
      function f(t, e) {
        e && e.seek(t - e.timelineOffset);
      }
      function h(t) {
        for (var e = 0, n = c.animations, r = n.length; e < r; ) {
          var i = n[e],
            o = i.animatable,
            a = i.tweens,
            s = a.length - 1,
            u = a[s];
          s &&
            (u =
              Cn(a, function (e) {
                return t < e.end;
              })[0] || u);
          for (
            var l = gn(t - u.start - u.delay, 0, u.duration) / u.duration,
              d = isNaN(l) ? 1 : u.easing(l),
              f = u.to.strings,
              h = u.round,
              p = [],
              g = u.to.numbers.length,
              v = void 0,
              m = 0;
            m < g;
            m++
          ) {
            var y = void 0,
              b = u.to.numbers[m],
              w = u.from.numbers[m] || 0;
            (y = u.isPath ? Yn(u.value, d * b, u.isPathTargetInsideSVG) : w + d * (b - w)), h && ((u.isColor && m > 2) || (y = Math.round(y * h) / h)), p.push(y);
          }
          var _ = f.length;
          if (_) {
            v = f[0];
            for (var E = 0; E < _; E++) {
              f[E];
              var k = f[E + 1],
                A = p[E];
              isNaN(A) || (v += k ? A + k : A + ' ');
            }
          } else v = p[0];
          tr[i.type](o.target, i.property, v, o.transforms), (i.currentValue = v), e++;
        }
      }
      function p(t) {
        c[t] && !c.passThrough && c[t](c);
      }
      function g(t) {
        var d = c.duration,
          g = c.delay,
          v = d - c.endDelay,
          m = l(t);
        (c.progress = gn((m / d) * 100, 0, 100)),
          (c.reversePlayback = m < c.currentTime),
          e &&
            (function (t) {
              if (c.reversePlayback) for (var n = o; n--; ) f(t, e[n]);
              else for (var r = 0; r < o; r++) f(t, e[r]);
            })(m),
          !c.began && c.currentTime > 0 && ((c.began = !0), p('begin')),
          !c.loopBegan && c.currentTime > 0 && ((c.loopBegan = !0), p('loopBegin')),
          m <= g && 0 !== c.currentTime && h(0),
          ((m >= v && c.currentTime !== d) || !d) && h(d),
          m > g && m < v
            ? (c.changeBegan || ((c.changeBegan = !0), (c.changeCompleted = !1), p('changeBegin')), p('change'), h(m))
            : c.changeBegan && ((c.changeCompleted = !0), (c.changeBegan = !1), p('changeComplete')),
          (c.currentTime = gn(m, 0, d)),
          c.began && p('update'),
          t >= d &&
            ((r = 0),
            c.remaining && !0 !== c.remaining && c.remaining--,
            c.remaining
              ? ((n = i), p('loopComplete'), (c.loopBegan = !1), 'alternate' === c.direction && u())
              : ((c.paused = !0), c.completed || ((c.completed = !0), p('loopComplete'), p('complete'), !c.passThrough && 'Promise' in window && (a(), s(c)))));
      }
      return (
        s(c),
        (c.reset = function () {
          var t = c.direction;
          (c.passThrough = !1),
            (c.currentTime = 0),
            (c.progress = 0),
            (c.paused = !0),
            (c.began = !1),
            (c.loopBegan = !1),
            (c.changeBegan = !1),
            (c.completed = !1),
            (c.changeCompleted = !1),
            (c.reversePlayback = !1),
            (c.reversed = 'reverse' === t),
            (c.remaining = c.loop),
            (e = c.children);
          for (var n = (o = e.length); n--; ) c.children[n].reset();
          ((c.reversed && !0 !== c.loop) || ('alternate' === t && 1 === c.loop)) && c.remaining++, h(c.reversed ? c.duration : 0);
        }),
        (c._onDocumentVisibility = d),
        (c.set = function (t, e) {
          return er(t, e), c;
        }),
        (c.tick = function (t) {
          (i = t), n || (n = i), g((i + (r - n)) * cr.speed);
        }),
        (c.seek = function (t) {
          g(l(t));
        }),
        (c.pause = function () {
          (c.paused = !0), d();
        }),
        (c.play = function () {
          c.paused && (c.completed && c.reset(), (c.paused = !1), or.push(c), d(), ar());
        }),
        (c.reverse = function () {
          u(), (c.completed = !c.reversed), d();
        }),
        (c.restart = function () {
          c.reset(), c.play();
        }),
        (c.remove = function (t) {
          lr(Xn(t), c);
        }),
        c.reset(),
        c.autoplay && c.play(),
        c
      );
    }
    function ur(t, e) {
      for (var n = e.length; n--; ) qn(t, e[n].animatable.target) && e.splice(n, 1);
    }
    function lr(t, e) {
      var n = e.animations,
        r = e.children;
      ur(t, n);
      for (var i = r.length; i--; ) {
        var o = r[i],
          a = o.animations;
        ur(t, a), a.length || o.children.length || r.splice(i, 1);
      }
      n.length || r.length || e.pause();
    }
    (cr.version = '3.2.1'),
      (cr.speed = 1),
      (cr.suspendWhenDocumentHidden = !0),
      (cr.running = or),
      (cr.remove = function (t) {
        for (var e = Xn(t), n = or.length; n--; ) lr(e, or[n]);
      }),
      (cr.get = Fn),
      (cr.set = er),
      (cr.convertPx = Rn),
      (cr.path = function (t, e) {
        var n = yn.str(t) ? Sn(t)[0] : t,
          r = e || 100;
        return function (t) {
          return { property: t, el: n, svg: Jn(n), totalLength: $n(n) * (r / 100) };
        };
      }),
      (cr.setDashoffset = function (t) {
        var e = $n(t);
        return t.setAttribute('stroke-dasharray', e), e;
      }),
      (cr.stagger = function (t, e) {
        void 0 === e && (e = {});
        var n = e.direction || 'normal',
          r = e.easing ? xn(e.easing) : null,
          i = e.grid,
          o = e.axis,
          a = e.from || 0,
          s = 'first' === a,
          c = 'center' === a,
          u = 'last' === a,
          l = yn.arr(t),
          d = l ? parseFloat(t[0]) : parseFloat(t),
          f = l ? parseFloat(t[1]) : 0,
          h = Mn(l ? t[1] : t) || 0,
          p = e.start || 0 + (l ? d : 0),
          g = [],
          v = 0;
        return function (t, e, m) {
          if ((s && (a = 0), c && (a = (m - 1) / 2), u && (a = m - 1), !g.length)) {
            for (var y = 0; y < m; y++) {
              if (i) {
                var b = c ? (i[0] - 1) / 2 : a % i[0],
                  w = c ? (i[1] - 1) / 2 : Math.floor(a / i[0]),
                  _ = b - (y % i[0]),
                  E = w - Math.floor(y / i[0]),
                  k = Math.sqrt(_ * _ + E * E);
                'x' === o && (k = -_), 'y' === o && (k = -E), g.push(k);
              } else g.push(Math.abs(a - y));
              v = Math.max.apply(Math, g);
            }
            r &&
              (g = g.map(function (t) {
                return r(t / v) * v;
              })),
              'reverse' === n &&
                (g = g.map(function (t) {
                  return o ? (t < 0 ? -1 * t : -t) : Math.abs(v - t);
                }));
          }
          return p + (l ? (f - d) / v : d) * (Math.round(100 * g[e]) / 100) + h;
        };
      }),
      (cr.timeline = function (t) {
        void 0 === t && (t = {});
        var e = cr(t);
        return (
          (e.duration = 0),
          (e.add = function (n, r) {
            var i = or.indexOf(e),
              o = e.children;
            function a(t) {
              t.passThrough = !0;
            }
            i > -1 && or.splice(i, 1);
            for (var s = 0; s < o.length; s++) a(o[s]);
            var c = In(n, Pn(fn, t));
            c.targets = c.targets || t.targets;
            var u = e.duration;
            (c.autoplay = !1), (c.direction = e.direction), (c.timelineOffset = yn.und(r) ? u : Vn(r, u)), a(e), e.seek(c.timelineOffset);
            var l = cr(c);
            a(l), o.push(l);
            var d = rr(o, t);
            return (e.delay = d.delay), (e.endDelay = d.endDelay), (e.duration = d.duration), e.seek(0), e.reset(), e.autoplay && e.play(), e;
          }),
          e
        );
      }),
      (cr.easing = xn),
      (cr.penner = Tn),
      (cr.random = function (t, e) {
        return Math.floor(Math.random() * (e - t + 1)) + t;
      });
    var dr = cr,
      fr = function (t) {
        var e = [],
          n = d('[data-slider]', t),
          r = f('.slideshow__cell', t),
          i = n.dataset.autoplay,
          o = null,
          a = null;
        y(n, 'is-hidden'), n.offsetHeight;
        var s = function (t) {
            dr({
              targets: f('.animate', t),
              easing: 'easeOutQuart',
              translateY: [
                { value: 40, duration: 0 },
                { value: 0, duration: 500 },
              ],
              opacity: [
                { value: 0, duration: 0 },
                { value: 1, duration: 500 },
              ],
              delay: dr.stagger(150, { start: 800 }),
            });
          },
          c = new IntersectionObserver(function (t) {
            ie()(t, 1)[0].intersectionRatio && (s(r[0]), l(), c.disconnect());
          });
        function u() {
          o && o.pausePlayer();
        }
        function l() {
          o && o.unpausePlayer();
        }
        return (
          r.length > 1
            ? ((o = new tn.a(n, {
                adaptiveHeight: !0,
                autoPlay: Number(i),
                draggable: !0,
                prevNextButtons: !1,
                wrapAround: !0,
                pageDots: !1,
                dragThreshold: 10,
                pauseAutoPlayOnHover: !window.Shopify.designMode,
                on: {
                  ready: function () {
                    c.observe(t);
                  },
                },
              })),
              u(),
              (a = un(t, o)),
              o.on('change', function (t) {
                var e = o.cells[t].element;
                s(e), a && a.update(t);
              }),
              r.forEach(function (t) {
                t.querySelector('.slideshow__video') && e.push(Xt(t));
              }))
            : r.length && (m(r[0], 'is-selected'), s(r[0])),
          {
            select: function (t) {
              o && o.select(t);
            },
            pause: u,
            unpause: l,
            unload: function () {
              o && o.destroy(),
                e.forEach(function (t) {
                  return t();
                }),
                a && a.unload();
            },
          }
        );
      },
      hr = function (t) {
        var e = 'true' === t.dataset.carouselWraps,
          n = on(t, { wrapAround: e, adaptiveHeight: !1 });
        return {
          select: function (t) {
            n.select(t);
          },
          unload: function () {
            n.destroy();
          },
        };
      },
      pr = n(20),
      gr = n.n(pr),
      vr = n(21),
      mr = 'visible',
      yr = function (t) {
        var e = [],
          n = d('.video__inner', t).dataset,
          r = n.videoId,
          i = n.videoType;
        if (r && i) {
          var o = d('[data-video-player]', t),
            a = d('[data-play-button]', t),
            s = d('[data-overlay]', t),
            c = d('.video__image', t),
            u = (function (t, e) {
              void 0 === e && (e = {});
              var n,
                r = e.id,
                i = e.playerEl,
                o = e.type;
              if (r && o) {
                var a = ut(),
                  s = a.on,
                  c = a.emit;
                return (
                  'youtube' === o
                    ? ((n = gr()(i)).loadVideoById({ videoId: r, suggestedQuality: 'large' }),
                      n.stopVideo(),
                      n.on('stateChange', function (t) {
                        1 === t.data ? c('play') : 2 === t.data && c('pause');
                      }),
                      n.on('ready', function () {
                        c('ready'), u();
                      }))
                    : 'vimeo' === o &&
                      ((n = new vr.a(i, { id: r })).on('play', function () {
                        return c('play');
                      }),
                      n.on('pause', function () {
                        return c('pause');
                      }),
                      n.ready().then(function () {
                        c('ready'), u();
                      })),
                  {
                    destroy: function () {},
                    on: s,
                    pause: function () {
                      'youtube' === o ? n.pauseVideo() : 'vimeo' === o && n.pause();
                    },
                    play: function () {
                      'youtube' === o ? n.playVideo() : 'vimeo' === o && n.play();
                    },
                  }
                );
              }
              function u() {
                var e = d('iframe', t),
                  n = (e.height / e.width) * 100,
                  r = e.parentNode;
                (e.height = '100%'),
                  (e.width = '100%'),
                  'youtube' === o ? (r.style.paddingTop = n + '%') : 'vimeo' === o && (r.parentNode.style.paddingTop = n + '%'),
                  c('resized');
              }
            })(t, { id: r, type: i, playerEl: o });
          return (
            u.on('play', function () {
              var e = d('iframe', t);
              (e.taxindex = 0), e.focus(), y(s, mr), c && y(c, mr);
            }),
            e.push(
              g(a, 'click', function () {
                u.play();
              })
            ),
            {
              unload: function () {
                e.forEach(function (t) {
                  return t();
                });
              },
            }
          );
        }
      },
      br = function (t) {
        var e = f('.video-hero__video', t),
          n = null;
        e.length &&
          ((n = Xt(t)),
          (function (t) {
            if (t.length)
              var e = [
                g(window, 'click', function () {
                  return n();
                }),
                g(window, 'touchstart', function () {
                  return n();
                }),
              ];
            function n() {
              t.forEach(function (t) {
                t.playing || t.play();
              }),
                e.forEach(function (t) {
                  return t();
                });
            }
          })(e));
        var r = new IntersectionObserver(function (e) {
          ie()(e, 1)[0].intersectionRatio &&
            (dr({
              targets: f('.animate', t),
              easing: 'easeOutQuart',
              translateY: [
                { value: 40, duration: 0 },
                { value: 0, duration: 500 },
              ],
              opacity: [
                { value: 0, duration: 0 },
                { value: 1, duration: 500 },
              ],
              delay: dr.stagger(150, { start: 800 }),
            }),
            r.disconnect());
        });
        return (
          r.observe(t),
          {
            unload: function () {
              n && n();
            },
          }
        );
      },
      wr = {
        'featured-collection': function (t) {
          return an(t);
        },
        'featured-collection-row': function (t) {
          return sn(t);
        },
        faq: function (t) {
          return cn(t);
        },
        quote: function (t) {
          return ln(t);
        },
        slideshow: function (t) {
          return fr(t);
        },
        'social-proof': function (t) {
          return hr(t);
        },
        video: function (t) {
          return yr(t);
        },
        'video-hero': function (t) {
          return br(t);
        },
      };
    Bt('product-section', {
      onLoad: function () {
        this.sections = f('[data-section-block-type]', this.container);
      },
      _reloadSections: function () {
        this.sections.forEach(function (t) {
          var e = t.dataset.sectionBlockType;
          wr[e] && wr[e](t);
        });
      },
      onSelect: function () {
        this._reloadSections();
      },
      onBlockSelect: function (t) {
        var e = t.target;
        if (ct().SelectedCollectionSection !== e.firstChild.className) {
          var n = d('.shopify-section header__outer-wrapper', document).offsetHeight,
            r = e.getBoundingClientRect().top + window.pageYOffset + n;
          window.scrollTo({ top: r, behavior: 'smooth' }), st({ SelectedCollectionSection: e.firstChild.className });
        }
        this._reloadSections();
      },
      onUnload: function () {},
    });
    var _r = {
      'featured-collection': function (t) {
        return an(t);
      },
      'featured-collection-row': function (t) {
        return sn(t);
      },
      faq: function (t) {
        return cn(t);
      },
      quote: function (t) {
        return ln(t);
      },
      slideshow: function (t) {
        return fr(t);
      },
      'social-proof': function (t) {
        return hr(t);
      },
      video: function (t) {
        return yr(t);
      },
      'video-hero': function (t) {
        return br(t);
      },
    };
    function Er(t, e) {
      if ((Ar(t), 'number' != typeof e)) throw new TypeError(e + ' is not a Number.');
      return (
        t.variants.filter(function (t) {
          return t.id === e;
        })[0] || null
      );
    }
    function kr(t, e) {
      Ar(t);
      var n = (function (t, e) {
        Ar(t),
          (function (t) {
            if (!Array.isArray(t)) throw new TypeError(t + ' is not an array.');
            if (0 === t.length) return [];
            if (!t[0].hasOwnProperty('name')) throw new Error(t[0] + 'does not contain name key.');
            if ('string' != typeof t[0].name) throw new TypeError('Invalid value type passed for name of option ' + t[0].name + '. Value should be string.');
          })(e);
        var n = [];
        return (
          e.forEach(function (e) {
            for (var r = 0; r < t.options.length; r++)
              if (t.options[r].name.toLowerCase() === e.name.toLowerCase()) {
                n[r] = e.value;
                break;
              }
          }),
          n
        );
      })(t, e);
      return (function (t, e) {
        return (
          Ar(t),
          (function (t) {
            if (Array.isArray(t) && 'object' == typeof t[0]) throw new Error(t + 'is not a valid array of options.');
          })(e),
          t.variants.filter(function (t) {
            return e.every(function (e, n) {
              return t.options[n] === e;
            });
          })[0] || null
        );
      })(t, n);
    }
    function Ar(t) {
      if ('object' != typeof t) throw new TypeError(t + ' is not an object.');
      if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + ' is empty.');
    }
    Bt('collection-section', {
      onLoad: function () {
        this.sections = f('[data-section-block-type]', this.container);
      },
      _reloadSections: function () {
        this.sections.forEach(function (t) {
          var e = t.dataset.sectionBlockType;
          _r[e] && _r[e](t);
        });
      },
      onSelect: function () {
        this._reloadSections();
      },
      onBlockSelect: function (t) {
        var e = t.target;
        if (ct().SelectedProductSection !== e.firstChild.className) {
          var n = d('.shopify-section header__outer-wrapper', document).offsetHeight,
            r = e.getBoundingClientRect().top + window.pageYOffset + n;
          window.scrollTo({ top: r, behavior: 'smooth' }), st({ SelectedProductSection: e.firstChild.className });
        }
        this._reloadSections();
      },
      onUnload: function () {},
    }),
      Bt('featured-collection', {
        onLoad: function () {
          this.featuredCollection = an(this.container);
        },
        onUnload: function () {
          this.featuredCollection.unload();
        },
      }),
      Bt('featured-collection-row', {
        onLoad: function () {
          this.featuredCollectionRow = sn(this.container);
        },
        onUnload: function () {
          this.featuredCollectionRow.unload();
        },
      });
    var Tr = '[data-close]',
      xr = '[data-slider]',
      Sr = '[data-slide]',
      Cr = function (t) {
        return "[data-id='".concat(t, "']");
      },
      Or = '[data-nav-item]',
      Lr = '.lightbox__images-wrapper',
      qr = '[data-prev]',
      Dr = '[data-next]',
      Pr = 'visible',
      Ir = 'active',
      Mr = 'zoom';
    function Nr(t) {
      var e = V(t),
        n = f(Or, t),
        r = d(Lr, t),
        i = f(Sr, t),
        o = d(qr, t),
        a = d(Dr, t),
        s = d(xr, t),
        c = new tn.a(s, { adaptiveHeight: !0, draggable: k()({ tablet: !0, featureDetect: !0 }), prevNextButtons: !1, wrapAround: !1, pageDots: !1 });
      i.length > 1
        ? (c.on('scroll', function (t) {
            l();
            var e = 100 * t;
            (o.disabled = e < 1), (a.disabled = e > 99);
          }),
          c.on('select', function () {
            n.forEach(function (t) {
              return y(t, Ir);
            }),
              m(n[c.selectedIndex], Ir),
              n[c.selectedIndex].scrollIntoView({ behavior: 'smooth', inline: 'nearest' });
          }))
        : (m(o, 'hidden'), m(a, 'hidden'), (o.disabled = !0), (a.disabled = !0));
      var u = [
        g(d(Tr, t), 'click', function (t) {
          t.preventDefault(), h();
        }),
        g(t, 'keydown', function (t) {
          27 === t.keyCode && h();
        }),
        g(n, 'click', function (t) {
          t.preventDefault();
          var e = t.currentTarget.dataset.index;
          c.select(e);
        }),
        g(i, 'click', function (t) {
          t.preventDefault(),
            (function (t) {
              var e = t.currentTarget,
                n = e.classList.contains(Mr);
              if ((b(e, Mr, !n), n)) l(e);
              else {
                var i = t.clientX,
                  o = t.clientY + r.scrollTop - s.offsetTop,
                  a = -1 * (i - e.clientWidth / 2),
                  c = -1 * (o - e.clientHeight / 2);
                e.style.transform = 'translate3d('.concat(a, 'px, ').concat(c, 'px, 0) scale(2)');
              }
            })(t);
        }),
        g(o, 'click', function () {
          return c.previous();
        }),
        g(a, 'click', function () {
          return c.next();
        }),
      ];
      function l(t) {
        if (t) return y(t, Mr), void (t.style.transform = 'translate3d(0px, 0px, 0) scale(1)');
        i.forEach(function (t) {
          y(t, Mr), (t.style.transform = 'translate3d(0px, 0px, 0) scale(1)');
        });
      }
      function h() {
        l(),
          y(t, Pr),
          setTimeout(function () {
            y(t, Ir), et(t), e.deactivate();
          }, 300);
      }
      return {
        destroy: function () {
          u.forEach(function (t) {
            return t();
          }),
            c.destroy();
        },
        open: function (n) {
          m(t, Ir),
            setTimeout(function () {
              m(t, Pr),
                tt(t, {
                  allowTouchMove: function (t) {
                    for (; t && t !== document.body; ) {
                      if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                      t = t.parentNode;
                    }
                  },
                  reserveScrollBarGap: !0,
                }),
                e.activate();
              var r = d(Cr(n), t).dataset.slideIndex;
              c.select(r, !1, !0);
            }, 50);
        },
      };
    }
    function jr(t) {
      var e = window,
        n = e.Shopify,
        r = e.YT,
        i = f('[data-interactive]', t);
      if (i.length) {
        var o = ['video', 'model', 'external_video'],
          a = null,
          s = !1,
          c = {};
        return (
          s && i.forEach(u),
          window.Shopify.loadFeatures(
            [
              { name: 'model-viewer-ui', version: '1.0' },
              { name: 'shopify-xr', version: '1.0' },
              { name: 'video-ui', version: '1.0' },
            ],
            function () {
              (s = !0),
                'YT' in window && Boolean(r.loaded)
                  ? i.forEach(u)
                  : (window.onYouTubeIframeAPIReady = function () {
                      i.forEach(u);
                    });
            }
          ),
          { pauseActiveMedia: l }
        );
      }
      function u(t) {
        var e = t.dataset,
          i = e.mediaId,
          s = e.mediaType;
        if (s && o.includes(s) && !Object.keys(c).includes(i)) {
          var u = { id: i, type: s, container: t, media: t.children[0] };
          switch (u.type) {
            case 'video':
              u.player = new n.Plyr(u.media, { loop: { active: 'true' == t.dataset.loop } });
              break;
            case 'external_video':
              u.player = new r.Player(u.media);
              break;
            case 'model':
              (u.viewer = new n.ModelViewerUI(d('model-viewer', t))),
                g(d('.model-poster', t), 'click', function (t) {
                  t.preventDefault(),
                    (function (t) {
                      l(t),
                        t.viewer.play(),
                        m(t.container, 'model-active'),
                        (a = t),
                        setTimeout(function () {
                          d('model-viewer', t.container).focus();
                        }, 300);
                    })(u);
                });
          }
          (c[i] = u),
            u.player &&
              ('video' === u.type
                ? u.player.on('playing', function () {
                    l(u), (a = u);
                  })
                : 'external_video' === u.type &&
                  u.player.addEventListener('onStateChange', function (t) {
                    1 === t.data && (l(u), (a = u));
                  }));
        }
      }
      function l(t) {
        if (a && t != a)
          return a.player
            ? ('video' === a.type ? a.player.pause() : 'external_video' === a.type && a.player.pauseVideo(), void (a = null))
            : void (a.viewer && (y(a.container, 'model-active'), a.viewer.pause(), (a = null)));
      }
    }
    var Rr = n(22),
      Br = n.n(Rr),
      zr = '[name="id"]',
      Hr = '[name^="options"]',
      Fr = '[name="quantity"]',
      Vr = '[name^="properties"]';
    function Ur(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        r = (function (t) {
          if ('object' !== Br()(t)) throw new TypeError(t + ' is not an object.');
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
            );
          return t;
        })(e),
        i = [],
        o = function () {
          return (
            (t = function (t) {
              return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
            }),
            l.reduce(function (e, n) {
              return (n.checked || ('radio' !== n.type && 'checkbox' !== n.type)) && e.push(t({ name: n.name, value: n.value })), e;
            }, [])
          );
          var t;
        },
        a = function () {
          return kr(r, o());
        },
        s = function () {
          return {
            options: o(),
            variant: a(),
            properties:
              ((t = (function (t, e) {
                return t.reduce(function (t, n) {
                  return (n.checked || ('radio' !== n.type && 'checkbox' !== n.type)) && (t[e(n.name)] = n.value), t;
                }, {});
              })(f, function (t) {
                return /(?:^(properties\[))(.*?)(?:\])/.exec(t)[2];
              })),
              0 === Object.entries(t).length ? null : t),
            quantity: d[0] ? Number.parseInt(d[0].value, 10) : 1,
          };
          var t;
        },
        c = function (e) {
          var n = t.querySelector(zr);
          n || (((n = document.createElement('input')).type = 'hidden'), (n.name = 'id'), t.appendChild(n)), (n.value = e.toString());
        },
        u = function (e, n) {
          return At()(t.querySelectorAll(e)).map(function (t) {
            return (
              i.push(
                g(
                  t,
                  'change',
                  (function (t) {
                    if (void 0 !== t)
                      return function (e) {
                        (e.dataset = s()), t(e);
                      };
                  })(n)
                )
              ),
              t
            );
          });
        };
      i.push(
        g(t, 'submit', function (t) {
          (t.dataset = s()), c(t.dataset.variant.id), n.onFormSubmit && n.onFormSubmit(t);
        })
      );
      var l = u(Hr, n.onOptionChange),
        d = u(Fr, n.onQuantityChange),
        f = u(Vr, n.onPropertyChange);
      return {
        getVariant: a,
        destroy: function () {
          i.forEach(function (t) {
            return t();
          });
        },
      };
    }
    var Wr = function (t) {
        var e = d('.product-form__quantity', t),
          n = d('[data-quantity-input]', e),
          r = d('[data-add-quantity]', e),
          i = d('[data-subtract-quantity]', e),
          o = [
            g(r, 'click', function () {
              var t = parseInt(n.value) + 1;
              (n.value = t), n.dispatchEvent(new Event('change'));
            }),
            g(i, 'click', function () {
              var t = parseInt(n.value);
              if (1 !== t) {
                var e = t - 1;
                (n.value = e), n.dispatchEvent(new Event('change'));
              }
            }),
          ];
        return {
          unload: function () {
            o.forEach(function (t) {
              return t();
            });
          },
        };
      },
      Gr = function (t) {
        var e = new T.a(t);
        return (
          e.on('click', '[data-variant-popup-trigger]', function (e) {
            e.preventDefault();
            var n = e.target.dataset.modalContentId,
              r = d('#'.concat(n), t);
            at('modal:open', null, { modalContent: r });
          }),
          {
            unload: function () {
              e.destroy();
            },
          }
        );
      },
      $r = window.theme.strings.products,
      Jr = function (t, e) {
        var n = f('[data-price]', t),
          r = f('[data-compare-price]', t),
          i = $r.product.unavailable;
        if (!e)
          return (
            n.forEach(function (t) {
              return (t.innerHTML = i);
            }),
            void r.forEach(function (t) {
              return (t.innerHTML = '');
            })
          );
        n.forEach(function (t) {
          return (t.innerHTML = jt(e.price));
        }),
          r.forEach(function (t) {
            return (t.innerHTML = e.compare_at_price > e.price ? jt(e.compare_at_price) : '');
          });
      },
      Yr = window.theme.strings.products,
      Qr = function (t, e) {
        var n = d('[data-product-sku]', t);
        if (n) {
          var r,
            i = Yr.product.sku;
          e && e.sku ? (n.innerText = ((r = e.sku), ''.concat(i, ': ').concat(r))) : (n.innerText = '');
        }
      },
      Xr = function (t, e) {
        var n = d('[data-add-to-cart-text]', t),
          r = t.dataset,
          i = r.langAvailable,
          o = r.langUnavailable,
          a = r.langSoldOut;
        e
          ? e.available
            ? (t.removeAttribute('disabled'), (n.textContent = i))
            : (t.setAttribute('disabled', 'disabled'), (n.textContent = a))
          : (t.setAttribute('disabled', 'disabled'), (n.textContent = o));
      },
      Zr = 'is-hidden',
      Kr = theme.strings.product,
      ti = '.spr-form';
    function ei(t) {
      var e = t.map(ni);
      return {
        groups: e,
        destroy: function () {
          e &&
            e.forEach(function (t) {
              return t();
            });
        },
      };
    }
    function ni(t) {
      var e = d('select', t),
        n = f('[data-button]', t),
        r = g(n, 'click', function (t) {
          t.preventDefault();
          var r = t.currentTarget.dataset.button;
          n.forEach(function (t) {
            return b(t, 'selected', t.dataset.button === r);
          }),
            (d('[value="'.concat(r, '"]'), e).selected = !0),
            e.dispatchEvent(new Event('change'));
        });
      return function () {
        return r();
      };
    }
    var ri = function (t, e, n, r) {
        var i = null,
          o = n,
          a = new T.a(t),
          s = function (e) {
            o = e;
            var n = ''.concat(t.dataset.baseUrl, '/variants/').concat(e.id, '/?section_id=store-availability');
            (t.innerHTML = ''),
              fetch(n)
                .then(function (t) {
                  return t.text();
                })
                .then(function (e) {
                  '' !== e.trim() && ((t.innerHTML = e.trim()), (t.innerHTML = t.firstElementChild.innerHTML), (i = d('[data-store-availability-list-content]', t)));
                });
          };
        return (
          s(n),
          a.on('click', '[data-store-availability-drawer-trigger]', function (t) {
            t.preventDefault(),
              at('availability:showMore', function () {
                return { product: e, variant: o, storeList: i, options: r };
              });
          }),
          {
            unload: function () {
              t.innerHTML = '';
            },
            update: s,
          }
        );
      },
      ii = '[data-add-to-cart]';
    Bt('featured-product', {
      productForm: null,
      events: [],
      onLoad: function () {
        var t = this,
          e = this.container.dataset,
          n = e.placeholder,
          r = e.productHasOnlyDefaultVariant;
        if ('true' !== n) {
          this.formElement = d('[data-product-form]', this.container);
          var i = this.formElement.dataset,
            o = i.productHandle,
            a = i.currentProductId;
          (this.images = f('[data-open]', this.container)), (this.quantityError = d('[data-quantity-error]', this.container));
          var s = d('[data-in-your-space]', this.container);
          s && b(s, 'visible', isMobile()),
            (this.storeAvailabilityContainer = d('[data-store-availability-container]', this.container)),
            (this.availability = null),
            Rt(o)(function (e) {
              var n = Er(e, parseInt(a));
              t.storeAvailabilityContainer && n && (t.availability = ri(t.storeAvailabilityContainer, e, n, { hideVariantTitle: 'true' === r })),
                (t.productForm = Ur(t.formElement, e, {
                  onOptionChange: function (e) {
                    return t.onOptionChange(e);
                  },
                  onFormSubmit: function (e) {
                    return t.onFormSubmit(e);
                  },
                }));
            }),
            (this.lightbox = Nr(d('[data-lightbox]', this.container))),
            (this.media = jr(d('.featured-product__media-container', this.container))),
            (this.optionButtons = ei(f('[data-option-buttons]', this.container))),
            (this.quantityInput = Wr(this.container)),
            (this.variantPopup = Gr(this.container)),
            this._initEvents();
        }
      },
      _initEvents: function () {
        var t = this;
        this.events.push(
          g(this.images, 'click', function (e) {
            e.preventDefault(), t.lightbox.open(e.currentTarget.dataset.open);
          })
        ),
          this.events.push(
            ot('cart:stock-error', function () {
              y(t.quantityError, 'hidden'), y(d(ii, t.container), 'loading');
            })
          );
      },
      onOptionChange: function (t) {
        var e = t.dataset.variant,
          n = d(ii, this.container);
        if ((Jr(this.container, e), Xr(n, e), Vt(this.container, e), Qr(this.container, e), !e))
          return Xr(d('[data-add-to-cart]', this.container), !1), void (this.availability && this.availability.unload());
        (d(
          ''.concat('[data-variant-select]', ' ').concat(
            (function (t) {
              return "[value='".concat(t, "']");
            })(e.id)
          ),
          this.container
        ).selected = !0),
          this.formElement.dispatchEvent(new Event('change')),
          e.featured_media && ue(this.container, e.featured_media.id),
          this.availability && this.availability.update(e);
      },
      onFormSubmit: function (t) {
        if (document.body.dataset.enableCartAjax) {
          t.preventDefault(), m(this.quantityError, 'hidden');
          var e = d(ii, this.container);
          m(e, 'loading'),
            Mt.addItem(this.formElement).then(function (t) {
              var n = t.item;
              y(e, 'loading'), at('cart:open', null, { flash: n.variant_id });
            });
        }
      },
      onUnload: function () {
        this.productForm.destroy(),
          this.lightbox.destroy(),
          this.optionButtons.destroy(),
          this.quantityInput.unload(),
          this.events.forEach(function (t) {
            return t();
          });
      },
    }),
      Bt('newsletter', {
        onLoad: function () {
          Qt(this.container);
        },
        onUnload: function () {},
      });
    var oi = '[data-recommendations]';
    Bt('recommended-products', {
      onLoad: function () {
        var t = this,
          e = this.container.dataset,
          n = e.limit,
          r = e.productId,
          i = d(oi, this.container);
        if (i) {
          var o = ''.concat(window.theme.routes.productRecommendations, '?section_id=recommended-products--static&limit=').concat(n, '&product_id=').concat(r),
            a = new XMLHttpRequest();
          a.open('GET', o, !0),
            (a.onload = function () {
              if (a.status >= 200 && a.status < 300) {
                var e = document.createElement('div');
                if (((e.innerHTML = a.response), !d('.product-item', e))) return void t.container.parentNode.removeChild(t.container);
                i.innerHTML = d(oi, e).innerHTML;
                var n = d('[data-slider]', i),
                  r = 'true' === n.dataset.carouselWraps;
                n && (t.carousel = on(i, { wrapAround: r }));
              } else t.container.parentNode.removeChild(t.container);
            }),
            a.send();
        }
      },
      onUnload: function () {
        this.carousel.destroy();
      },
    }),
      Bt('slideshow', {
        onLoad: function () {
          this.slideshow = fr(this.container);
        },
        onBlockSelect: function (t) {
          var e = t.target;
          this.slideshow.select(e.dataset.index), this.slideshow.pause();
        },
        onBlockDeselect: function () {
          this.slideshow.unpause();
        },
        onUnload: function () {
          this.slideshow.unload();
        },
      }),
      Bt('video', {
        onLoad: function () {
          this.video = yr(this.container);
        },
        onUnload: function () {
          this.video.unload();
        },
      }),
      Bt('video-hero', {
        onLoad: function () {
          this.videoHero = br(this.container);
        },
        onUnload: function () {
          this.videoHero.unload();
        },
      });
    Bt('faq', {
      onLoad: function () {
        this.faq = cn(this.container);
      },
      onBlockSelect: function (t) {
        var e = d('.faq__accordion-label', t.target),
          n = e.parentNode,
          r = e.nextElementSibling;
        this.faq.open(e, n, r);
      },
      onBlockDeselect: function () {
        this.faq.closeAll();
      },
      onUnload: function () {
        this.faq.unload();
      },
    }),
      Bt('social-proof', {
        onLoad: function () {
          this.carousel = hr(this.container);
        },
        onUnload: function () {
          this.carousel.unload();
        },
        onBlockSelect: function (t) {
          var e = t.target;
          this.carousel.select(e.dataset.index);
        },
      }),
      Bt('quote', {
        onLoad: function () {
          this.quote = ln(this.container);
        },
        onBlockSelect: function (t) {
          var e = t.target;
          this.quote.select(e.dataset.index), this.quote.pause();
        },
        onBlockDeselect: function () {
          this.quote.unpause();
        },
        onUnload: function () {
          this.quote.unload();
        },
      });
    class ai {
      constructor({
        apiKey: t,
        channel: e,
        client: n,
        id: r = '__googleMapsScriptId',
        libraries: i = [],
        language: o,
        region: a,
        version: s,
        mapIds: c,
        nonce: u,
        retries: l = 3,
        url: d = 'https://maps.googleapis.com/maps/api/js',
      }) {
        if (
          ((this.CALLBACK = '__googleMapsCallback'),
          (this.callbacks = []),
          (this.done = !1),
          (this.loading = !1),
          (this.errors = []),
          (this.version = s),
          (this.apiKey = t),
          (this.channel = e),
          (this.client = n),
          (this.id = r || '__googleMapsScriptId'),
          (this.libraries = i),
          (this.language = o),
          (this.region = a),
          (this.mapIds = c),
          (this.nonce = u),
          (this.retries = l),
          (this.url = d),
          ai.instance)
        ) {
          if (
            !(function t(e, n) {
              if (e === n) return !0;
              if (e && n && 'object' == typeof e && 'object' == typeof n) {
                if (e.constructor !== n.constructor) return !1;
                var r, i, o;
                if (Array.isArray(e)) {
                  if ((r = e.length) != n.length) return !1;
                  for (i = r; 0 != i--; ) if (!t(e[i], n[i])) return !1;
                  return !0;
                }
                if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
                if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
                if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
                if ((r = (o = Object.keys(e)).length) !== Object.keys(n).length) return !1;
                for (i = r; 0 != i--; ) if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
                for (i = r; 0 != i--; ) {
                  var a = o[i];
                  if (!t(e[a], n[a])) return !1;
                }
                return !0;
              }
              return e != e && n != n;
            })(this.options, ai.instance.options)
          )
            throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(ai.instance.options)}`);
          return ai.instance;
        }
        ai.instance = this;
      }
      get options() {
        return {
          version: this.version,
          apiKey: this.apiKey,
          channel: this.channel,
          client: this.client,
          id: this.id,
          libraries: this.libraries,
          language: this.language,
          region: this.region,
          mapIds: this.mapIds,
          nonce: this.nonce,
          url: this.url,
        };
      }
      get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
      }
      createUrl() {
        let t = this.url;
        return (
          (t += '?callback=' + this.CALLBACK),
          this.apiKey && (t += '&key=' + this.apiKey),
          this.channel && (t += '&channel=' + this.channel),
          this.client && (t += '&client=' + this.client),
          this.libraries.length > 0 && (t += '&libraries=' + this.libraries.join(',')),
          this.language && (t += '&language=' + this.language),
          this.region && (t += '&region=' + this.region),
          this.version && (t += '&v=' + this.version),
          this.mapIds && (t += '&map_ids=' + this.mapIds.join(',')),
          t
        );
      }
      load() {
        return this.loadPromise();
      }
      loadPromise() {
        return new Promise((t, e) => {
          this.loadCallback((n) => {
            n ? e(n) : t();
          });
        });
      }
      loadCallback(t) {
        this.callbacks.push(t), this.execute();
      }
      setScript() {
        if (document.getElementById(this.id)) return void this.callback();
        const t = this.createUrl(),
          e = document.createElement('script');
        (e.id = this.id),
          (e.type = 'text/javascript'),
          (e.src = t),
          (e.onerror = this.loadErrorCallback.bind(this)),
          (e.defer = !0),
          (e.async = !0),
          this.nonce && (e.nonce = this.nonce),
          document.head.appendChild(e);
      }
      deleteScript() {
        const t = document.getElementById(this.id);
        t && t.remove();
      }
      reset() {
        this.deleteScript(), (this.done = !1), (this.loading = !1), (this.errors = []), (this.onerrorEvent = null);
      }
      resetIfRetryingFailed() {
        this.failed && this.reset();
      }
      loadErrorCallback(t) {
        if ((this.errors.push(t), this.errors.length <= this.retries)) {
          const t = this.errors.length * Math.pow(2, this.errors.length);
          console.log(`Failed to load Google Maps script, retrying in ${t} ms.`),
            setTimeout(() => {
              this.deleteScript(), this.setScript();
            }, t);
        } else (this.onerrorEvent = t), this.callback();
      }
      setCallback() {
        window.__googleMapsCallback = this.callback.bind(this);
      }
      callback() {
        (this.done = !0),
          (this.loading = !1),
          this.callbacks.forEach((t) => {
            t(this.onerrorEvent);
          }),
          (this.callbacks = []);
      }
      execute() {
        if ((this.resetIfRetryingFailed(), this.done)) this.callback();
        else {
          if (window.google && window.google.maps && window.google.maps.version)
            return (
              console.warn('Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.'),
              void this.callback()
            );
          this.loading || ((this.loading = !0), this.setCallback(), this.setScript());
        }
      }
    }
    var si = '.map__container',
      ci = '.map__image',
      ui = 'hidden';
    function li() {
      this.entries = [];
    }
    Bt('map', {
      onLoad: function () {
        var t = this,
          e = d(si, this.container);
        if (e) {
          var n,
            r = e.dataset,
            i = r.apiKey,
            o = r.address,
            a = d('#map-styles', this.container).innerHTML;
          if (a)
            try {
              n = JSON.parse(a);
            } catch (t) {
              (n = {}), console.error('Custom map JSON error: '.concat(t));
            }
          if (i && o) {
            var s = function () {
              m(d(ci, t.container), ui),
                new google.maps.Geocoder().geocode({ address: o }, function (e, r) {
                  var i = e[0].geometry.location,
                    o = { lat: i.lat(), lng: i.lng() },
                    a = new google.maps.Map(d('.map__element', t.container), { center: o, zoom: 12, styles: n.styles });
                  new google.maps.Marker({ position: o, map: a });
                });
            };
            (window.gm_authFailure = function () {
              var t = f(si, document),
                e = f(ci, document);
              t.forEach(function (t) {
                m(t, ui);
              }),
                e.forEach(function (t) {
                  y(t, ui);
                });
            }),
              (function (t, e, n) {
                var r = new ai({ apiKey: i, version: 'weekly' });
                window.google
                  ? s()
                  : r.load().then(function () {
                      s();
                    });
              })();
          }
        }
      },
      onUnload: function () {},
    }),
      Bt('cart', {
        onLoad: function () {
          var t = this,
            e = 'true' === this.container.dataset.enableCartAjax;
          this.form = d('[data-form]', this.container);
          var n = f('[data-change]', this.container),
            r = d('[data-quantity-input]', this.container);
          this.timer,
            (this.events = [
              g(n, 'click', function (n) {
                n.preventDefault();
                var r = n.currentTarget.dataset.change,
                  i = d('input', n.currentTarget.parentNode);
                'increment' === r ? i.value >= 0 && i.value++ : 'decrement' === r && i.value > 0 && i.value--, e && t.handleTimeout();
              }),
            ]),
            e && this.events.push(g(r, 'input', this.handleTimeout));
        },
        handleTimeout: function () {
          var t = this;
          clearTimeout(this.timer),
            (this.timer = setTimeout(function () {
              t.form.submit();
            }, 1e3));
        },
        onUnload: function () {
          this.events.forEach(function (t) {
            return t();
          });
        },
      }),
      (li.prototype.add = function (t, e, n) {
        this.entries.push({ element: t, event: e, fn: n }), t.addEventListener(e, n);
      }),
      (li.prototype.removeAll = function () {
        this.entries = this.entries.filter(function (t) {
          return t.element.removeEventListener(t.event, t.fn), !1;
        });
      });
    var di = '[name^="options"]',
      fi = '[name="quantity"]',
      hi = '[name^="properties"]';
    function pi(t, e, n) {
      (this.element = t),
        (this.product = (function (t) {
          if ('object' != typeof t) throw new TypeError(t + ' is not an object.');
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
            );
          return t;
        })(e)),
        (n = n || {}),
        (this._listeners = new li()),
        this._listeners.add(this.element, 'submit', this._onSubmit.bind(this, n)),
        (this.optionInputs = this._initInputs(di, n.onOptionChange)),
        (this.quantityInputs = this._initInputs(fi, n.onQuantityChange)),
        (this.propertyInputs = this._initInputs(hi, n.onPropertyChange));
    }
    (pi.prototype.destroy = function () {
      this._listeners.removeAll();
    }),
      (pi.prototype.options = function () {
        return (
          (t = this.optionInputs),
          (e = function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          }),
          t.reduce(function (t, n) {
            return (n.checked || ('radio' !== n.type && 'checkbox' !== n.type)) && t.push(e({ name: n.name, value: n.value })), t;
          }, [])
        );
        var t, e;
      }),
      (pi.prototype.variant = function () {
        return kr(this.product, this.options());
      }),
      (pi.prototype.properties = function () {
        var t,
          e,
          n =
            ((t = this.propertyInputs),
            (e = function (t) {
              return /(?:^(properties\[))(.*?)(?:\])/.exec(t)[2];
            }),
            t.reduce(function (t, n) {
              return (n.checked || ('radio' !== n.type && 'checkbox' !== n.type)) && (t[e(n.name)] = n.value), t;
            }, {}));
        return 0 === Object.entries(n).length ? null : n;
      }),
      (pi.prototype.quantity = function () {
        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
      }),
      (pi.prototype._setIdInputValue = function (t) {
        var e = this.element.querySelector('[name="id"]');
        e || (((e = document.createElement('input')).type = 'hidden'), (e.name = 'id'), this.element.appendChild(e)), (e.value = t.toString());
      }),
      (pi.prototype._onSubmit = function (t, e) {
        (e.dataset = this._getProductFormEventData()), this._setIdInputValue(e.dataset.variant.id), t.onFormSubmit && t.onFormSubmit(e);
      }),
      (pi.prototype._onFormEvent = function (t) {
        return void 0 === t
          ? Function.prototype
          : function (e) {
              (e.dataset = this._getProductFormEventData()), t(e);
            }.bind(this);
      }),
      (pi.prototype._initInputs = function (t, e) {
        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
          function (t) {
            return this._listeners.add(t, 'change', this._onFormEvent(e)), t;
          }.bind(this)
        );
      }),
      (pi.prototype._getProductFormEventData = function () {
        return { options: this.options(), variant: this.variant(), properties: this.properties(), quantity: this.quantity() };
      });
    var gi = window.theme.routes.cart || {},
      vi = window.theme.strings,
      mi = 'active',
      yi = 'hidden',
      bi = 'is-visible',
      wi = 'is-fixed',
      _i = function () {
        (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function (t) {
          var e = document.createElement('div');
          e.classList.add('rte__iframe'), t.parentNode.insertBefore(e, t), e.appendChild(t), (t.src = t.src);
        });
      },
      Ei = function () {
        (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function (t) {
          var e = document.createElement('div');
          e.classList.add('rte__table-wrapper'), t.parentNode.insertBefore(e, t), e.appendChild(t);
        });
      },
      ki = '[data-add-to-cart]';
    Bt('product', {
      productForm: null,
      events: [],
      reviewsHandler: null,
      onLoad: function () {
        var t = this,
          e = this.container.dataset.productHasOnlyDefaultVariant;
        this.formElement = d('[data-product-form]', this.container);
        var n = this.formElement.dataset,
          r = n.productHandle,
          i = n.currentProductId;
        (this.images = f('[data-open]', this.container)), (this.quantityError = d('[data-quantity-error]', this.container));
        var o = d('[data-in-your-space]', this.container);
        o && b(o, 'visible', k()()),
          (this.productThumbs = f('[data-product-thumbnail]', this.container)),
          (this.storeAvailabilityContainer = d('[data-store-availability-container]', this.container)),
          (this.availability = null),
          (window.SPRCallbacks = {}),
          (window.SPRCallbacks.onReviewsLoad = function () {
            t.reviewsHandler ||
              (t.reviewsHandler = (function () {
                var t = d(ti, document),
                  e = d('.spr-summary-actions-newreview', document),
                  n = d('.modal__content', document),
                  r = d('.spr-summary', document);
                d('.spr-starrating', r) ||
                  r.insertAdjacentHTML(
                    'afterbegin',
                    '\n      <span class="spr-starrating spr-summary-starrating">\n        <i class="spr-icon spr-icon-star-empty"></i>\n        <i class="spr-icon spr-icon-star-empty"></i>\n        <i class="spr-icon spr-icon-star-empty"></i>\n        <i class="spr-icon spr-icon-star-empty"></i>\n        <i class="spr-icon spr-icon-star-empty"></i>\n      </span>\n    '
                  );
                var i,
                  o = ot('spr-form:updated', function () {
                    var t = d(ti, document).cloneNode(!0);
                    (n.innerHTML = ''), n.appendChild(t);
                  });
                return (
                  m((i = document.createElement('button')), 'spr-summary-actions-newreview', 'active'),
                  (i.innerText = Kr.review),
                  e.parentNode.insertBefore(i, e),
                  g(i, 'click', function (e) {
                    e.preventDefault(), at('modal:open', null, { modalContent: t, narrow: !0 });
                  }),
                  {
                    unload: function () {
                      o();
                    },
                  }
                );
              })());
          }),
          (window.SPRCallbacks.onBadgeLoad = function () {
            var e, n, r;
            t.badgeHandler =
              ((e = d('.spr-badge-caption', document)),
              (n = d('.shopify-product-reviews-wrapper', document)),
              (r = document.createElement('button')).classList.add('reviews__anchor-trigger'),
              e.parentNode.insertBefore(r, e),
              r.appendChild(e),
              (r.tabIndex = '0'),
              void g(r, 'click', function (t) {
                t.preventDefault(), n && n.scrollIntoView({ behavior: 'smooth' });
              }));
          }),
          (window.SPRCallbacks.onFormFailure = function () {
            at('spr-form:updated');
          }),
          (window.SPRCallbacks.onFormSuccess = function () {
            at('spr-form:updated');
          }),
          Rt(r)(function (n) {
            var r = Er(n, parseInt(i));
            t.storeAvailabilityContainer && r && (t.availability = ri(t.storeAvailabilityContainer, n, r, { hideVariantTitle: 'true' === e })),
              d('[data-quick-purchase-bar]', t.container) &&
                (t.quickPurchaseBar = (function (t, e) {
                  var n = d('.product-form', t),
                    r = d('[data-quick-purchase-bar]', t),
                    i = d('[data-quick-purchase-button]', t),
                    o = d('[data-mobile-hide]', t),
                    a = d('.quick-purchase-bar__product-image', t),
                    s = d('[data-bar-quantity]', t),
                    c = d('[data-bar-product-title]', t),
                    u = d('input[name="quantity"]', n),
                    l = d('#variant-selector', n);
                  (s.innerHTML = 'x '.concat(parseInt(u.value, 10))), (c.innerHTML = e.name);
                  var f = null;
                  p(), xt('quick_purchase_bar') && m(r, Zr), v(l.value, u.value);
                  var h = [
                    g(i, 'click', function (t) {
                      t.preventDefault();
                    }),
                    g(o, 'click', function (t) {
                      p(),
                        b(r, Zr),
                        (function (t) {
                          St('quick_purchase_bar', t);
                        })(w(r, Zr));
                    }),
                  ];
                  function p() {
                    r.style.setProperty('--quick-purchase-offset', ''.concat(r.clientHeight - 20, 'px'));
                  }
                  function v(t, e) {
                    i.href = ''.concat(window.theme.routes.cart.base, '/').concat(t, ':').concat(e);
                  }
                  return (
                    window.matchMedia('(min-width: 60em)').matches
                      ? (f = new IntersectionObserver(function (t) {
                          var e = ie()(t, 1)[0].isIntersecting;
                          b(r, 'active', !e);
                        })).observe(n)
                      : setTimeout(function () {
                          m(r, 'active');
                        }, 1e3),
                    {
                      update: function (t) {
                        if (
                          t.available &&
                          (v(t.id, u.value),
                          Jr(r, t),
                          (s.innerHTML = ''),
                          (c.innerHTML = ''),
                          (s.innerHTML = 'x '.concat(parseInt(u.value, 10))),
                          (c.innerHTML = t.name),
                          t.featured_media)
                        ) {
                          var e = '<img class="image__img lazyload" data-src="'.concat(fe(t.featured_media.preview_image.src, '120x'), '" />');
                          a.innerHTML = e;
                        }
                      },
                      unload: function () {
                        f && f.disconnect(),
                          h.forEach(function (t) {
                            return t();
                          });
                      },
                    }
                  );
                })(t.container, r)),
              (t.productForm = Ur(t.formElement, n, {
                onOptionChange: function (e) {
                  return t.onOptionChange(e);
                },
                onFormSubmit: function (e) {
                  return t.onFormSubmit(e);
                },
                onQuantityChange: function (e) {
                  return t.onQuantityChange(e);
                },
              }));
          }),
          (this.lightbox = Nr(d('[data-lightbox]', this.container))),
          (this.media = jr(d('.product__media-container', this.container))),
          (this.optionButtons = ei(f('[data-option-buttons]', this.container))),
          (this.quantityInput = Wr(this.container)),
          (this.variantPopup = Gr(this.container)),
          (this.shippingEstimatorButtons = f('[data-estimator-trigger]', this.container)),
          (this.shippingEstimator = this.shippingEstimatorButtons.map(function (t) {
            return (function (t) {
              var e,
                n = d('[data-form]', t),
                r = d('[data-variant-select]', document),
                i = d('[data-address-country]', t),
                o = d('[data-address-province]', t),
                a = d('[data-address-province-wrapper]', t),
                s = d('[data-address-zip]', t),
                c = d('[data-estimator-modal]', t),
                u = d('[data-mobile-wash]', t),
                l = d('[data-estimator-trigger]', t),
                f = d('[data-estimator-button]', t),
                h = d('[data-estimator-success]', t),
                p = d('[data-estimator-error]', t),
                v = null,
                w = d('option', i);
              w.setAttribute('selected', !0), (w.innerText = vi.product.country_placeholder), T();
              var _ = [
                  g(n, 'submit', function (t) {
                    t.preventDefault(), x();
                  }),
                  g(i, 'change', T),
                  g(l, 'click', function (e) {
                    e.preventDefault(),
                      m(c, wi),
                      setTimeout(function () {
                        m(c, bi, mi);
                      }, 50),
                      c.setAttribute('aria-hidden', 'false'),
                      (v = V(c, { allowOutsideClick: !0 })).activate(),
                      tt(t, {
                        allowTouchMove: function (t) {
                          for (; t && t !== document.body; ) {
                            if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                            t = t.parentNode;
                          }
                        },
                        reserveScrollBarGap: !0,
                      });
                  }),
                  g(u, 'click', S),
                  g(d('[data-close-icon]', t), 'click', S),
                  g(f, 'click', x),
                  g(t, 'keydown', function (t) {
                    27 === t.keyCode && S();
                  }),
                ],
                E = function (t) {
                  var e = ('; ' + document.cookie).split('; ' + t + '=');
                  if (2 == e.length) return e.pop().split(';').shift();
                },
                k = function (t) {
                  var e = new Date();
                  e.setTime(e.getTime() + 12096e5);
                  var n = '; expires=' + e.toGMTString();
                  document.cookie = 'cart=' + t + n + '; path=/';
                },
                A = function () {
                  k(e);
                };
              function T() {
                var t = d('[value="'.concat(i.value, '"]'), i),
                  e = JSON.parse(t.dataset.provinces);
                b(a, yi, !e.length),
                  (o.innerHTML = e.reduce(function (t, e) {
                    return t + '<option value="'.concat(e[0], '">').concat(e[0], '</option>');
                  }, ''));
              }
              function x() {
                if (r.value.length) {
                  e = E('cart');
                  var n = n || 'temp-cart-cookie___' + Date.now(),
                    a = a || 'fake-cart-cookie___' + Date.now();
                  e || (k(n), (e = E('cart'))),
                    e.length < 32 ||
                      (k(a),
                      (function (e) {
                        if ((m(f, 'loading'), void 0 !== e)) {
                          var n = d('[data-quantity-input]', t),
                            r = { id: e, quantity: n ? parseInt(n.value) : 1 };
                          fetch(gi.add + '.js', {
                            body: JSON.stringify(r),
                            credentials: 'same-origin',
                            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
                            method: 'POST',
                          })
                            .then(function (t) {
                              return t.json();
                            })
                            .then(function () {
                              (p.innerHTML = ''), (h.innerHTML = ''), y(h, 'active');
                              var t = 'shipping_address%5Bcountry%5D='.concat(i.value),
                                e = 'shipping_address%5Bprovince%5D='.concat(o.value),
                                n = 'shipping_address%5Bzip%5D='.concat(s.value),
                                r = ''.concat(gi.shipping, '.json?').concat(t, '&').concat(e, '&').concat(n),
                                a = new XMLHttpRequest();
                              a.open('GET', r, !0),
                                (a.onload = function () {
                                  var t = JSON.parse(a.response);
                                  if (a.status >= 200 && a.status < 300)
                                    if (t.shipping_rates && t.shipping_rates.length)
                                      m(h, 'active'),
                                        t.shipping_rates.forEach(function (t) {
                                          var e = '\n                  <li class="shipping-estimator-modal__success-item">\n                    <h4 class="ff-body fs-body-bold">'
                                            .concat(t.name, '</h4>\n                    <span class="ff-body fs-body-small">')
                                            .concat(jt(t.price), '</span>\n                  </li>\n                ');
                                          h.insertAdjacentHTML('beforeend', e);
                                        });
                                    else {
                                      var e =
                                        '\n                <li class="shipping-estimator-modal__success-item">\n                  <span class="ff-body fs-body-small">'.concat(
                                          vi.product.no_shipping_rates,
                                          '</span>\n                </li>\n              '
                                        );
                                      h.insertAdjacentHTML('beforeend', e);
                                    }
                                  else
                                    for (var n = 0, r = Object.entries(t); n < r.length; n++) {
                                      var i = ie()(r[n], 2),
                                        o = i[0],
                                        s = i[1],
                                        c = '\n              <li class="shipping-estimator-modal__error-item">\n                <p class="ff-body fs-body-small"><span>'
                                          .concat(o, '</span> ')
                                          .concat(s, '</p>\n              </li>\n            ');
                                      p.insertAdjacentHTML('beforeend', c);
                                    }
                                  A(), y(f, 'loading');
                                }),
                                a.send();
                            })
                            .catch(function () {
                              A(), y(f, 'loading');
                            });
                        }
                      })(parseInt(r.value)));
                }
              }
              function S(e) {
                e && e.preventDefault(),
                  y(c, bi, mi),
                  v && v.deactivate(),
                  setTimeout(function () {
                    y(c, wi);
                  }, 300),
                  c.setAttribute('aria-hidden', 'true'),
                  et(t);
              }
              return function () {
                _.forEach(function (t) {
                  return t();
                });
              };
            })(t.parentNode);
          })),
          (this.widgetAccordions = wt(f('.widgets-accordion', this.container), { firstOpen: !1 }));
        var a = d('.product__description', this.container),
          s = f('.accordion', a);
        if ((_i(f('iframe', a)), Ei(f('table', a)), s.length)) {
          var c = d('[data-share]', a),
            u = d('[data-description]', a);
          if (c) {
            var l = u.childNodes,
              h = l[l.length - 1];
            if ('DIV' === h.nodeName && h.classList.contains('accordion')) {
              var p = '\n              <div class="accordion__group">\n                <a class="accordion__label">'
                .concat(c.dataset.share, '</a>\n                <div class="accordion__text share">')
                .concat(c.innerHTML, '</div>\n              </div>\n            ');
              h.insertAdjacentHTML('beforeend', p), (c.style.display = 'none');
            }
          }
          (this.descriptionAccordions = wt(s, { firstOpen: !1 })), m(a, 'product__description--has-accordion'), y(d('.product__description-content', a), 'measure');
        }
        this._initEvents();
      },
      _initEvents: function () {
        var t = this;
        this.events.push(
          g(this.productThumbs, 'click', function (e) {
            e.preventDefault();
            var n = e.currentTarget.dataset;
            t.productThumbs.forEach(function (t) {
              return y(t, 'active');
            }),
              m(e.currentTarget, 'active'),
              ue(t.container, n.thumbnailId);
          })
        ),
          this.events.push(
            g(this.images, 'click', function (e) {
              e.preventDefault(), t.lightbox.open(e.currentTarget.dataset.open);
            })
          ),
          this.events.push(
            ot('cart:stock-error', function () {
              y(t.quantityError, 'hidden'), y(d(ki, t.container), 'loading');
            })
          );
      },
      onOptionChange: function (t) {
        var e = t.dataset.variant,
          n = d(ki, this.container);
        if ((Jr(this.container, e), Xr(n, e), Vt(this.container, e), Qr(this.container, e), !e))
          return (
            Xr(d('[data-add-to-cart]', this.container), !1),
            this.shippingEstimatorButtons.forEach(function (t) {
              return m(t, 'hidden');
            }),
            void (this.availability && this.availability.unload())
          );
        this.quickPurchaseBar && this.quickPurchaseBar.update(e);
        var r = (function (t, e) {
          return /variant=/.test(t) ? t.replace(/(variant=)[^&]+/, '$1' + e) : /\?/.test(t) ? t.concat('&variant=').concat(e) : t.concat('?variant=').concat(e);
        })(window.location.href, e.id);
        if (
          (window.history.replaceState({ path: r }, '', r),
          (d(
            ''.concat('[data-variant-select]', ' ').concat(
              (function (t) {
                return "[value='".concat(t, "']");
              })(e.id)
            ),
            this.container
          ).selected = !0),
          this.formElement.dispatchEvent(new Event('change')),
          e.featured_media)
        ) {
          ue(this.container, e.featured_media.id);
          var i = d('[data-thumbnail-id="'.concat(e.featured_media.id, '"]'), this.container);
          this.productThumbs.forEach(function (t) {
            return y(t, 'active');
          }),
            m(i, 'active');
        }
        this.availability && this.availability.update(e),
          this.shippingEstimatorButtons.forEach(function (t) {
            return y(t, 'hidden');
          });
      },
      onQuantityChange: function (t) {
        var e = t.dataset.variant;
        e && this.quickPurchaseBar && this.quickPurchaseBar.update(e);
      },
      onFormSubmit: function (t) {
        if (document.body.dataset.enableCartAjax) {
          t.preventDefault(), m(this.quantityError, 'hidden');
          var e = d(ki, this.container);
          m(e, 'loading'),
            Mt.addItem(this.formElement).then(function (t) {
              var n = t.item;
              y(e, 'loading'), at('cart:open', null, { flash: n.variant_id });
            });
        }
      },
      onBlockSelect: function (t) {
        var e = t.target,
          n = d('.accordion__label', e);
        if ((e.scrollIntoView({ block: 'center', behavior: 'smooth' }), n)) {
          var r = n.parentNode,
            i = n.nextElementSibling;
          vt(i), pt(i), r.setAttribute('data-open', !0), n.setAttribute('aria-expanded', !0), i.setAttribute('aria-hidden', !1);
        }
      },
      onBlockDeselect: function (t) {
        var e = d('.accordion__label', t.target);
        if (e) {
          var n = e.parentNode,
            r = e.nextElementSibling;
          vt(r), gt(r), n.setAttribute('data-open', !1), e.setAttribute('aria-expanded', !1), r.setAttribute('aria-hidden', !0);
        }
      },
      onUnload: function () {
        this.productForm.destroy(),
          this.lightbox.destroy(),
          this.shippingEstimator.forEach(function (t) {
            return t();
          }),
          this.widgetAccordions && this.accordions.unload(),
          this.descriptionAccordions && this.accordions.unload(),
          this.optionButtons.destroy(),
          this.quantityInput.unload(),
          this.events.forEach(function (t) {
            return t();
          }),
          this.quickPurchaseBar && this.quickPurchaseBar.unload(),
          this.reviewsHandler && this.reviewsHandler.unload();
      },
    });
    var Ai = n(23),
      Ti = n.n(Ai);
    function xi(t) {
      const e = t || {};
      (this.settings = Object.assign(
        { method: 'scroll', container: '#AjaxinateContainer', pagination: '#AjaxinatePagination', offset: 0, loadingText: 'Loading', callback: null },
        e
      )),
        (this.addScrollListeners = this.addScrollListeners.bind(this)),
        (this.addClickListener = this.addClickListener.bind(this)),
        (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
        (this.preventMultipleClicks = this.preventMultipleClicks.bind(this)),
        (this.removeClickListener = this.removeClickListener.bind(this)),
        (this.removeScrollListener = this.removeScrollListener.bind(this)),
        (this.removePaginationElement = this.removePaginationElement.bind(this)),
        (this.destroy = this.destroy.bind(this)),
        (this.containerElement = document.querySelector(this.settings.container)),
        (this.paginationElement = document.querySelector(this.settings.pagination)),
        this.initialize();
    }
    (xi.prototype.initialize = function () {
      this.containerElement && { click: this.addClickListener, scroll: this.addScrollListeners }[this.settings.method]();
    }),
      (xi.prototype.addScrollListeners = function () {
        this.paginationElement &&
          (document.addEventListener('scroll', this.checkIfPaginationInView),
          window.addEventListener('resize', this.checkIfPaginationInView),
          window.addEventListener('orientationchange', this.checkIfPaginationInView));
      }),
      (xi.prototype.addClickListener = function () {
        this.paginationElement &&
          ((this.nextPageLinkElement = this.paginationElement.querySelector('a')),
          (this.clickActive = !0),
          void 0 !== this.nextPageLinkElement && null !== this.nextPageLinkElement && this.nextPageLinkElement.addEventListener('click', this.preventMultipleClicks));
      }),
      (xi.prototype.preventMultipleClicks = function (t) {
        t.preventDefault(),
          this.clickActive &&
            ((this.nextPageLinkElement.innerText = this.settings.loadingText), (this.nextPageUrl = this.nextPageLinkElement.href), (this.clickActive = !1), this.loadMore());
      }),
      (xi.prototype.checkIfPaginationInView = function () {
        const t = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
          e = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
        t <= window.innerHeight &&
          e >= 0 &&
          ((this.nextPageLinkElement = this.paginationElement.querySelector('a')),
          this.removeScrollListener(),
          this.nextPageLinkElement && ((this.nextPageLinkElement.innerText = this.settings.loadingText), (this.nextPageUrl = this.nextPageLinkElement.href), this.loadMore()));
      }),
      (xi.prototype.loadMore = function () {
        (this.request = new XMLHttpRequest()),
          (this.request.onreadystatechange = function () {
            if (4 === this.request.readyState && 200 === this.request.status) {
              var t = new DOMParser().parseFromString(this.request.responseText, 'text/html'),
                e = t.querySelectorAll(this.settings.container)[0],
                n = t.querySelectorAll(this.settings.pagination)[0];
              this.containerElement.insertAdjacentHTML('beforeend', e.innerHTML),
                (this.paginationElement.innerHTML = n.innerHTML),
                this.settings.callback && 'function' == typeof this.settings.callback && this.settings.callback(this.request.responseXML),
                this.initialize();
            }
          }.bind(this)),
          this.request.open('GET', this.nextPageUrl, !1),
          this.request.send();
      }),
      (xi.prototype.removeClickListener = function () {
        this.nextPageLinkElement.removeEventListener('click', this.preventMultipleClicks);
      }),
      (xi.prototype.removePaginationElement = function () {
        (this.paginationElement.innerHTML = ''), this.destroy();
      }),
      (xi.prototype.removeScrollListener = function () {
        document.removeEventListener('scroll', this.checkIfPaginationInView),
          window.removeEventListener('resize', this.checkIfPaginationInView),
          window.removeEventListener('orientationchange', this.checkIfPaginationInView);
      }),
      (xi.prototype.destroy = function () {
        return { click: this.removeClickListener, scroll: this.removeScrollListener }[this.settings.method](), this;
      });
    var Si = function (t) {
        var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return at('collection:filters:remove', null, { tags: t, fetch: e });
      },
      Ci = function () {
        return at('collection:sort:clear', null);
      },
      Oi = function (t) {
        return ot('collection:filters:remove', t);
      },
      Li = function (t) {
        return ot('collection:sort:set', t);
      },
      qi = function (t) {
        return ot('collection:sort:clear', t);
      },
      Di = function (t) {
        return ot('collection:clear', t);
      },
      Pi = '[data-filter-modal]',
      Ii = '[data-tag]',
      Mi = '.collection-modal__group',
      Ni = '.collection-modal__panel',
      ji = 'active',
      Ri = 'active-filters',
      Bi = 'is-fixed',
      zi = '.collection__infinite-trigger',
      Hi = '[data-partial]';
    Bt('collection', {
      infiniteScroll: null,
      onLoad: function () {
        var t,
          e = this,
          n = this.container.dataset,
          r = n.collectionItemCount,
          i = n.paginationType;
        parseInt(r) &&
          ((this.collection = (function (t) {
            var e = new Ti.a(t || window.location.href),
              n = e.paths().indexOf('collections') > 0 ? 3 : 2;
            function r(t) {
              var r = e.paths().slice(0, n);
              e.paths([].concat(r, [t]));
            }
            function i() {
              var t = e.paths().filter(Boolean);
              return t[n] ? t[n].split(' ') : [];
            }
            return {
              getState: function () {
                return { handle: e.paths()[1], page: Number(e.query.page) || 1, sort_by: e.query.sort_by || null, tags: i(), url: e.toString().replace(/%20/g, '+') };
              },
              addTags: function (t, n) {
                return (
                  r(
                    []
                      .concat(i(), t)
                      .filter(function (t, e, n) {
                        return n.indexOf(t) == e;
                      })
                      .join(' ')
                  ),
                  delete e.query.page,
                  n(this.getState())
                );
              },
              removeTags: function (t, n) {
                return (
                  r(
                    i()
                      .filter(function (e) {
                        return !t.includes(e);
                      })
                      .join(' ')
                  ),
                  delete e.query.page,
                  n(this.getState())
                );
              },
              setSort: function (t, n) {
                return (e.query.sort_by = t), n(this.getState());
              },
              clearSort: function (t) {
                return delete e.query.sort_by, t(this.getState());
              },
              clearAll: function (t) {
                return delete e.query.sort_by, r(''), t(this.getState());
              },
            };
          })(window.location.href)),
          (this.filtering = (function (t) {
            var e = f(Pi, t),
              n = d('[data-filer-modal-wrapper]', t),
              r = d('[data-mobile-wash]', t),
              i = f(Ii, t),
              o = f('[data-filter-modal="__sort"] '.concat('[data-sort]')),
              a = d('[data-mobile-trigger]', t),
              s = d('[data-mobile-filters]', t),
              c = null,
              u = [
                g(f('[data-filter]', t), 'click', function (e) {
                  e.preventDefault();
                  var r = e.currentTarget.dataset.filter,
                    i = d('[data-filter-modal="'.concat(r, '"]'), t);
                  (c = V(i, { allowOutsideClick: !0 })),
                    m(n, Bi),
                    setTimeout(function () {
                      m(n, ji), m(i, ji);
                    }, 50),
                    i.setAttribute('aria-hidden', 'false'),
                    c.activate(),
                    tt(t, {
                      allowTouchMove: function (t) {
                        for (; t && t !== document.body; ) {
                          if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                          t = t.parentNode;
                        }
                      },
                      reserveScrollBarGap: !0,
                    });
                }),
                g(i, 'click', function (t) {
                  t.preventDefault(), b(t.target.parentNode, ji), v(t.currentTarget);
                  var e = t.target.closest(Mi);
                  e && b(e, Ri, f('.active', e).length);
                }),
                g(o, 'click', function (t) {
                  t.preventDefault(),
                    w(t.currentTarget.parentNode, ji) ||
                      (o.forEach(function (e) {
                        return b(e.parentNode, ji, e === t.currentTarget);
                      }),
                      v(t.target));
                }),
                g(r, 'click', p),
                g(f('[data-button]', t), 'click', function (t) {
                  t.preventDefault();
                  var e,
                    n = t.currentTarget.dataset,
                    r = n.button,
                    i = n.category,
                    a = t.currentTarget.closest(Pi);
                  if ('__sort' === a.dataset.filterModal) {
                    if (
                      ('clear-all' === r &&
                        (y(
                          o.map(function (t) {
                            return t.parentNode;
                          }),
                          ji
                        ),
                        y(t.currentTarget.closest(Ni), Ri)),
                      'apply' === r)
                    ) {
                      var s = d('.'.concat(ji), a);
                      return s ? ((e = s.firstElementChild.dataset.sort), at('collection:sort:set', null, { method: e })) : Ci(), void p();
                    }
                  } else {
                    var c = f(Ii, a);
                    if ('clear-all' === r) {
                      y(
                        c.map(function (t) {
                          return t.parentNode;
                        }),
                        ji
                      );
                      var u = t.currentTarget.closest(Ni);
                      y([].concat(At()(f(Mi, u)), [u]), Ri);
                    }
                    if (
                      ('clear' === r &&
                        (y(
                          c
                            .filter(function (t) {
                              return t.dataset.tag.split('_')[0] === i;
                            })
                            .map(function (t) {
                              return t.parentNode;
                            }),
                          ji
                        ),
                        y(t.currentTarget.closest(Mi), Ri),
                        v(t.currentTarget)),
                      'apply' === r)
                    ) {
                      var l = [],
                        h = [];
                      c.forEach(function (t) {
                        var e = t.parentNode,
                          n = t.dataset.tag;
                        w(e, ji) ? l.push(n) : h.push(n);
                      }),
                        h.length > 0 && Si(h, l.length <= 0),
                        l.length > 0 && at('collection:filters:add', null, { tags: l }),
                        p();
                    }
                  }
                }),
                g(f('[data-close-icon]', t), 'click', p),
                g(t, 'keydown', function (t) {
                  27 === t.keyCode && p();
                }),
                g(a, 'click', function () {
                  s.style.setProperty('--mobile-filters-offset', ''.concat(s.clientHeight - 20, 'px')), b(s, ji);
                }),
              ],
              l = ot('tags', function (t) {
                var e = t.tags;
                i.forEach(function (t) {
                  return b(t.parentElement, ji, e.includes(t.dataset.tag));
                });
              }),
              h = ot('sort_by', function (t) {
                var e = t.sort_by;
                o.forEach(function (t) {
                  return b(t.parentElement, ji, t.dataset.sort === e);
                });
              });
            function p(r) {
              r && r.preventDefault(),
                c && c.deactivate(),
                y(e, ji),
                y(n, ji),
                e.forEach(function (t) {
                  return t.setAttribute('aria-hidden', 'true');
                }),
                et(t),
                setTimeout(function () {
                  y(n, Bi);
                }, 300);
            }
            function v(t) {
              var e = t.closest(Ni);
              e && b(e, Ri, f('.active', e).length);
            }
            return function () {
              l(),
                h(),
                u.forEach(function (t) {
                  return t();
                });
            };
          })(this.container)),
          st(this.collection.getState()),
          (this.partial = d(Hi, this.container)),
          (this.subscriptions = [
            ((t = function (t, n) {
              var r = n.tags;
              return e.collection.addTags(r, function (t) {
                e._renderView(t.url), st(t)();
              });
            }),
            ot('collection:filters:add', t)),
            Oi(function (t, n) {
              var r = n.tags,
                i = n.fetch;
              e.collection.removeTags(r, function (t) {
                i && (e._renderView(t.url), st(t)());
              });
            }),
            Li(function (t, n) {
              var r = n.method;
              e.collection.setSort(r, function (t) {
                e._renderView(t.url), st(t)();
              });
            }),
            qi(function () {
              e.collection.clearSort(function (t) {
                e._renderView(t.url), st(t)();
              });
            }),
            Di(function () {
              e.collection.clearAll(function (t) {
                e._renderView(t.url), st(t)();
              });
            }),
          ]),
          (this.delegate = new T.a(this.partial)),
          this.delegate.on('click', '[data-button="filter"]', function (t) {
            t.preventDefault();
            var e = t.target.dataset.tag;
            Si([e]);
          }),
          this.delegate.on('click', '[data-button="sort"]', function (t) {
            t.preventDefault(), Ci();
          }),
          this.delegate.on('click', '[data-clear]', function (t) {
            t.preventDefault(), at('collection:clear');
          }),
          (this.paginationType = i),
          (this.paginated = 'paginated' === this.paginationType),
          (this.infiniteScrollTrigger = d(zi, this.container)),
          this._initInfiniteScroll());
      },
      _initInfiniteScroll: function () {
        if (!this.paginated) {
          var t = {
            container: '.collection__infinite-container',
            pagination: zi,
            loadingText: 'Loading...',
            callback: function () {
              return at('collection:updated');
            },
          };
          'click' === this.paginationType && (t.method = 'click'), (this.infiniteScroll = new xi(t));
        }
      },
      _renderView: function (t) {
        var e = this,
          n = d('.collection__loading', this.container);
        m(n, 'is-active'),
          fetch(t, { credentials: 'include' })
            .then(function (t) {
              return t.text();
            })
            .then(function (r) {
              window.history.pushState({}, '', t);
              var i = new window.DOMParser().parseFromString(r, 'text/html'),
                o = d(Hi, i).innerHTML;
              (e.partial.innerHTML = o), e.paginated || ((e.infiniteScrollTrigger.innerHTML = ''), e._initInfiniteScroll()), y(n, 'is-active'), at('collection:updated');
            });
      },
      onUnload: function () {
        this.infiniteScroll && this.infiniteScroll.destroy(),
          this.filtering(),
          this.delegate.off(),
          this.subscriptions.forEach(function (t) {
            return t();
          });
      },
    }),
      Bt('login', {
        onLoad: function () {
          var t = d('[data-part="login"]', this.container),
            e = d('[data-part="reset"]', this.container),
            n = f('[data-toggle]', this.container),
            r = d('.login__wrapper', this.container),
            i = d('.login__error', this.container),
            o = d('[data-success]', this.container),
            a = d('[data-success-message]', this.container);
          function s(n) {
            n && n.preventDefault(), b([t, e], 'hide'), t.setAttribute('aria-hidden', w(t, 'hide')), e.setAttribute('aria-hidden', w(e, 'hide'));
          }
          o && (m(a, 'visible'), m(r, 'hide')), i && s(), (this.toggleClick = g(n, 'click', s));
        },
        onUnload: function () {
          this.toggleClick();
        },
      }),
      Bt('addresses', {
        onLoad: function () {
          var t = this;
          (this.modals = f('[data-address-modal]', this.container)), (this.focusTrap = null);
          var e = f('[data-overlay]', this.container),
            n = f('[data-open]', this.container),
            r = f('[data-close]', this.container),
            i = f('[data-remove]', this.container),
            o = f('[data-country-option]', this.container) || [];
          (this.events = [
            g(n, 'click', function (e) {
              return t.openModal(e);
            }),
            g([].concat(At()(r), At()(e)), 'click', function (e) {
              return t.closeModal(e);
            }),
            g(i, 'click', function (e) {
              return t.removeAddress(e);
            }),
            g(this.modals, 'keydown', function (e) {
              27 === e.keyCode && t.closeModal(e);
            }),
          ]),
            o.forEach(function (t) {
              var e = t.dataset.formId,
                n = 'AddressCountry_' + e,
                r = 'AddressProvince_' + e,
                i = 'AddressProvinceContainer_' + e;
              new window.Shopify.CountryProvinceSelector(n, r, { hideElement: i });
            });
        },
        onUnload: function () {
          this.events.forEach(function (t) {
            return t();
          });
        },
        openModal: function (t) {
          t.preventDefault();
          var e = t.currentTarget.dataset.open,
            n = this.modals.find(function (t) {
              return t.dataset.addressModal == e;
            });
          m(n, 'active'),
            (this.focusTrap = V(n, { allowOutsideClick: !0 })),
            this.focusTrap.activate(),
            tt(n, {
              allowTouchMove: function (t) {
                for (; t && t !== document.body; ) {
                  if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                  t = t.parentNode;
                }
              },
              reserveScrollBarGap: !0,
            }),
            setTimeout(function () {
              m(n, 'visible');
            }, 50);
        },
        closeModal: function (t) {
          t.preventDefault();
          var e = t.target.closest('.addresses__modal');
          et(e),
            this.focusTrap.deactivate(),
            y(e, 'visible'),
            setTimeout(function () {
              y(e, 'active');
            }, 350);
        },
        removeAddress: function (t) {
          var e = t.currentTarget.dataset,
            n = e.confirmMessage,
            r = e.target;
          confirm(n), window.Shopify.postLink(r, { parameters: { _method: 'delete' } });
        },
      }),
      Bt('article', {
        onLoad: function () {
          Qt(this.container);
          var t = f('[data-social-share]', this.container);
          (this.events = [
            g(t, 'click', function (t) {
              b(t.target, 'active'), d('.article__share-icons', t.target).setAttribute('aria-hidden', !w(t.target, 'active'));
            }),
          ]),
            _i(f('iframe', this.container)),
            Ei(f('table', this.container));
        },
        onUnload: function () {
          this.events.forEach(function (t) {
            return t();
          });
        },
      });
    Bt('password', {
      onLoad: function () {
        var t = this,
          e = d('[data-js-toggle]', this.container),
          n = d('[data-text-toggle]', this.container),
          r = d('[data-social-share]', this.container);
        this.events = [
          g([e, n], 'click', function (e) {
            return t.toggleView(e);
          }),
          g(r, 'click', function (t) {
            b(t.target, 'active'), d('.password__share-icons', t.target).setAttribute('aria-hidden', !w(t.target, 'active'));
          }),
        ];
      },
      toggleView: function () {
        b(this.container, 'welcome');
      },
      onUnload: function () {
        this.events.forEach(function (t) {
          return t();
        });
      },
    });
    var Fi;
    if (
      (Bt('page', {
        onLoad: function () {
          var t = this,
            e = f('.about__block-video', this.container);
          (this.videoHandlers = []),
            e.length &&
              e.forEach(function (e) {
                t.videoHandlers.push(Xt(e.parentNode));
              }),
            (this.accordions = wt(f('.accordion', this.container))),
            _i(f('iframe', this.container)),
            Ei(f('table', this.container));
        },
        onUnload: function () {
          this.accordions.unload(),
            this.videoHandlers.forEach(function (t) {
              return t();
            });
        },
      }),
      Bt('search', {
        onLoad: function () {
          var t = d('[data-clear-search]', this.container),
            e = d('.search__submit', this.container),
            n = d('[data-search-input]', this.container);
          b([t, e], 'visible', '' !== n.value),
            (this.events = [
              g(t, 'click', function () {
                (n.value = ''), b([t, e], 'visible', '' !== n.value);
              }),
              g(n, 'input', function (n) {
                return b([t, e], 'visible', '' !== n.target.value);
              }),
            ]);
        },
        onUnload: function () {
          this.buttonHandler();
        },
      }),
      Bt('contact', {
        onLoad: function () {
          (this.accordions = wt(f('.accordion', this.container))), _i(f('iframe', this.container)), Ei(f('table', this.container));
        },
        onUnload: function () {
          this.accordions.unload();
        },
      }),
      !0 === window.Shopify.designMode)
    )
      m(document.documentElement, 'theme-editor'), document.documentElement.classList.add('theme-editor');
    else {
      var Vi = d('.theme-editor-scroll-offset', document);
      Vi && Vi.parentNode.removeChild(Vi);
    }
    g(document, 'DOMContentLoaded', function () {
      a('*'), st({ SelectedProductSection: null });
    }),
      k()({ tablet: !0, featureDetect: !0 }) && m(document.body, 'is-mobile'),
      (Fi = document.querySelector('.page-transition')) &&
        (Object.assign(Fi.style, { opacity: 0, pointerEvents: 'none' }),
        setTimeout(function () {
          Fi.style.visibility = 'hidden';
        }, 300),
        new T.a(document.body).on('click', 'a[href]:not([href^="#"]):not(.no-transition):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', function (t, e) {
          t.preventDefault(),
            Fi.addEventListener('transitionend', function t(n) {
              'opacity' === n.propertyName && (Fi.removeEventListener('transitionend', t), (window.location.href = e.href));
            }),
            Object.assign(Fi.style, { opacity: 1, pointerEvents: 'all', visibility: 'visible' });
        }),
        (window.onpageshow = function (t) {
          t.persisted && Object.assign(Fi.style, { opacity: 0, pointerEvents: 'none' });
        })),
      (function () {
        var t = null,
          e = ['INPUT', 'TEXTAREA', 'SELECT'];
        function n(n) {
          9 !== n.keyCode || e.includes(document.activeElement.tagName) || (document.body.classList.add('user-is-tabbing'), t(), (t = g(window, 'mousedown', r)));
        }
        function r() {
          document.body.classList.remove('user-is-tabbing'), t(), (t = g(window, 'keydown', n));
        }
        t = g(window, 'keydown', n);
      })(),
      (function () {
        function t() {
          f('.shopify-section').forEach(function (t) {
            var e = t.firstElementChild;
            e && e.classList.contains(Zt) && m(t, Kt), e && e.classList.contains(te) && m(t, ee), e && e.classList.contains(ne) && m(t, ne);
          });
        }
        t(), g(document, 'shopify:section:load', t);
      })(),
      (function (t) {
        var e = V(t, { allowOutsideClick: !0 }),
          n = d('.modal__wash', t.parentNode),
          r = d('.modal__content', t),
          i = null,
          o = [
            g([d('[data-modal-close]', t), n], 'click', function (t) {
              t.preventDefault(), u();
            }),
            g(t, 'keydown', function (t) {
              27 === t.keyCode && u();
            }),
            ot('modal:open', function (e, n) {
              var r = n.modalContent,
                i = n.narrow;
              b(t, 'modal--narrow', void 0 !== i && i), a(r), c();
            }),
          ],
          a = function (t) {
            var e = t.cloneNode(!0);
            (r.innerHTML = ''), r.appendChild(e), s();
          },
          s = function () {
            i = wt(f('.accordion', t));
          },
          c = function () {
            m(t, Et),
              setTimeout(function () {
                m(t, _t), m(t, 'active');
              }, 50),
              e.activate(),
              tt(t, {
                allowTouchMove: function (t) {
                  for (; t && t !== document.body; ) {
                    if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                    t = t.parentNode;
                  }
                },
                reserveScrollBarGap: !0,
              });
          },
          u = function () {
            e.deactivate(),
              y(t, _t),
              y(t, 'active'),
              et(t),
              setTimeout(function () {
                y(t, Et), (r.innerHTML = '');
              }, 300);
          };
      })(d('[data-modal]', document)),
      (function (t) {
        var e = V(t, { allowOutsideClick: !0 }),
          n = d('[data-store-availability-drawer-wash]', t.parentNode),
          r = d('[data-store-availability-product]', t),
          i = d('[data-store-list-container]', t),
          o = [
            g([d('[data-store-availability-close]', t), n], 'click', function (t) {
              t.preventDefault(), f();
            }),
            g(t, 'keydown', function (t) {
              27 === t.keyCode && f();
            }),
            ot('availability:showMore', function (t) {
              var e = t.product,
                n = t.variant,
                i = t.storeList,
                o = t.options;
              (r.innerHTML = s(e, n, o)), a(i), l();
            }),
          ],
          a = function (t) {
            (i.innerHTML = ''), i.appendChild(t);
          },
          s = function (t, e, n) {
            var r = t.featured_image,
              i = t.title,
              o = e.title,
              a = e.featured_image,
              s = e.price,
              u = e.unit_price,
              l = e.unit_price_measurement,
              d = n.hideVariantTitle,
              f = c(r, a);
            return '\n      <div class="store-availbility-drawer__product-card">\n        '
              .concat(
                f
                  ? "\n            <div class='store-availbility-drawer__product-card-image'>\n              <img src='"
                      .concat(f, "' alt='")
                      .concat(i, "'/>\n            </div>\n          ")
                  : '',
                '\n        <div class=\'store-availbility-drawer__product-card-details\'>\n          <div>\n            <h4 class="fs-body-bold">\n              <span>'
              )
              .concat(
                i,
                '</span>\n            </h4>\n            <div class="store-availbility-drawer__product-price-wrapper">\n              <span class="store-availbility-drawer__product-price">'
              )
              .concat(jt(s), '</span>\n              ')
              .concat(Ut(u, l), '\n            </div>\n            <div class="store-availbility-drawer__product-card-variant')
              .concat(d ? ' hidden' : '', '">\n              ')
              .concat(o, '\n            </div>\n          </div>\n        </div>\n      </div>\n    ');
          },
          c = function (t, e) {
            return t || e ? u(e ? e.src : t) : '';
          },
          u = function (t) {
            return (function (t, e) {
              if (null === e) return t;
              if ('master' === e) return zt(t);
              var n = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
              if (n) {
                var r = t.split(n[0]),
                  i = n[0];
                return zt(r[0] + '_' + e + i);
              }
              return null;
            })(t.replace('.' + ((e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/)) ? e[1] : null), ''), '200x');
            var e;
          },
          l = function () {
            m(t, Jt),
              setTimeout(function () {
                m(t, $t), m(t, 'active');
              }, 50),
              t.setAttribute('aria-hidden', 'false'),
              e.activate(),
              tt(t, {
                allowTouchMove: function (t) {
                  for (; t && t !== document.body; ) {
                    if (null !== t.getAttribute('data-scroll-lock-ignore')) return !0;
                    t = t.parentNode;
                  }
                },
                reserveScrollBarGap: !0,
              });
          },
          f = function () {
            e.deactivate(),
              y(t, 'active'),
              y(t, $t),
              t.setAttribute('aria-hidden', 'true'),
              et(t),
              setTimeout(function () {
                y(t, Jt);
              }, 300);
          };
      })(d('[data-store-availability-drawer]', document)),
      (window.SHA = 'unknown');
  },
]);
